webpackJsonp([0],{

/***/ 0:
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var platform_browser_dynamic_1 = __webpack_require__(1);
	var core_1 = __webpack_require__(5);
	var forms_1 = __webpack_require__(326);
	var http_1 = __webpack_require__(363);
	var app_component_1 = __webpack_require__(384);
	var app_routes_1 = __webpack_require__(447);
	// import { APP_ROUTERR_PROVIDERS } from './app/Home/home.routes';
	// import  { LoginComponent } from './app/AuthModule/login.component'
	if (true) {
	    core_1.enableProdMode();
	}
	// bootstrap(AppComponent, [HTTP_PROVIDERS]);
	// bootstrap(LoginComponent, []);
	platform_browser_dynamic_1.bootstrap(app_component_1.AppComponent, [http_1.HTTP_PROVIDERS,
	    forms_1.disableDeprecatedForms(),
	    forms_1.provideForms(),
	    app_routes_1.APP_ROUTER_PROVIDERS,
	]);


/***/ },

/***/ 326:
/***/ function(module, exports, __webpack_require__) {

	/**
	 * @license
	 * Copyright Google Inc. All Rights Reserved.
	 *
	 * Use of this source code is governed by an MIT-style license that can be
	 * found in the LICENSE file at https://angular.io/license
	 */
	"use strict";
	function __export(m) {
	    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
	}
	__export(__webpack_require__(327));
	//# sourceMappingURL=index.js.map

/***/ },

/***/ 327:
/***/ function(module, exports, __webpack_require__) {

	/**
	 * @license
	 * Copyright Google Inc. All Rights Reserved.
	 *
	 * Use of this source code is governed by an MIT-style license that can be
	 * found in the LICENSE file at https://angular.io/license
	 */
	"use strict";
	function __export(m) {
	    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
	}
	/**
	 * @module
	 * @description
	 * This module is used for handling user input, by defining and building a {@link FormGroup} that
	 * consists of
	 * {@link FormControl} objects, and mapping them onto the DOM. {@link FormControl} objects can then
	 * be used
	 * to read information
	 * from the form DOM elements.
	 *
	 * Forms providers are not included in default providers; you must import these providers
	 * explicitly.
	 */
	var directives_1 = __webpack_require__(328);
	exports.FORM_DIRECTIVES = directives_1.FORM_DIRECTIVES;
	exports.REACTIVE_FORM_DIRECTIVES = directives_1.REACTIVE_FORM_DIRECTIVES;
	var abstract_control_directive_1 = __webpack_require__(339);
	exports.AbstractControlDirective = abstract_control_directive_1.AbstractControlDirective;
	var checkbox_value_accessor_1 = __webpack_require__(329);
	exports.CheckboxControlValueAccessor = checkbox_value_accessor_1.CheckboxControlValueAccessor;
	var control_container_1 = __webpack_require__(351);
	exports.ControlContainer = control_container_1.ControlContainer;
	var control_value_accessor_1 = __webpack_require__(330);
	exports.NG_VALUE_ACCESSOR = control_value_accessor_1.NG_VALUE_ACCESSOR;
	var default_value_accessor_1 = __webpack_require__(331);
	exports.DefaultValueAccessor = default_value_accessor_1.DefaultValueAccessor;
	var ng_control_1 = __webpack_require__(334);
	exports.NgControl = ng_control_1.NgControl;
	var ng_control_status_1 = __webpack_require__(333);
	exports.NgControlStatus = ng_control_status_1.NgControlStatus;
	var ng_form_1 = __webpack_require__(340);
	exports.NgForm = ng_form_1.NgForm;
	var ng_model_1 = __webpack_require__(352);
	exports.NgModel = ng_model_1.NgModel;
	var ng_model_group_1 = __webpack_require__(353);
	exports.NgModelGroup = ng_model_group_1.NgModelGroup;
	var form_array_name_1 = __webpack_require__(355);
	exports.FormArrayName = form_array_name_1.FormArrayName;
	var form_control_directive_1 = __webpack_require__(356);
	exports.FormControlDirective = form_control_directive_1.FormControlDirective;
	var form_control_name_1 = __webpack_require__(357);
	exports.FormControlName = form_control_name_1.FormControlName;
	var form_group_directive_1 = __webpack_require__(358);
	exports.FormGroupDirective = form_group_directive_1.FormGroupDirective;
	var form_group_name_1 = __webpack_require__(359);
	exports.FormGroupName = form_group_name_1.FormGroupName;
	var select_control_value_accessor_1 = __webpack_require__(349);
	exports.NgSelectOption = select_control_value_accessor_1.NgSelectOption;
	exports.SelectControlValueAccessor = select_control_value_accessor_1.SelectControlValueAccessor;
	var validators_1 = __webpack_require__(360);
	exports.MaxLengthValidator = validators_1.MaxLengthValidator;
	exports.MinLengthValidator = validators_1.MinLengthValidator;
	exports.PatternValidator = validators_1.PatternValidator;
	exports.RequiredValidator = validators_1.RequiredValidator;
	var form_builder_1 = __webpack_require__(361);
	exports.FormBuilder = form_builder_1.FormBuilder;
	var model_1 = __webpack_require__(343);
	exports.AbstractControl = model_1.AbstractControl;
	exports.FormArray = model_1.FormArray;
	exports.FormControl = model_1.FormControl;
	exports.FormGroup = model_1.FormGroup;
	var validators_2 = __webpack_require__(345);
	exports.NG_ASYNC_VALIDATORS = validators_2.NG_ASYNC_VALIDATORS;
	exports.NG_VALIDATORS = validators_2.NG_VALIDATORS;
	exports.Validators = validators_2.Validators;
	__export(__webpack_require__(362));
	//# sourceMappingURL=forms.js.map

/***/ },

/***/ 328:
/***/ function(module, exports, __webpack_require__) {

	/**
	 * @license
	 * Copyright Google Inc. All Rights Reserved.
	 *
	 * Use of this source code is governed by an MIT-style license that can be
	 * found in the LICENSE file at https://angular.io/license
	 */
	"use strict";
	var checkbox_value_accessor_1 = __webpack_require__(329);
	var default_value_accessor_1 = __webpack_require__(331);
	var ng_control_status_1 = __webpack_require__(333);
	var ng_form_1 = __webpack_require__(340);
	var ng_model_1 = __webpack_require__(352);
	var ng_model_group_1 = __webpack_require__(353);
	var number_value_accessor_1 = __webpack_require__(347);
	var radio_control_value_accessor_1 = __webpack_require__(348);
	var form_array_name_1 = __webpack_require__(355);
	var form_control_directive_1 = __webpack_require__(356);
	var form_control_name_1 = __webpack_require__(357);
	var form_group_directive_1 = __webpack_require__(358);
	var form_group_name_1 = __webpack_require__(359);
	var select_control_value_accessor_1 = __webpack_require__(349);
	var select_multiple_control_value_accessor_1 = __webpack_require__(350);
	var validators_1 = __webpack_require__(360);
	var checkbox_value_accessor_2 = __webpack_require__(329);
	exports.CheckboxControlValueAccessor = checkbox_value_accessor_2.CheckboxControlValueAccessor;
	var default_value_accessor_2 = __webpack_require__(331);
	exports.DefaultValueAccessor = default_value_accessor_2.DefaultValueAccessor;
	var ng_control_1 = __webpack_require__(334);
	exports.NgControl = ng_control_1.NgControl;
	var ng_control_status_2 = __webpack_require__(333);
	exports.NgControlStatus = ng_control_status_2.NgControlStatus;
	var ng_form_2 = __webpack_require__(340);
	exports.NgForm = ng_form_2.NgForm;
	var ng_model_2 = __webpack_require__(352);
	exports.NgModel = ng_model_2.NgModel;
	var ng_model_group_2 = __webpack_require__(353);
	exports.NgModelGroup = ng_model_group_2.NgModelGroup;
	var number_value_accessor_2 = __webpack_require__(347);
	exports.NumberValueAccessor = number_value_accessor_2.NumberValueAccessor;
	var radio_control_value_accessor_2 = __webpack_require__(348);
	exports.RadioControlValueAccessor = radio_control_value_accessor_2.RadioControlValueAccessor;
	var form_array_name_2 = __webpack_require__(355);
	exports.FormArrayName = form_array_name_2.FormArrayName;
	var form_control_directive_2 = __webpack_require__(356);
	exports.FormControlDirective = form_control_directive_2.FormControlDirective;
	var form_control_name_2 = __webpack_require__(357);
	exports.FormControlName = form_control_name_2.FormControlName;
	var form_group_directive_2 = __webpack_require__(358);
	exports.FormGroupDirective = form_group_directive_2.FormGroupDirective;
	var form_group_name_2 = __webpack_require__(359);
	exports.FormGroupName = form_group_name_2.FormGroupName;
	var select_control_value_accessor_2 = __webpack_require__(349);
	exports.NgSelectOption = select_control_value_accessor_2.NgSelectOption;
	exports.SelectControlValueAccessor = select_control_value_accessor_2.SelectControlValueAccessor;
	var select_multiple_control_value_accessor_2 = __webpack_require__(350);
	exports.NgSelectMultipleOption = select_multiple_control_value_accessor_2.NgSelectMultipleOption;
	exports.SelectMultipleControlValueAccessor = select_multiple_control_value_accessor_2.SelectMultipleControlValueAccessor;
	var validators_2 = __webpack_require__(360);
	exports.MaxLengthValidator = validators_2.MaxLengthValidator;
	exports.MinLengthValidator = validators_2.MinLengthValidator;
	exports.PatternValidator = validators_2.PatternValidator;
	exports.RequiredValidator = validators_2.RequiredValidator;
	/**
	 *
	 * A list of all the form directives used as part of a `@Component` annotation.
	 *
	 *  This is a shorthand for importing them each individually.
	 *
	 * ### Example
	 *
	 * ```typescript
	 * @Component({
	 *   selector: 'my-app',
	 *   directives: [FORM_DIRECTIVES]
	 * })
	 * class MyApp {}
	 * ```
	 * @experimental
	 */
	exports.FORM_DIRECTIVES = [
	    ng_model_1.NgModel, ng_model_group_1.NgModelGroup, ng_form_1.NgForm,
	    select_control_value_accessor_1.NgSelectOption, select_multiple_control_value_accessor_1.NgSelectMultipleOption, default_value_accessor_1.DefaultValueAccessor, number_value_accessor_1.NumberValueAccessor,
	    checkbox_value_accessor_1.CheckboxControlValueAccessor, select_control_value_accessor_1.SelectControlValueAccessor, select_multiple_control_value_accessor_1.SelectMultipleControlValueAccessor,
	    radio_control_value_accessor_1.RadioControlValueAccessor, ng_control_status_1.NgControlStatus,
	    validators_1.RequiredValidator, validators_1.MinLengthValidator, validators_1.MaxLengthValidator, validators_1.PatternValidator
	];
	/**
	 * @experimental
	 */
	exports.REACTIVE_FORM_DIRECTIVES = 
	/*@ts2dart_const*/ [
	    form_control_directive_1.FormControlDirective, form_group_directive_1.FormGroupDirective, form_control_name_1.FormControlName, form_group_name_1.FormGroupName, form_array_name_1.FormArrayName
	];
	//# sourceMappingURL=directives.js.map

/***/ },

/***/ 329:
/***/ function(module, exports, __webpack_require__) {

	/**
	 * @license
	 * Copyright Google Inc. All Rights Reserved.
	 *
	 * Use of this source code is governed by an MIT-style license that can be
	 * found in the LICENSE file at https://angular.io/license
	 */
	"use strict";
	var core_1 = __webpack_require__(5);
	var control_value_accessor_1 = __webpack_require__(330);
	exports.CHECKBOX_VALUE_ACCESSOR = {
	    provide: control_value_accessor_1.NG_VALUE_ACCESSOR,
	    useExisting: core_1.forwardRef(function () { return CheckboxControlValueAccessor; }),
	    multi: true
	};
	var CheckboxControlValueAccessor = (function () {
	    function CheckboxControlValueAccessor(_renderer, _elementRef) {
	        this._renderer = _renderer;
	        this._elementRef = _elementRef;
	        this.onChange = function (_) { };
	        this.onTouched = function () { };
	    }
	    CheckboxControlValueAccessor.prototype.writeValue = function (value) {
	        this._renderer.setElementProperty(this._elementRef.nativeElement, 'checked', value);
	    };
	    CheckboxControlValueAccessor.prototype.registerOnChange = function (fn) { this.onChange = fn; };
	    CheckboxControlValueAccessor.prototype.registerOnTouched = function (fn) { this.onTouched = fn; };
	    /** @nocollapse */
	    CheckboxControlValueAccessor.decorators = [
	        { type: core_1.Directive, args: [{
	                    selector: 'input[type=checkbox][formControlName],input[type=checkbox][formControl],input[type=checkbox][ngModel]',
	                    host: { '(change)': 'onChange($event.target.checked)', '(blur)': 'onTouched()' },
	                    providers: [exports.CHECKBOX_VALUE_ACCESSOR]
	                },] },
	    ];
	    /** @nocollapse */
	    CheckboxControlValueAccessor.ctorParameters = [
	        { type: core_1.Renderer, },
	        { type: core_1.ElementRef, },
	    ];
	    return CheckboxControlValueAccessor;
	}());
	exports.CheckboxControlValueAccessor = CheckboxControlValueAccessor;
	//# sourceMappingURL=checkbox_value_accessor.js.map

/***/ },

/***/ 330:
144,

/***/ 331:
/***/ function(module, exports, __webpack_require__) {

	/**
	 * @license
	 * Copyright Google Inc. All Rights Reserved.
	 *
	 * Use of this source code is governed by an MIT-style license that can be
	 * found in the LICENSE file at https://angular.io/license
	 */
	"use strict";
	var core_1 = __webpack_require__(5);
	var lang_1 = __webpack_require__(332);
	var control_value_accessor_1 = __webpack_require__(330);
	exports.DEFAULT_VALUE_ACCESSOR = 
	/* @ts2dart_Provider */ {
	    provide: control_value_accessor_1.NG_VALUE_ACCESSOR,
	    useExisting: core_1.forwardRef(function () { return DefaultValueAccessor; }),
	    multi: true
	};
	var DefaultValueAccessor = (function () {
	    function DefaultValueAccessor(_renderer, _elementRef) {
	        this._renderer = _renderer;
	        this._elementRef = _elementRef;
	        this.onChange = function (_) { };
	        this.onTouched = function () { };
	    }
	    DefaultValueAccessor.prototype.writeValue = function (value) {
	        var normalizedValue = lang_1.isBlank(value) ? '' : value;
	        this._renderer.setElementProperty(this._elementRef.nativeElement, 'value', normalizedValue);
	    };
	    DefaultValueAccessor.prototype.registerOnChange = function (fn) { this.onChange = fn; };
	    DefaultValueAccessor.prototype.registerOnTouched = function (fn) { this.onTouched = fn; };
	    /** @nocollapse */
	    DefaultValueAccessor.decorators = [
	        { type: core_1.Directive, args: [{
	                    selector: 'input:not([type=checkbox])[formControlName],textarea[formControlName],input:not([type=checkbox])[formControl],textarea[formControl],input:not([type=checkbox])[ngModel],textarea[ngModel],[ngDefaultControl]',
	                    // TODO: vsavkin replace the above selector with the one below it once
	                    // https://github.com/angular/angular/issues/3011 is implemented
	                    // selector: '[ngControl],[ngModel],[ngFormControl]',
	                    host: { '(input)': 'onChange($event.target.value)', '(blur)': 'onTouched()' },
	                    providers: [exports.DEFAULT_VALUE_ACCESSOR]
	                },] },
	    ];
	    /** @nocollapse */
	    DefaultValueAccessor.ctorParameters = [
	        { type: core_1.Renderer, },
	        { type: core_1.ElementRef, },
	    ];
	    return DefaultValueAccessor;
	}());
	exports.DefaultValueAccessor = DefaultValueAccessor;
	//# sourceMappingURL=default_value_accessor.js.map

/***/ },

/***/ 332:
9,

/***/ 333:
/***/ function(module, exports, __webpack_require__) {

	/**
	 * @license
	 * Copyright Google Inc. All Rights Reserved.
	 *
	 * Use of this source code is governed by an MIT-style license that can be
	 * found in the LICENSE file at https://angular.io/license
	 */
	"use strict";
	var core_1 = __webpack_require__(5);
	var lang_1 = __webpack_require__(332);
	var ng_control_1 = __webpack_require__(334);
	var NgControlStatus = (function () {
	    function NgControlStatus(cd) {
	        this._cd = cd;
	    }
	    Object.defineProperty(NgControlStatus.prototype, "ngClassUntouched", {
	        get: function () {
	            return lang_1.isPresent(this._cd.control) ? this._cd.control.untouched : false;
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(NgControlStatus.prototype, "ngClassTouched", {
	        get: function () {
	            return lang_1.isPresent(this._cd.control) ? this._cd.control.touched : false;
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(NgControlStatus.prototype, "ngClassPristine", {
	        get: function () {
	            return lang_1.isPresent(this._cd.control) ? this._cd.control.pristine : false;
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(NgControlStatus.prototype, "ngClassDirty", {
	        get: function () {
	            return lang_1.isPresent(this._cd.control) ? this._cd.control.dirty : false;
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(NgControlStatus.prototype, "ngClassValid", {
	        get: function () {
	            return lang_1.isPresent(this._cd.control) ? this._cd.control.valid : false;
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(NgControlStatus.prototype, "ngClassInvalid", {
	        get: function () {
	            return lang_1.isPresent(this._cd.control) ? !this._cd.control.valid : false;
	        },
	        enumerable: true,
	        configurable: true
	    });
	    /** @nocollapse */
	    NgControlStatus.decorators = [
	        { type: core_1.Directive, args: [{
	                    selector: '[formControlName],[ngModel],[formControl]',
	                    host: {
	                        '[class.ng-untouched]': 'ngClassUntouched',
	                        '[class.ng-touched]': 'ngClassTouched',
	                        '[class.ng-pristine]': 'ngClassPristine',
	                        '[class.ng-dirty]': 'ngClassDirty',
	                        '[class.ng-valid]': 'ngClassValid',
	                        '[class.ng-invalid]': 'ngClassInvalid'
	                    }
	                },] },
	    ];
	    /** @nocollapse */
	    NgControlStatus.ctorParameters = [
	        { type: ng_control_1.NgControl, decorators: [{ type: core_1.Self },] },
	    ];
	    return NgControlStatus;
	}());
	exports.NgControlStatus = NgControlStatus;
	//# sourceMappingURL=ng_control_status.js.map

/***/ },

/***/ 334:
/***/ function(module, exports, __webpack_require__) {

	/**
	 * @license
	 * Copyright Google Inc. All Rights Reserved.
	 *
	 * Use of this source code is governed by an MIT-style license that can be
	 * found in the LICENSE file at https://angular.io/license
	 */
	"use strict";
	var __extends = (this && this.__extends) || function (d, b) {
	    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
	    function __() { this.constructor = d; }
	    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	};
	var exceptions_1 = __webpack_require__(335);
	var abstract_control_directive_1 = __webpack_require__(339);
	/**
	 * A base class that all control directive extend.
	 * It binds a {@link Control} object to a DOM element.
	 *
	 * Used internally by Angular forms.
	 *
	 * @experimental
	 */
	var NgControl = (function (_super) {
	    __extends(NgControl, _super);
	    function NgControl() {
	        _super.apply(this, arguments);
	        this.name = null;
	        this.valueAccessor = null;
	    }
	    Object.defineProperty(NgControl.prototype, "validator", {
	        get: function () { return exceptions_1.unimplemented(); },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(NgControl.prototype, "asyncValidator", {
	        get: function () { return exceptions_1.unimplemented(); },
	        enumerable: true,
	        configurable: true
	    });
	    return NgControl;
	}(abstract_control_directive_1.AbstractControlDirective));
	exports.NgControl = NgControl;
	//# sourceMappingURL=ng_control.js.map

/***/ },

/***/ 335:
[1062, 336, 337, 337],

/***/ 336:
21,

/***/ 337:
[1063, 336, 338, 332],

/***/ 338:
[1064, 332],

/***/ 339:
/***/ function(module, exports, __webpack_require__) {

	/**
	 * @license
	 * Copyright Google Inc. All Rights Reserved.
	 *
	 * Use of this source code is governed by an MIT-style license that can be
	 * found in the LICENSE file at https://angular.io/license
	 */
	"use strict";
	var exceptions_1 = __webpack_require__(335);
	var lang_1 = __webpack_require__(332);
	/**
	 * Base class for control directives.
	 *
	 * Only used internally in the forms module.
	 *
	 * @experimental
	 */
	var AbstractControlDirective = (function () {
	    function AbstractControlDirective() {
	    }
	    Object.defineProperty(AbstractControlDirective.prototype, "control", {
	        get: function () { return exceptions_1.unimplemented(); },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(AbstractControlDirective.prototype, "value", {
	        get: function () { return lang_1.isPresent(this.control) ? this.control.value : null; },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(AbstractControlDirective.prototype, "valid", {
	        get: function () { return lang_1.isPresent(this.control) ? this.control.valid : null; },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(AbstractControlDirective.prototype, "errors", {
	        get: function () {
	            return lang_1.isPresent(this.control) ? this.control.errors : null;
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(AbstractControlDirective.prototype, "pristine", {
	        get: function () { return lang_1.isPresent(this.control) ? this.control.pristine : null; },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(AbstractControlDirective.prototype, "dirty", {
	        get: function () { return lang_1.isPresent(this.control) ? this.control.dirty : null; },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(AbstractControlDirective.prototype, "touched", {
	        get: function () { return lang_1.isPresent(this.control) ? this.control.touched : null; },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(AbstractControlDirective.prototype, "untouched", {
	        get: function () { return lang_1.isPresent(this.control) ? this.control.untouched : null; },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(AbstractControlDirective.prototype, "statusChanges", {
	        get: function () {
	            return lang_1.isPresent(this.control) ? this.control.statusChanges : null;
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(AbstractControlDirective.prototype, "valueChanges", {
	        get: function () {
	            return lang_1.isPresent(this.control) ? this.control.valueChanges : null;
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(AbstractControlDirective.prototype, "path", {
	        get: function () { return null; },
	        enumerable: true,
	        configurable: true
	    });
	    return AbstractControlDirective;
	}());
	exports.AbstractControlDirective = AbstractControlDirective;
	//# sourceMappingURL=abstract_control_directive.js.map

/***/ },

/***/ 340:
/***/ function(module, exports, __webpack_require__) {

	/**
	 * @license
	 * Copyright Google Inc. All Rights Reserved.
	 *
	 * Use of this source code is governed by an MIT-style license that can be
	 * found in the LICENSE file at https://angular.io/license
	 */
	"use strict";
	var __extends = (this && this.__extends) || function (d, b) {
	    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
	    function __() { this.constructor = d; }
	    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	};
	var core_1 = __webpack_require__(5);
	var async_1 = __webpack_require__(341);
	var collection_1 = __webpack_require__(338);
	var lang_1 = __webpack_require__(332);
	var model_1 = __webpack_require__(343);
	var validators_1 = __webpack_require__(345);
	var control_container_1 = __webpack_require__(351);
	var shared_1 = __webpack_require__(344);
	exports.formDirectiveProvider = 
	/*@ts2dart_const*/ { provide: control_container_1.ControlContainer, useExisting: core_1.forwardRef(function () { return NgForm; }) };
	var NgForm = (function (_super) {
	    __extends(NgForm, _super);
	    function NgForm(validators, asyncValidators) {
	        _super.call(this);
	        this._submitted = false;
	        this.ngSubmit = new async_1.EventEmitter();
	        this.form = new model_1.FormGroup({}, null, shared_1.composeValidators(validators), shared_1.composeAsyncValidators(asyncValidators));
	    }
	    Object.defineProperty(NgForm.prototype, "submitted", {
	        get: function () { return this._submitted; },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(NgForm.prototype, "formDirective", {
	        get: function () { return this; },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(NgForm.prototype, "control", {
	        get: function () { return this.form; },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(NgForm.prototype, "path", {
	        get: function () { return []; },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(NgForm.prototype, "controls", {
	        get: function () { return this.form.controls; },
	        enumerable: true,
	        configurable: true
	    });
	    NgForm.prototype.addControl = function (dir) {
	        var _this = this;
	        async_1.PromiseWrapper.scheduleMicrotask(function () {
	            var container = _this._findContainer(dir.path);
	            dir._control = container.registerControl(dir.name, dir.control);
	            shared_1.setUpControl(dir.control, dir);
	            dir.control.updateValueAndValidity({ emitEvent: false });
	        });
	    };
	    NgForm.prototype.getControl = function (dir) { return this.form.find(dir.path); };
	    NgForm.prototype.removeControl = function (dir) {
	        var _this = this;
	        async_1.PromiseWrapper.scheduleMicrotask(function () {
	            var container = _this._findContainer(dir.path);
	            if (lang_1.isPresent(container)) {
	                container.removeControl(dir.name);
	            }
	        });
	    };
	    NgForm.prototype.addFormGroup = function (dir) {
	        var _this = this;
	        async_1.PromiseWrapper.scheduleMicrotask(function () {
	            var container = _this._findContainer(dir.path);
	            var group = new model_1.FormGroup({});
	            shared_1.setUpFormContainer(group, dir);
	            container.registerControl(dir.name, group);
	            group.updateValueAndValidity({ emitEvent: false });
	        });
	    };
	    NgForm.prototype.removeFormGroup = function (dir) {
	        var _this = this;
	        async_1.PromiseWrapper.scheduleMicrotask(function () {
	            var container = _this._findContainer(dir.path);
	            if (lang_1.isPresent(container)) {
	                container.removeControl(dir.name);
	            }
	        });
	    };
	    NgForm.prototype.getFormGroup = function (dir) { return this.form.find(dir.path); };
	    NgForm.prototype.updateModel = function (dir, value) {
	        var _this = this;
	        async_1.PromiseWrapper.scheduleMicrotask(function () {
	            var ctrl = _this.form.find(dir.path);
	            ctrl.updateValue(value);
	        });
	    };
	    NgForm.prototype.onSubmit = function () {
	        this._submitted = true;
	        async_1.ObservableWrapper.callEmit(this.ngSubmit, null);
	        return false;
	    };
	    /** @internal */
	    NgForm.prototype._findContainer = function (path) {
	        path.pop();
	        return collection_1.ListWrapper.isEmpty(path) ? this.form : this.form.find(path);
	    };
	    /** @nocollapse */
	    NgForm.decorators = [
	        { type: core_1.Directive, args: [{
	                    selector: 'form:not([ngNoForm]):not([formGroup]),ngForm,[ngForm]',
	                    providers: [exports.formDirectiveProvider],
	                    host: {
	                        '(submit)': 'onSubmit()',
	                    },
	                    outputs: ['ngSubmit'],
	                    exportAs: 'ngForm'
	                },] },
	    ];
	    /** @nocollapse */
	    NgForm.ctorParameters = [
	        { type: Array, decorators: [{ type: core_1.Optional }, { type: core_1.Self }, { type: core_1.Inject, args: [validators_1.NG_VALIDATORS,] },] },
	        { type: Array, decorators: [{ type: core_1.Optional }, { type: core_1.Self }, { type: core_1.Inject, args: [validators_1.NG_ASYNC_VALIDATORS,] },] },
	    ];
	    return NgForm;
	}(control_container_1.ControlContainer));
	exports.NgForm = NgForm;
	//# sourceMappingURL=ng_form.js.map

/***/ },

/***/ 341:
[1065, 332, 342],

/***/ 342:
56,

/***/ 343:
/***/ function(module, exports, __webpack_require__) {

	/**
	 * @license
	 * Copyright Google Inc. All Rights Reserved.
	 *
	 * Use of this source code is governed by an MIT-style license that can be
	 * found in the LICENSE file at https://angular.io/license
	 */
	"use strict";
	var __extends = (this && this.__extends) || function (d, b) {
	    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
	    function __() { this.constructor = d; }
	    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	};
	var shared_1 = __webpack_require__(344);
	var async_1 = __webpack_require__(341);
	var collection_1 = __webpack_require__(338);
	var lang_1 = __webpack_require__(332);
	/**
	 * Indicates that a FormControl is valid, i.e. that no errors exist in the input value.
	 */
	exports.VALID = 'VALID';
	/**
	 * Indicates that a FormControl is invalid, i.e. that an error exists in the input value.
	 */
	exports.INVALID = 'INVALID';
	/**
	 * Indicates that a FormControl is pending, i.e. that async validation is occurring and
	 * errors are not yet available for the input value.
	 */
	exports.PENDING = 'PENDING';
	function isControl(control) {
	    return control instanceof AbstractControl;
	}
	exports.isControl = isControl;
	function _find(control, path) {
	    if (lang_1.isBlank(path))
	        return null;
	    if (!(path instanceof Array)) {
	        path = path.split('/');
	    }
	    if (path instanceof Array && collection_1.ListWrapper.isEmpty(path))
	        return null;
	    return path.reduce(function (v, name) {
	        if (v instanceof FormGroup) {
	            return lang_1.isPresent(v.controls[name]) ? v.controls[name] : null;
	        }
	        else if (v instanceof FormArray) {
	            var index = name;
	            return lang_1.isPresent(v.at(index)) ? v.at(index) : null;
	        }
	        else {
	            return null;
	        }
	    }, control);
	}
	function toObservable(r) {
	    return lang_1.isPromise(r) ? async_1.ObservableWrapper.fromPromise(r) : r;
	}
	function coerceToValidator(validator) {
	    return Array.isArray(validator) ? shared_1.composeValidators(validator) : validator;
	}
	function coerceToAsyncValidator(asyncValidator) {
	    return Array.isArray(asyncValidator) ? shared_1.composeAsyncValidators(asyncValidator) : asyncValidator;
	}
	/**
	 * @experimental
	 */
	var AbstractControl = (function () {
	    function AbstractControl(validator, asyncValidator) {
	        this.validator = validator;
	        this.asyncValidator = asyncValidator;
	        this._pristine = true;
	        this._touched = false;
	    }
	    Object.defineProperty(AbstractControl.prototype, "value", {
	        get: function () { return this._value; },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(AbstractControl.prototype, "status", {
	        get: function () { return this._status; },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(AbstractControl.prototype, "valid", {
	        get: function () { return this._status === exports.VALID; },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(AbstractControl.prototype, "errors", {
	        /**
	         * Returns the errors of this control.
	         */
	        get: function () { return this._errors; },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(AbstractControl.prototype, "pristine", {
	        get: function () { return this._pristine; },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(AbstractControl.prototype, "dirty", {
	        get: function () { return !this.pristine; },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(AbstractControl.prototype, "touched", {
	        get: function () { return this._touched; },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(AbstractControl.prototype, "untouched", {
	        get: function () { return !this._touched; },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(AbstractControl.prototype, "valueChanges", {
	        get: function () { return this._valueChanges; },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(AbstractControl.prototype, "statusChanges", {
	        get: function () { return this._statusChanges; },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(AbstractControl.prototype, "pending", {
	        get: function () { return this._status == exports.PENDING; },
	        enumerable: true,
	        configurable: true
	    });
	    AbstractControl.prototype.setAsyncValidators = function (newValidator) {
	        this.asyncValidator = coerceToAsyncValidator(newValidator);
	    };
	    AbstractControl.prototype.clearAsyncValidators = function () { this.asyncValidator = null; };
	    AbstractControl.prototype.setValidators = function (newValidator) {
	        this.validator = coerceToValidator(newValidator);
	    };
	    AbstractControl.prototype.clearValidators = function () { this.validator = null; };
	    AbstractControl.prototype.markAsTouched = function () { this._touched = true; };
	    AbstractControl.prototype.markAsDirty = function (_a) {
	        var onlySelf = (_a === void 0 ? {} : _a).onlySelf;
	        onlySelf = lang_1.normalizeBool(onlySelf);
	        this._pristine = false;
	        if (lang_1.isPresent(this._parent) && !onlySelf) {
	            this._parent.markAsDirty({ onlySelf: onlySelf });
	        }
	    };
	    AbstractControl.prototype.markAsPending = function (_a) {
	        var onlySelf = (_a === void 0 ? {} : _a).onlySelf;
	        onlySelf = lang_1.normalizeBool(onlySelf);
	        this._status = exports.PENDING;
	        if (lang_1.isPresent(this._parent) && !onlySelf) {
	            this._parent.markAsPending({ onlySelf: onlySelf });
	        }
	    };
	    AbstractControl.prototype.setParent = function (parent) { this._parent = parent; };
	    AbstractControl.prototype.updateValueAndValidity = function (_a) {
	        var _b = _a === void 0 ? {} : _a, onlySelf = _b.onlySelf, emitEvent = _b.emitEvent;
	        onlySelf = lang_1.normalizeBool(onlySelf);
	        emitEvent = lang_1.isPresent(emitEvent) ? emitEvent : true;
	        this._updateValue();
	        this._errors = this._runValidator();
	        this._status = this._calculateStatus();
	        if (this._status == exports.VALID || this._status == exports.PENDING) {
	            this._runAsyncValidator(emitEvent);
	        }
	        if (emitEvent) {
	            async_1.ObservableWrapper.callEmit(this._valueChanges, this._value);
	            async_1.ObservableWrapper.callEmit(this._statusChanges, this._status);
	        }
	        if (lang_1.isPresent(this._parent) && !onlySelf) {
	            this._parent.updateValueAndValidity({ onlySelf: onlySelf, emitEvent: emitEvent });
	        }
	    };
	    AbstractControl.prototype._runValidator = function () {
	        return lang_1.isPresent(this.validator) ? this.validator(this) : null;
	    };
	    AbstractControl.prototype._runAsyncValidator = function (emitEvent) {
	        var _this = this;
	        if (lang_1.isPresent(this.asyncValidator)) {
	            this._status = exports.PENDING;
	            this._cancelExistingSubscription();
	            var obs = toObservable(this.asyncValidator(this));
	            this._asyncValidationSubscription = async_1.ObservableWrapper.subscribe(obs, function (res) { return _this.setErrors(res, { emitEvent: emitEvent }); });
	        }
	    };
	    AbstractControl.prototype._cancelExistingSubscription = function () {
	        if (lang_1.isPresent(this._asyncValidationSubscription)) {
	            async_1.ObservableWrapper.dispose(this._asyncValidationSubscription);
	        }
	    };
	    /**
	     * Sets errors on a form control.
	     *
	     * This is used when validations are run not automatically, but manually by the user.
	     *
	     * Calling `setErrors` will also update the validity of the parent control.
	     *
	     * ## Usage
	     *
	     * ```
	     * var login = new FormControl("someLogin");
	     * login.setErrors({
	     *   "notUnique": true
	     * });
	     *
	     * expect(login.valid).toEqual(false);
	     * expect(login.errors).toEqual({"notUnique": true});
	     *
	     * login.updateValue("someOtherLogin");
	     *
	     * expect(login.valid).toEqual(true);
	     * ```
	     */
	    AbstractControl.prototype.setErrors = function (errors, _a) {
	        var emitEvent = (_a === void 0 ? {} : _a).emitEvent;
	        emitEvent = lang_1.isPresent(emitEvent) ? emitEvent : true;
	        this._errors = errors;
	        this._updateControlsErrors(emitEvent);
	    };
	    AbstractControl.prototype.find = function (path) { return _find(this, path); };
	    AbstractControl.prototype.getError = function (errorCode, path) {
	        if (path === void 0) { path = null; }
	        var control = lang_1.isPresent(path) && !collection_1.ListWrapper.isEmpty(path) ? this.find(path) : this;
	        if (lang_1.isPresent(control) && lang_1.isPresent(control._errors)) {
	            return collection_1.StringMapWrapper.get(control._errors, errorCode);
	        }
	        else {
	            return null;
	        }
	    };
	    AbstractControl.prototype.hasError = function (errorCode, path) {
	        if (path === void 0) { path = null; }
	        return lang_1.isPresent(this.getError(errorCode, path));
	    };
	    Object.defineProperty(AbstractControl.prototype, "root", {
	        get: function () {
	            var x = this;
	            while (lang_1.isPresent(x._parent)) {
	                x = x._parent;
	            }
	            return x;
	        },
	        enumerable: true,
	        configurable: true
	    });
	    /** @internal */
	    AbstractControl.prototype._updateControlsErrors = function (emitEvent) {
	        this._status = this._calculateStatus();
	        if (emitEvent) {
	            async_1.ObservableWrapper.callEmit(this._statusChanges, this._status);
	        }
	        if (lang_1.isPresent(this._parent)) {
	            this._parent._updateControlsErrors(emitEvent);
	        }
	    };
	    /** @internal */
	    AbstractControl.prototype._initObservables = function () {
	        this._valueChanges = new async_1.EventEmitter();
	        this._statusChanges = new async_1.EventEmitter();
	    };
	    AbstractControl.prototype._calculateStatus = function () {
	        if (lang_1.isPresent(this._errors))
	            return exports.INVALID;
	        if (this._anyControlsHaveStatus(exports.PENDING))
	            return exports.PENDING;
	        if (this._anyControlsHaveStatus(exports.INVALID))
	            return exports.INVALID;
	        return exports.VALID;
	    };
	    return AbstractControl;
	}());
	exports.AbstractControl = AbstractControl;
	/**
	 * Defines a part of a form that cannot be divided into other controls. `FormControl`s have values
	 * and
	 * validation state, which is determined by an optional validation function.
	 *
	 * `FormControl` is one of the three fundamental building blocks used to define forms in Angular,
	 * along
	 * with {@link FormGroup} and {@link FormArray}.
	 *
	 * ## Usage
	 *
	 * By default, a `FormControl` is created for every `<input>` or other form component.
	 * With {@link FormControlDirective} or {@link FormGroupDirective} an existing {@link FormControl}
	 * can be bound to a DOM element instead. This `FormControl` can be configured with a custom
	 * validation function.
	 *
	 * @experimental
	 */
	var FormControl = (function (_super) {
	    __extends(FormControl, _super);
	    function FormControl(value, validator, asyncValidator) {
	        if (value === void 0) { value = null; }
	        if (validator === void 0) { validator = null; }
	        if (asyncValidator === void 0) { asyncValidator = null; }
	        _super.call(this, coerceToValidator(validator), coerceToAsyncValidator(asyncValidator));
	        /** @internal */
	        this._onChange = [];
	        this._value = value;
	        this.updateValueAndValidity({ onlySelf: true, emitEvent: false });
	        this._initObservables();
	    }
	    /**
	     * Set the value of the form control to `value`.
	     *
	     * If `onlySelf` is `true`, this change will only affect the validation of this `FormControl`
	     * and not its parent component. If `emitEvent` is `true`, this change will cause a
	     * `valueChanges` event on the `FormControl` to be emitted. Both of these options default to
	     * `false`.
	     *
	     * If `emitModelToViewChange` is `true`, the view will be notified about the new value
	     * via an `onChange` event. This is the default behavior if `emitModelToViewChange` is not
	     * specified.
	     */
	    FormControl.prototype.updateValue = function (value, _a) {
	        var _this = this;
	        var _b = _a === void 0 ? {} : _a, onlySelf = _b.onlySelf, emitEvent = _b.emitEvent, emitModelToViewChange = _b.emitModelToViewChange;
	        emitModelToViewChange = lang_1.isPresent(emitModelToViewChange) ? emitModelToViewChange : true;
	        this._value = value;
	        if (this._onChange.length && emitModelToViewChange) {
	            this._onChange.forEach(function (changeFn) { return changeFn(_this._value); });
	        }
	        this.updateValueAndValidity({ onlySelf: onlySelf, emitEvent: emitEvent });
	    };
	    /**
	     * @internal
	     */
	    FormControl.prototype._updateValue = function () { };
	    /**
	     * @internal
	     */
	    FormControl.prototype._anyControlsHaveStatus = function (status) { return false; };
	    /**
	     * Register a listener for change events.
	     */
	    FormControl.prototype.registerOnChange = function (fn) { this._onChange.push(fn); };
	    return FormControl;
	}(AbstractControl));
	exports.FormControl = FormControl;
	/**
	 * Defines a part of a form, of fixed length, that can contain other controls.
	 *
	 * A `FormGroup` aggregates the values of each {@link FormControl} in the group.
	 * The status of a `FormGroup` depends on the status of its children.
	 * If one of the controls in a group is invalid, the entire group is invalid.
	 * Similarly, if a control changes its value, the entire group changes as well.
	 *
	 * `FormGroup` is one of the three fundamental building blocks used to define forms in Angular,
	 * along with {@link FormControl} and {@link FormArray}. {@link FormArray} can also contain other
	 * controls, but is of variable length.
	 *
	 * ### Example ([live demo](http://plnkr.co/edit/23DESOpbNnBpBHZt1BR4?p=preview))
	 *
	 * @experimental
	 */
	var FormGroup = (function (_super) {
	    __extends(FormGroup, _super);
	    function FormGroup(controls, optionals, validator, asyncValidator) {
	        if (optionals === void 0) { optionals = null; }
	        if (validator === void 0) { validator = null; }
	        if (asyncValidator === void 0) { asyncValidator = null; }
	        _super.call(this, validator, asyncValidator);
	        this.controls = controls;
	        this._optionals = lang_1.isPresent(optionals) ? optionals : {};
	        this._initObservables();
	        this._setParentForControls();
	        this.updateValueAndValidity({ onlySelf: true, emitEvent: false });
	    }
	    /**
	     * Register a control with the group's list of controls.
	     */
	    FormGroup.prototype.registerControl = function (name, control) {
	        if (this.controls[name])
	            return this.controls[name];
	        this.controls[name] = control;
	        control.setParent(this);
	        return control;
	    };
	    /**
	     * Add a control to this group.
	     */
	    FormGroup.prototype.addControl = function (name, control) {
	        this.registerControl(name, control);
	        this.updateValueAndValidity();
	    };
	    /**
	     * Remove a control from this group.
	     */
	    FormGroup.prototype.removeControl = function (name) {
	        collection_1.StringMapWrapper.delete(this.controls, name);
	        this.updateValueAndValidity();
	    };
	    /**
	     * Mark the named control as non-optional.
	     */
	    FormGroup.prototype.include = function (controlName) {
	        collection_1.StringMapWrapper.set(this._optionals, controlName, true);
	        this.updateValueAndValidity();
	    };
	    /**
	     * Mark the named control as optional.
	     */
	    FormGroup.prototype.exclude = function (controlName) {
	        collection_1.StringMapWrapper.set(this._optionals, controlName, false);
	        this.updateValueAndValidity();
	    };
	    /**
	     * Check whether there is a control with the given name in the group.
	     */
	    FormGroup.prototype.contains = function (controlName) {
	        var c = collection_1.StringMapWrapper.contains(this.controls, controlName);
	        return c && this._included(controlName);
	    };
	    /** @internal */
	    FormGroup.prototype._setParentForControls = function () {
	        var _this = this;
	        collection_1.StringMapWrapper.forEach(this.controls, function (control, name) { control.setParent(_this); });
	    };
	    /** @internal */
	    FormGroup.prototype._updateValue = function () { this._value = this._reduceValue(); };
	    /** @internal */
	    FormGroup.prototype._anyControlsHaveStatus = function (status) {
	        var _this = this;
	        var res = false;
	        collection_1.StringMapWrapper.forEach(this.controls, function (control, name) {
	            res = res || (_this.contains(name) && control.status == status);
	        });
	        return res;
	    };
	    /** @internal */
	    FormGroup.prototype._reduceValue = function () {
	        return this._reduceChildren({}, function (acc, control, name) {
	            acc[name] = control.value;
	            return acc;
	        });
	    };
	    /** @internal */
	    FormGroup.prototype._reduceChildren = function (initValue, fn) {
	        var _this = this;
	        var res = initValue;
	        collection_1.StringMapWrapper.forEach(this.controls, function (control, name) {
	            if (_this._included(name)) {
	                res = fn(res, control, name);
	            }
	        });
	        return res;
	    };
	    /** @internal */
	    FormGroup.prototype._included = function (controlName) {
	        var isOptional = collection_1.StringMapWrapper.contains(this._optionals, controlName);
	        return !isOptional || collection_1.StringMapWrapper.get(this._optionals, controlName);
	    };
	    return FormGroup;
	}(AbstractControl));
	exports.FormGroup = FormGroup;
	/**
	 * Defines a part of a form, of variable length, that can contain other controls.
	 *
	 * A `FormArray` aggregates the values of each {@link FormControl} in the group.
	 * The status of a `FormArray` depends on the status of its children.
	 * If one of the controls in a group is invalid, the entire array is invalid.
	 * Similarly, if a control changes its value, the entire array changes as well.
	 *
	 * `FormArray` is one of the three fundamental building blocks used to define forms in Angular,
	 * along with {@link FormControl} and {@link FormGroup}. {@link FormGroup} can also contain
	 * other controls, but is of fixed length.
	 *
	 * ## Adding or removing controls
	 *
	 * To change the controls in the array, use the `push`, `insert`, or `removeAt` methods
	 * in `FormArray` itself. These methods ensure the controls are properly tracked in the
	 * form's hierarchy. Do not modify the array of `AbstractControl`s used to instantiate
	 * the `FormArray` directly, as that will result in strange and unexpected behavior such
	 * as broken change detection.
	 *
	 * ### Example ([live demo](http://plnkr.co/edit/23DESOpbNnBpBHZt1BR4?p=preview))
	 *
	 * @experimental
	 */
	var FormArray = (function (_super) {
	    __extends(FormArray, _super);
	    function FormArray(controls, validator, asyncValidator) {
	        if (validator === void 0) { validator = null; }
	        if (asyncValidator === void 0) { asyncValidator = null; }
	        _super.call(this, validator, asyncValidator);
	        this.controls = controls;
	        this._initObservables();
	        this._setParentForControls();
	        this.updateValueAndValidity({ onlySelf: true, emitEvent: false });
	    }
	    /**
	     * Get the {@link AbstractControl} at the given `index` in the array.
	     */
	    FormArray.prototype.at = function (index) { return this.controls[index]; };
	    /**
	     * Insert a new {@link AbstractControl} at the end of the array.
	     */
	    FormArray.prototype.push = function (control) {
	        this.controls.push(control);
	        control.setParent(this);
	        this.updateValueAndValidity();
	    };
	    /**
	     * Insert a new {@link AbstractControl} at the given `index` in the array.
	     */
	    FormArray.prototype.insert = function (index, control) {
	        collection_1.ListWrapper.insert(this.controls, index, control);
	        control.setParent(this);
	        this.updateValueAndValidity();
	    };
	    /**
	     * Remove the control at the given `index` in the array.
	     */
	    FormArray.prototype.removeAt = function (index) {
	        collection_1.ListWrapper.removeAt(this.controls, index);
	        this.updateValueAndValidity();
	    };
	    Object.defineProperty(FormArray.prototype, "length", {
	        /**
	         * Length of the control array.
	         */
	        get: function () { return this.controls.length; },
	        enumerable: true,
	        configurable: true
	    });
	    /** @internal */
	    FormArray.prototype._updateValue = function () { this._value = this.controls.map(function (control) { return control.value; }); };
	    /** @internal */
	    FormArray.prototype._anyControlsHaveStatus = function (status) {
	        return this.controls.some(function (c) { return c.status == status; });
	    };
	    /** @internal */
	    FormArray.prototype._setParentForControls = function () {
	        var _this = this;
	        this.controls.forEach(function (control) { control.setParent(_this); });
	    };
	    return FormArray;
	}(AbstractControl));
	exports.FormArray = FormArray;
	//# sourceMappingURL=model.js.map

/***/ },

/***/ 344:
/***/ function(module, exports, __webpack_require__) {

	/**
	 * @license
	 * Copyright Google Inc. All Rights Reserved.
	 *
	 * Use of this source code is governed by an MIT-style license that can be
	 * found in the LICENSE file at https://angular.io/license
	 */
	"use strict";
	var collection_1 = __webpack_require__(338);
	var exceptions_1 = __webpack_require__(335);
	var lang_1 = __webpack_require__(332);
	var validators_1 = __webpack_require__(345);
	var checkbox_value_accessor_1 = __webpack_require__(329);
	var default_value_accessor_1 = __webpack_require__(331);
	var normalize_validator_1 = __webpack_require__(346);
	var number_value_accessor_1 = __webpack_require__(347);
	var radio_control_value_accessor_1 = __webpack_require__(348);
	var select_control_value_accessor_1 = __webpack_require__(349);
	var select_multiple_control_value_accessor_1 = __webpack_require__(350);
	function controlPath(name, parent) {
	    var p = collection_1.ListWrapper.clone(parent.path);
	    p.push(name);
	    return p;
	}
	exports.controlPath = controlPath;
	function setUpControl(control, dir) {
	    if (lang_1.isBlank(control))
	        _throwError(dir, 'Cannot find control');
	    if (lang_1.isBlank(dir.valueAccessor))
	        _throwError(dir, 'No value accessor for');
	    control.validator = validators_1.Validators.compose([control.validator, dir.validator]);
	    control.asyncValidator = validators_1.Validators.composeAsync([control.asyncValidator, dir.asyncValidator]);
	    dir.valueAccessor.writeValue(control.value);
	    // view -> model
	    dir.valueAccessor.registerOnChange(function (newValue) {
	        dir.viewToModelUpdate(newValue);
	        control.updateValue(newValue, { emitModelToViewChange: false });
	        control.markAsDirty();
	    });
	    // model -> view
	    control.registerOnChange(function (newValue) { return dir.valueAccessor.writeValue(newValue); });
	    // touched
	    dir.valueAccessor.registerOnTouched(function () { return control.markAsTouched(); });
	}
	exports.setUpControl = setUpControl;
	function setUpFormContainer(control, dir) {
	    if (lang_1.isBlank(control))
	        _throwError(dir, 'Cannot find control');
	    control.validator = validators_1.Validators.compose([control.validator, dir.validator]);
	    control.asyncValidator = validators_1.Validators.composeAsync([control.asyncValidator, dir.asyncValidator]);
	}
	exports.setUpFormContainer = setUpFormContainer;
	function _throwError(dir, message) {
	    var path = dir.path.join(' -> ');
	    throw new exceptions_1.BaseException(message + " '" + path + "'");
	}
	function composeValidators(validators) {
	    return lang_1.isPresent(validators) ? validators_1.Validators.compose(validators.map(normalize_validator_1.normalizeValidator)) : null;
	}
	exports.composeValidators = composeValidators;
	function composeAsyncValidators(validators) {
	    return lang_1.isPresent(validators) ? validators_1.Validators.composeAsync(validators.map(normalize_validator_1.normalizeAsyncValidator)) :
	        null;
	}
	exports.composeAsyncValidators = composeAsyncValidators;
	function isPropertyUpdated(changes, viewModel) {
	    if (!collection_1.StringMapWrapper.contains(changes, 'model'))
	        return false;
	    var change = changes['model'];
	    if (change.isFirstChange())
	        return true;
	    return !lang_1.looseIdentical(viewModel, change.currentValue);
	}
	exports.isPropertyUpdated = isPropertyUpdated;
	// TODO: vsavkin remove it once https://github.com/angular/angular/issues/3011 is implemented
	function selectValueAccessor(dir, valueAccessors) {
	    if (lang_1.isBlank(valueAccessors))
	        return null;
	    var defaultAccessor;
	    var builtinAccessor;
	    var customAccessor;
	    valueAccessors.forEach(function (v) {
	        if (lang_1.hasConstructor(v, default_value_accessor_1.DefaultValueAccessor)) {
	            defaultAccessor = v;
	        }
	        else if (lang_1.hasConstructor(v, checkbox_value_accessor_1.CheckboxControlValueAccessor) || lang_1.hasConstructor(v, number_value_accessor_1.NumberValueAccessor) ||
	            lang_1.hasConstructor(v, select_control_value_accessor_1.SelectControlValueAccessor) ||
	            lang_1.hasConstructor(v, select_multiple_control_value_accessor_1.SelectMultipleControlValueAccessor) ||
	            lang_1.hasConstructor(v, radio_control_value_accessor_1.RadioControlValueAccessor)) {
	            if (lang_1.isPresent(builtinAccessor))
	                _throwError(dir, 'More than one built-in value accessor matches');
	            builtinAccessor = v;
	        }
	        else {
	            if (lang_1.isPresent(customAccessor))
	                _throwError(dir, 'More than one custom value accessor matches');
	            customAccessor = v;
	        }
	    });
	    if (lang_1.isPresent(customAccessor))
	        return customAccessor;
	    if (lang_1.isPresent(builtinAccessor))
	        return builtinAccessor;
	    if (lang_1.isPresent(defaultAccessor))
	        return defaultAccessor;
	    _throwError(dir, 'No valid value accessor for');
	    return null;
	}
	exports.selectValueAccessor = selectValueAccessor;
	//# sourceMappingURL=shared.js.map

/***/ },

/***/ 345:
/***/ function(module, exports, __webpack_require__) {

	/**
	 * @license
	 * Copyright Google Inc. All Rights Reserved.
	 *
	 * Use of this source code is governed by an MIT-style license that can be
	 * found in the LICENSE file at https://angular.io/license
	 */
	"use strict";
	var core_1 = __webpack_require__(5);
	var async_1 = __webpack_require__(341);
	var collection_1 = __webpack_require__(338);
	var lang_1 = __webpack_require__(332);
	var promise_1 = __webpack_require__(342);
	/**
	 * Providers for validators to be used for {@link FormControl}s in a form.
	 *
	 * Provide this using `multi: true` to add validators.
	 *
	 * ### Example
	 *
	 * {@example core/forms/ts/ng_validators/ng_validators.ts region='ng_validators'}
	 * @experimental
	 */
	exports.NG_VALIDATORS = new core_1.OpaqueToken('NgValidators');
	/**
	 * Providers for asynchronous validators to be used for {@link FormControl}s
	 * in a form.
	 *
	 * Provide this using `multi: true` to add validators.
	 *
	 * See {@link NG_VALIDATORS} for more details.
	 *
	 * @experimental
	 */
	exports.NG_ASYNC_VALIDATORS = 
	/*@ts2dart_const*/ new core_1.OpaqueToken('NgAsyncValidators');
	/**
	 * Provides a set of validators used by form controls.
	 *
	 * A validator is a function that processes a {@link FormControl} or collection of
	 * controls and returns a map of errors. A null map means that validation has passed.
	 *
	 * ### Example
	 *
	 * ```typescript
	 * var loginControl = new FormControl("", Validators.required)
	 * ```
	 *
	 * @experimental
	 */
	var Validators = (function () {
	    function Validators() {
	    }
	    /**
	     * Validator that requires controls to have a non-empty value.
	     */
	    Validators.required = function (control) {
	        return lang_1.isBlank(control.value) || (lang_1.isString(control.value) && control.value == '') ?
	            { 'required': true } :
	            null;
	    };
	    /**
	     * Validator that requires controls to have a value of a minimum length.
	     */
	    Validators.minLength = function (minLength) {
	        return function (control) {
	            if (lang_1.isPresent(Validators.required(control)))
	                return null;
	            var v = control.value;
	            return v.length < minLength ?
	                { 'minlength': { 'requiredLength': minLength, 'actualLength': v.length } } :
	                null;
	        };
	    };
	    /**
	     * Validator that requires controls to have a value of a maximum length.
	     */
	    Validators.maxLength = function (maxLength) {
	        return function (control) {
	            if (lang_1.isPresent(Validators.required(control)))
	                return null;
	            var v = control.value;
	            return v.length > maxLength ?
	                { 'maxlength': { 'requiredLength': maxLength, 'actualLength': v.length } } :
	                null;
	        };
	    };
	    /**
	     * Validator that requires a control to match a regex to its value.
	     */
	    Validators.pattern = function (pattern) {
	        return function (control) {
	            if (lang_1.isPresent(Validators.required(control)))
	                return null;
	            var regex = new RegExp("^" + pattern + "$");
	            var v = control.value;
	            return regex.test(v) ? null :
	                { 'pattern': { 'requiredPattern': "^" + pattern + "$", 'actualValue': v } };
	        };
	    };
	    /**
	     * No-op validator.
	     */
	    Validators.nullValidator = function (c) { return null; };
	    /**
	     * Compose multiple validators into a single function that returns the union
	     * of the individual error maps.
	     */
	    Validators.compose = function (validators) {
	        if (lang_1.isBlank(validators))
	            return null;
	        var presentValidators = validators.filter(lang_1.isPresent);
	        if (presentValidators.length == 0)
	            return null;
	        return function (control) {
	            return _mergeErrors(_executeValidators(control, presentValidators));
	        };
	    };
	    Validators.composeAsync = function (validators) {
	        if (lang_1.isBlank(validators))
	            return null;
	        var presentValidators = validators.filter(lang_1.isPresent);
	        if (presentValidators.length == 0)
	            return null;
	        return function (control) {
	            var promises = _executeAsyncValidators(control, presentValidators).map(_convertToPromise);
	            return promise_1.PromiseWrapper.all(promises).then(_mergeErrors);
	        };
	    };
	    return Validators;
	}());
	exports.Validators = Validators;
	function _convertToPromise(obj) {
	    return lang_1.isPromise(obj) ? obj : async_1.ObservableWrapper.toPromise(obj);
	}
	function _executeValidators(control, validators) {
	    return validators.map(function (v) { return v(control); });
	}
	function _executeAsyncValidators(control, validators) {
	    return validators.map(function (v) { return v(control); });
	}
	function _mergeErrors(arrayOfErrors) {
	    var res = arrayOfErrors.reduce(function (res, errors) {
	        return lang_1.isPresent(errors) ? collection_1.StringMapWrapper.merge(res, errors) : res;
	    }, {});
	    return collection_1.StringMapWrapper.isEmpty(res) ? null : res;
	}
	//# sourceMappingURL=validators.js.map

/***/ },

/***/ 346:
156,

/***/ 347:
/***/ function(module, exports, __webpack_require__) {

	/**
	 * @license
	 * Copyright Google Inc. All Rights Reserved.
	 *
	 * Use of this source code is governed by an MIT-style license that can be
	 * found in the LICENSE file at https://angular.io/license
	 */
	"use strict";
	var core_1 = __webpack_require__(5);
	var lang_1 = __webpack_require__(332);
	var control_value_accessor_1 = __webpack_require__(330);
	exports.NUMBER_VALUE_ACCESSOR = {
	    provide: control_value_accessor_1.NG_VALUE_ACCESSOR,
	    useExisting: core_1.forwardRef(function () { return NumberValueAccessor; }),
	    multi: true
	};
	var NumberValueAccessor = (function () {
	    function NumberValueAccessor(_renderer, _elementRef) {
	        this._renderer = _renderer;
	        this._elementRef = _elementRef;
	        this.onChange = function (_) { };
	        this.onTouched = function () { };
	    }
	    NumberValueAccessor.prototype.writeValue = function (value) {
	        this._renderer.setElementProperty(this._elementRef.nativeElement, 'value', value);
	    };
	    NumberValueAccessor.prototype.registerOnChange = function (fn) {
	        this.onChange = function (value) { fn(value == '' ? null : lang_1.NumberWrapper.parseFloat(value)); };
	    };
	    NumberValueAccessor.prototype.registerOnTouched = function (fn) { this.onTouched = fn; };
	    /** @nocollapse */
	    NumberValueAccessor.decorators = [
	        { type: core_1.Directive, args: [{
	                    selector: 'input[type=number][formControlName],input[type=number][formControl],input[type=number][ngModel]',
	                    host: {
	                        '(change)': 'onChange($event.target.value)',
	                        '(input)': 'onChange($event.target.value)',
	                        '(blur)': 'onTouched()'
	                    },
	                    providers: [exports.NUMBER_VALUE_ACCESSOR]
	                },] },
	    ];
	    /** @nocollapse */
	    NumberValueAccessor.ctorParameters = [
	        { type: core_1.Renderer, },
	        { type: core_1.ElementRef, },
	    ];
	    return NumberValueAccessor;
	}());
	exports.NumberValueAccessor = NumberValueAccessor;
	//# sourceMappingURL=number_value_accessor.js.map

/***/ },

/***/ 348:
/***/ function(module, exports, __webpack_require__) {

	/**
	 * @license
	 * Copyright Google Inc. All Rights Reserved.
	 *
	 * Use of this source code is governed by an MIT-style license that can be
	 * found in the LICENSE file at https://angular.io/license
	 */
	"use strict";
	var core_1 = __webpack_require__(5);
	var collection_1 = __webpack_require__(338);
	var exceptions_1 = __webpack_require__(335);
	var lang_1 = __webpack_require__(332);
	var control_value_accessor_1 = __webpack_require__(330);
	var ng_control_1 = __webpack_require__(334);
	exports.RADIO_VALUE_ACCESSOR = {
	    provide: control_value_accessor_1.NG_VALUE_ACCESSOR,
	    useExisting: core_1.forwardRef(function () { return RadioControlValueAccessor; }),
	    multi: true
	};
	var RadioControlRegistry = (function () {
	    function RadioControlRegistry() {
	        this._accessors = [];
	    }
	    RadioControlRegistry.prototype.add = function (control, accessor) {
	        this._accessors.push([control, accessor]);
	    };
	    RadioControlRegistry.prototype.remove = function (accessor) {
	        var indexToRemove = -1;
	        for (var i = 0; i < this._accessors.length; ++i) {
	            if (this._accessors[i][1] === accessor) {
	                indexToRemove = i;
	            }
	        }
	        collection_1.ListWrapper.removeAt(this._accessors, indexToRemove);
	    };
	    RadioControlRegistry.prototype.select = function (accessor) {
	        var _this = this;
	        this._accessors.forEach(function (c) {
	            if (_this._isSameGroup(c, accessor) && c[1] !== accessor) {
	                c[1].fireUncheck(accessor.value);
	            }
	        });
	    };
	    RadioControlRegistry.prototype._isSameGroup = function (controlPair, accessor) {
	        if (!controlPair[0].control)
	            return false;
	        return controlPair[0].control.root === accessor._control.control.root &&
	            controlPair[1].name === accessor.name;
	    };
	    /** @nocollapse */
	    RadioControlRegistry.decorators = [
	        { type: core_1.Injectable },
	    ];
	    return RadioControlRegistry;
	}());
	exports.RadioControlRegistry = RadioControlRegistry;
	var RadioControlValueAccessor = (function () {
	    function RadioControlValueAccessor(_renderer, _elementRef, _registry, _injector) {
	        this._renderer = _renderer;
	        this._elementRef = _elementRef;
	        this._registry = _registry;
	        this._injector = _injector;
	        this.onChange = function () { };
	        this.onTouched = function () { };
	    }
	    RadioControlValueAccessor.prototype.ngOnInit = function () {
	        this._control = this._injector.get(ng_control_1.NgControl);
	        this._checkName();
	        this._registry.add(this._control, this);
	    };
	    RadioControlValueAccessor.prototype.ngOnDestroy = function () { this._registry.remove(this); };
	    RadioControlValueAccessor.prototype.writeValue = function (value) {
	        this._state = value === this.value;
	        if (lang_1.isPresent(value)) {
	            this._renderer.setElementProperty(this._elementRef.nativeElement, 'checked', this._state);
	        }
	    };
	    RadioControlValueAccessor.prototype.registerOnChange = function (fn) {
	        var _this = this;
	        this._fn = fn;
	        this.onChange = function () {
	            fn(_this.value);
	            _this._registry.select(_this);
	        };
	    };
	    RadioControlValueAccessor.prototype.fireUncheck = function (value) { this.writeValue(value); };
	    RadioControlValueAccessor.prototype.registerOnTouched = function (fn) { this.onTouched = fn; };
	    RadioControlValueAccessor.prototype._checkName = function () {
	        if (this.name && this.formControlName && this.name !== this.formControlName) {
	            this._throwNameError();
	        }
	        if (!this.name && this.formControlName)
	            this.name = this.formControlName;
	    };
	    RadioControlValueAccessor.prototype._throwNameError = function () {
	        throw new exceptions_1.BaseException("\n      If you define both a name and a formControlName attribute on your radio button, their values\n      must match. Ex: <input type=\"radio\" formControlName=\"food\" name=\"food\">\n    ");
	    };
	    /** @nocollapse */
	    RadioControlValueAccessor.decorators = [
	        { type: core_1.Directive, args: [{
	                    selector: 'input[type=radio][formControlName],input[type=radio][formControl],input[type=radio][ngModel]',
	                    host: { '(change)': 'onChange()', '(blur)': 'onTouched()' },
	                    providers: [exports.RADIO_VALUE_ACCESSOR]
	                },] },
	    ];
	    /** @nocollapse */
	    RadioControlValueAccessor.ctorParameters = [
	        { type: core_1.Renderer, },
	        { type: core_1.ElementRef, },
	        { type: RadioControlRegistry, },
	        { type: core_1.Injector, },
	    ];
	    /** @nocollapse */
	    RadioControlValueAccessor.propDecorators = {
	        'name': [{ type: core_1.Input },],
	        'formControlName': [{ type: core_1.Input },],
	        'value': [{ type: core_1.Input },],
	    };
	    return RadioControlValueAccessor;
	}());
	exports.RadioControlValueAccessor = RadioControlValueAccessor;
	//# sourceMappingURL=radio_control_value_accessor.js.map

/***/ },

/***/ 349:
/***/ function(module, exports, __webpack_require__) {

	/**
	 * @license
	 * Copyright Google Inc. All Rights Reserved.
	 *
	 * Use of this source code is governed by an MIT-style license that can be
	 * found in the LICENSE file at https://angular.io/license
	 */
	"use strict";
	var core_1 = __webpack_require__(5);
	var collection_1 = __webpack_require__(338);
	var lang_1 = __webpack_require__(332);
	var control_value_accessor_1 = __webpack_require__(330);
	exports.SELECT_VALUE_ACCESSOR = {
	    provide: control_value_accessor_1.NG_VALUE_ACCESSOR,
	    useExisting: core_1.forwardRef(function () { return SelectControlValueAccessor; }),
	    multi: true
	};
	function _buildValueString(id, value) {
	    if (lang_1.isBlank(id))
	        return "" + value;
	    if (!lang_1.isPrimitive(value))
	        value = 'Object';
	    return lang_1.StringWrapper.slice(id + ": " + value, 0, 50);
	}
	function _extractId(valueString) {
	    return valueString.split(':')[0];
	}
	var SelectControlValueAccessor = (function () {
	    function SelectControlValueAccessor(_renderer, _elementRef) {
	        this._renderer = _renderer;
	        this._elementRef = _elementRef;
	        /** @internal */
	        this._optionMap = new Map();
	        /** @internal */
	        this._idCounter = 0;
	        this.onChange = function (_) { };
	        this.onTouched = function () { };
	    }
	    SelectControlValueAccessor.prototype.writeValue = function (value) {
	        this.value = value;
	        var valueString = _buildValueString(this._getOptionId(value), value);
	        this._renderer.setElementProperty(this._elementRef.nativeElement, 'value', valueString);
	    };
	    SelectControlValueAccessor.prototype.registerOnChange = function (fn) {
	        var _this = this;
	        this.onChange = function (valueString) {
	            _this.value = valueString;
	            fn(_this._getOptionValue(valueString));
	        };
	    };
	    SelectControlValueAccessor.prototype.registerOnTouched = function (fn) { this.onTouched = fn; };
	    /** @internal */
	    SelectControlValueAccessor.prototype._registerOption = function () { return (this._idCounter++).toString(); };
	    /** @internal */
	    SelectControlValueAccessor.prototype._getOptionId = function (value) {
	        for (var _i = 0, _a = collection_1.MapWrapper.keys(this._optionMap); _i < _a.length; _i++) {
	            var id = _a[_i];
	            if (lang_1.looseIdentical(this._optionMap.get(id), value))
	                return id;
	        }
	        return null;
	    };
	    /** @internal */
	    SelectControlValueAccessor.prototype._getOptionValue = function (valueString) {
	        var value = this._optionMap.get(_extractId(valueString));
	        return lang_1.isPresent(value) ? value : valueString;
	    };
	    /** @nocollapse */
	    SelectControlValueAccessor.decorators = [
	        { type: core_1.Directive, args: [{
	                    selector: 'select:not([multiple])[formControlName],select:not([multiple])[formControl],select:not([multiple])[ngModel]',
	                    host: { '(change)': 'onChange($event.target.value)', '(blur)': 'onTouched()' },
	                    providers: [exports.SELECT_VALUE_ACCESSOR]
	                },] },
	    ];
	    /** @nocollapse */
	    SelectControlValueAccessor.ctorParameters = [
	        { type: core_1.Renderer, },
	        { type: core_1.ElementRef, },
	    ];
	    return SelectControlValueAccessor;
	}());
	exports.SelectControlValueAccessor = SelectControlValueAccessor;
	var NgSelectOption = (function () {
	    function NgSelectOption(_element, _renderer, _select) {
	        this._element = _element;
	        this._renderer = _renderer;
	        this._select = _select;
	        if (lang_1.isPresent(this._select))
	            this.id = this._select._registerOption();
	    }
	    Object.defineProperty(NgSelectOption.prototype, "ngValue", {
	        set: function (value) {
	            if (this._select == null)
	                return;
	            this._select._optionMap.set(this.id, value);
	            this._setElementValue(_buildValueString(this.id, value));
	            this._select.writeValue(this._select.value);
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(NgSelectOption.prototype, "value", {
	        set: function (value) {
	            this._setElementValue(value);
	            if (lang_1.isPresent(this._select))
	                this._select.writeValue(this._select.value);
	        },
	        enumerable: true,
	        configurable: true
	    });
	    /** @internal */
	    NgSelectOption.prototype._setElementValue = function (value) {
	        this._renderer.setElementProperty(this._element.nativeElement, 'value', value);
	    };
	    NgSelectOption.prototype.ngOnDestroy = function () {
	        if (lang_1.isPresent(this._select)) {
	            this._select._optionMap.delete(this.id);
	            this._select.writeValue(this._select.value);
	        }
	    };
	    /** @nocollapse */
	    NgSelectOption.decorators = [
	        { type: core_1.Directive, args: [{ selector: 'option' },] },
	    ];
	    /** @nocollapse */
	    NgSelectOption.ctorParameters = [
	        { type: core_1.ElementRef, },
	        { type: core_1.Renderer, },
	        { type: SelectControlValueAccessor, decorators: [{ type: core_1.Optional }, { type: core_1.Host },] },
	    ];
	    /** @nocollapse */
	    NgSelectOption.propDecorators = {
	        'ngValue': [{ type: core_1.Input, args: ['ngValue',] },],
	        'value': [{ type: core_1.Input, args: ['value',] },],
	    };
	    return NgSelectOption;
	}());
	exports.NgSelectOption = NgSelectOption;
	//# sourceMappingURL=select_control_value_accessor.js.map

/***/ },

/***/ 350:
/***/ function(module, exports, __webpack_require__) {

	/**
	 * @license
	 * Copyright Google Inc. All Rights Reserved.
	 *
	 * Use of this source code is governed by an MIT-style license that can be
	 * found in the LICENSE file at https://angular.io/license
	 */
	"use strict";
	var core_1 = __webpack_require__(5);
	var collection_1 = __webpack_require__(338);
	var lang_1 = __webpack_require__(332);
	var control_value_accessor_1 = __webpack_require__(330);
	var SELECT_MULTIPLE_VALUE_ACCESSOR = {
	    provide: control_value_accessor_1.NG_VALUE_ACCESSOR,
	    useExisting: core_1.forwardRef(function () { return SelectMultipleControlValueAccessor; }),
	    multi: true
	};
	function _buildValueString(id, value) {
	    if (lang_1.isBlank(id))
	        return "" + value;
	    if (lang_1.isString(value))
	        value = "'" + value + "'";
	    if (!lang_1.isPrimitive(value))
	        value = 'Object';
	    return lang_1.StringWrapper.slice(id + ": " + value, 0, 50);
	}
	function _extractId(valueString) {
	    return valueString.split(':')[0];
	}
	/** Mock interface for HTMLCollection */
	var HTMLCollection = (function () {
	    function HTMLCollection() {
	    }
	    return HTMLCollection;
	}());
	var SelectMultipleControlValueAccessor = (function () {
	    function SelectMultipleControlValueAccessor() {
	        /** @internal */
	        this._optionMap = new Map();
	        /** @internal */
	        this._idCounter = 0;
	        this.onChange = function (_) { };
	        this.onTouched = function () { };
	    }
	    SelectMultipleControlValueAccessor.prototype.writeValue = function (value) {
	        var _this = this;
	        this.value = value;
	        if (value == null)
	            return;
	        var values = value;
	        // convert values to ids
	        var ids = values.map(function (v) { return _this._getOptionId(v); });
	        this._optionMap.forEach(function (opt, o) { opt._setSelected(ids.indexOf(o.toString()) > -1); });
	    };
	    SelectMultipleControlValueAccessor.prototype.registerOnChange = function (fn) {
	        var _this = this;
	        this.onChange = function (_) {
	            var selected = [];
	            if (_.hasOwnProperty('selectedOptions')) {
	                var options = _.selectedOptions;
	                for (var i = 0; i < options.length; i++) {
	                    var opt = options.item(i);
	                    var val = _this._getOptionValue(opt.value);
	                    selected.push(val);
	                }
	            }
	            else {
	                var options = _.options;
	                for (var i = 0; i < options.length; i++) {
	                    var opt = options.item(i);
	                    if (opt.selected) {
	                        var val = _this._getOptionValue(opt.value);
	                        selected.push(val);
	                    }
	                }
	            }
	            fn(selected);
	        };
	    };
	    SelectMultipleControlValueAccessor.prototype.registerOnTouched = function (fn) { this.onTouched = fn; };
	    /** @internal */
	    SelectMultipleControlValueAccessor.prototype._registerOption = function (value) {
	        var id = (this._idCounter++).toString();
	        this._optionMap.set(id, value);
	        return id;
	    };
	    /** @internal */
	    SelectMultipleControlValueAccessor.prototype._getOptionId = function (value) {
	        for (var _i = 0, _a = collection_1.MapWrapper.keys(this._optionMap); _i < _a.length; _i++) {
	            var id = _a[_i];
	            if (lang_1.looseIdentical(this._optionMap.get(id)._value, value))
	                return id;
	        }
	        return null;
	    };
	    /** @internal */
	    SelectMultipleControlValueAccessor.prototype._getOptionValue = function (valueString) {
	        var opt = this._optionMap.get(_extractId(valueString));
	        return lang_1.isPresent(opt) ? opt._value : valueString;
	    };
	    /** @nocollapse */
	    SelectMultipleControlValueAccessor.decorators = [
	        { type: core_1.Directive, args: [{
	                    selector: 'select[multiple][formControlName],select[multiple][formControl],select[multiple][ngModel]',
	                    host: { '(input)': 'onChange($event.target)', '(blur)': 'onTouched()' },
	                    providers: [SELECT_MULTIPLE_VALUE_ACCESSOR]
	                },] },
	    ];
	    /** @nocollapse */
	    SelectMultipleControlValueAccessor.ctorParameters = [];
	    return SelectMultipleControlValueAccessor;
	}());
	exports.SelectMultipleControlValueAccessor = SelectMultipleControlValueAccessor;
	var NgSelectMultipleOption = (function () {
	    function NgSelectMultipleOption(_element, _renderer, _select) {
	        this._element = _element;
	        this._renderer = _renderer;
	        this._select = _select;
	        if (lang_1.isPresent(this._select)) {
	            this.id = this._select._registerOption(this);
	        }
	    }
	    Object.defineProperty(NgSelectMultipleOption.prototype, "ngValue", {
	        set: function (value) {
	            if (this._select == null)
	                return;
	            this._value = value;
	            this._setElementValue(_buildValueString(this.id, value));
	            this._select.writeValue(this._select.value);
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(NgSelectMultipleOption.prototype, "value", {
	        set: function (value) {
	            if (lang_1.isPresent(this._select)) {
	                this._value = value;
	                this._setElementValue(_buildValueString(this.id, value));
	                this._select.writeValue(this._select.value);
	            }
	            else {
	                this._setElementValue(value);
	            }
	        },
	        enumerable: true,
	        configurable: true
	    });
	    /** @internal */
	    NgSelectMultipleOption.prototype._setElementValue = function (value) {
	        this._renderer.setElementProperty(this._element.nativeElement, 'value', value);
	    };
	    /** @internal */
	    NgSelectMultipleOption.prototype._setSelected = function (selected) {
	        this._renderer.setElementProperty(this._element.nativeElement, 'selected', selected);
	    };
	    NgSelectMultipleOption.prototype.ngOnDestroy = function () {
	        if (lang_1.isPresent(this._select)) {
	            this._select._optionMap.delete(this.id);
	            this._select.writeValue(this._select.value);
	        }
	    };
	    /** @nocollapse */
	    NgSelectMultipleOption.decorators = [
	        { type: core_1.Directive, args: [{ selector: 'option' },] },
	    ];
	    /** @nocollapse */
	    NgSelectMultipleOption.ctorParameters = [
	        { type: core_1.ElementRef, },
	        { type: core_1.Renderer, },
	        { type: SelectMultipleControlValueAccessor, decorators: [{ type: core_1.Optional }, { type: core_1.Host },] },
	    ];
	    /** @nocollapse */
	    NgSelectMultipleOption.propDecorators = {
	        'ngValue': [{ type: core_1.Input, args: ['ngValue',] },],
	        'value': [{ type: core_1.Input, args: ['value',] },],
	    };
	    return NgSelectMultipleOption;
	}());
	exports.NgSelectMultipleOption = NgSelectMultipleOption;
	exports.SELECT_DIRECTIVES = [SelectMultipleControlValueAccessor, NgSelectMultipleOption];
	//# sourceMappingURL=select_multiple_control_value_accessor.js.map

/***/ },

/***/ 351:
[1067, 339],

/***/ 352:
/***/ function(module, exports, __webpack_require__) {

	/**
	 * @license
	 * Copyright Google Inc. All Rights Reserved.
	 *
	 * Use of this source code is governed by an MIT-style license that can be
	 * found in the LICENSE file at https://angular.io/license
	 */
	"use strict";
	var __extends = (this && this.__extends) || function (d, b) {
	    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
	    function __() { this.constructor = d; }
	    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	};
	var core_1 = __webpack_require__(5);
	var async_1 = __webpack_require__(341);
	var exceptions_1 = __webpack_require__(335);
	var model_1 = __webpack_require__(343);
	var validators_1 = __webpack_require__(345);
	var control_container_1 = __webpack_require__(351);
	var control_value_accessor_1 = __webpack_require__(330);
	var ng_control_1 = __webpack_require__(334);
	var shared_1 = __webpack_require__(344);
	exports.formControlBinding = 
	/*@ts2dart_const*/ /* @ts2dart_Provider */ {
	    provide: ng_control_1.NgControl,
	    useExisting: core_1.forwardRef(function () { return NgModel; })
	};
	var NgModel = (function (_super) {
	    __extends(NgModel, _super);
	    function NgModel(_parent, _validators, _asyncValidators, valueAccessors) {
	        _super.call(this);
	        this._parent = _parent;
	        this._validators = _validators;
	        this._asyncValidators = _asyncValidators;
	        /** @internal */
	        this._control = new model_1.FormControl();
	        /** @internal */
	        this._registered = false;
	        this.update = new async_1.EventEmitter();
	        this.valueAccessor = shared_1.selectValueAccessor(this, valueAccessors);
	    }
	    NgModel.prototype.ngOnChanges = function (changes) {
	        this._checkName();
	        if (!this._registered)
	            this._setUpControl();
	        if (shared_1.isPropertyUpdated(changes, this.viewModel)) {
	            this._updateValue(this.model);
	            this.viewModel = this.model;
	        }
	    };
	    NgModel.prototype.ngOnDestroy = function () { this.formDirective && this.formDirective.removeControl(this); };
	    Object.defineProperty(NgModel.prototype, "control", {
	        get: function () { return this._control; },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(NgModel.prototype, "path", {
	        get: function () {
	            return this._parent ? shared_1.controlPath(this.name, this._parent) : [];
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(NgModel.prototype, "formDirective", {
	        get: function () { return this._parent ? this._parent.formDirective : null; },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(NgModel.prototype, "validator", {
	        get: function () { return shared_1.composeValidators(this._validators); },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(NgModel.prototype, "asyncValidator", {
	        get: function () {
	            return shared_1.composeAsyncValidators(this._asyncValidators);
	        },
	        enumerable: true,
	        configurable: true
	    });
	    NgModel.prototype.viewToModelUpdate = function (newValue) {
	        this.viewModel = newValue;
	        async_1.ObservableWrapper.callEmit(this.update, newValue);
	    };
	    NgModel.prototype._setUpControl = function () {
	        this._isStandalone() ? this._setUpStandalone() :
	            this.formDirective.addControl(this);
	        this._registered = true;
	    };
	    NgModel.prototype._isStandalone = function () {
	        return !this._parent || (this.options && this.options.standalone);
	    };
	    NgModel.prototype._setUpStandalone = function () {
	        shared_1.setUpControl(this._control, this);
	        this._control.updateValueAndValidity({ emitEvent: false });
	    };
	    NgModel.prototype._checkName = function () {
	        if (this.options && this.options.name)
	            this.name = this.options.name;
	        if (!this._isStandalone() && !this.name) {
	            throw new exceptions_1.BaseException("If ngModel is used within a form tag, either the name attribute must be set\n                      or the form control must be defined as 'standalone' in ngModelOptions.\n\n                      Example 1: <input [(ngModel)]=\"person.firstName\" name=\"first\">\n                      Example 2: <input [(ngModel)]=\"person.firstName\" [ngModelOptions]=\"{standalone: true}\">\n                   ");
	        }
	    };
	    NgModel.prototype._updateValue = function (value) {
	        var _this = this;
	        async_1.PromiseWrapper.scheduleMicrotask(function () { _this.control.updateValue(value); });
	    };
	    /** @nocollapse */
	    NgModel.decorators = [
	        { type: core_1.Directive, args: [{
	                    selector: '[ngModel]:not([formControlName]):not([formControl])',
	                    providers: [exports.formControlBinding],
	                    exportAs: 'ngModel'
	                },] },
	    ];
	    /** @nocollapse */
	    NgModel.ctorParameters = [
	        { type: control_container_1.ControlContainer, decorators: [{ type: core_1.Optional }, { type: core_1.Host },] },
	        { type: Array, decorators: [{ type: core_1.Optional }, { type: core_1.Self }, { type: core_1.Inject, args: [validators_1.NG_VALIDATORS,] },] },
	        { type: Array, decorators: [{ type: core_1.Optional }, { type: core_1.Self }, { type: core_1.Inject, args: [validators_1.NG_ASYNC_VALIDATORS,] },] },
	        { type: Array, decorators: [{ type: core_1.Optional }, { type: core_1.Self }, { type: core_1.Inject, args: [control_value_accessor_1.NG_VALUE_ACCESSOR,] },] },
	    ];
	    /** @nocollapse */
	    NgModel.propDecorators = {
	        'model': [{ type: core_1.Input, args: ['ngModel',] },],
	        'name': [{ type: core_1.Input },],
	        'options': [{ type: core_1.Input, args: ['ngModelOptions',] },],
	        'update': [{ type: core_1.Output, args: ['ngModelChange',] },],
	    };
	    return NgModel;
	}(ng_control_1.NgControl));
	exports.NgModel = NgModel;
	//# sourceMappingURL=ng_model.js.map

/***/ },

/***/ 353:
/***/ function(module, exports, __webpack_require__) {

	/**
	 * @license
	 * Copyright Google Inc. All Rights Reserved.
	 *
	 * Use of this source code is governed by an MIT-style license that can be
	 * found in the LICENSE file at https://angular.io/license
	 */
	"use strict";
	var __extends = (this && this.__extends) || function (d, b) {
	    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
	    function __() { this.constructor = d; }
	    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	};
	var core_1 = __webpack_require__(5);
	var validators_1 = __webpack_require__(345);
	var abstract_form_group_directive_1 = __webpack_require__(354);
	var control_container_1 = __webpack_require__(351);
	exports.modelGroupProvider = 
	/*@ts2dart_const*/ /* @ts2dart_Provider */ {
	    provide: control_container_1.ControlContainer,
	    useExisting: core_1.forwardRef(function () { return NgModelGroup; })
	};
	var NgModelGroup = (function (_super) {
	    __extends(NgModelGroup, _super);
	    function NgModelGroup(parent, validators, asyncValidators) {
	        _super.call(this);
	        this._parent = parent;
	        this._validators = validators;
	        this._asyncValidators = asyncValidators;
	    }
	    /** @nocollapse */
	    NgModelGroup.decorators = [
	        { type: core_1.Directive, args: [{ selector: '[ngModelGroup]', providers: [exports.modelGroupProvider], exportAs: 'ngModelGroup' },] },
	    ];
	    /** @nocollapse */
	    NgModelGroup.ctorParameters = [
	        { type: control_container_1.ControlContainer, decorators: [{ type: core_1.Host }, { type: core_1.SkipSelf },] },
	        { type: Array, decorators: [{ type: core_1.Optional }, { type: core_1.Self }, { type: core_1.Inject, args: [validators_1.NG_VALIDATORS,] },] },
	        { type: Array, decorators: [{ type: core_1.Optional }, { type: core_1.Self }, { type: core_1.Inject, args: [validators_1.NG_ASYNC_VALIDATORS,] },] },
	    ];
	    /** @nocollapse */
	    NgModelGroup.propDecorators = {
	        'name': [{ type: core_1.Input, args: ['ngModelGroup',] },],
	    };
	    return NgModelGroup;
	}(abstract_form_group_directive_1.AbstractFormGroupDirective));
	exports.NgModelGroup = NgModelGroup;
	//# sourceMappingURL=ng_model_group.js.map

/***/ },

/***/ 354:
/***/ function(module, exports, __webpack_require__) {

	/**
	 * @license
	 * Copyright Google Inc. All Rights Reserved.
	 *
	 * Use of this source code is governed by an MIT-style license that can be
	 * found in the LICENSE file at https://angular.io/license
	 */
	"use strict";
	var __extends = (this && this.__extends) || function (d, b) {
	    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
	    function __() { this.constructor = d; }
	    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	};
	var control_container_1 = __webpack_require__(351);
	var shared_1 = __webpack_require__(344);
	/**
	  This is a base class for code shared between {@link NgModelGroup} and {@link FormGroupName}.
	 */
	var AbstractFormGroupDirective = (function (_super) {
	    __extends(AbstractFormGroupDirective, _super);
	    function AbstractFormGroupDirective() {
	        _super.apply(this, arguments);
	    }
	    AbstractFormGroupDirective.prototype.ngOnInit = function () { this.formDirective.addFormGroup(this); };
	    AbstractFormGroupDirective.prototype.ngOnDestroy = function () { this.formDirective.removeFormGroup(this); };
	    Object.defineProperty(AbstractFormGroupDirective.prototype, "control", {
	        /**
	         * Get the {@link FormGroup} backing this binding.
	         */
	        get: function () { return this.formDirective.getFormGroup(this); },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(AbstractFormGroupDirective.prototype, "path", {
	        /**
	         * Get the path to this control group.
	         */
	        get: function () { return shared_1.controlPath(this.name, this._parent); },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(AbstractFormGroupDirective.prototype, "formDirective", {
	        /**
	         * Get the {@link Form} to which this group belongs.
	         */
	        get: function () { return this._parent.formDirective; },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(AbstractFormGroupDirective.prototype, "validator", {
	        get: function () { return shared_1.composeValidators(this._validators); },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(AbstractFormGroupDirective.prototype, "asyncValidator", {
	        get: function () { return shared_1.composeAsyncValidators(this._asyncValidators); },
	        enumerable: true,
	        configurable: true
	    });
	    return AbstractFormGroupDirective;
	}(control_container_1.ControlContainer));
	exports.AbstractFormGroupDirective = AbstractFormGroupDirective;
	//# sourceMappingURL=abstract_form_group_directive.js.map

/***/ },

/***/ 355:
/***/ function(module, exports, __webpack_require__) {

	/**
	 * @license
	 * Copyright Google Inc. All Rights Reserved.
	 *
	 * Use of this source code is governed by an MIT-style license that can be
	 * found in the LICENSE file at https://angular.io/license
	 */
	"use strict";
	var __extends = (this && this.__extends) || function (d, b) {
	    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
	    function __() { this.constructor = d; }
	    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	};
	var core_1 = __webpack_require__(5);
	var validators_1 = __webpack_require__(345);
	var control_container_1 = __webpack_require__(351);
	var shared_1 = __webpack_require__(344);
	exports.formArrayNameProvider = 
	/*@ts2dart_const*/ /* @ts2dart_Provider */ {
	    provide: control_container_1.ControlContainer,
	    useExisting: core_1.forwardRef(function () { return FormArrayName; })
	};
	var FormArrayName = (function (_super) {
	    __extends(FormArrayName, _super);
	    function FormArrayName(parent, validators, asyncValidators) {
	        _super.call(this);
	        this._parent = parent;
	        this._validators = validators;
	        this._asyncValidators = asyncValidators;
	    }
	    FormArrayName.prototype.ngOnInit = function () { this.formDirective.addFormArray(this); };
	    FormArrayName.prototype.ngOnDestroy = function () { this.formDirective.removeFormArray(this); };
	    Object.defineProperty(FormArrayName.prototype, "control", {
	        get: function () { return this.formDirective.getFormArray(this); },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(FormArrayName.prototype, "formDirective", {
	        get: function () { return this._parent.formDirective; },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(FormArrayName.prototype, "path", {
	        get: function () { return shared_1.controlPath(this.name, this._parent); },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(FormArrayName.prototype, "validator", {
	        get: function () { return shared_1.composeValidators(this._validators); },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(FormArrayName.prototype, "asyncValidator", {
	        get: function () { return shared_1.composeAsyncValidators(this._asyncValidators); },
	        enumerable: true,
	        configurable: true
	    });
	    /** @nocollapse */
	    FormArrayName.decorators = [
	        { type: core_1.Directive, args: [{ selector: '[formArrayName]', providers: [exports.formArrayNameProvider] },] },
	    ];
	    /** @nocollapse */
	    FormArrayName.ctorParameters = [
	        { type: control_container_1.ControlContainer, decorators: [{ type: core_1.Host }, { type: core_1.SkipSelf },] },
	        { type: Array, decorators: [{ type: core_1.Optional }, { type: core_1.Self }, { type: core_1.Inject, args: [validators_1.NG_VALIDATORS,] },] },
	        { type: Array, decorators: [{ type: core_1.Optional }, { type: core_1.Self }, { type: core_1.Inject, args: [validators_1.NG_ASYNC_VALIDATORS,] },] },
	    ];
	    /** @nocollapse */
	    FormArrayName.propDecorators = {
	        'name': [{ type: core_1.Input, args: ['formArrayName',] },],
	    };
	    return FormArrayName;
	}(control_container_1.ControlContainer));
	exports.FormArrayName = FormArrayName;
	//# sourceMappingURL=form_array_name.js.map

/***/ },

/***/ 356:
/***/ function(module, exports, __webpack_require__) {

	/**
	 * @license
	 * Copyright Google Inc. All Rights Reserved.
	 *
	 * Use of this source code is governed by an MIT-style license that can be
	 * found in the LICENSE file at https://angular.io/license
	 */
	"use strict";
	var __extends = (this && this.__extends) || function (d, b) {
	    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
	    function __() { this.constructor = d; }
	    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	};
	var core_1 = __webpack_require__(5);
	var async_1 = __webpack_require__(341);
	var collection_1 = __webpack_require__(338);
	var validators_1 = __webpack_require__(345);
	var control_value_accessor_1 = __webpack_require__(330);
	var ng_control_1 = __webpack_require__(334);
	var shared_1 = __webpack_require__(344);
	exports.formControlBinding = 
	/*@ts2dart_const*/ /* @ts2dart_Provider */ {
	    provide: ng_control_1.NgControl,
	    useExisting: core_1.forwardRef(function () { return FormControlDirective; })
	};
	var FormControlDirective = (function (_super) {
	    __extends(FormControlDirective, _super);
	    function FormControlDirective(_validators, _asyncValidators, valueAccessors) {
	        _super.call(this);
	        this._validators = _validators;
	        this._asyncValidators = _asyncValidators;
	        this.update = new async_1.EventEmitter();
	        this.valueAccessor = shared_1.selectValueAccessor(this, valueAccessors);
	    }
	    FormControlDirective.prototype.ngOnChanges = function (changes) {
	        if (this._isControlChanged(changes)) {
	            shared_1.setUpControl(this.form, this);
	            this.form.updateValueAndValidity({ emitEvent: false });
	        }
	        if (shared_1.isPropertyUpdated(changes, this.viewModel)) {
	            this.form.updateValue(this.model);
	            this.viewModel = this.model;
	        }
	    };
	    Object.defineProperty(FormControlDirective.prototype, "path", {
	        get: function () { return []; },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(FormControlDirective.prototype, "validator", {
	        get: function () { return shared_1.composeValidators(this._validators); },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(FormControlDirective.prototype, "asyncValidator", {
	        get: function () {
	            return shared_1.composeAsyncValidators(this._asyncValidators);
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(FormControlDirective.prototype, "control", {
	        get: function () { return this.form; },
	        enumerable: true,
	        configurable: true
	    });
	    FormControlDirective.prototype.viewToModelUpdate = function (newValue) {
	        this.viewModel = newValue;
	        async_1.ObservableWrapper.callEmit(this.update, newValue);
	    };
	    FormControlDirective.prototype._isControlChanged = function (changes) {
	        return collection_1.StringMapWrapper.contains(changes, 'form');
	    };
	    /** @nocollapse */
	    FormControlDirective.decorators = [
	        { type: core_1.Directive, args: [{ selector: '[formControl]', providers: [exports.formControlBinding], exportAs: 'ngForm' },] },
	    ];
	    /** @nocollapse */
	    FormControlDirective.ctorParameters = [
	        { type: Array, decorators: [{ type: core_1.Optional }, { type: core_1.Self }, { type: core_1.Inject, args: [validators_1.NG_VALIDATORS,] },] },
	        { type: Array, decorators: [{ type: core_1.Optional }, { type: core_1.Self }, { type: core_1.Inject, args: [validators_1.NG_ASYNC_VALIDATORS,] },] },
	        { type: Array, decorators: [{ type: core_1.Optional }, { type: core_1.Self }, { type: core_1.Inject, args: [control_value_accessor_1.NG_VALUE_ACCESSOR,] },] },
	    ];
	    /** @nocollapse */
	    FormControlDirective.propDecorators = {
	        'form': [{ type: core_1.Input, args: ['formControl',] },],
	        'model': [{ type: core_1.Input, args: ['ngModel',] },],
	        'update': [{ type: core_1.Output, args: ['ngModelChange',] },],
	    };
	    return FormControlDirective;
	}(ng_control_1.NgControl));
	exports.FormControlDirective = FormControlDirective;
	//# sourceMappingURL=form_control_directive.js.map

/***/ },

/***/ 357:
/***/ function(module, exports, __webpack_require__) {

	/**
	 * @license
	 * Copyright Google Inc. All Rights Reserved.
	 *
	 * Use of this source code is governed by an MIT-style license that can be
	 * found in the LICENSE file at https://angular.io/license
	 */
	"use strict";
	var __extends = (this && this.__extends) || function (d, b) {
	    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
	    function __() { this.constructor = d; }
	    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	};
	var core_1 = __webpack_require__(5);
	var async_1 = __webpack_require__(341);
	var validators_1 = __webpack_require__(345);
	var control_container_1 = __webpack_require__(351);
	var control_value_accessor_1 = __webpack_require__(330);
	var ng_control_1 = __webpack_require__(334);
	var shared_1 = __webpack_require__(344);
	exports.controlNameBinding = 
	/*@ts2dart_const*/ /* @ts2dart_Provider */ {
	    provide: ng_control_1.NgControl,
	    useExisting: core_1.forwardRef(function () { return FormControlName; })
	};
	var FormControlName = (function (_super) {
	    __extends(FormControlName, _super);
	    function FormControlName(_parent, _validators, _asyncValidators, valueAccessors) {
	        _super.call(this);
	        this._parent = _parent;
	        this._validators = _validators;
	        this._asyncValidators = _asyncValidators;
	        this._added = false;
	        this.update = new async_1.EventEmitter();
	        this.valueAccessor = shared_1.selectValueAccessor(this, valueAccessors);
	    }
	    FormControlName.prototype.ngOnChanges = function (changes) {
	        if (!this._added) {
	            this.formDirective.addControl(this);
	            this._added = true;
	        }
	        if (shared_1.isPropertyUpdated(changes, this.viewModel)) {
	            this.viewModel = this.model;
	            this.formDirective.updateModel(this, this.model);
	        }
	    };
	    FormControlName.prototype.ngOnDestroy = function () { this.formDirective.removeControl(this); };
	    FormControlName.prototype.viewToModelUpdate = function (newValue) {
	        this.viewModel = newValue;
	        async_1.ObservableWrapper.callEmit(this.update, newValue);
	    };
	    Object.defineProperty(FormControlName.prototype, "path", {
	        get: function () { return shared_1.controlPath(this.name, this._parent); },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(FormControlName.prototype, "formDirective", {
	        get: function () { return this._parent.formDirective; },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(FormControlName.prototype, "validator", {
	        get: function () { return shared_1.composeValidators(this._validators); },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(FormControlName.prototype, "asyncValidator", {
	        get: function () {
	            return shared_1.composeAsyncValidators(this._asyncValidators);
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(FormControlName.prototype, "control", {
	        get: function () { return this.formDirective.getControl(this); },
	        enumerable: true,
	        configurable: true
	    });
	    /** @nocollapse */
	    FormControlName.decorators = [
	        { type: core_1.Directive, args: [{ selector: '[formControlName]', providers: [exports.controlNameBinding] },] },
	    ];
	    /** @nocollapse */
	    FormControlName.ctorParameters = [
	        { type: control_container_1.ControlContainer, decorators: [{ type: core_1.Host }, { type: core_1.SkipSelf },] },
	        { type: Array, decorators: [{ type: core_1.Optional }, { type: core_1.Self }, { type: core_1.Inject, args: [validators_1.NG_VALIDATORS,] },] },
	        { type: Array, decorators: [{ type: core_1.Optional }, { type: core_1.Self }, { type: core_1.Inject, args: [validators_1.NG_ASYNC_VALIDATORS,] },] },
	        { type: Array, decorators: [{ type: core_1.Optional }, { type: core_1.Self }, { type: core_1.Inject, args: [control_value_accessor_1.NG_VALUE_ACCESSOR,] },] },
	    ];
	    /** @nocollapse */
	    FormControlName.propDecorators = {
	        'name': [{ type: core_1.Input, args: ['formControlName',] },],
	        'model': [{ type: core_1.Input, args: ['ngModel',] },],
	        'update': [{ type: core_1.Output, args: ['ngModelChange',] },],
	    };
	    return FormControlName;
	}(ng_control_1.NgControl));
	exports.FormControlName = FormControlName;
	//# sourceMappingURL=form_control_name.js.map

/***/ },

/***/ 358:
/***/ function(module, exports, __webpack_require__) {

	/**
	 * @license
	 * Copyright Google Inc. All Rights Reserved.
	 *
	 * Use of this source code is governed by an MIT-style license that can be
	 * found in the LICENSE file at https://angular.io/license
	 */
	"use strict";
	var __extends = (this && this.__extends) || function (d, b) {
	    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
	    function __() { this.constructor = d; }
	    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	};
	var core_1 = __webpack_require__(5);
	var async_1 = __webpack_require__(341);
	var collection_1 = __webpack_require__(338);
	var exceptions_1 = __webpack_require__(335);
	var lang_1 = __webpack_require__(332);
	var validators_1 = __webpack_require__(345);
	var control_container_1 = __webpack_require__(351);
	var shared_1 = __webpack_require__(344);
	exports.formDirectiveProvider = 
	/*@ts2dart_const*/ /* @ts2dart_Provider */ {
	    provide: control_container_1.ControlContainer,
	    useExisting: core_1.forwardRef(function () { return FormGroupDirective; })
	};
	var FormGroupDirective = (function (_super) {
	    __extends(FormGroupDirective, _super);
	    function FormGroupDirective(_validators, _asyncValidators) {
	        _super.call(this);
	        this._validators = _validators;
	        this._asyncValidators = _asyncValidators;
	        this._submitted = false;
	        this.directives = [];
	        this.form = null;
	        this.ngSubmit = new async_1.EventEmitter();
	    }
	    FormGroupDirective.prototype.ngOnChanges = function (changes) {
	        this._checkFormPresent();
	        if (collection_1.StringMapWrapper.contains(changes, 'form')) {
	            var sync = shared_1.composeValidators(this._validators);
	            this.form.validator = validators_1.Validators.compose([this.form.validator, sync]);
	            var async = shared_1.composeAsyncValidators(this._asyncValidators);
	            this.form.asyncValidator = validators_1.Validators.composeAsync([this.form.asyncValidator, async]);
	            this.form.updateValueAndValidity({ onlySelf: true, emitEvent: false });
	        }
	        this._updateDomValue();
	    };
	    Object.defineProperty(FormGroupDirective.prototype, "submitted", {
	        get: function () { return this._submitted; },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(FormGroupDirective.prototype, "formDirective", {
	        get: function () { return this; },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(FormGroupDirective.prototype, "control", {
	        get: function () { return this.form; },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(FormGroupDirective.prototype, "path", {
	        get: function () { return []; },
	        enumerable: true,
	        configurable: true
	    });
	    FormGroupDirective.prototype.addControl = function (dir) {
	        var ctrl = this.form.find(dir.path);
	        shared_1.setUpControl(ctrl, dir);
	        ctrl.updateValueAndValidity({ emitEvent: false });
	        this.directives.push(dir);
	    };
	    FormGroupDirective.prototype.getControl = function (dir) { return this.form.find(dir.path); };
	    FormGroupDirective.prototype.removeControl = function (dir) { collection_1.ListWrapper.remove(this.directives, dir); };
	    FormGroupDirective.prototype.addFormGroup = function (dir) {
	        var ctrl = this.form.find(dir.path);
	        shared_1.setUpFormContainer(ctrl, dir);
	        ctrl.updateValueAndValidity({ emitEvent: false });
	    };
	    FormGroupDirective.prototype.removeFormGroup = function (dir) { };
	    FormGroupDirective.prototype.getFormGroup = function (dir) { return this.form.find(dir.path); };
	    FormGroupDirective.prototype.addFormArray = function (dir) {
	        var ctrl = this.form.find(dir.path);
	        shared_1.setUpFormContainer(ctrl, dir);
	        ctrl.updateValueAndValidity({ emitEvent: false });
	    };
	    FormGroupDirective.prototype.removeFormArray = function (dir) { };
	    FormGroupDirective.prototype.getFormArray = function (dir) { return this.form.find(dir.path); };
	    FormGroupDirective.prototype.updateModel = function (dir, value) {
	        var ctrl = this.form.find(dir.path);
	        ctrl.updateValue(value);
	    };
	    FormGroupDirective.prototype.onSubmit = function () {
	        this._submitted = true;
	        async_1.ObservableWrapper.callEmit(this.ngSubmit, null);
	        return false;
	    };
	    /** @internal */
	    FormGroupDirective.prototype._updateDomValue = function () {
	        var _this = this;
	        this.directives.forEach(function (dir) {
	            var ctrl = _this.form.find(dir.path);
	            dir.valueAccessor.writeValue(ctrl.value);
	        });
	    };
	    FormGroupDirective.prototype._checkFormPresent = function () {
	        if (lang_1.isBlank(this.form)) {
	            throw new exceptions_1.BaseException("formGroup expects a FormGroup instance. Please pass one in.\n           Example: <form [formGroup]=\"myFormGroup\">\n      ");
	        }
	    };
	    /** @nocollapse */
	    FormGroupDirective.decorators = [
	        { type: core_1.Directive, args: [{
	                    selector: '[formGroup]',
	                    providers: [exports.formDirectiveProvider],
	                    host: { '(submit)': 'onSubmit()' },
	                    exportAs: 'ngForm'
	                },] },
	    ];
	    /** @nocollapse */
	    FormGroupDirective.ctorParameters = [
	        { type: Array, decorators: [{ type: core_1.Optional }, { type: core_1.Self }, { type: core_1.Inject, args: [validators_1.NG_VALIDATORS,] },] },
	        { type: Array, decorators: [{ type: core_1.Optional }, { type: core_1.Self }, { type: core_1.Inject, args: [validators_1.NG_ASYNC_VALIDATORS,] },] },
	    ];
	    /** @nocollapse */
	    FormGroupDirective.propDecorators = {
	        'form': [{ type: core_1.Input, args: ['formGroup',] },],
	        'ngSubmit': [{ type: core_1.Output },],
	    };
	    return FormGroupDirective;
	}(control_container_1.ControlContainer));
	exports.FormGroupDirective = FormGroupDirective;
	//# sourceMappingURL=form_group_directive.js.map

/***/ },

/***/ 359:
/***/ function(module, exports, __webpack_require__) {

	/**
	 * @license
	 * Copyright Google Inc. All Rights Reserved.
	 *
	 * Use of this source code is governed by an MIT-style license that can be
	 * found in the LICENSE file at https://angular.io/license
	 */
	"use strict";
	var __extends = (this && this.__extends) || function (d, b) {
	    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
	    function __() { this.constructor = d; }
	    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	};
	var core_1 = __webpack_require__(5);
	var validators_1 = __webpack_require__(345);
	var abstract_form_group_directive_1 = __webpack_require__(354);
	var control_container_1 = __webpack_require__(351);
	exports.formGroupNameProvider = 
	/*@ts2dart_const*/ /* @ts2dart_Provider */ {
	    provide: control_container_1.ControlContainer,
	    useExisting: core_1.forwardRef(function () { return FormGroupName; })
	};
	var FormGroupName = (function (_super) {
	    __extends(FormGroupName, _super);
	    function FormGroupName(parent, validators, asyncValidators) {
	        _super.call(this);
	        this._parent = parent;
	        this._validators = validators;
	        this._asyncValidators = asyncValidators;
	    }
	    /** @nocollapse */
	    FormGroupName.decorators = [
	        { type: core_1.Directive, args: [{ selector: '[formGroupName]', providers: [exports.formGroupNameProvider] },] },
	    ];
	    /** @nocollapse */
	    FormGroupName.ctorParameters = [
	        { type: control_container_1.ControlContainer, decorators: [{ type: core_1.Host }, { type: core_1.SkipSelf },] },
	        { type: Array, decorators: [{ type: core_1.Optional }, { type: core_1.Self }, { type: core_1.Inject, args: [validators_1.NG_VALIDATORS,] },] },
	        { type: Array, decorators: [{ type: core_1.Optional }, { type: core_1.Self }, { type: core_1.Inject, args: [validators_1.NG_ASYNC_VALIDATORS,] },] },
	    ];
	    /** @nocollapse */
	    FormGroupName.propDecorators = {
	        'name': [{ type: core_1.Input, args: ['formGroupName',] },],
	    };
	    return FormGroupName;
	}(abstract_form_group_directive_1.AbstractFormGroupDirective));
	exports.FormGroupName = FormGroupName;
	//# sourceMappingURL=form_group_name.js.map

/***/ },

/***/ 360:
/***/ function(module, exports, __webpack_require__) {

	/**
	 * @license
	 * Copyright Google Inc. All Rights Reserved.
	 *
	 * Use of this source code is governed by an MIT-style license that can be
	 * found in the LICENSE file at https://angular.io/license
	 */
	"use strict";
	var core_1 = __webpack_require__(5);
	var lang_1 = __webpack_require__(332);
	var validators_1 = __webpack_require__(345);
	var REQUIRED = validators_1.Validators.required;
	exports.REQUIRED_VALIDATOR = {
	    provide: validators_1.NG_VALIDATORS,
	    useValue: REQUIRED,
	    multi: true
	};
	var RequiredValidator = (function () {
	    function RequiredValidator() {
	    }
	    /** @nocollapse */
	    RequiredValidator.decorators = [
	        { type: core_1.Directive, args: [{
	                    selector: '[required][formControlName],[required][formControl],[required][ngModel]',
	                    providers: [exports.REQUIRED_VALIDATOR]
	                },] },
	    ];
	    return RequiredValidator;
	}());
	exports.RequiredValidator = RequiredValidator;
	/**
	 * Provivder which adds {@link MinLengthValidator} to {@link NG_VALIDATORS}.
	 *
	 * ## Example:
	 *
	 * {@example common/forms/ts/validators/validators.ts region='min'}
	 */
	exports.MIN_LENGTH_VALIDATOR = {
	    provide: validators_1.NG_VALIDATORS,
	    useExisting: core_1.forwardRef(function () { return MinLengthValidator; }),
	    multi: true
	};
	var MinLengthValidator = (function () {
	    function MinLengthValidator(minLength) {
	        this._validator = validators_1.Validators.minLength(lang_1.NumberWrapper.parseInt(minLength, 10));
	    }
	    MinLengthValidator.prototype.validate = function (c) { return this._validator(c); };
	    /** @nocollapse */
	    MinLengthValidator.decorators = [
	        { type: core_1.Directive, args: [{
	                    selector: '[minlength][formControlName],[minlength][formControl],[minlength][ngModel]',
	                    providers: [exports.MIN_LENGTH_VALIDATOR]
	                },] },
	    ];
	    /** @nocollapse */
	    MinLengthValidator.ctorParameters = [
	        { type: undefined, decorators: [{ type: core_1.Attribute, args: ['minlength',] },] },
	    ];
	    return MinLengthValidator;
	}());
	exports.MinLengthValidator = MinLengthValidator;
	/**
	 * Provider which adds {@link MaxLengthValidator} to {@link NG_VALIDATORS}.
	 *
	 * ## Example:
	 *
	 * {@example common/forms/ts/validators/validators.ts region='max'}
	 */
	exports.MAX_LENGTH_VALIDATOR = {
	    provide: validators_1.NG_VALIDATORS,
	    useExisting: core_1.forwardRef(function () { return MaxLengthValidator; }),
	    multi: true
	};
	var MaxLengthValidator = (function () {
	    function MaxLengthValidator(maxLength) {
	        this._validator = validators_1.Validators.maxLength(lang_1.NumberWrapper.parseInt(maxLength, 10));
	    }
	    MaxLengthValidator.prototype.validate = function (c) { return this._validator(c); };
	    /** @nocollapse */
	    MaxLengthValidator.decorators = [
	        { type: core_1.Directive, args: [{
	                    selector: '[maxlength][formControlName],[maxlength][formControl],[maxlength][ngModel]',
	                    providers: [exports.MAX_LENGTH_VALIDATOR]
	                },] },
	    ];
	    /** @nocollapse */
	    MaxLengthValidator.ctorParameters = [
	        { type: undefined, decorators: [{ type: core_1.Attribute, args: ['maxlength',] },] },
	    ];
	    return MaxLengthValidator;
	}());
	exports.MaxLengthValidator = MaxLengthValidator;
	exports.PATTERN_VALIDATOR = {
	    provide: validators_1.NG_VALIDATORS,
	    useExisting: core_1.forwardRef(function () { return PatternValidator; }),
	    multi: true
	};
	var PatternValidator = (function () {
	    function PatternValidator(pattern) {
	        this._validator = validators_1.Validators.pattern(pattern);
	    }
	    PatternValidator.prototype.validate = function (c) { return this._validator(c); };
	    /** @nocollapse */
	    PatternValidator.decorators = [
	        { type: core_1.Directive, args: [{
	                    selector: '[pattern][formControlName],[pattern][formControl],[pattern][ngModel]',
	                    providers: [exports.PATTERN_VALIDATOR]
	                },] },
	    ];
	    /** @nocollapse */
	    PatternValidator.ctorParameters = [
	        { type: undefined, decorators: [{ type: core_1.Attribute, args: ['pattern',] },] },
	    ];
	    return PatternValidator;
	}());
	exports.PatternValidator = PatternValidator;
	//# sourceMappingURL=validators.js.map

/***/ },

/***/ 361:
/***/ function(module, exports, __webpack_require__) {

	/**
	 * @license
	 * Copyright Google Inc. All Rights Reserved.
	 *
	 * Use of this source code is governed by an MIT-style license that can be
	 * found in the LICENSE file at https://angular.io/license
	 */
	"use strict";
	var core_1 = __webpack_require__(5);
	var collection_1 = __webpack_require__(338);
	var lang_1 = __webpack_require__(332);
	var model_1 = __webpack_require__(343);
	var FormBuilder = (function () {
	    function FormBuilder() {
	    }
	    /**
	     * Construct a new {@link FormGroup} with the given map of configuration.
	     * Valid keys for the `extra` parameter map are `optionals` and `validator`.
	     *
	     * See the {@link FormGroup} constructor for more details.
	     */
	    FormBuilder.prototype.group = function (controlsConfig, extra) {
	        if (extra === void 0) { extra = null; }
	        var controls = this._reduceControls(controlsConfig);
	        var optionals = (lang_1.isPresent(extra) ? collection_1.StringMapWrapper.get(extra, 'optionals') : null);
	        var validator = lang_1.isPresent(extra) ? collection_1.StringMapWrapper.get(extra, 'validator') : null;
	        var asyncValidator = lang_1.isPresent(extra) ? collection_1.StringMapWrapper.get(extra, 'asyncValidator') : null;
	        return new model_1.FormGroup(controls, optionals, validator, asyncValidator);
	    };
	    /**
	     * Construct a new {@link FormControl} with the given `value`,`validator`, and `asyncValidator`.
	     */
	    FormBuilder.prototype.control = function (value, validator, asyncValidator) {
	        if (validator === void 0) { validator = null; }
	        if (asyncValidator === void 0) { asyncValidator = null; }
	        return new model_1.FormControl(value, validator, asyncValidator);
	    };
	    /**
	     * Construct an array of {@link FormControl}s from the given `controlsConfig` array of
	     * configuration, with the given optional `validator` and `asyncValidator`.
	     */
	    FormBuilder.prototype.array = function (controlsConfig, validator, asyncValidator) {
	        var _this = this;
	        if (validator === void 0) { validator = null; }
	        if (asyncValidator === void 0) { asyncValidator = null; }
	        var controls = controlsConfig.map(function (c) { return _this._createControl(c); });
	        return new model_1.FormArray(controls, validator, asyncValidator);
	    };
	    /** @internal */
	    FormBuilder.prototype._reduceControls = function (controlsConfig) {
	        var _this = this;
	        var controls = {};
	        collection_1.StringMapWrapper.forEach(controlsConfig, function (controlConfig, controlName) {
	            controls[controlName] = _this._createControl(controlConfig);
	        });
	        return controls;
	    };
	    /** @internal */
	    FormBuilder.prototype._createControl = function (controlConfig) {
	        if (controlConfig instanceof model_1.FormControl || controlConfig instanceof model_1.FormGroup ||
	            controlConfig instanceof model_1.FormArray) {
	            return controlConfig;
	        }
	        else if (lang_1.isArray(controlConfig)) {
	            var value = controlConfig[0];
	            var validator = controlConfig.length > 1 ? controlConfig[1] : null;
	            var asyncValidator = controlConfig.length > 2 ? controlConfig[2] : null;
	            return this.control(value, validator, asyncValidator);
	        }
	        else {
	            return this.control(controlConfig);
	        }
	    };
	    /** @nocollapse */
	    FormBuilder.decorators = [
	        { type: core_1.Injectable },
	    ];
	    return FormBuilder;
	}());
	exports.FormBuilder = FormBuilder;
	//# sourceMappingURL=form_builder.js.map

/***/ },

/***/ 362:
/***/ function(module, exports, __webpack_require__) {

	/**
	 * @license
	 * Copyright Google Inc. All Rights Reserved.
	 *
	 * Use of this source code is governed by an MIT-style license that can be
	 * found in the LICENSE file at https://angular.io/license
	 */
	"use strict";
	var common_1 = __webpack_require__(2);
	var compiler_1 = __webpack_require__(174);
	var core_1 = __webpack_require__(5);
	var directives_1 = __webpack_require__(328);
	var radio_control_value_accessor_1 = __webpack_require__(348);
	var collection_1 = __webpack_require__(338);
	var form_builder_1 = __webpack_require__(361);
	/**
	 * Shorthand set of providers used for building Angular forms.
	 *
	 * ### Example
	 *
	 * ```typescript
	 * bootstrap(MyApp, [FORM_PROVIDERS]);
	 * ```
	 *
	 * @experimental
	 */
	exports.FORM_PROVIDERS = [form_builder_1.FormBuilder, radio_control_value_accessor_1.RadioControlRegistry];
	function flatten(platformDirectives) {
	    var flattenedDirectives = [];
	    platformDirectives.forEach(function (directives) {
	        if (Array.isArray(directives)) {
	            flattenedDirectives = flattenedDirectives.concat(directives);
	        }
	        else {
	            flattenedDirectives.push(directives);
	        }
	    });
	    return flattenedDirectives;
	}
	/**
	 * @experimental
	 */
	function disableDeprecatedForms() {
	    return [{
	            provide: compiler_1.CompilerConfig,
	            useFactory: function (platformDirectives, platformPipes) {
	                var flattenedDirectives = flatten(platformDirectives);
	                collection_1.ListWrapper.remove(flattenedDirectives, common_1.FORM_DIRECTIVES);
	                return new compiler_1.CompilerConfig({ platformDirectives: flattenedDirectives, platformPipes: platformPipes });
	            },
	            deps: [core_1.PLATFORM_DIRECTIVES, core_1.PLATFORM_PIPES]
	        }];
	}
	exports.disableDeprecatedForms = disableDeprecatedForms;
	/**
	 * @experimental
	 */
	function provideForms() {
	    return [
	        { provide: core_1.PLATFORM_DIRECTIVES, useValue: directives_1.FORM_DIRECTIVES, multi: true }, exports.FORM_PROVIDERS
	    ];
	}
	exports.provideForms = provideForms;
	//# sourceMappingURL=form_providers.js.map

/***/ },

/***/ 384:
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var core_1 = __webpack_require__(5);
	__webpack_require__(385);
	//  import {HeaderComponent} from './header/header.component';
	// import {FooterComponent} from './Theme/components/footer/footer.component';
	// import {LoginComponent} from './AuthModule/login.component';
	// import {HomeComponent} from './Home/home.component';
	// import {PersonComponent} from './Home/person/person.component';
	var router_1 = __webpack_require__(389);
	var app_constants_1 = __webpack_require__(441);
	var AppComponent = (function () {
	    function AppComponent() {
	    }
	    AppComponent = __decorate([
	        core_1.Component({
	            selector: 'my-app',
	            directives: [router_1.ROUTER_DIRECTIVES],
	            providers: [app_constants_1.Configuration],
	            template: __webpack_require__(446),
	        }), 
	        __metadata('design:paramtypes', [])
	    ], AppComponent);
	    return AppComponent;
	}());
	exports.AppComponent = AppComponent;


/***/ },

/***/ 385:
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },

/***/ 441:
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(Buffer) {"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var core_1 = __webpack_require__(5);
	var http_1 = __webpack_require__(363);
	var Configuration = (function () {
	    function Configuration() {
	        this.Server = 'http://165.227.152.243:3000/';
	        this.ApiUrl = 'api/v1/';
	        this.Url = this.Server + this.ApiUrl;
	        this.authPassword = '&jno-@8az=wSo*NHYVGpF^AQ?4yn36ZvW5ToUCUN+XGOuC?sz#SE$oxXVbwQGP|3WFyjcTAj2SIRQnLE|vo^-|-ATV5FZUf2*5A3Oiu|_EOMmG==&iApzQL3R7HHQj?jtb0mc2mT$Y%Isrgrxveld#Z^g3-ul^|0xAITganIuF23J0waSa6z6aP_+%De5LqtuY&ptx?qhZySECdyE^*4R^b*hFjQ-9?cCSJNfROzztEYbRyN=SqDyhhpzSmmP|Eb';
	        this.bodyAuth = '^*aNJW=#u*xrV+U^Z@3eLJTm&w@p&hWLA8T2X=Br%*+-Vqb^pgVZ$Km?sRRB7-Dfx!bkgc*L&7$Ad&x-rttNU!$65t9hbgQTT?YLSum#3jZB@5KbLhhwDwAND%hxEFMF';
	        this.auth = 'Basic ' + new Buffer("basicAuth:" + this.authPassword).toString('base64');
	        this.token = localStorage.getItem('user') || '';
	        this.headers = new http_1.Headers({ 'Content-Type': 'application/json' });
	        this.headers.append('token', this.token);
	        this.headers.append('authorization', this.auth);
	    }
	    Configuration = __decorate([
	        core_1.Injectable(), 
	        __metadata('design:paramtypes', [])
	    ], Configuration);
	    return Configuration;
	}());
	exports.Configuration = Configuration;
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(442).Buffer))

/***/ },

/***/ 446:
/***/ function(module, exports) {

	module.exports = "\r\n\r\n<router-outlet></router-outlet>\r\n\r\n\r\n\r\n\r\n\r\n";

/***/ },

/***/ 447:
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var router_1 = __webpack_require__(389);
	var login_component_1 = __webpack_require__(448);
	var home_component_1 = __webpack_require__(458);
	var content_component_1 = __webpack_require__(464);
	var person_component_1 = __webpack_require__(486);
	var personlocation_component_1 = __webpack_require__(489);
	var personcaption_component_1 = __webpack_require__(492);
	var homepost_component_1 = __webpack_require__(495);
	var discoverpost_component_1 = __webpack_require__(498);
	var discover_component_1 = __webpack_require__(501);
	var profile_component_1 = __webpack_require__(504);
	var profile_edit_component_1 = __webpack_require__(507);
	var reset_component_1 = __webpack_require__(510);
	var privacy_component_1 = __webpack_require__(512);
	var terms_component_1 = __webpack_require__(514);
	var eula_component_1 = __webpack_require__(516);
	var pageloading_component_1 = __webpack_require__(518);
	exports.routes = [
	    { path: '', redirectTo: 'login', terminal: true },
	    { path: 'login', component: login_component_1.LoginComponent },
	    { path: 'reset/:reset_token', component: reset_component_1.ResetpasswordComponent },
	    { path: 'privacy', component: privacy_component_1.PrivacyComponent },
	    { path: 'eula', component: eula_component_1.EulaComponent },
	    { path: 'terms', component: terms_component_1.TermsComponent },
	    {
	        path: 'home', component: home_component_1.HomeComponent,
	        children: [
	            { path: '', component: content_component_1.ContentComponent },
	            { path: 'homepost/:name/:id', component: homepost_component_1.HomepostComponent },
	            { path: 'person/:name', component: person_component_1.PersonComponent },
	            { path: 'personlocation/:name', component: personlocation_component_1.PersonlocationComponent },
	            { path: 'personcaption/:name', component: personcaption_component_1.PersoncaptionComponent },
	            { path: 'profile', component: profile_component_1.ProfileComponent },
	            { path: 'profile-edit', component: profile_edit_component_1.ProfileeditComponent },
	            { path: 'discover', component: discover_component_1.DiscoverComponent },
	            { path: 'discoverpost', component: discoverpost_component_1.DiscoverpostComponent }
	        ]
	    },
	    { path: 'page', component: pageloading_component_1.PageComponent },
	];
	exports.APP_ROUTER_PROVIDERS = [
	    router_1.provideRouter(exports.routes)
	];


/***/ },

/***/ 448:
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var core_1 = __webpack_require__(5);
	__webpack_require__(449);
	// import {FooterComponent} from './footer.component';
	var footer_component_1 = __webpack_require__(453);
	var router_1 = __webpack_require__(389);
	var forms_1 = __webpack_require__(326);
	var login_message_component_1 = __webpack_require__(454);
	var login_validation_service_1 = __webpack_require__(455);
	var auth_service_1 = __webpack_require__(456);
	var router_2 = __webpack_require__(389);
	var LoginComponent = (function () {
	    function LoginComponent(_authService, formBuilder, _router) {
	        this._authService = _authService;
	        this.formBuilder = formBuilder;
	        this._router = _router;
	        this.bufferlogin = false;
	        this.buffer_login = false;
	        this.loged = false;
	        this.error_icon = false;
	        this.error_iconfb = false;
	        this.fbdisplayLogin = false;
	        this.hideElement = false;
	        this.displayLogin = false;
	        this.edited = false;
	        FB.init({
	            appId: '1992785894293760',
	            status: true,
	            cookie: true,
	            xfbml: true,
	            version: 'v2.11' // use graph api version 2.5 
	        });
	        this.signupForm = this.formBuilder.group({
	            'username': ['', forms_1.Validators.required],
	            'fullName': ['', forms_1.Validators.required],
	            'email': ['', [forms_1.Validators.required, login_validation_service_1.ValidationService.emailValidator]],
	            'password': ['', [forms_1.Validators.required]]
	        });
	        this.loginForm = this.formBuilder.group({
	            'username': ['', forms_1.Validators.required],
	            'password': ['', [forms_1.Validators.required]]
	        });
	        this.resetForm = this.formBuilder.group({
	            'email': ['', [forms_1.Validators.required, login_validation_service_1.ValidationService.emailValidator]],
	        });
	    }
	    LoginComponent.prototype.ngOnInit = function () {
	        var token = localStorage.getItem('authToken');
	        if (token) {
	            this._router.navigate(["home"]);
	        }
	        jQuery("#phone").intlTelInput();
	    };
	    LoginComponent.prototype.ngAfterViewInit = function () {
	        jQuery("#phone").intlTelInput({
	            allowExtensions: false,
	            autoFormat: true,
	            autoHideDialCode: true,
	            autoPlaceholder: true,
	            customPlaceholder: null,
	            defaultCountry: "gb",
	            geoIpLookup: null,
	            nationalMode: true,
	            numberType: "MOBILE",
	            onlyCountries: undefined,
	            preferredCountries: ['gb', 'in', 'us'],
	            skipUtilScriptDownload: false,
	        });
	    };
	    LoginComponent.prototype.login = function () {
	        this.registerEmpty();
	        jQuery("#myModalAdmin").modal("hide");
	        jQuery(".fbuserPassword").hide();
	        jQuery(".signupUserotp").hide();
	        this.displayLogin = true;
	        this.hideElement = false;
	        this.edited = false;
	    };
	    LoginComponent.prototype.registerEmpty = function () {
	        jQuery("#phone").val("");
	        this.fullName = "";
	        this.username = "";
	        this.password = "";
	    };
	    LoginComponent.prototype.authenticateUser = function () {
	        var _this = this;
	        this.bufferlogin = true;
	        this._authService.login({ username: this.username, password: this.password })
	            .subscribe(function (res) {
	            if (res.code == 200) {
	                setTimeout(function () {
	                    _this.bufferlogin = false;
	                }, 500);
	                // this.loginSuccess = res.message; 
	                setTimeout(function () {
	                    // this._router.navigate(['home']);
	                    window.location.replace('home');
	                }, 500);
	            }
	            if (res.code == 1971) {
	                setTimeout(function () {
	                    _this.bufferlogin = false;
	                }, 500);
	                setTimeout(function () {
	                    _this.loginMessage = res.errMessage1;
	                }, 500);
	            }
	            if (res.code == 1972) {
	                setTimeout(function () {
	                    _this.bufferlogin = false;
	                }, 500);
	                setTimeout(function () {
	                    _this.loginMessage = res.errMessage2;
	                }, 500);
	            }
	            if (res.code == 1973) {
	                setTimeout(function () {
	                    _this.bufferlogin = false;
	                }, 500);
	                setTimeout(function () {
	                    _this.loginMessage = res.message;
	                }, 500);
	            }
	            if (res.code == 1974) {
	                setTimeout(function () {
	                    _this.bufferlogin = false;
	                }, 500);
	                setTimeout(function () {
	                    _this.loginMessage = res.message;
	                }, 500);
	            }
	        });
	    };
	    LoginComponent.prototype.register = function () {
	        this.displayLogin = false;
	        this.hideElement = false;
	        this.edited = false;
	    };
	    LoginComponent.prototype.forgot = function () {
	        this.hideElement = true;
	        this.edited = true;
	    };
	    // private right_icon=false;
	    LoginComponent.prototype.registerUser = function () {
	        var _this = this;
	        this.errPhone = false;
	        var phonecheck = jQuery(".sign_validation").val();
	        // var fullName = jQuery(".fullname").val();
	        var username = jQuery(".sign_validation1").val();
	        var fullname_register = jQuery('.fullname_register').val();
	        var password_signup = jQuery('.sign_validation2').val();
	        if (fullname_register) {
	            jQuery(".fullname_register").siblings().removeClass("error");
	            jQuery(".fullname_register").siblings().addClass("right");
	        }
	        if (password_signup) {
	            jQuery(".sign_validation2").siblings().removeClass("error");
	            jQuery(".sign_validation2").siblings().addClass("right");
	        }
	        if (username) {
	            this._authService.signupusernamecheck({
	                username: username,
	            })
	                .subscribe(function (res) {
	                if (res.code == 1994) {
	                    // this.error_icon = false;
	                    jQuery(".sign_validation1").siblings().removeClass("right");
	                    jQuery(".sign_validation1").siblings().addClass("error");
	                    jQuery(".error_show").hide();
	                }
	                if (res.code == 200) {
	                    _this.error_icon = false;
	                    jQuery(".sign_validation1").siblings().removeClass("error");
	                    jQuery(".sign_validation1").siblings().addClass("right");
	                    jQuery(".error_show").hide();
	                }
	            });
	        }
	        if (phonecheck) {
	            this._authService.phoneNumbercheck({
	                phoneNumber: phonecheck,
	            }).subscribe(function (res) {
	                // console.log(res);
	                if (res.code == 1988) {
	                    // this.error_icon = false;
	                    jQuery("#phoneErr").removeClass("right");
	                    jQuery("#phoneErr").addClass("error");
	                    jQuery(".error_show").hide();
	                }
	                if (res.code == 200) {
	                    _this.error_icon = false;
	                    jQuery("#phoneErr").removeClass("error");
	                    jQuery("#phoneErr").addClass("right");
	                    jQuery(".error_show").hide();
	                }
	            });
	        }
	    };
	    LoginComponent.prototype.mobileValidation = function (value) {
	        var val = value.replace(/([^+0-9]+)/gi, '');
	        jQuery(".sign_validation").val(val);
	    };
	    LoginComponent.prototype.registerUsersubmitList = function () {
	        var _this = this;
	        if (jQuery('.sign_validation').val() != '') {
	            jQuery("#phoneErr").removeClass("error");
	            jQuery("#phoneErr").addClass("right");
	            jQuery(".error_show").hide();
	        }
	        else {
	            jQuery("#phoneErr").removeClass("right");
	            jQuery("#phoneErr").addClass("error");
	            jQuery(".error_show").show();
	        }
	        if (jQuery('.sign_validation1').val() != '') {
	            jQuery(".sign_validation1").siblings().removeClass("error");
	            jQuery(".sign_validation1").siblings().addClass("right");
	            jQuery(".error_show").hide();
	        }
	        else {
	            jQuery(".sign_validation1").siblings().removeClass("right");
	            jQuery(".sign_validation1").siblings().addClass("error");
	            jQuery(".error_show").show();
	        }
	        if (jQuery('.sign_validation2').val() != '') {
	            jQuery(".sign_validation2").siblings().removeClass("error");
	            jQuery(".sign_validation2").siblings().addClass("right");
	            jQuery(".error_show").hide();
	        }
	        else {
	            jQuery(".sign_validation2").siblings().removeClass("right");
	            jQuery(".sign_validation2").siblings().addClass("error");
	            jQuery(".error_show").show();
	        }
	        var phonecheck = jQuery("#phone").val();
	        var list = {
	            deviceId: 'browser',
	            phoneNumber: phonecheck
	        };
	        if (jQuery('.sign_validation').val() && jQuery('.sign_validation1').val() && jQuery('.sign_validation2').val()) {
	            this.bufferlogin = true;
	            setTimeout(function () {
	                _this.bufferlogin = false;
	            }, 3000);
	            this._authService.generateOTPCheck(list)
	                .subscribe(function (res) {
	                _this.bufferlogin = false;
	                // console.log(res);
	                if (res.code == 200) {
	                    _this.errPhone = false;
	                    jQuery(".fbuserPasswordsign").hide();
	                    jQuery(".signupUserotp").show();
	                }
	                else {
	                    _this.errPhone = "Please try entering your full number, including the country";
	                    setTimeout(function () {
	                        _this.errPhone = false;
	                    }, 3000);
	                }
	            });
	        }
	    };
	    LoginComponent.prototype.registerUsersubmit = function () {
	        // function ValidateEmail(email: any) {
	        //     var expr = /^([\w-\.]+)@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.)|(([\w-]+\.)+))([a-zA-Z]{2,4}|[0-9]{1,3})(\]?)$/;
	        //     return expr.test(email);
	        // }
	        // if (!ValidateEmail(jQuery(".sign_validation").val())) {
	        //     //alert("Invalid email address.");
	        //     jQuery(".sign_validation").siblings().removeClass("right");
	        //     jQuery(".sign_validation").siblings().addClass("error");
	        //     jQuery(".error_show").show();
	        //     jQuery(".error_email").show();
	        // }
	        // else {
	        //     //alert("Valid email address.");
	        //     jQuery(".sign_validation").siblings().removeClass("error");
	        //     jQuery(".sign_validation").siblings().addClass("right");
	        //     jQuery(".error_show").hide();
	        //     jQuery(".error_email").hide();
	        // }
	        // if (jQuery('.sign_validation1').val() != '') {
	        //     jQuery(".sign_validation1").siblings().removeClass("error");
	        //     jQuery(".sign_validation1").siblings().addClass("right");
	        //     jQuery(".error_show").hide();
	        // } else {
	        //     jQuery(".sign_validation1").siblings().removeClass("right");
	        //     jQuery(".sign_validation1").siblings().addClass("error");
	        //     jQuery(".error_show").show();
	        // }
	        // if (jQuery('.sign_validation2').val() != '') {
	        //     jQuery(".sign_validation2").siblings().removeClass("error");
	        //     jQuery(".sign_validation2").siblings().addClass("right");
	        //     jQuery(".error_show").hide();
	        // } else {
	        //     jQuery(".sign_validation2").siblings().removeClass("right");
	        //     jQuery(".sign_validation2").siblings().addClass("error");
	        //     jQuery(".error_show").show();
	        // }
	        var _this = this;
	        // if (ValidateEmail(jQuery(".sign_validation").val()) && jQuery('.sign_validation1').val() && jQuery('.sign_validation2').val()) {
	        var phonecheck = jQuery("#phone").val();
	        this.bufferlogin = true;
	        setTimeout(function () {
	            _this.bufferlogin = false;
	        }, 3000);
	        this._authService.register({
	            signupType: 3,
	            phoneNumber: phonecheck,
	            otp: this.OtpNumber,
	            username: this.username,
	            fullName: this.fullName,
	            deviceType: 3,
	            pushToken: 'browser',
	            profilePicUrl: null,
	            password: this.password,
	            deviceId: 'browser'
	        })
	            .subscribe(function (res) {
	            console.log(res);
	            // if (res.code == 2004) {
	            //     jQuery(".sign_validation").siblings().removeClass("right");
	            //     jQuery(".sign_validation1").siblings().removeClass("right");
	            //     this.error_icon = true;
	            //     setTimeout(() => {
	            //         this.bufferlogin = false;
	            //     }, 500);
	            //     setTimeout(() => {
	            //         this.signupMessage = res.message;
	            //     }, 500);
	            // }
	            if (res.code == 200) {
	                setTimeout(function () {
	                    _this.bufferlogin = false;
	                }, 500);
	                // this.signupSuccess = res.message;     
	                setTimeout(function () {
	                    // this._router.navigate(['home']);
	                    // this.OtpNumber = "";
	                    // jQuery("#myModalAdmin").modal("show");
	                    window.location.replace('home');
	                }, 500);
	            }
	            else {
	                _this.loginMessage = res.message;
	                setTimeout(function () {
	                    _this.loginMessage = false;
	                }, 3000);
	            }
	        });
	        // }
	    };
	    LoginComponent.prototype.forgotPassword = function () {
	        var _this = this;
	        this.bufferlogin = true;
	        this._authService.resetPassword({
	            email: this.email,
	            type: '0'
	        }).subscribe(function (res) {
	            if (res.code == 200) {
	                setTimeout(function () {
	                    _this.bufferlogin = false;
	                }, 500);
	                _this.resetSuccess = res.message;
	                setTimeout(function () {
	                    _this.resetSuccess = " ";
	                    jQuery("#forgotemail").val(" ");
	                    _this.displayLogin = false;
	                    _this.hideElement = false;
	                    _this.edited = false;
	                }, 2000);
	            }
	            if (res.code == 1976) {
	                setTimeout(function () {
	                    _this.bufferlogin = false;
	                }, 500);
	                _this.reseterror = res.message;
	                setTimeout(function () {
	                    _this.reseterror = " ";
	                    jQuery("#forgotemail").val(" ");
	                    _this.displayLogin = false;
	                    _this.hideElement = false;
	                    _this.edited = false;
	                }, 2000);
	            }
	        });
	    };
	    LoginComponent.prototype.userNameCheck = function (val) {
	        var _this = this;
	        this._authService.userNameCheckList(val)
	            .subscribe(function (res) {
	            _this.error_iconfb = true;
	            if (res.code != 200) {
	                // this.loginMessage = res.message;
	                jQuery(".fberror").removeClass("right");
	            }
	            else {
	                jQuery(".fberror").addClass("right");
	            }
	        });
	    };
	    LoginComponent.prototype.fbauthenticateUser = function () {
	        var _this = this;
	        var list = {
	            name: this.username,
	            password: this.password,
	            id: this.accessToken
	        };
	        this.bufferlogin = true;
	        setTimeout(function () {
	            _this.buffer_login = false;
	            jQuery(".loaderFb").hide();
	        }, 3000);
	        this._authService.registerfacebooklogin(list)
	            .subscribe(function (res) {
	            _this.buffer_login = false;
	            if (res.code == 200) {
	                // this._router.navigate(['home']);
	                window.location.replace('home');
	            }
	            else {
	                _this.loginMessage = res.message;
	            }
	        });
	    };
	    LoginComponent.prototype.onFacebookLoginClick = function () {
	        var _this = this;
	        FB.getLoginStatus(function (response) {
	            // console.log(response);
	            _this.statusChangeCallback(response);
	        });
	    };
	    LoginComponent.prototype.statusChangeCallback = function (response) {
	        if (response.status === 'connected') {
	            this.fb_login();
	            this.accessToken = response.authResponse.accessToken;
	        }
	        else {
	            this.fblogin();
	        }
	    };
	    LoginComponent.prototype.fblogin = function () {
	        var _this = this;
	        FB.login(function (result) {
	            _this.loged = true;
	            _this.token = result;
	            _this.fb_login();
	        }, { scope: 'user_friends' });
	    };
	    LoginComponent.prototype.me = function () {
	        var _this = this;
	        FB.getLoginStatus(function (response) {
	            if (response) {
	                _this.accessToken = response.authResponse.accessToken;
	            }
	        });
	        FB.api('/me?fields=id,name,first_name,email,gender', function (result) {
	            _this.user = result;
	            _this.user.id = _this.accessToken;
	            _this.fbdisplayLogin = true;
	            // console.log(this.user);
	            // this.buffer_login = true;
	            // setTimeout(() => {
	            //     this.buffer_login = false;
	            //     jQuery(".loaderFb").hide();
	            // }, 5000); 
	            // this._authService.registerfacebooklogin(this.user)
	            //     .subscribe((res) => {
	            //         if (res.code == 2005) {
	            //             jQuery(".loaderFb").hide();
	            //             // this.fb_login();
	            //         } else if (res.code == 200) {
	            //             jQuery(".loaderFb").hide();
	            //             this._router.navigate(['home']);
	            //         } else {
	            //             jQuery(".loaderFb").hide();
	            //             this.fbloginerror = res.message;
	            //         }
	            //     });
	        });
	    };
	    LoginComponent.prototype.fb_login = function () {
	        var _this = this;
	        FB.api('/me?fields=id,name,first_name,email,gender', function (result) {
	            _this.user = result;
	            _this.buffer_login = true;
	            setTimeout(function () {
	                _this.buffer_login = false;
	                jQuery(".loaderFb").hide();
	            }, 5000);
	            _this._authService.facebooklogin(_this.user)
	                .subscribe(function (res) {
	                _this.buffer_login = false;
	                jQuery(".loaderFb").hide();
	                if (res.code == 200) {
	                    // this._router.navigate(['home']);
	                    window.location.replace('home');
	                }
	                else {
	                    // jQuery(".fberror").show();                                                   
	                    _this.me();
	                    jQuery(".fbuserPasswordsign").hide();
	                    jQuery(".fbuserPassword").show();
	                }
	            });
	        });
	    };
	    LoginComponent.prototype.signupUser = function () {
	        if (this.signupForm.dirty && this.signupForm.valid) {
	        }
	    };
	    LoginComponent.prototype.loginUser = function () {
	        if (this.loginForm.dirty && this.loginForm.valid) {
	        }
	    };
	    LoginComponent = __decorate([
	        core_1.Component({
	            selector: 'login',
	            // directives: [FooterComponent],
	            directives: [footer_component_1.FooterComponent, forms_1.REACTIVE_FORM_DIRECTIVES, router_2.ROUTER_DIRECTIVES, login_message_component_1.ControlMessages],
	            providers: [auth_service_1.AuthService],
	            // template: '<h1>My First Angular 2 App</h1>',
	            template: __webpack_require__(457)
	        }), 
	        __metadata('design:paramtypes', [auth_service_1.AuthService, forms_1.FormBuilder, router_1.Router])
	    ], LoginComponent);
	    return LoginComponent;
	}());
	exports.LoginComponent = LoginComponent;


/***/ },

/***/ 449:
385,

/***/ 453:
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var core_1 = __webpack_require__(5);
	var FooterComponent = (function () {
	    function FooterComponent() {
	    }
	    FooterComponent = __decorate([
	        core_1.Component({
	            selector: 'footer',
	            template: "\n        <div class=\"container-fluid pico_total_footer\" style=\"clear: both;position: relative;top: 50px;\">\n    <div class=\"container pico_footer\" style=\"\">\n        <div class=\"picogram_footer_text col-xs-12 col-sm-9\" style=\"padding:0px;\">\n            <span class=\"footer_list\"></span>\n            <span class=\"footer_list\"></span>\n            <span class=\"footer_list\"></span>\n            <span class=\"footer_list\"></span>\n            <span class=\"footer_list\"></span>\n            <span class=\"footer_list\"></span>\n            <span class=\"footer_list\"></span>\n            <span class=\"footer_list\"></span>\n            <span class=\"footer_list\"></span>\n        </div>\n        <div class=\"picogram_footer col-xs-12 col-sm-3\" style=\"text-align:right;padding:0px;\">\n            <span class=\"col-xs-12 footer_pico_2016\" style=\"color: #999;\"></span>\n        </div>\n    </div>\n</div>"
	        }), 
	        __metadata('design:paramtypes', [])
	    ], FooterComponent);
	    return FooterComponent;
	}());
	exports.FooterComponent = FooterComponent;


/***/ },

/***/ 454:
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var core_1 = __webpack_require__(5);
	var forms_1 = __webpack_require__(326);
	var login_validation_service_1 = __webpack_require__(455);
	var ControlMessages = (function () {
	    function ControlMessages() {
	    }
	    Object.defineProperty(ControlMessages.prototype, "errorMessage", {
	        get: function () {
	            for (var propertyName in this.control.errors) {
	                if (this.control.errors.hasOwnProperty(propertyName) && this.control.touched) {
	                    return login_validation_service_1.ValidationService.getValidatorErrorMessage(propertyName, this.control.errors[propertyName]);
	                }
	            }
	            return null;
	        },
	        enumerable: true,
	        configurable: true
	    });
	    __decorate([
	        core_1.Input(), 
	        __metadata('design:type', forms_1.FormControl)
	    ], ControlMessages.prototype, "control", void 0);
	    ControlMessages = __decorate([
	        core_1.Component({
	            selector: 'control-messages',
	            template: "<div style=\"color:#FF5A5F\" class=\"loginmessage\" *ngIf=\"errorMessage !== null\">{{errorMessage}}</div>"
	        }), 
	        __metadata('design:paramtypes', [])
	    ], ControlMessages);
	    return ControlMessages;
	}());
	exports.ControlMessages = ControlMessages;


/***/ },

/***/ 455:
/***/ function(module, exports) {

	"use strict";
	var ValidationService = (function () {
	    function ValidationService() {
	    }
	    ValidationService.getValidatorErrorMessage = function (validatorName, validatorValue) {
	        var config = {
	            'required': 'Required',
	            'invalidCreditCard': 'Is invalid credit card number',
	            'invalidEmailAddress': 'Invalid email address',
	            'invalidPassword': 'Invalid password. Password must be at least 6 characters long, and contain a number.',
	            'minlength': "Minimum length " + validatorValue.requiredLength
	        };
	        return config[validatorName];
	    };
	    ValidationService.creditCardValidator = function (control) {
	        // Visa, MasterCard, American Express, Diners Club, Discover, JCB
	        if (control.value.match(/^(?:4[0-9]{12}(?:[0-9]{3})?|5[1-5][0-9]{14}|6(?:011|5[0-9][0-9])[0-9]{12}|3[47][0-9]{13}|3(?:0[0-5]|[68][0-9])[0-9]{11}|(?:2131|1800|35\d{3})\d{11})$/)) {
	            return null;
	        }
	        else {
	            return { 'invalidCreditCard': true };
	        }
	    };
	    ValidationService.emailValidator = function (control) {
	        // RFC 2822 compliant regex
	        if (control.value.match(/[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*@(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?/)) {
	            return null;
	        }
	        else {
	            return { 'invalidEmailAddress': true };
	        }
	    };
	    ValidationService.passwordValidator = function (control) {
	        // {6,100}           - Assert password is between 6 and 100 characters
	        // (?=.*[0-9])       - Assert a string has at least one number
	        if (control.value.match(/^(?=.*[0-9])[a-zA-Z0-9!@#$%^&*]{6,100}$/)) {
	            return null;
	        }
	        else {
	            return { 'invalidPassword': true };
	        }
	    };
	    return ValidationService;
	}());
	exports.ValidationService = ValidationService;


/***/ },

/***/ 456:
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var core_1 = __webpack_require__(5);
	var router_1 = __webpack_require__(389);
	var app_constants_1 = __webpack_require__(441);
	var http_1 = __webpack_require__(363);
	var Observable_1 = __webpack_require__(38);
	var User = (function () {
	    function User(username, password) {
	        this.username = username;
	        this.password = password;
	    }
	    return User;
	}());
	exports.User = User;
	var AuthService = (function () {
	    function AuthService(_router, _http, _conf) {
	        this._router = _router;
	        this._http = _http;
	        this._conf = _conf;
	    }
	    AuthService.prototype.logout = function () {
	        localStorage.removeItem("user");
	        // this._router.navigate(['Login']);
	    };
	    AuthService.prototype.login = function (user) {
	        user.bodyAuth = this._conf.bodyAuth;
	        var body = JSON.stringify(user);
	        // //console.log(user);
	        return this._http.post(this._conf.Url + 'login', body, { headers: this._conf.headers })
	            .map(function (res) { return res.json(); })
	            .map(function (res) {
	            //console.log(res);
	            if (res.token) {
	                localStorage.setItem('authToken', res.token);
	                localStorage.setItem('username', res.username);
	            }
	            return res;
	        });
	        //.catch(this.handleError);
	    };
	    AuthService.prototype.register = function (user) {
	        user.bodyAuth = this._conf.bodyAuth;
	        var body = JSON.stringify(user);
	        // console.log(body);
	        return this._http.post(this._conf.Url + 'register', body, { headers: this._conf.headers })
	            .map(function (res) { return res.json(); })
	            .map(function (res) {
	            //console.log(res);
	            if (res.code == 200) {
	                if (res.response.authToken) {
	                    localStorage.setItem('authToken', res.response.authToken);
	                    localStorage.setItem('username', res.response.username);
	                }
	            }
	            // if (res.token) {
	            //     localStorage.setItem('user', res.token);S
	            //     // this._router.navigate(['Pages']);
	            //     return res.code;
	            // }
	            return res;
	        });
	    };
	    AuthService.prototype.phoneNumbercheck = function (user) {
	        user.bodyAuth = this._conf.bodyAuth;
	        var body = JSON.stringify(user);
	        // console.log(body);
	        return this._http.post(this._conf.Url + 'phoneNumberCheck', body, { headers: this._conf.headers })
	            .map(function (res) { return res.json(); })
	            .map(function (res) {
	            return res;
	        });
	    };
	    AuthService.prototype.generateOTPCheck = function (user) {
	        user.bodyAuth = this._conf.bodyAuth;
	        var body = JSON.stringify(user);
	        // console.log(body);
	        return this._http.post(this._conf.Url + 'otp', body, { headers: this._conf.headers })
	            .map(function (res) { return res.json(); })
	            .map(function (res) {
	            return res;
	        });
	    };
	    AuthService.prototype.signupemailcheck = function (user) {
	        user.bodyAuth = this._conf.bodyAuth;
	        var body = JSON.stringify(user);
	        // console.log(body);
	        return this._http.post(this._conf.Url + 'emailCheck', body, { headers: this._conf.headers })
	            .map(function (res) { return res.json(); })
	            .map(function (res) {
	            //console.log(res);
	            // if (res.code != 2004 && res.code != 1995) { 
	            //     if (res.response.authToken) {
	            //         localStorage.setItem('authToken', res.response.authToken);
	            //         localStorage.setItem('username', res.response.username);
	            //     }
	            // }
	            // if (res.token) {
	            //     localStorage.setItem('user', res.token);S
	            //     // this._router.navigate(['Pages']);
	            //     return res.code;
	            // }
	            return res;
	        });
	    };
	    AuthService.prototype.signupusernamecheck = function (user) {
	        user.bodyAuth = this._conf.bodyAuth;
	        var body = JSON.stringify(user);
	        //console.log(body);
	        return this._http.post(this._conf.Url + 'usernameCheck', body, { headers: this._conf.headers })
	            .map(function (res) { return res.json(); })
	            .map(function (res) {
	            //console.log(res);
	            // if (res.code != 2004 && res.code != 1995) { 
	            //     if (res.response.authToken) {
	            //         localStorage.setItem('authToken', res.response.authToken);
	            //         localStorage.setItem('username', res.response.username);
	            //     }
	            // }
	            // if (res.token) {
	            //     localStorage.setItem('user', res.token);S
	            //     // this._router.navigate(['Pages']);
	            //     return res.code;
	            // }
	            return res;
	        });
	    };
	    AuthService.prototype.resetPassword = function (user) {
	        var body = JSON.stringify(user);
	        //console.log(body);
	        return this._http.post(this._conf.Url + 'resetPassword', body, { headers: this._conf.headers })
	            .map(function (res) { return res.json(); })
	            .map(function (res) {
	            //console.log(res);
	            // if (res.token) {
	            //     localStorage.setItem('user', res.token);S
	            //     // this._router.navigate(['Pages']);
	            //     return res.code;
	            // }
	            return res;
	        });
	    };
	    AuthService.prototype.changePassword = function (user) {
	        // //console.log(user);
	        // user.passwordResetLink = 'AmB8qLwREFq6FvKW67lirq6q63mCxV68';
	        var body = JSON.stringify(user);
	        //console.log(body);
	        return this._http.post(this._conf.Url + 'changePassword', body, { headers: this._conf.headers })
	            .map(function (res) { return res.json(); })
	            .map(function (res) {
	            //console.log(res);
	            // if (res.token) {
	            //     localStorage.setItem('user', res.token);S
	            //     // this._router.navigate(['Pages']);
	            //     return res.code;
	            // }
	            return res;
	        });
	    };
	    AuthService.prototype.userNameCheckList = function (user) {
	        var body = {
	            bodyAuth: this._conf.bodyAuth,
	            username: user
	        };
	        // console.log(body);
	        return this._http.post(this._conf.Url + 'usernameCheck', body, { headers: this._conf.headers })
	            .map(function (res) { return res.json(); })
	            .map(function (res) {
	            console.log(res);
	            return res;
	        });
	    };
	    AuthService.prototype.registerfacebooklogin = function (user) {
	        var body = {
	            bodyAuth: this._conf.bodyAuth,
	            email: user.email,
	            signupType: 1,
	            deviceType: 3,
	            accessToken: user.id,
	            password: user.password,
	            username: user.name.toLowerCase().replace(/ /g, '')
	        };
	        // console.log(body);
	        return this._http.post(this._conf.Url + 'register', body, { headers: this._conf.headers })
	            .map(function (res) { return res.json(); })
	            .map(function (res) {
	            // console.log(res);
	            if (res.code != 2005) {
	                if (res.response.authToken) {
	                    localStorage.setItem('authToken', res.response.authToken);
	                    localStorage.setItem('username', res.response.username);
	                }
	            }
	            return res;
	        });
	    };
	    AuthService.prototype.facebooklogin = function (user) {
	        var body = {
	            bodyAuth: this._conf.bodyAuth,
	            facebookAuth: 1,
	            facebookId: user.id,
	            username: user.name.toLowerCase().replace(/ /g, '')
	        };
	        // console.log(body);
	        return this._http.post(this._conf.Url + 'login', body, { headers: this._conf.headers })
	            .map(function (res) { return res.json(); })
	            .map(function (res) {
	            // console.log(res);
	            if (res.token) {
	                localStorage.setItem('authToken', res.token);
	                localStorage.setItem('username', res.username);
	            }
	            return res;
	        });
	    };
	    AuthService.prototype.handleError = function (error) {
	        console.error(error);
	        return Observable_1.Observable.throw(error.json().error || 'Server error');
	    };
	    AuthService.prototype.checkCredentials = function () {
	        if (localStorage.getItem("authToken") === null) {
	            this._router.navigate(['Login']);
	        }
	    };
	    AuthService = __decorate([
	        core_1.Injectable(), 
	        __metadata('design:paramtypes', [router_1.Router, http_1.Http, app_constants_1.Configuration])
	    ], AuthService);
	    return AuthService;
	}());
	exports.AuthService = AuthService;


/***/ },

/***/ 457:
/***/ function(module, exports) {

	module.exports = "<!DOCTYPE html>\r\n<html>\r\n\r\n<head>\r\n    <title>Sportemage</title>\r\n    <link rel=\"icon\" type=\"image/gif/png\" href=\"/public/images/picoTitleLogo.png\">\r\n</head>\r\n\r\n<body>\r\n    <div class=\"container-fluid picogram_total\">\r\n        <div class=\"container landing_login_signup login_mobile_imgg\" style=\"\">\r\n            <div class=\"col-xs-12 hidden-xs hidden-sm col-sm-6 col-md-6 zero_padding mobile_image\">\r\n                <div id=\"carouselHacked\" class=\"carousel slide carousel-fade\" data-ride=\"carousel\">\r\n                    <!-- Wrapper for slides -->\r\n                    <div class=\"carousel-inner\" role=\"listbox\">\r\n                        <div class=\"item active\">\r\n                            <img class=\"change_image img-responsive\" src=\"/public/images/picoslide1.jpg\">\r\n                        </div>\r\n                        <div class=\"item\">\r\n                            <img class=\"change_image img-responsive\" src=\"/public/images/picoslide2.jpg\">\r\n                        </div>\r\n                        <div class=\"item\">\r\n                            <img class=\"change_image img-responsive\" src=\"/public/images/picoslide3.jpg\">\r\n                        </div>\r\n                        <div class=\"item\">\r\n                            <img class=\"change_image img-responsive\" src=\"/public/images/picoslide4.jpg\">\r\n                        </div>\r\n                        <div class=\"item\">\r\n                            <img class=\"change_image img-responsive\" src=\"/public/images/picoslide5.jpg\">\r\n                        </div>\r\n                    </div>\r\n                </div>\r\n            </div>\r\n            <div class=\"col-xs-12 col-sm-12 col-md-6 zero_padding login_mobile_img\" style=\"text-align:center;\">\r\n                <div class=\"login_pico_logo col-xs-12 col-sm-12 zero_padding\">\r\n                    <span class=\"\">\r\n                        <img src=\"/public/images/pico_logo.png\" alt=\"Sportemage\">\r\n                    </span>\r\n                    <!--<span class=\"\"><img class=\"title_image\" src=\"\" alt=\"Sportemage\"></span>-->\r\n\r\n                </div>\r\n                <div class=\"col-xs-12 col-sm-12 zero_padding signup_form_total hidedetails fbuserPasswordsign\" [hidden]=\"hideElement\" *ngIf=\"!displayLogin\">\r\n                    <div class=\"col-xs-12 zero_padding signup_form\">\r\n                        <h2 class=\"col-xs-12 color_thick zero_padding\" style=\"color:#999\">Sign up to see photos and videos from your friends.</h2>\r\n                    </div>\r\n\r\n                    <div class=\"col-xs-12 zero_padding signup_form\">\r\n                        <span class=\"col-xs-5 zero_padding left_border\"></span>\r\n                        <span class=\"col-xs-2 zero_padding\" style=\"color:#999\">OR</span>\r\n                        <span class=\"col-xs-5 zero_padding right_border\"></span>\r\n                    </div>\r\n                    <div class=\"col-xs-12 zero_padding signup_form\">\r\n                        <span class=\"col-xs-12 zero_padding\">\r\n                            <i class=\"facebook_icon_landing\"></i>\r\n                            <span class=\"bufferlogin_gif loaderFb\" *ngIf=\"buffer_login\">\r\n                                <img src=\"/public/images/ajax-loader2.gif\" alt=\"loader\">\r\n                            </span>\r\n                            <button class=\"landing_click col-xs-12 zero_padding\" (click)=\"onFacebookLoginClick()\">Log in with Facebook</button>\r\n                        </span>\r\n\r\n                        <h5 class=\"text-danger fberror\" style=\"display:none;\"> No User Found! </h5>\r\n                    </div>\r\n\r\n                    <form [formGroup]=\"signupForm\" (submit)=\"signupUser()\">\r\n                        <div class=\"col-xs-12 zero_padding signup_form\">\r\n                            <span class=\"\">\r\n                                <input type=\"tel\" name=\"phoneNumber\" id=\"phone\" value=\"\" #rmv (keyup)=\"mobileValidation(rmv.value)\" (click)=\"registerUser()\"\r\n                                    class=\"sign_validation form-control color_thick color_opacity\" placeholder=\"Phone Number (+44019293029)\"\r\n                                    ng-intl-tel-input>\r\n                                <i class=\"icon_err_right\" id=\"phoneErr\"></i>\r\n                            </span>\r\n                            <div style=\"color:#FF5A5F\" *ngIf=\"errPhone\">{{errPhone}}</div>\r\n                            <!--<control-messages [control]=\"signupForm.controls.email\"></control-messages> -->\r\n                            <div *ngIf=\"error_icon\" class=\"icon_err_right error\"></div>\r\n\r\n                        </div>\r\n                        <div class=\"col-xs-12 zero_padding signup_form\">\r\n                            <span class=\"\">\r\n                                <input type=\"text\" id=\"fullName\" [(ngModel)]=\"fullName\" name=\"fullName\" (click)=\"registerUser()\" value=\"\" id=\"fullname_register\"\r\n                                    class=\"fullname_register form-control color_thick color_opacity\" placeholder=\"Full Name\">\r\n                                <i class=\"icon_err_right\"></i>\r\n                            </span>\r\n\r\n                        </div>\r\n                        <div class=\"col-xs-12 zero_padding signup_form\">\r\n                            <span class=\"\">\r\n                                <input type=\"text\" [(ngModel)]=\"username\" name=\"username\" (click)=\"registerUser()\" id=\"username\" value=\"\" class=\"sign_validation1 form-control color_thick color_opacity\"\r\n                                    placeholder=\"Username\" style=\"text-transform: lowercase;\">\r\n                                <i class=\"icon_err_right\"></i>\r\n                            </span>\r\n                            <!--<control-messages [control]=\"signupForm.controls.username\"></control-messages>-->\r\n                            <div *ngIf=\"error_icon\" class=\"icon_err_right error\"></div>\r\n                        </div>\r\n                        <div class=\"col-xs-12 zero_padding signup_form\">\r\n                            <span class=\"\">\r\n                                <input type=\"password\" [(ngModel)]=\"password\" name=\"password\" (click)=\"registerUser()\" id=\"password\" value=\"\" class=\"sign_validation2 form-control color_thick color_opacity\"\r\n                                    placeholder=\"Password\">\r\n                                <i class=\"icon_err_right\"></i>\r\n                            </span>\r\n                            <!--<control-messages [control]=\"signupForm.controls.password\"></control-messages>-->\r\n                        </div>\r\n\r\n                        <div class=\"col-xs-12 zero_padding signup_form\">\r\n                            <span class=\"bufferlogin_gif\" *ngIf=\"bufferlogin\">\r\n                                <img src=\"/public/images/ajax-loader2.gif\" alt=\"loader\">\r\n                            </span>\r\n                            <span class=\"col-xs-12 zero_padding\">\r\n                                <button type=\"submit\" (click)=\"registerUsersubmitList();\" class=\"submitregister landing_click signup_click col-xs-12 zero_padding\">Sign up</button>\r\n                            </span>\r\n                            <span class=\"col-xs-12 zero_padding error_show\" style=\"color:red;display:none;\">This field is required.</span>\r\n                        </div>\r\n                        <div style=\"color:#FF5A5F\" *ngIf=\"signupMessage\">{{signupMessage}}</div>\r\n                        <div style=\"color:green\" *ngIf=\"signupSuccess\">{{signupSuccess}}</div>\r\n                        <div style=\"color:#FF5A5F\" *ngIf=\"fbloginerror\">{{fbloginerror}}</div>\r\n                    </form>\r\n                    <div class=\"col-xs-12 zero_padding signup_form terms_agree\">\r\n                        <span class=\"col-xs-12 zero_padding privacy_terms\">\r\n                            By signing up, you agree to our\r\n                            <a class=\"link_color\" target=\"_blank\" [routerLink]=\"['/terms']\">Terms</a> &\r\n                            <a class=\"link_color\" target=\"_blank\" [routerLink]=\"['/privacy']\">Privacy Policy</a>\r\n                        </span>\r\n                    </div>\r\n                </div>\r\n\r\n                <div class=\"col-xs-12 zero_padding account_login_page showdetails signupUserotp\" style=\"display:none;\">\r\n                    <div class=\"col-xs-12 zero_padding signup_form\">\r\n                        <span class=\"\">\r\n                            <input type=\"text\" maxlength=\"4\" [(ngModel)]=\"OtpNumber\" name=\"OtpNumber\" value=\"\" class=\"form-control color_thick color_opacity icon_err_right\"\r\n                                oninput=\"this.value = this.value.replace(/[^0-9.]/g, '').replace(/(\\..*)\\./g, '$1');\" placeholder=\"otp\">\r\n                            <i class=\"icon_err_right\"></i>\r\n                        </span>\r\n                        <div *ngIf=\"error_iconfb\" class=\"icon_err_right fberror error\"></div>\r\n                    </div>\r\n                    <div class=\"col-xs-12 zero_padding signup_form\">\r\n                        <span class=\"bufferlogin_gif loaderFb\" *ngIf=\"bufferlogin\">\r\n                            <img src=\"/public/images/ajax-loader2.gif\" alt=\"loader\">\r\n                        </span>\r\n                        <span class=\"col-xs-12 zero_padding\">\r\n                            <button type=\"submit\" (click)=\"registerUsersubmit();\" [disabled]=\"!OtpNumber\" class=\"landing_click login_click col-xs-12 zero_padding\">Submit</button>\r\n                        </span>\r\n                    </div>\r\n                    <div style=\"color:#FF5A5F\" *ngIf=\"loginMessage\">{{loginMessage}}</div>\r\n                    <!--<div style=\"color:green\" *ngIf=\"loginSuccess\">{{loginSuccess}}</div>-->\r\n                </div>\r\n\r\n                <div class=\"col-xs-12 zero_padding account_login_page showdetails fbuserPassword\" style=\"display:none;\">\r\n                    <div class=\"col-xs-12 zero_padding text-center\" style=\"color: #999;padding: 0% 10%;\">Thank you for registering, please create your username and password.</div>\r\n                    <form [formGroup]=\"loginForm\" (submit)=\"loginUser()\">\r\n                        <div class=\"col-xs-12 zero_padding signup_form\">\r\n                            <span class=\"\">\r\n                                <input type=\"text\" [(ngModel)]=\"username\" #unc (keyup)=\"userNameCheck(unc.value)\" (change)=\"userNameCheck(unc.value)\" name=\"username\"\r\n                                    id=\"usernamefb\" value=\"\" class=\"sign_validation3 form-control color_thick color_opacity icon_err_right\"\r\n                                    placeholder=\"Username\">\r\n                                <i class=\"icon_err_right\"></i>\r\n                            </span>\r\n                            <div *ngIf=\"error_iconfb\" class=\"icon_err_right fberror error\"></div>\r\n                        </div>\r\n                        <div class=\"col-xs-12 zero_padding signup_form\">\r\n                            <span class=\"\">\r\n                                <input type=\"password\" [(ngModel)]=\"password\" name=\"password\" id=\"password1\" value=\"\" class=\"sign_validation4 form-control color_thick color_opacity icon_err_right\"\r\n                                    placeholder=\"Passsword\">\r\n                                <i class=\"icon_err_right\"></i>\r\n                            </span>\r\n                        </div>\r\n                        <div class=\"col-xs-12 zero_padding signup_form\">\r\n                            <span class=\"bufferlogin_gif loaderFb\" *ngIf=\"bufferlogin\">\r\n                                <img src=\"/public/images/ajax-loader2.gif\" alt=\"loader\">\r\n                            </span>\r\n                            <span class=\"col-xs-12 zero_padding\">\r\n                                <button type=\"submit\" (click)=\"fbauthenticateUser();\" [disabled]=\"!(username && password)\" class=\"landing_click login_click col-xs-12 zero_padding\">Submit</button>\r\n                            </span>\r\n                        </div>\r\n                        <div style=\"color:#FF5A5F\" *ngIf=\"loginMessage\">{{loginMessage}}</div>\r\n                        <!--<div style=\"color:green\" *ngIf=\"loginSuccess\">{{loginSuccess}}</div>-->\r\n                    </form>\r\n                </div>\r\n\r\n                <div class=\"col-xs-12 zero_padding account_login_page showdetails\" [hidden]=\"hideElement\" *ngIf=\"displayLogin\">\r\n                    <form [formGroup]=\"loginForm\" (submit)=\"loginUser()\">\r\n                        <div class=\"col-xs-12 zero_padding signup_form\">\r\n                            <span class=\"\">\r\n                                <input type=\"text\" [(ngModel)]=\"username\" name=\"username\" id=\"username1\" value=\"\" class=\"sign_validation3 form-control color_thick color_opacity icon_err_right\"\r\n                                    placeholder=\"Username\">\r\n                                <i class=\"icon_err_right\"></i>\r\n                            </span>\r\n                            <!--control-messages [control]=\"loginForm.controls.username\"></control-messages>-->\r\n                        </div>\r\n                        <div class=\"col-xs-12 zero_padding signup_form\">\r\n                            <span class=\"\">\r\n                                <input type=\"password\" [(ngModel)]=\"password\" name=\"password\" id=\"password1\" value=\"\" class=\"sign_validation4 form-control color_thick color_opacity icon_err_right\"\r\n                                    placeholder=\"Passsword\">\r\n                                <i class=\"icon_err_right\"></i>\r\n                            </span>\r\n                            <span class=\"forget_password_pico\" (click)=\"forgot()\">Forgot?</span>\r\n                            <!--control-messages [control]=\"loginForm.controls.password\"></control-messages>-->\r\n                        </div>\r\n                        <div class=\"col-xs-12 zero_padding signup_form\">\r\n                            <span class=\"bufferlogin_gif\" *ngIf=\"bufferlogin\">\r\n                                <img src=\"/public/images/ajax-loader2.gif\" alt=\"loader\">\r\n                            </span>\r\n                            <span class=\"col-xs-12 zero_padding\">\r\n                                <button type=\"submit\" (click)=\"authenticateUser();\" class=\"landing_click login_click col-xs-12 zero_padding\">Log in</button>\r\n                            </span>\r\n                        </div>\r\n                        <div style=\"color:#FF5A5F\" *ngIf=\"loginMessage\">{{loginMessage}}</div>\r\n                        <!--<div style=\"color:green\" *ngIf=\"loginSuccess\">{{loginSuccess}}</div>-->\r\n                    </form>\r\n                </div>\r\n\r\n                <div class=\"col-xs-12 zero_padding account_login_page\" *ngIf=\"edited\">\r\n                    <form [formGroup]=\"resetForm\">\r\n                        <div class=\"col-xs-12 zero_padding signup_form\">\r\n                            <span class=\"\">\r\n                                <input type=\"text\" [(ngModel)]=\"email\" name=\"email\" class=\"sign_validation3 form-control color_thick color_opacity icon_err_right\"\r\n                                    id=\"forgotemail\" placeholder=\"Email\">\r\n                                <i class=\"icon_err_right\"></i>\r\n                            </span>\r\n                            <control-messages [control]=\"resetForm.controls.email\"></control-messages>\r\n                        </div>\r\n                        <div class=\"col-xs-12 zero_padding signup_form\">\r\n                            <span class=\"bufferlogin_gif\" *ngIf=\"bufferlogin\">\r\n                                <img src=\"/public/images/ajax-loader2.gif\" alt=\"loader\">\r\n                            </span>\r\n                            <span class=\"col-xs-12 zero_padding\">\r\n                                <button type=\"submit\" [disabled]=\"!resetForm.valid\" (click)=\"forgotPassword();\" class=\"landing_click login_click col-xs-12 zero_padding\">Reset Password</button>\r\n                            </span>\r\n                        </div>\r\n                        <div style=\"color:green\" *ngIf=\"resetSuccess\">{{resetSuccess}}</div>\r\n                        <div style=\"color:#FF5A5F\" *ngIf=\"reseterror\">{{reseterror}}</div>\r\n                    </form>\r\n                </div>\r\n\r\n                <div class=\"col-xs-12 zero_padding login_signup\">\r\n                    <div class=\"col-xs-12 zero_padding account_login hidedetails\" *ngIf=\"!displayLogin\">\r\n                        <h5 class=\"col-xs-12 zero_padding\">Have an account?\r\n                            <span class=\"login click_login\" (click)=\"login();\">Log in</span>\r\n                        </h5>\r\n                    </div>\r\n                    <div class=\"col-xs-12 zero_padding account_sigup showdetails\" *ngIf=\"displayLogin\">\r\n                        <h5 class=\"col-xs-12 zero_padding\">Don't have an account?\r\n                            <span class=\"signup click_signup\" (click)=\"register();\">Sign up</span>\r\n                        </h5>\r\n                    </div>\r\n                </div>\r\n                <div class=\"col-xs-12 zero_padding get_the_app\">\r\n                    <h6 class=\"col-xs-12\">Get the app.</h6>\r\n                    <span class=\"col-xs-6 col-sm-5 col-sm-offset-1\" style=\"padding:0px;\">\r\n                        <img class=\"image_app\" src=\"/public/images/appstore.png\" alt=\"app store\">\r\n                    </span>\r\n                    <span class=\"col-xs-6 col-sm-5\" style=\"padding:0px;\">\r\n                        <img class=\"image_app\" src=\"/public/images/playstore.png\" alt=\"google play store\">\r\n                    </span>\r\n                </div>\r\n            </div>\r\n\r\n\r\n        </div>\r\n    </div>\r\n\r\n    <!-- popup modal -->\r\n    <div class=\"modal fade\" id=\"myModalAdmin\" role=\"dialog\" data-backdrop=\"static\">\r\n        <div class=\"modal-dialog modal-md\" style=\"margin-top: 15%;\">\r\n            <div class=\"modal-content\">\r\n                <div class=\"modal-body\">\r\n                    <button type=\"button\" class=\"close\" (click)=\"login()\">&times;</button>\r\n                    <h4>Thank you for registering in the app.We have sent your request to the admin.We will be getting back to\r\n                        you shortly.</h4>\r\n                </div>\r\n            </div>\r\n        </div>\r\n    </div>\r\n\r\n    <footer></footer>\r\n\r\n</body>\r\n\r\n</html>";

/***/ },

/***/ 458:
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var core_1 = __webpack_require__(5);
	var header_component_1 = __webpack_require__(459);
	var footer_component_1 = __webpack_require__(453);
	var router_1 = __webpack_require__(389);
	var router_2 = __webpack_require__(389);
	var home_service_1 = __webpack_require__(462);
	var HomeComponent = (function () {
	    function HomeComponent(HomeService, _router) {
	        this.HomeService = HomeService;
	        this._router = _router;
	        this.sharePost = false;
	    }
	    HomeComponent.prototype.ngOnInit = function () {
	        var token = localStorage.getItem('authToken');
	        if (token) {
	            this.sharePost = true;
	        }
	        // this.HomeService.profile()
	        // .subscribe((res) => {
	        //     console.log("testing");
	        //     console.log(res);
	        // });
	    };
	    HomeComponent = __decorate([
	        core_1.Component({
	            selector: 'home',
	            template: __webpack_require__(463),
	            directives: [header_component_1.HeaderComponent, footer_component_1.FooterComponent, router_1.ROUTER_DIRECTIVES],
	            providers: [home_service_1.HomeService]
	        }), 
	        __metadata('design:paramtypes', [home_service_1.HomeService, router_2.Router])
	    ], HomeComponent);
	    return HomeComponent;
	}());
	exports.HomeComponent = HomeComponent;


/***/ },

/***/ 459:
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var core_1 = __webpack_require__(5);
	var router_1 = __webpack_require__(389);
	var header_service_1 = __webpack_require__(460);
	var router_2 = __webpack_require__(389);
	var HeaderComponent = (function () {
	    function HeaderComponent(_headerService, _router) {
	        this._headerService = _headerService;
	        this._router = _router;
	        this.values = '';
	        this.limit = 10;
	        this.offset = 0;
	        this.data = 0;
	        this.blur_close = false;
	        this.recentactivityloader = false;
	        this.recentactivityactivity = false;
	        this.search_person = false;
	        this.search_hashtag = false;
	        this.search_location = false;
	    }
	    HeaderComponent.prototype.ngOnInit = function () {
	        var _this = this;
	        var token = localStorage.getItem('authToken');
	        if (!token)
	            this._router.navigate(["login"]);
	        // console.log("hiiiii...");
	        this._headerService.recentactivitypeople(this.limit, this.offset)
	            .subscribe(function (res) {
	            // console.log(res);
	            // if (res.code == 401){
	            //   // console.log("hiiiiissss...");
	            //   // var token = localStorage.removeItem('authToken');
	            //   // var username = localStorage.removeItem('username');
	            //   // this._router.navigate(['login']);
	            // }
	            _this.activity = res.data;
	            _this.commentfunction();
	        });
	    };
	    HeaderComponent.prototype.recentactivityy = function () {
	        this.recentactivityactivity = true;
	    };
	    HeaderComponent.prototype.commentfunction = function () {
	        var len = this.activity.length;
	        for (var i = 0; i < len; i++) {
	            var post = this.activity[i].createdOn;
	            var poston = Number(post);
	            var postdate = new Date(poston);
	            var currentdate = new Date();
	            var timeDiff = Math.abs(postdate.getTime() - currentdate.getTime());
	            var diffDays = Math.ceil(timeDiff / (1000 * 3600 * 24));
	            var diffHrs = Math.round((timeDiff % 86400000) / 3600000);
	            var diffMins = Math.round(((timeDiff % 86400000) % 3600000) / 60000);
	            if (1 < diffDays) {
	                this.activity[i].createdOn = diffDays + "d";
	            }
	            else if (1 <= diffHrs) {
	                this.activity[i].createdOn = diffHrs + "h";
	            }
	            else {
	                this.activity[i].createdOn = diffMins + "m";
	            }
	        }
	    };
	    HeaderComponent.prototype.memberprofile = function (item) {
	        var personname = item.membername;
	        var username = localStorage.getItem('username');
	        if (username == personname) {
	            this._router.navigate(['home/profile']);
	        }
	        else {
	            var link = ['home/person', personname];
	            this._router.navigate(link);
	        }
	        this.blur_close = false;
	    };
	    HeaderComponent.prototype.memberprofileactivity = function (item) {
	        var person_name = item.membername;
	        var personname = item.username;
	        var postId = item.postId;
	        if (postId) {
	            //console.log(personname, postId);
	            var link = ['home/homepost', personname, postId];
	            this._router.navigate(link);
	        }
	        else {
	            var link = ['home/person', person_name];
	            this._router.navigate(link);
	        }
	        // var username = localStorage.getItem('username');
	        // if (username == personname) {
	        //     this._router.navigate(['home/profile']);
	        // }
	        // else {
	        //     let link = ['home/person', personname];
	        //     this._router.navigate(link);
	        // }
	        this.blur_close = false;
	    };
	    HeaderComponent.prototype.memberprofilehashtag = function (item) {
	        var personname = item.hashTagName;
	        var username = localStorage.getItem('username');
	        var link = ['home/personcaption', personname];
	        this._router.navigate(link);
	        this.blur_close = false;
	    };
	    HeaderComponent.prototype.memberprofilelocation = function (item) {
	        var personname = item.placename;
	        var username = localStorage.getItem('username');
	        var link = ['home/personlocation', personname];
	        this._router.navigate(link);
	        this.blur_close = false;
	    };
	    HeaderComponent.prototype.onKey = function (value, limit, offset) {
	        var _this = this;
	        this.values = value;
	        if (value.length > 0) {
	            if (this.values.charAt(0) == '#') {
	                var hashtag_regexp = /#([a-zA-Z0-9_]+)/g;
	                this.values = this.values.replace(hashtag_regexp, '$1');
	                // //console.log(search_text);
	                this._headerService.searchpeople(this.values, this.limit, this.offset)
	                    .subscribe(function (res) {
	                    _this.search_person = false;
	                    _this.search_hashtag = true;
	                    _this.search_location = false;
	                    _this.data = res.data;
	                    if (res.data.userData[0]) {
	                        _this.userData = res.data.hashTagData[0].hashTagName;
	                    }
	                });
	            }
	            else if (this.values.charAt(0) == '@') {
	                var hashtag_regexp = /@([a-zA-Z0-9_]+)/g;
	                this.values = this.values.replace(hashtag_regexp, '$1');
	                // //console.log(search_text);
	                this._headerService.searchpeople(this.values, this.limit, this.offset)
	                    .subscribe(function (res) {
	                    _this.search_person = true;
	                    _this.search_hashtag = false;
	                    _this.search_location = false;
	                    _this.data = res.data;
	                    if (res.data.userData[0]) {
	                        _this.userData = res.data.userData[0].membername;
	                    }
	                });
	            }
	            else {
	                this._headerService.searchpeople(this.values, this.limit, this.offset)
	                    .subscribe(function (res) {
	                    _this.search_person = true;
	                    _this.search_hashtag = true;
	                    _this.search_location = true;
	                    _this.data = res.data;
	                    if (res.data.userData[0]) {
	                        _this.userData = res.data.userData[0].membername;
	                    }
	                    //  //console.log(res.data.userData[0].membername);
	                });
	            }
	        }
	    };
	    HeaderComponent.prototype.usersearchSubmit = function (value, data) {
	        // //console.log(this.userData);
	        var searchname = this.userData;
	        if (value.charAt(0) == '#') {
	            var link = ['home/personcaption', searchname];
	            this._router.navigate(link);
	            this.blur_close = false;
	        }
	        else if (value.charAt(0) != '#') {
	            if (searchname) {
	                var link = ['home/person', searchname];
	                this._router.navigate(link);
	                this.blur_close = false;
	            }
	            else {
	                var link = ['home/person', value];
	                this._router.navigate(link);
	                this.blur_close = false;
	            }
	        }
	    };
	    HeaderComponent.prototype.blursearch = function () {
	        var _this = this;
	        // alert("hai");
	        setTimeout(function () {
	            jQuery("#searchPico").val('');
	            _this.blur_close = false;
	        }, 200);
	    };
	    HeaderComponent.prototype.searchopen = function () {
	        // alert("hi");
	        this.blur_close = true;
	    };
	    HeaderComponent = __decorate([
	        core_1.Component({
	            selector: 'header',
	            // templateUrl : '/header.html',
	            template: __webpack_require__(461),
	            directives: [router_1.ROUTER_DIRECTIVES],
	            providers: [header_service_1.HeaderService]
	        }), 
	        __metadata('design:paramtypes', [header_service_1.HeaderService, router_2.Router])
	    ], HeaderComponent);
	    return HeaderComponent;
	}());
	exports.HeaderComponent = HeaderComponent;


/***/ },

/***/ 460:
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var core_1 = __webpack_require__(5);
	var router_1 = __webpack_require__(389);
	var app_constants_1 = __webpack_require__(441);
	var http_1 = __webpack_require__(363);
	var HeaderService = (function () {
	    function HeaderService(_router, _http, _conf) {
	        this._router = _router;
	        this._http = _http;
	        this._conf = _conf;
	        this._recentactivityUrl = this._conf.Url + 'selfActivity';
	        this._searchUrl = this._conf.Url + 'generalSearch';
	    }
	    // private _searchuserUrl = 'http://159.203.143.251:3000/api/v1/searchUsers';
	    // private _searchhastagUrl = 'http://159.203.143.251:3000/api/v1/getHashTagSuggetion';
	    HeaderService.prototype.recentactivitypeople = function (limit, offset) {
	        var token = localStorage.getItem('authToken');
	        var body = { token: token, limit: limit, offset: offset };
	        // console.log(body);
	        return this._http.post(this._conf.Url + 'selfActivity', body, { headers: this._conf.headers })
	            .map(function (res) { return res.json(); })
	            .map(function (res) {
	            // console.log('activity', res);
	            // if (res.token) {
	            //     localStorage.setItem('user', res.token);S
	            //     // this._router.navigate(['Pages']);
	            //     return res.code;
	            // }
	            return res;
	        });
	    };
	    HeaderService.prototype.searchpeople = function (value, limit, offset) {
	        var token = localStorage.getItem('authToken');
	        var body = { token: token, keyToSearch: value, limit: limit, offset: offset };
	        //console.log(body);
	        return this._http.post(this._conf.Url + 'generalSearch', body, { headers: this._conf.headers })
	            .map(function (res) { return res.json(); })
	            .map(function (res) {
	            //console.log(res);
	            // if (res.token) {
	            //     localStorage.setItem('user', res.token);S
	            //     // this._router.navigate(['Pages']);
	            //     return res.code;
	            // }
	            return res;
	        });
	    };
	    HeaderService = __decorate([
	        core_1.Injectable(), 
	        __metadata('design:paramtypes', [router_1.Router, http_1.Http, app_constants_1.Configuration])
	    ], HeaderService);
	    return HeaderService;
	}());
	exports.HeaderService = HeaderService;


/***/ },

/***/ 461:
/***/ function(module, exports) {

	module.exports = "<div class=\"container-fluid picogram_total\">\r\n\t<div class=\"container-fluid pico_total\">\r\n\t\t<div class=\"container pico_header\">\r\n\t\t\t<div class=\"picogram_logo col-xs-4 col-sm-4\" style=\"padding:0px;\">\r\n\t\t\t\t<a [routerLink]=\"['/home']\">\r\n\t\t\t\t\t<span class=\"logo_image\">\r\n\t\t\t\t\t\t<img src=\"/public/images/pico_logo.png\">\r\n\t\t\t\t\t\t<!-- <span class=\"titleLogo\">Sportemage</span> -->\r\n\t\t\t\t\t</span>\r\n\t\t\t\t</a>\r\n\t\t\t</div>\r\n\t\t\t<div class=\"picogram_search col-xs-4 col-sm-4\" style=\"text-align:center;padding:0px;\">\r\n\t\t\t\t<span class=\"searchicon\">\r\n\t\t\t\t\t<input type=\"text\" #box (keyup)=\"onKey(box.value)\" (keyup.enter)=\"usersearchSubmit(box.value); box.value=''\" (blur)=\"blursearch()\"\r\n\t\t\t\t\t id=\"searchPico\" (click)=\"searchopen()\" class=\"form-control search_type\" placeholder=\"Search\">\r\n\t\t\t\t\t<i class=\"pico_search_icon search_icon\"></i>\r\n\t\t\t\t</span>\r\n\t\t\t\t<div *ngIf=\"blur_close\">\r\n\t\t\t\t\t<div class=\"search_arrowicon\" *ngIf=\"data\"></div>\r\n\t\t\t\t\t<ul class=\"serarch_dropdown zero_padding col-xs-12\" *ngIf=\"data\" style=\"\">\r\n\r\n\t\t\t\t\t\t<div class=\"profilename_comment drop_down_list col-xs-12\" [hidden]=\"!search_person\" *ngFor=\"let item of data.userData\" style=\"height: 50px;padding: 2% 2%;\">\r\n\t\t\t\t\t\t\t<span class=\"follow_detailss col-xs-2 zero_padding\">\r\n\t\t\t\t\t\t\t\t<img class=\"suggestion_image\" src=\"{{item.memberProfilePicUrl}}\" onError=\"this.src='/public/images/default.png';\">\r\n\t\t\t\t\t\t\t</span>\r\n\t\t\t\t\t\t\t<span class=\"name_comment zero_padding col-xs-10\" style=\"text-align: left;\">\r\n\t\t\t\t\t\t\t\t<h5 class=\"color_thick member_name zero_padding\" (click)=\"memberprofile(item)\">{{item.membername}}</h5>\r\n\t\t\t\t\t\t\t\t<h6 class=\"color_thick color_opacity zero_padding\"> {{item.memberFullName}} </h6>\r\n\t\t\t\t\t\t\t</span>\r\n\t\t\t\t\t\t</div>\r\n\t\t\t\t\t\t<div class=\"profilename_comment drop_down_list col-xs-12\" [hidden]=\"!search_hashtag\" *ngFor=\"let item of data.hashTagData\"\r\n\t\t\t\t\t\t style=\"height: 50px;padding: 2% 2%;\">\r\n\t\t\t\t\t\t\t<span class=\"follow_detailss col-xs-2 zero_padding\">\r\n\t\t\t\t\t\t\t\t<span class=\"hastag_icon hastagicon\"></span>\r\n\t\t\t\t\t\t\t</span>\r\n\t\t\t\t\t\t\t<span class=\"name_comment zero_padding col-xs-10\" style=\"text-align: left;\">\r\n\t\t\t\t\t\t\t\t<h5 class=\"color_thick member_name zero_padding\" (click)=\"memberprofilehashtag(item)\">{{item.hashTagName}}</h5>\r\n\t\t\t\t\t\t\t\t<h6 class=\"color_thick color_opacity zero_padding\"> {{item.hashTagCount}} posts</h6>\r\n\t\t\t\t\t\t\t</span>\r\n\t\t\t\t\t\t</div>\r\n\t\t\t\t\t\t<div class=\"profilename_comment drop_down_list col-xs-12\" [hidden]=\"!search_location\" *ngFor=\"let item of data.placeData\"\r\n\t\t\t\t\t\t style=\"height: 50px;padding: 2% 2%;\">\r\n\t\t\t\t\t\t\t<span class=\"follow_detailss col-xs-2 zero_padding\">\r\n\t\t\t\t\t\t\t\t<span class=\"location_icon locationicon\"></span>\r\n\t\t\t\t\t\t\t</span>\r\n\t\t\t\t\t\t\t<span class=\"name_comment zero_padding col-xs-10\" style=\"text-align: left;\">\r\n\t\t\t\t\t\t\t\t<h5 class=\"color_thick member_name zero_padding\" (click)=\"memberprofilelocation(item)\">{{item.placename}}</h5>\r\n\t\t\t\t\t\t\t\t<h6 class=\"color_thick color_opacity zero_padding\"> {{item.memberFullName}} </h6>\r\n\t\t\t\t\t\t\t</span>\r\n\t\t\t\t\t\t</div>\r\n\t\t\t\t\t\t<div class=\"profilename_comment drop_down_list col-xs-12\" style=\"padding: 0px;\" *ngIf=\"data.userData.length == 0 && data.hashTagData.length == 0 && data.placeData.length == 0\">\r\n\t\t\t\t\t\t\t<span class=\"color_opacity\">No results found.</span>\r\n\t\t\t\t\t\t</div>\r\n\t\t\t\t\t</ul>\r\n\t\t\t\t\t<!--<ul class=\"serarch_dropdown zero_padding col-xs-12\" *ngIf=\"data.userData.length == 0\" style=\"\">\r\n\t\t\t\t\t\t<span class=\"color_opacity\">No results found.</span>\r\n\t\t\t\t\t</ul>-->\r\n\t\t\t\t</div>\r\n\t\t\t\t<!--<ul class=\"serarch_dropdown zero_padding col-xs-12\" *ngIf=\"!data\" style=\"\">\r\n\t\t\t\t\t <h5>no results found</h5>\r\n\t\t\t\t </ul>-->\r\n\t\t\t</div>\r\n\t\t\t<div class=\"picogram_image col-xs-4 col-sm-4\" style=\"text-align:right;padding:0px;\">\r\n\t\t\t\t<a [routerLink]=\"['discover']\">\r\n\t\t\t\t\t<span class=\"pico_right_image find_pepole\"></span>\r\n\t\t\t\t</a>\r\n\t\t\t\t<span class=\"pico_right_image activity_feed dropdown-toggle member_name\" (click)=\"recentactivityy();\" data-toggle=\"dropdown\"></span>\r\n\t\t\t\t<!-- dropdown menu-->\r\n\t\t\t\t<ul class=\"dropdown-menu\" style=\"\" *ngIf=\"activity\">\r\n\t\t\t\t\t<!--<span class=\"bufferdiscover_gif\" id=\"\" [hidden]=\"!recentactivityloader\" style=\"left: 45%;top: 20%;\"><img src=\"/public/images/ajax-loader2.gif\" alt=\"loader\"></span>\t\t\t\t\t  -->\r\n\t\t\t\t\t<div class=\"profilename_comment drop_down_list col-xs-12\" [hidden]=\"!recentactivityactivity\" *ngFor=\"let item of activity\">\r\n\t\t\t\t\t\t<!--<div *ngIf=\"item.type==4\">-->\r\n\t\t\t\t\t\t<span class=\"follow_detailss col-xs-1\">\r\n\t\t\t\t\t\t\t<img class=\"suggestion_image member_name\" (click)=\"memberprofile(item);\" src=\"{{item.memberProfilePicUrl}}\" onError=\"this.src='/public/images/default.png';\">\r\n\t\t\t\t\t\t</span>\r\n\t\t\t\t\t\t<span class=\"name_comment col-xs-11\" style=\"padding-right: 0%;\">\r\n\t\t\t\t\t\t\t<span class=\"color_thick member_name\" (click)=\"memberprofile(item);\">{{item.membername}}</span>\r\n\t\t\t\t\t\t\t<span class=\"\">\r\n\t\t\t\t\t\t\t\t<span class=\"color_thick color_opacity member_name\" (click)=\"memberprofileactivity(item);\" *ngIf=\"item.notificationMessage == 'likedPost'\">liked your photo</span>\r\n\t\t\t\t\t\t\t\t<span class=\"color_thick color_opacity member_name\" (click)=\"memberprofileactivity(item);\" *ngIf=\"item.notificationMessage == 'requestedToFollow'\">requested to follow you</span>\r\n\t\t\t\t\t\t\t\t<span class=\"color_thick color_opacity member_name\" (click)=\"memberprofileactivity(item);\" *ngIf=\"item.notificationMessage == 'tagged'\">tagged you in a post</span>\r\n\t\t\t\t\t\t\t\t<span class=\"color_thick color_opacity member_name\" *ngIf=\"item.notificationMessage != 'likedPost' && item.notificationMessage != 'requestedToFollow' && item.notificationMessage != 'tagged'\"\r\n\t\t\t\t\t\t\t\t (click)=\"memberprofileactivity(item);\">{{item.notificationMessage}} you.</span>\r\n\t\t\t\t\t\t\t\t<time class=\"time_mention\">{{item.createdOn}}</time>\r\n\t\t\t\t\t\t\t</span>\r\n\t\t\t\t\t\t</span>\r\n\t\t\t\t\t\t<span class=\"follow_detailss col-xs-1 zero_padding\" *ngIf=\"item.notificationMessage == 'likedPost'\">\r\n\t\t\t\t\t\t\t<img class=\"suggestion_image drop_sideimg member_name\" (click)=\"memberprofileactivity(item);\" src=\"{{item.thumbnailImageUrl}}\"\r\n\t\t\t\t\t\t\t onError=\"this.src='/public/images/default.png';\">\r\n\t\t\t\t\t\t</span>\r\n\r\n\t\t\t\t\t\t<!--</div>-->\r\n\t\t\t\t\t</div>\r\n\t\t\t\t</ul>\r\n\t\t\t\t<!--end dropdown menu-->\r\n\t\t\t\t<a [routerLink]=\"['profile']\">\r\n\t\t\t\t\t<span class=\"pico_right_image  profile\"></span>\r\n\t\t\t\t</a>\r\n\t\t\t</div>\r\n\t\t</div>\r\n\t</div>\r\n</div>";

/***/ },

/***/ 462:
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var core_1 = __webpack_require__(5);
	var router_1 = __webpack_require__(389);
	var app_constants_1 = __webpack_require__(441);
	var http_1 = __webpack_require__(363);
	var HomeService = (function () {
	    function HomeService(_router, _http, _conf) {
	        this._router = _router;
	        this._http = _http;
	        this._conf = _conf;
	    }
	    HomeService.prototype.profile = function () {
	        var token = localStorage.getItem('authToken');
	        var body = {
	            token: token
	        };
	        // console.log(body);
	        return this._http.post(this._conf.Url + 'getUserProfile', body, { headers: this._conf.headers })
	            .map(function (res) { return res.json(); })
	            .map(function (res) {
	            // console.log("profile",res);
	            // if (res.token) {
	            //     localStorage.setItem('user', res.token);S
	            //     // this._router.navigate(['Pages']);
	            //     return res.code;
	            // }
	            return res;
	        });
	    };
	    HomeService = __decorate([
	        core_1.Injectable(), 
	        __metadata('design:paramtypes', [router_1.Router, http_1.Http, app_constants_1.Configuration])
	    ], HomeService);
	    return HomeService;
	}());
	exports.HomeService = HomeService;


/***/ },

/***/ 463:
/***/ function(module, exports) {

	module.exports = "<div class=\"\" *ngIf=\"sharePost\">\r\n    <header></header>\r\n</div>\r\n    <router-outlet></router-outlet>\r\n\r\n\r\n<!--<footer></footer>-->";

/***/ },

/***/ 464:
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var core_1 = __webpack_require__(5);
	var home_service_1 = __webpack_require__(465);
	var router_1 = __webpack_require__(389);
	var router_2 = __webpack_require__(389);
	var angular2_infinite_scroll_1 = __webpack_require__(466);
	var ContentComponent = (function () {
	    // items: any[] = [];
	    // canFly = true;
	    function ContentComponent(_homeService, _router) {
	        // for (let i = 0; i < this.sum; ++i) {
	        //      this.array.push(i);
	        // }
	        this._homeService = _homeService;
	        this._router = _router;
	        this.data = [];
	        this.commnentdetails = [];
	        // array:any = [];
	        this.sum = 0;
	        this.loading = true;
	        this.comment = false;
	        this.commentt = false;
	        this.firstallcomment = true;
	        this.lastcomment = false;
	        this.viewallcomment = false;
	        this.offset = 0;
	        this.post = false;
	        this.nopost = false;
	    }
	    ContentComponent.prototype.ngOnInit = function () {
	        var _this = this;
	        jQuery(".modal-backdrop").css({ "display": "none" });
	        this.CurrentDate = new Date();
	        var token = localStorage.getItem('authToken');
	        if (!token)
	            this._router.navigate(["login"]);
	        var username = localStorage.getItem('username');
	        this.username = username;
	        if (username) {
	        }
	        this._homeService.home()
	            .subscribe(function (res) {
	            if (res.code == 200) {
	                if (res.message != "success") {
	                    // this.post = true;
	                    _this._router.navigate(["home/discoverpost"]);
	                }
	                else {
	                    _this.loading = false;
	                    // this.data = res.result;
	                    _this.data = [];
	                    _this.totaldata = res.data;
	                    //  this.totaldata1 = res.result;
	                    _this.offset = _this.totaldata.length;
	                    _this.commentfunction();
	                }
	            }
	            // var len = this.totaldata.length;
	            // for (var i = 0; i < len; i++) {
	            //     this.commentdata = [];
	            //     if (this.totaldata[i].comments) {
	            //         var postCommentNodeArr = this.totaldata[i].comments.split('^^');
	            //         for (var x = 0; x < postCommentNodeArr.length; x++) {
	            //             postCommentNodeArr.splice(x, 0);
	            //             var postCommentNodeArr1 = postCommentNodeArr[x].split('$$');
	            //             this.commentdata.push(postCommentNodeArr1);
	            //         }
	            //     }
	            //     this.totaldata[i].comments = this.commentdata;
	            // }
	            // this.data = this.totaldata;
	            // //console.log(this.data);
	            if (_this.offset >= 10)
	                _this.loadmoree = true;
	        });
	        jQuery(document).keyup(function (e) {
	            if (e.keyCode == 27) {
	                jQuery(".modal").css({ "display": "none" });
	                jQuery(".modal-backdrop").css({ "display": "none" });
	            }
	        });
	    };
	    ContentComponent.prototype.hashtagFunction = function () {
	        var len = this.totaldata.length;
	        for (var i = 0; i < len; i++) {
	            if (this.totaldata[i].commentData) {
	                var commenttext = this.totaldata[i].commentData;
	                for (var x = 0; x < commenttext.length; x++) {
	                    // commenttext.splice(x, 0);
	                    if (this.totaldata[i].commentData[x].commentBody) {
	                        var postCommentNodeArr1 = commenttext[x].commentBody;
	                        // //console.log(postCommentNodeArr1);
	                        var hashtag_regexp = /#([a-zA-Z0-9_]+)/g;
	                        var comment_text = postCommentNodeArr1.replace(hashtag_regexp, '<a href="home/personcaption/$1" class="hashtag member_name biohashtag">#$1</a>');
	                        var hashtag_regexp1 = /@([a-zA-Z0-9_]+)/g;
	                        var comment_textt = comment_text.replace(hashtag_regexp1, '<a href="home/person/$1" class="hashtag member_name biohashtag">@$1</a>');
	                        this.totaldata[i].commentData[x].commentBody = comment_textt;
	                    }
	                }
	            }
	        }
	    };
	    ContentComponent.prototype.commentfunction = function () {
	        this.hashtagFunction();
	        // alert("hi");
	        var len = this.totaldata.length;
	        // alert(len);
	        for (var i = 0; i < len; i++) {
	            // //console.log('hello');
	            // this.commentdata = [];
	            // if (this.totaldata[i].comments != "") {
	            //     var commenttext = this.totaldata[i].comments;
	            //     var hashtag_regexp = /#([a-zA-Z0-9_]+)/g;
	            //     var comment_text = commenttext.replace(
	            //         hashtag_regexp,
	            //         '<a href="home/personcaption/$1" class="hashtag member_name biohashtag">#$1</a>'
	            //     );
	            //     var hashtag_regexp1 = /@([a-zA-Z0-9_]+)/g;
	            //     var comment_textt = comment_text.replace(
	            //         hashtag_regexp1,
	            //         '<a href="home/person/$1" class="hashtag member_name biohashtag">@$1</a>'
	            //     );
	            //     var postCommentNodeArr = comment_textt.split('^^');
	            //     for (var x = 0; x < postCommentNodeArr.length; x++) {
	            //         postCommentNodeArr.splice(x, 0);
	            //         var postCommentNodeArr1 = postCommentNodeArr[x].split('$$');
	            //         if (postCommentNodeArr1.length == 2)
	            //             this.commentdata.push(postCommentNodeArr1);
	            //     }
	            // }
	            // this.totaldata[i].comments = this.commentdata;
	            // var lend = this.commentdata.length - 1;
	            // if(lend > 5){
	            //     this.totaldata[i].commentslength = this.commentdata.length - 6;
	            // }
	            // var halfComments: any = [];
	            // if (lend > 5) {
	            //     let j = 0;
	            //     while (j < 5) {
	            //         halfComments.unshift(this.commentdata[lend--]);
	            //         j++;
	            //     }
	            //     this.totaldata[i].halfComments = halfComments;
	            // }
	            var postCaption = [];
	            if (this.totaldata[i].postCaption) {
	                var postCaptionn = this.totaldata[i].postCaption.split(' ');
	                this.totaldata[i].postCaption = postCaptionn;
	            }
	            var likedByUser = [];
	            if (this.totaldata[i].likedByUser) {
	                var liked = this.totaldata[i].likedByUser.split(',');
	                if (liked.length) {
	                    this.totaldata[i].likedByUser = liked;
	                }
	            }
	            else {
	                this.totaldata[i].likedByUser = [];
	            }
	            var usersTaggedInPosts = [];
	            if (this.totaldata[i].usersTaggedInPosts) {
	                usersTaggedInPosts = this.totaldata[i].usersTaggedInPosts.split(',');
	                this.totaldata[i].usersTaggedInPosts = usersTaggedInPosts;
	            }
	            var taggedUserCoordinates = [];
	            if (this.totaldata[i].taggedUserCoordinates) {
	                taggedUserCoordinates = this.totaldata[i].taggedUserCoordinates.split(',');
	                this.totaldata[i].taggedUserCoordinates = taggedUserCoordinates;
	            }
	            if (usersTaggedInPosts[0] != 'undefined' && taggedUserCoordinates[0] != null) {
	                var lenn = usersTaggedInPosts.length;
	                var tagsCords = [];
	                for (var j = 0; j < lenn; j++) {
	                    var userCords = {
	                        name: usersTaggedInPosts[j],
	                        right: 0,
	                        top: 0
	                    };
	                    if (taggedUserCoordinates[j]) {
	                        var cordinates = taggedUserCoordinates[j].split('-');
	                        userCords.right = cordinates[0];
	                        userCords.top = cordinates[1];
	                        tagsCords.push(userCords);
	                    }
	                }
	                this.totaldata[i].coords = tagsCords;
	            }
	            var post = this.totaldata[i].postedOn;
	            var poston = Number(post);
	            var postdate = new Date(poston);
	            var currentdate = new Date();
	            var timeDiff = Math.abs(postdate.getTime() - currentdate.getTime());
	            var diffDays = Math.ceil(timeDiff / (1000 * 3600 * 24));
	            var diffHrs = Math.round((timeDiff % 86400000) / 3600000);
	            var diffMins = Math.round(((timeDiff % 86400000) % 3600000) / 60000);
	            if (1 < diffDays) {
	                this.totaldata[i].postedOn = diffDays + "d";
	            }
	            else if (1 <= diffHrs) {
	                this.totaldata[i].postedOn = diffHrs + "h";
	            }
	            else {
	                this.totaldata[i].postedOn = diffMins + "m";
	            }
	            this.data.push(this.totaldata[i]);
	        }
	        // //console.log(this.data);
	    };
	    ContentComponent.prototype.allcomment = function (i) {
	        // //console.log(this.data[i].comments);
	        // var comments_length = this.data[i].commentslength;
	        // if(comments_length >= 0){
	        //     this.commentslength = comments_length;
	        //     this.commentslength = this.commentslength - 10;
	        //     this.data[i].commentslength =  this.commentslength;
	        //        if(this.commentslength <= 0){
	        //            this.commentslength = 0;
	        //            this.data[i].commentFlagg = true;
	        //        }
	        //         for(var m = comments_length; m >= this.commentslength; m--){
	        //             var aa = this.data[i].comments[m];
	        //             this.data[i].halfComments.unshift(this.data[i].comments[m]);
	        //             //console.log(aa, m);
	        //         }
	        // }
	        this.data[i].commentFlag = true;
	        this.data[i].commentFlagg = true;
	    };
	    ContentComponent.prototype.usertagged = function (i) {
	        this.data[i].usertaggedFlagg = true;
	    };
	    ContentComponent.prototype.falseusertagged = function (i) {
	        this.data[i].usertaggedFlagg = false;
	    };
	    ContentComponent.prototype.loadmore = function () {
	        var _this = this;
	        this.offset = this.data.length;
	        //console.log(this.offset);
	        this._homeService.loadmore(this.offset)
	            .subscribe(function (res) {
	            if (res.data) {
	                _this.totaldata = res.data;
	                _this.commentfunction();
	                _this.offset = res.data.length || 0;
	                if (_this.offset >= 10)
	                    _this.loadmoree = true;
	                else
	                    _this.loadmoree = false;
	            }
	            else {
	                _this.loadmoree = false;
	            }
	        });
	    };
	    ContentComponent.prototype.timepost = function (item) {
	        var postId = item.postId;
	        var postedByUserName = item.postedByUserName;
	        // //console.log(postId+"ff"+postedByUserName);
	        var link = ['home/homepost', postedByUserName, postId];
	        this._router.navigate(link);
	    };
	    ContentComponent.prototype.memberprofile = function (item) {
	        // alert(item.postId);
	        var personname = item.postedByUserName;
	        var username = localStorage.getItem('username');
	        if (username == personname) {
	            this._router.navigate(['home/profile']);
	        }
	        else {
	            var link = ['home/person', personname];
	            this._router.navigate(link);
	        }
	    };
	    ContentComponent.prototype.memberprofileplace = function (item) {
	        // alert(item.postId);
	        var placename = item.place;
	        // //console.log(placename);
	        var link = ['home/personlocation', placename];
	        this._router.navigate(link);
	    };
	    ContentComponent.prototype.memberprofilee = function (comment) {
	        // alert(item.postId);
	        var personname = comment.commentedByUser;
	        var username = localStorage.getItem('username');
	        if (username == personname) {
	            this._router.navigate(['home/profile']);
	        }
	        else {
	            var link = ['home/person', comment.commentedByUser];
	            this._router.navigate(link);
	        }
	    };
	    ContentComponent.prototype.membercaption = function (caption) {
	        var hashtagname = caption.split('#');
	        //console.log(hashtagname);
	        var link = ['home/personcaption', hashtagname[1]];
	        this._router.navigate(link);
	    };
	    ContentComponent.prototype.membercaptionn = function (comment) {
	        var hashtagname = comment[1].split('#');
	        //   //console.log(hashtagname[1]);        
	        var link = ['home/personcaption', hashtagname[1].replace(" ", "")];
	        this._router.navigate(link);
	    };
	    ContentComponent.prototype.memberprofilecaption = function (comment) {
	        var personname = comment[1].split('@');
	        var username = localStorage.getItem('username');
	        if (username == personname[1]) {
	            this._router.navigate(['home/profile']);
	        }
	        else {
	            var link = ['home/person', personname[1].replace(" ", "")];
	            this._router.navigate(link);
	        }
	    };
	    ContentComponent.prototype.memberprofilecaptionn = function (caption) {
	        var personname = caption.split('@');
	        var username = localStorage.getItem('username');
	        if (username == personname[1]) {
	            this._router.navigate(['home/profile']);
	        }
	        else {
	            var link = ['home/person', personname[1].replace(" ", "")];
	            this._router.navigate(link);
	        }
	    };
	    // var commnentdetails:any=[];
	    ContentComponent.prototype.commentdelete = function (comment, id, postsType, i, k) {
	        //  //console.log(comment[0]+" ss "+comment[1]+" id "+id+" postsType "+postsType+" i "+i);
	        postsType = postsType.toString();
	        this.commnentdetails = ({ username: comment.commentedByUser, message: comment.commentBody, commentId: comment.commentId, id: id, postsType: postsType, i: i, k: k });
	    };
	    ContentComponent.prototype.commentmodaldelete = function () {
	        //console.log(this.commnentdetails);
	        var commentlist = this.commnentdetails;
	        var commenttext = commentlist.message;
	        var hashtag_regexp = /<a[^>]*>([^<]+)<\/a>/g;
	        var comment_text = commenttext.replace(hashtag_regexp, '$1');
	        //  //console.log(commentlist.i);
	        this.data[commentlist.i].commentData.splice([commentlist.k], 1);
	        // if (this.data[commentlist.i].halfComments) {
	        //     this.data[commentlist.i].halfComments.splice([commentlist.k], 1);            
	        // }
	        this._homeService.userdeletecomment({ username: commentlist.username, message: comment_text, commentId: commentlist.commentId, id: commentlist.id, postsType: commentlist.postsType })
	            .subscribe();
	    };
	    ContentComponent.prototype.likedbyuser = function (liked) {
	        var personname = liked;
	        // alert(personname);
	        var username = localStorage.getItem('username');
	        if (username == personname) {
	            this._router.navigate(['home/profile']);
	        }
	        else {
	            var link = ['home/person', personname];
	            this._router.navigate(link);
	        }
	    };
	    ContentComponent.prototype.usertaggedname = function (tagged) {
	        // alert(item.postId);
	        var personname = tagged.name;
	        var username = localStorage.getItem('username');
	        if (username == personname) {
	            this._router.navigate(['home/profile']);
	        }
	        else {
	            var link = ['home/person', personname];
	            this._router.navigate(link);
	        }
	    };
	    ContentComponent.prototype.likedoubleClick = function (id, postsType, i) {
	        var _this = this;
	        // alert(id+'aa'+'bb'+postsType+'cc'+i);
	        if (this.data[i].likeStatus == 0) {
	            this.data[i].likeheartFlagg = true;
	            var username = localStorage.getItem('username');
	            this.data[i].likedByUser.unshift(username);
	            this.data[i].likeStatus = 1;
	            this.data[i].likes += 1;
	            this._homeService.userlike(id, postsType)
	                .subscribe();
	            setTimeout(function () {
	                _this.data[i].likeheartFlagg = false;
	            }, 500);
	        }
	    };
	    ContentComponent.prototype.likeactive = function (id, postsType, i) {
	        // alert(id);
	        var username = localStorage.getItem('username');
	        this.data[i].likedByUser.unshift(username);
	        this.data[i].likeStatus = 1;
	        this.data[i].likes += 1;
	        this._homeService.userlike(id, postsType)
	            .subscribe();
	    };
	    ContentComponent.prototype.likedeactive = function (id, postsType, i) {
	        //  alert(id);
	        var username = localStorage.getItem('username');
	        var array = this.data[i].likedByUser;
	        var index = array.indexOf(username);
	        if (index > -1) {
	            array.splice(index, 1);
	        }
	        this.data[i].likeStatus = 0;
	        this.data[i].likes -= 1;
	        this._homeService.userunlike(id, postsType)
	            .subscribe();
	    };
	    ContentComponent.prototype.usercommentSubmit = function (value, id, postsType, i) {
	        var _this = this;
	        postsType = postsType.toString();
	        // //console.log('you submitted value:', value, id, postType, i);        
	        var username = localStorage.getItem('username');
	        var commenttext = value;
	        var hashtag_regexp = /#([a-zA-Z0-9_]+)/g;
	        var comment_text = commenttext.replace(hashtag_regexp, '<a href="home/personcaption/$1" class="hashtag member_name biohashtag">#$1</a>');
	        var hashtag_regexp1 = /@([a-zA-Z0-9_]+)/g;
	        var comment_textt = comment_text.replace(hashtag_regexp1, '<a href="home/person/$1" class="hashtag member_name biohashtag">@$1</a>');
	        // //console.log(value.length)
	        if (value.length > 0) {
	            // this.data[i].comments.push([username, comment_textt]);
	            // if (this.data[i].halfComments) {
	            //     this.data[i].halfComments.push([username, comment_textt]);
	            // }
	            this._homeService.usercomment({ message: value, id: id, postsType: postsType })
	                .subscribe(function (res) {
	                _this.submitComment = res.data;
	                _this.data[i].commentData.push(_this.submitComment[0].commentData[0]);
	                _this.hashtagFunction();
	            });
	        }
	    };
	    ContentComponent = __decorate([
	        core_1.Component({
	            selector: 'content',
	            template: __webpack_require__(485),
	            directives: [router_1.ROUTER_DIRECTIVES, angular2_infinite_scroll_1.InfiniteScroll],
	            providers: [home_service_1.HomeService]
	        }), 
	        __metadata('design:paramtypes', [home_service_1.HomeService, router_2.Router])
	    ], ContentComponent);
	    return ContentComponent;
	}());
	exports.ContentComponent = ContentComponent;


/***/ },

/***/ 465:
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var core_1 = __webpack_require__(5);
	var router_1 = __webpack_require__(389);
	var app_constants_1 = __webpack_require__(441);
	var http_1 = __webpack_require__(363);
	var HomeService = (function () {
	    function HomeService(_router, _http, _conf) {
	        this._router = _router;
	        this._http = _http;
	        this._conf = _conf;
	    }
	    HomeService.prototype.home = function () {
	        var token = localStorage.getItem('authToken');
	        var body = { token: token };
	        //console.log(body);
	        return this._http.post(this._conf.Url + 'home', body, { headers: this._conf.headers })
	            .map(function (res) { return res.json(); })
	            .map(function (res) {
	            console.log(res);
	            // if (res.token) {
	            //     localStorage.setItem('user', res.token);
	            //     // this._router.navigate(['Pages']);
	            //     return res.code;
	            // }
	            return res;
	        });
	    };
	    HomeService.prototype.loadmore = function (offset) {
	        var token = localStorage.getItem('authToken');
	        var body = {
	            token: token,
	            offset: offset
	        };
	        console.log(body);
	        return this._http.post(this._conf.Url + 'home', body, { headers: this._conf.headers })
	            .map(function (res) { return res.json(); })
	            .map(function (res) {
	            console.log(res);
	            // if (res.token) {
	            //     localStorage.setItem('user', res.token);S
	            //     // this._router.navigate(['Pages']);
	            //     return res.code;
	            // }
	            return res;
	        });
	    };
	    HomeService.prototype.usercomment = function (value) {
	        var token = localStorage.getItem('authToken');
	        var body = {
	            comment: value.message,
	            type: value.postsType,
	            postId: value.id,
	            token: token
	        };
	        //console.log(body);
	        // return;
	        return this._http.post(this._conf.Url + 'comments', body, { headers: this._conf.headers })
	            .map(function (res) { return res.json(); })
	            .map(function (res) {
	            //console.log(res);
	            // if (res.token) {
	            //     localStorage.setItem('user', res.token);S
	            //     // this._router.navigate(['Pages']);
	            //     return res.code;
	            // }
	            return res;
	        });
	    };
	    HomeService.prototype.userdeletecomment = function (value) {
	        var token = localStorage.getItem('authToken');
	        var body = {
	            commentedByUser: value.username,
	            commentBody: value.message,
	            commentId: value.commentId,
	            type: value.postsType,
	            postId: value.id,
	            token: token
	        };
	        //console.log(body);
	        // return;
	        return this._http.post(this._conf.Url + 'deleteCommentsFromPost', body, { headers: this._conf.headers })
	            .map(function (res) { return res.json(); })
	            .map(function (res) {
	            //console.log(res);
	            // if (res.token) {
	            //     localStorage.setItem('user', res.token);S
	            //     // this._router.navigate(['Pages']);
	            //     return res.code;
	            // }
	            return res;
	        });
	    };
	    HomeService.prototype.userlike = function (id, postsType) {
	        var token = localStorage.getItem('authToken');
	        var body = {
	            token: token,
	            postId: id,
	            label: 'Photo'
	        };
	        if (postsType == 1)
	            body.label = 'Video';
	        //console.log(body);
	        return this._http.post(this._conf.Url + 'like', body, { headers: this._conf.headers })
	            .map(function (res) { return res.json(); })
	            .map(function (res) {
	            //console.log(res);
	            // if (res.token) {
	            //     localStorage.setItem('user', res.token);S
	            //     // this._router.navigate(['Pages']);
	            //     return res.code;
	            // }
	            return res;
	        });
	    };
	    HomeService.prototype.userunlike = function (id, postsType) {
	        var token = localStorage.getItem('authToken');
	        var body = {
	            token: token,
	            postId: id,
	            label: 'Photo'
	        };
	        if (postsType == 1)
	            body.label = 'Video';
	        //console.log(body);
	        return this._http.post(this._conf.Url + 'unlike', body, { headers: this._conf.headers })
	            .map(function (res) { return res.json(); })
	            .map(function (res) {
	            //console.log(res);
	            // if (res.token) {
	            //     localStorage.setItem('user', res.token);S
	            //     // this._router.navigate(['Pages']);
	            //     return res.code;
	            // }
	            return res;
	        });
	    };
	    HomeService = __decorate([
	        core_1.Injectable(), 
	        __metadata('design:paramtypes', [router_1.Router, http_1.Http, app_constants_1.Configuration])
	    ], HomeService);
	    return HomeService;
	}());
	exports.HomeService = HomeService;


/***/ },

/***/ 466:
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	function __export(m) {
	    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
	}
	var infinite_scroll_1 = __webpack_require__(467);
	var scroller_1 = __webpack_require__(468);
	var axis_resolver_1 = __webpack_require__(469);
	__export(__webpack_require__(467));
	__export(__webpack_require__(468));
	__export(__webpack_require__(469));
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.default = {
	    directives: [infinite_scroll_1.InfiniteScroll, scroller_1.Scroller, axis_resolver_1.AxisResolver]
	};
	//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiYW5ndWxhcjItaW5maW5pdGUtc2Nyb2xsLmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiYW5ndWxhcjItaW5maW5pdGUtc2Nyb2xsLnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiI7Ozs7QUFBQSxnQ0FBK0IsdUJBQXVCLENBQUMsQ0FBQTtBQUN2RCx5QkFBeUIsZ0JBQWdCLENBQUMsQ0FBQTtBQUMxQyw4QkFBNkIscUJBQXFCLENBQUMsQ0FBQTtBQUVuRCxpQkFBYyx1QkFBdUIsQ0FBQyxFQUFBO0FBQ3RDLGlCQUFjLGdCQUFnQixDQUFDLEVBQUE7QUFDL0IsaUJBQWMscUJBQXFCLENBQUMsRUFBQTtBQUVwQztrQkFBZTtJQUNkLFVBQVUsRUFBRSxDQUFFLGdDQUFjLEVBQUUsbUJBQVEsRUFBRSw0QkFBWSxDQUFFO0NBQ3RELENBQUEiLCJzb3VyY2VzQ29udGVudCI6WyJpbXBvcnQgeyBJbmZpbml0ZVNjcm9sbCB9IGZyb20gJy4vc3JjL2luZmluaXRlLXNjcm9sbCc7XG5pbXBvcnQgeyBTY3JvbGxlciB9IGZyb20gJy4vc3JjL3Njcm9sbGVyJztcbmltcG9ydCB7IEF4aXNSZXNvbHZlciB9IGZyb20gJy4vc3JjL2F4aXMtcmVzb2x2ZXInO1xuXG5leHBvcnQgKiBmcm9tICcuL3NyYy9pbmZpbml0ZS1zY3JvbGwnO1xuZXhwb3J0ICogZnJvbSAnLi9zcmMvc2Nyb2xsZXInO1xuZXhwb3J0ICogZnJvbSAnLi9zcmMvYXhpcy1yZXNvbHZlcic7XG5cbmV4cG9ydCBkZWZhdWx0IHtcblx0ZGlyZWN0aXZlczogWyBJbmZpbml0ZVNjcm9sbCwgU2Nyb2xsZXIsIEF4aXNSZXNvbHZlciBdXG59Il19

/***/ },

/***/ 467:
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var core_1 = __webpack_require__(5);
	var scroller_1 = __webpack_require__(468);
	var InfiniteScroll = (function () {
	    function InfiniteScroll(element) {
	        this.element = element;
	        this._distanceDown = 2;
	        this._distanceUp = 1.5;
	        this._throttle = 3;
	        this.scrollWindow = true;
	        this._immediate = false;
	        this._horizontal = false;
	        this._alwaysCallback = false;
	        this.scrolled = new core_1.EventEmitter();
	        this.scrolledUp = new core_1.EventEmitter();
	    }
	    InfiniteScroll.prototype.ngOnInit = function () {
	        var containerElement = this.scrollWindow ? window : this.element;
	        this.scroller = new scroller_1.Scroller(containerElement, setInterval, this.element, this.onScrollDown.bind(this), this.onScrollUp.bind(this), this._distanceDown, this._distanceUp, {}, this._throttle, this._immediate, this._horizontal, this._alwaysCallback);
	    };
	    InfiniteScroll.prototype.ngOnDestroy = function () {
	        this.scroller.clean();
	    };
	    InfiniteScroll.prototype.onScrollDown = function (data) {
	        if (data === void 0) { data = {}; }
	        this.scrolled.next(data);
	    };
	    InfiniteScroll.prototype.onScrollUp = function (data) {
	        if (data === void 0) { data = {}; }
	        this.scrolledUp.next(data);
	    };
	    __decorate([
	        core_1.Input('infiniteScrollDistance'), 
	        __metadata('design:type', Number)
	    ], InfiniteScroll.prototype, "_distanceDown", void 0);
	    __decorate([
	        core_1.Input('infiniteScrollUpDistance'), 
	        __metadata('design:type', Number)
	    ], InfiniteScroll.prototype, "_distanceUp", void 0);
	    __decorate([
	        core_1.Input('infiniteScrollThrottle'), 
	        __metadata('design:type', Number)
	    ], InfiniteScroll.prototype, "_throttle", void 0);
	    __decorate([
	        core_1.Input('scrollWindow'), 
	        __metadata('design:type', Boolean)
	    ], InfiniteScroll.prototype, "scrollWindow", void 0);
	    __decorate([
	        core_1.Input('immediateCheck'), 
	        __metadata('design:type', Boolean)
	    ], InfiniteScroll.prototype, "_immediate", void 0);
	    __decorate([
	        core_1.Input('horizontal'), 
	        __metadata('design:type', Boolean)
	    ], InfiniteScroll.prototype, "_horizontal", void 0);
	    __decorate([
	        core_1.Input('alwaysCallback'), 
	        __metadata('design:type', Boolean)
	    ], InfiniteScroll.prototype, "_alwaysCallback", void 0);
	    __decorate([
	        core_1.Output(), 
	        __metadata('design:type', Object)
	    ], InfiniteScroll.prototype, "scrolled", void 0);
	    __decorate([
	        core_1.Output(), 
	        __metadata('design:type', Object)
	    ], InfiniteScroll.prototype, "scrolledUp", void 0);
	    InfiniteScroll = __decorate([
	        core_1.Directive({
	            selector: '[infinite-scroll]'
	        }), 
	        __metadata('design:paramtypes', [core_1.ElementRef])
	    ], InfiniteScroll);
	    return InfiniteScroll;
	}());
	exports.InfiniteScroll = InfiniteScroll;
	//# sourceMappingURL=data:application/json;base64,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

/***/ },

/***/ 468:
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var Observable_1 = __webpack_require__(38);
	var axis_resolver_1 = __webpack_require__(469);
	__webpack_require__(470);
	__webpack_require__(473);
	__webpack_require__(483);
	var Scroller = (function () {
	    function Scroller(windowElement, $interval, $elementRef, infiniteScrollDownCallback, infiniteScrollUpCallback, infiniteScrollDownDistance, infiniteScrollUpDistance, infiniteScrollParent, infiniteScrollThrottle, isImmediate, horizontal, alwaysCallback) {
	        if (horizontal === void 0) { horizontal = false; }
	        if (alwaysCallback === void 0) { alwaysCallback = false; }
	        this.windowElement = windowElement;
	        this.$interval = $interval;
	        this.$elementRef = $elementRef;
	        this.infiniteScrollDownCallback = infiniteScrollDownCallback;
	        this.infiniteScrollUpCallback = infiniteScrollUpCallback;
	        this.infiniteScrollThrottle = infiniteScrollThrottle;
	        this.isImmediate = isImmediate;
	        this.horizontal = horizontal;
	        this.alwaysCallback = alwaysCallback;
	        this.lastScrollPosition = 0;
	        this.isContainerWindow = toString.call(this.windowElement).includes('Window');
	        this.documentElement = this.isContainerWindow ? this.windowElement.document.documentElement : null;
	        this.handleInfiniteScrollDistance(infiniteScrollDownDistance, infiniteScrollUpDistance);
	        // if (attrs.infiniteScrollParent != null) {
	        // 	attachEvent(angular.element(elem.parent()));
	        // }
	        this.handleInfiniteScrollDisabled(false);
	        this.defineContainer();
	        this.createInterval();
	        this.axis = new axis_resolver_1.AxisResolver(!this.horizontal);
	    }
	    Scroller.prototype.defineContainer = function () {
	        if (this.isContainerWindow) {
	            this.container = this.windowElement;
	        }
	        else {
	            this.container = this.windowElement.nativeElement;
	        }
	        this.attachEvent(this.container);
	    };
	    Scroller.prototype.createInterval = function () {
	        var _this = this;
	        if (this.isImmediate) {
	            this.checkInterval = this.$interval(function () {
	                return _this.handler();
	            }, 0);
	        }
	    };
	    Scroller.prototype.height = function (elem) {
	        var offsetHeight = this.axis.offsetHeightKey();
	        var clientHeight = this.axis.clientHeightKey();
	        // elem = elem.nativeElement;
	        if (isNaN(elem[offsetHeight])) {
	            return this.documentElement[clientHeight];
	        }
	        else {
	            return elem[offsetHeight];
	        }
	    };
	    Scroller.prototype.offsetTop = function (elem) {
	        var top = this.axis.topKey();
	        // elem = elem.nativeElement;
	        if (!elem.getBoundingClientRect) {
	            return;
	        }
	        return elem.getBoundingClientRect()[top] + this.pageYOffset(elem);
	    };
	    Scroller.prototype.pageYOffset = function (elem) {
	        var pageYOffset = this.axis.pageYOffsetKey();
	        var scrollTop = this.axis.scrollTopKey();
	        var offsetTop = this.axis.offsetTopKey();
	        // elem = elem.nativeElement;
	        if (isNaN(window[pageYOffset])) {
	            return this.documentElement[scrollTop];
	        }
	        else if (elem.ownerDocument) {
	            return elem.ownerDocument.defaultView[pageYOffset];
	        }
	        else {
	            return elem[offsetTop];
	        }
	    };
	    Scroller.prototype.handler = function () {
	        var container = this.calculatePoints();
	        var scrollingDown = this.lastScrollPosition < container.scrolledUntilNow;
	        this.lastScrollPosition = container.scrolledUntilNow;
	        var remaining;
	        var containerBreakpoint;
	        if (scrollingDown) {
	            remaining = container.totalToScroll - container.scrolledUntilNow;
	            containerBreakpoint = container.height * this.scrollDownDistance + 1;
	        }
	        else {
	            remaining = container.scrolledUntilNow;
	            containerBreakpoint = container.height * this.scrollUpDistance + 1;
	        }
	        var shouldScroll = remaining <= containerBreakpoint;
	        var triggerCallback = (this.alwaysCallback || shouldScroll) && this.scrollEnabled;
	        var shouldClearInterval = shouldScroll && this.checkInterval;
	        // if (this.useDocumentBottom) {
	        // 	container.totalToScroll = this.height(this.$elementRef.nativeElement.ownerDocument);
	        // }
	        this.checkWhenEnabled = shouldScroll;
	        if (triggerCallback) {
	            if (scrollingDown) {
	                this.infiniteScrollDownCallback({ currentScrollPosition: container.scrolledUntilNow });
	            }
	            else {
	                this.infiniteScrollUpCallback({ currentScrollPosition: container.scrolledUntilNow });
	            }
	        }
	        if (shouldClearInterval) {
	            clearInterval(this.checkInterval);
	        }
	    };
	    Scroller.prototype.calculatePoints = function () {
	        return this.isContainerWindow
	            ? this.calculatePointsForWindow()
	            : this.calculatePointsForElement();
	    };
	    Scroller.prototype.calculatePointsForWindow = function () {
	        // container's height
	        var height = this.height(this.container);
	        // scrolled until now / current y point
	        var scrolledUntilNow = height + this.pageYOffset(this.documentElement);
	        // total height / most bottom y point
	        var totalToScroll = this.offsetTop(this.$elementRef.nativeElement) + this.height(this.$elementRef.nativeElement);
	        return { height: height, scrolledUntilNow: scrolledUntilNow, totalToScroll: totalToScroll };
	    };
	    Scroller.prototype.calculatePointsForElement = function () {
	        var scrollTop = this.axis.scrollTopKey();
	        var scrollHeight = this.axis.scrollHeightKey();
	        var height = this.height(this.container);
	        // perhaps use this.container.offsetTop instead of 'scrollTop'
	        var scrolledUntilNow = this.container[scrollTop];
	        var containerTopOffset = 0;
	        var offsetTop = this.offsetTop(this.container);
	        if (offsetTop !== void 0) {
	            containerTopOffset = offsetTop;
	        }
	        var totalToScroll = this.container[scrollHeight];
	        // const totalToScroll = this.offsetTop(this.$elementRef.nativeElement) - containerTopOffset + this.height(this.$elementRef.nativeElement);
	        return { height: height, scrolledUntilNow: scrolledUntilNow, totalToScroll: totalToScroll };
	    };
	    Scroller.prototype.handleInfiniteScrollDistance = function (scrollDownDistance, scrollUpDistance) {
	        this.scrollDownDistance = parseFloat(scrollDownDistance) || 0;
	        this.scrollUpDistance = parseFloat(scrollUpDistance) || 0;
	    };
	    Scroller.prototype.attachEvent = function (newContainer) {
	        var _this = this;
	        this.clean();
	        if (newContainer) {
	            var throttle_1 = this.infiniteScrollThrottle;
	            this.disposeScroll = Observable_1.Observable.fromEvent(this.container, 'scroll')
	                .throttle(function (ev) { return Observable_1.Observable.timer(throttle_1); })
	                .subscribe(function (ev) { return _this.handler(); });
	        }
	    };
	    Scroller.prototype.clean = function () {
	        if (this.disposeScroll) {
	            this.disposeScroll.unsubscribe();
	        }
	    };
	    Scroller.prototype.handleInfiniteScrollDisabled = function (enableScroll) {
	        this.scrollEnabled = !enableScroll;
	        // if (this.scrollEnabled && checkWhenEnabled) {
	        // 	checkWhenEnabled = false;
	        // 	return handler();
	        // }
	    };
	    return Scroller;
	}());
	exports.Scroller = Scroller;
	//# sourceMappingURL=data:application/json;base64,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

/***/ },

/***/ 469:
/***/ function(module, exports) {

	"use strict";
	var AxisResolver = (function () {
	    function AxisResolver(vertical) {
	        if (vertical === void 0) { vertical = true; }
	        this.vertical = vertical;
	    }
	    AxisResolver.prototype.clientHeightKey = function () { return this.vertical ? 'clientHeight' : 'clientWidth'; };
	    AxisResolver.prototype.offsetHeightKey = function () { return this.vertical ? 'offsetHeight' : 'offsetWidth'; };
	    AxisResolver.prototype.scrollHeightKey = function () { return this.vertical ? 'scrollHeight' : 'scrollWidth'; };
	    AxisResolver.prototype.pageYOffsetKey = function () { return this.vertical ? 'pageYOffset' : 'pageXOffset'; };
	    AxisResolver.prototype.offsetTopKey = function () { return this.vertical ? 'offsetTop' : 'offsetLeft'; };
	    AxisResolver.prototype.scrollTopKey = function () { return this.vertical ? 'scrollTop' : 'scrollLeft'; };
	    AxisResolver.prototype.topKey = function () { return this.vertical ? 'top' : 'left'; };
	    return AxisResolver;
	}());
	exports.AxisResolver = AxisResolver;
	//# sourceMappingURL=data:application/json;base64,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

/***/ },

/***/ 485:
/***/ function(module, exports) {

	module.exports = "<head>\r\n\t<title>Sportemage</title>\r\n\t<link rel=\"icon\" type=\"image/gif/png\" href=\"/public/images/picoTitleLogo.png\">\r\n</head>\r\n\r\n<div class=\"loader\" *ngIf=\"loading\">\r\n\r\n</div>\r\n<div class=\"container-fluid picogram_total\">\r\n\t<div class=\"container pico_content_total\" [hidden]=\"post\" *ngIf=\"data\">\r\n\t\t<!--<div class=\"pico_content zero_padding col-xs-12\" style=\"margin-bottom:5%;\">\r\n\t\t\t<div class=\"follow_details suggestion zero_padding col-xs-12\">\r\n\t\t\t\t<h2 class=\"for_u_suggestion zero_padding col-xs-8 col-sm-10\">Suggestions for You</h2>\r\n\t\t\t\t<span class=\"col-xs-4 col-sm-2 zero_padding\" style=\"text-align:center;\"><a class=\"suggestion_seeall\" [routerLink]=\"['discover']\" style=\"color: #3897f0;\">See All </a>></span>\r\n\t\t\t</div>\r\n\r\n\t\t\t<div class=\"follow_details col-xs-12 zero_padding\">\r\n\t\t\t\t<span class=\"col-xs-2 col-sm-1 zero_padding\"><img class=\"suggestion_image\" src=\"https://igcdn-photos-b-a.akamaihd.net/hphotos-ak-xlp1/t51.2885-19/s150x150/13525376_303226200010785_381244316_a.jpg\"></span>\r\n\t\t\t\t<span class=\"col-xs-5 col-sm-8 zero_padding\">\r\n\t\t\t\t <h5 class=\"follow_name col-xs-12 zero_padding\"><a class=\"color_thick\" [routerLink]=\"['person']\">hemant2700</a></h5>\r\n\t\t\t\t <h6 class=\"follow_name col-xs-12 zero_padding color_thick color_opacity\" style=\"\">Hemant</h6>\t\t\t\r\n\t\t\t\t</span>\r\n\t\t\t\t<span class=\"col-xs-5 col-sm-3 zero_padding\" style=\"text-align:center;\"><button class=\"follow_button\">Follow</button></span>\r\n\t\t\t</div>\r\n\t\t\t<div class=\"follow_details col-xs-12 zero_padding\">\r\n\t\t\t\t<span class=\"col-xs-2 col-sm-1 zero_padding\"><img class=\"suggestion_image\" src=\"https://igcdn-photos-f-a.akamaihd.net/hphotos-ak-xat1/t51.2885-19/12224325_444042932469501_628900044_a.jpg\"></span>\r\n\t\t\t\t<span class=\"col-xs-5 col-sm-8 zero_padding\">\r\n\t\t\t\t <h5 class=\"follow_name col-xs-12 zero_padding\"><a class=\"color_thick\" [routerLink]=\"['person']\">ashwaryakeshwani</a></h5>\r\n\t\t\t\t <h6 class=\"follow_name col-xs-12 zero_padding color_thick color_opacity\" style=\"\">Ashwarya Keshwani</h6>\t\t\t\r\n\t\t\t\t</span>\r\n\t\t\t\t<span class=\"col-xs-5 col-sm-3 zero_padding\" style=\"text-align:center;\"><button class=\"follow_button\">Follow</button></span>\r\n\t\t\t</div>\r\n\t\t\t<div class=\"follow_details col-xs-12 zero_padding\">\r\n\t\t\t\t<span class=\"col-xs-2 col-sm-1 zero_padding\"><img class=\"suggestion_image\" src=\"https://igcdn-photos-b-a.akamaihd.net/hphotos-ak-xpa1/t51.2885-19/10903655_765595223531553_174967556_a.jpg\"></span>\r\n\t\t\t\t<span class=\"col-xs-5 col-sm-8 zero_padding\">\r\n\t\t\t\t <h5 class=\"follow_name col-xs-12 zero_padding\"><a class=\"color_thick\" [routerLink]=\"['person']\">akhil__ps</a></h5>\r\n\t\t\t\t <h6 class=\"follow_name col-xs-12 zero_padding color_thick color_opacity\" style=\"\">Akhil P S</h6>\t\t\t\r\n\t\t\t\t</span>\r\n\t\t\t\t<span class=\"col-xs-5 col-sm-3 zero_padding\" style=\"text-align:center;\"><button class=\"follow_button\">Follow</button></span>\r\n\t\t\t</div>\r\n\t\t</div>-->\r\n\r\n\t\t<div class=\"pico_contentdetails zero_padding col-xs-12\" *ngFor=\"let item of data; let i = index\" style=\"margin-bottom:10%;border: solid 1px #efefef;\">\r\n\t\t\t<div class=\"pico_contentdetails_name col-xs-12\">\r\n\t\t\t\t<span class=\"follow_detailss col-xs-2 col-sm-1 zero_padding\">\r\n\t\t\t\t\t<img class=\"suggestion_image member_name\" (click)=\"memberprofile(item)\" src=\"{{item.profilePicUrl}}\" onError=\"this.src='/public/images/default.png';\">\r\n\t\t\t\t</span>\r\n\t\t\t\t<span class=\"col-xs-8 col-sm-9 zero_padding\">\r\n\t\t\t\t\t<h5 class=\"follow_name1 zero_padding col-xs-12\" style=\"\">\r\n\t\t\t\t\t\t<a class=\"color_thick member_name\" (click)=\"memberprofile(item)\" id=\"{{item.postId}}\">{{item.postedByUserName}}</a>\r\n\t\t\t\t\t</h5>\r\n\t\t\t\t\t<h5 class=\"follow_name1 col-xs-12 zero_padding color_thick color_opacity member_name\" style=\"\" (click)=\"memberprofileplace(item)\"\r\n\t\t\t\t\t *ngIf=\"item.place !='null'\">{{item.place}}</h5>\r\n\t\t\t\t</span>\r\n\t\t\t\t<span class=\"col-xs-2 col-sm-2 zero_padding member_name\" (click)=\"timepost(item)\" style=\"text-align:right;color: #999;\">{{item.postedOn}}</span>\r\n\t\t\t</div>\r\n\t\t\t<div class=\"pico_contentdetails_image zero_padding col-xs-12\">\r\n\t\t\t\t<img class=\"profile_image zero_padding col-xs-12\" (click)=\"falseusertagged(i);\" (dblclick)=\"likedoubleClick(item.postId, item.postsType,i);\"\r\n\t\t\t\t *ngIf=\"item.postsType==0\" src=\"{{item.mainUrl}}\">\r\n\t\t\t\t<div class=\"doubleclick_heart\" *ngIf=\"item.likeheartFlagg==true\">\r\n\t\t\t\t\t<span class=\"double_click_heart like_icon\"></span>\r\n\t\t\t\t</div>\r\n\t\t\t\t<video class=\"profile_image zero_padding col-xs-12\" (click)=\"falseusertagged(i);\" *ngIf=\"item.postsType==1\" controls>\r\n\t\t\t\t\t<source src=\"{{item.mainUrl}}\" type=\"video/mp4\">\r\n\t\t\t\t\t<source src=\"{{item.mainUrl}}\" type=\"video/ogg\">\r\n\t\t\t\t</video>\r\n\r\n\t\t\t\t<div class=\"pico_contentdetails_tagged col-xs-12\">\r\n\t\t\t\t\t<div *ngIf=\"item.usertaggedFlagg==true\">\r\n\t\t\t\t\t\t<span *ngFor=\"let tagged of item.coords;\">\r\n\t\t\t\t\t\t\t<span class=\"tagg_color_name tagg_color\" (click)=\"usertaggedname(tagged);\" [ngStyle]=\"{'margin-left': tagged.right+'%', 'margin-top': '-'+tagged.top+'%'}\">\r\n\t\t\t\t\t\t\t\t<div class=\"tagg_arrowicon\"></div>\r\n\t\t\t\t\t\t\t\t{{tagged.name}}\r\n\t\t\t\t\t\t\t</span>\r\n\t\t\t\t\t\t</span>\r\n\t\t\t\t\t</div>\r\n\t\t\t\t\t<div class=\"\" *ngFor=\"let tagged of item.coords;\">\r\n\t\t\t\t\t\t<i class=\"usertag_icon tagged_icon\" (click)=\"usertagged(i);\"></i>\r\n\t\t\t\t\t</div>\r\n\t\t\t\t</div>\r\n\r\n\t\t\t</div>\r\n\t\t\t<div class=\"pico_contentdetails_comment zero_padding col-xs-12\" style=\"padding: 0 24px;\">\r\n\t\t\t\t<div class=\" col-xs-12 zero_padding itemProduct\" *ngIf=\"item.productUrl\">\r\n\t\t\t\t\t<span class=\"pull-left\">\r\n\t\t\t\t\t\t<a target=\"_blank\" href=\"{{item.productUrl}}\">Shop Now</a>\r\n\t\t\t\t\t</span>\r\n\t\t\t\t\t<span class=\"pull-right\">{{item.currency}} {{item.price}}</span>\r\n\t\t\t\t</div>\r\n\t\t\t\t<div *ngIf=\"item.likedByUser.length < 6\">\r\n\t\t\t\t\t<div *ngIf=\"item.likedByUser\" style=\"margin: 2% 0%;\">\r\n\t\t\t\t\t\t<span *ngFor=\"let liked of item.likedByUser; let i = index;\">\r\n\t\t\t\t\t\t\t<span *ngIf=\"liked != 'null'\">\r\n\t\t\t\t\t\t\t\t<span *ngIf=\"i != 0\" class=\"comma_moveleftside\">,</span>\r\n\t\t\t\t\t\t\t\t<span class=\"add_liked color_thick member_name\" (click)=\"likedbyuser(liked)\" id=\"likecontent\">{{liked}}</span>\r\n\t\t\t\t\t\t\t</span>\r\n\t\t\t\t\t\t</span>\r\n\t\t\t\t\t\t<span class=\"color_opacity\" *ngIf=\"item.likedByUser.length > 0\">like this</span>\r\n\t\t\t\t\t</div>\r\n\t\t\t\t</div>\r\n\t\t\t\t<h5 class=\"color_thick\" *ngIf=\"item.likedByUser.length > 6\" style=\"margin: 2% 0%;\">\r\n\t\t\t\t\t<span class=\"add_like\" id=\"likecontent\">{{item.likes}}</span> likes</h5>\r\n\t\t\t\t<ul class=\"comment_list zero_padding col-xs-12\">\r\n\t\t\t\t\t<li class=\"listcomment zero_padding col-xs-12\">\r\n\t\t\t\t\t\t<span class=\"color_thick member_name\" *ngIf=\"item.postCaption !='null'\" id=\"{{item.postId}}\">{{item.postedByUserName}}</span>\r\n\t\t\t\t\t\t<span class=\"name_comment\" style=\"\" *ngFor=\"let caption of item.postCaption;\">\r\n\t\t\t\t\t\t\t<span *ngIf=\"caption != 'null'\">\r\n\t\t\t\t\t\t\t\t<span class=\"color_thick color_opacity member_name\" id=\"{{item.postId}}\" *ngIf=\"caption.charAt(0) != '#' && caption.charAt(0) != '@'\">{{caption}}</span>\r\n\t\t\t\t\t\t\t\t<span class=\"color_thick color_opacity member_name\" id=\"{{item.postId}}\" (click)=\"membercaption(caption)\" style=\"color:#003569;\"\r\n\t\t\t\t\t\t\t\t *ngIf=\"caption.charAt(0) == '#'\">{{caption}}</span>\r\n\t\t\t\t\t\t\t\t<span class=\"color_thick color_opacity member_name\" id=\"{{item.postId}}\" (click)=\"memberprofilecaptionn(caption)\" style=\"color:#003569;\"\r\n\t\t\t\t\t\t\t\t *ngIf=\"caption.charAt(0) == '@'\">{{caption}}</span>\r\n\r\n\t\t\t\t\t\t\t</span>\r\n\t\t\t\t\t\t</span>\r\n\t\t\t\t\t</li>\r\n\t\t\t\t\t<!--<li class=\"hide_commentts zero_padding col-xs-12\" id=\"showcomment\" style=\"cursor:pointer;\">\r\n\t\t\t\t\t\t<div *ngIf=\"!item.commentFlagg==true\">\r\n\t\t\t\t\t\t\t<h5 class=\"color_thick color_opacity\" style=\"opacity: 0.7;\" *ngIf=\"item.comments.length > 5\" [hidden]=\"viewallcomment\" (click)=\"allcomment(i);\">view all {{item.comments.length}} comments</h5>\r\n\t\t\t\t\t\t</div>\r\n\t\t\t\t\t</li>-->\r\n\t\t\t\t\t<!--<div *ngIf=\"item.commentFlag==true\">-->\r\n\t\t\t\t\t<li class=\"listcomment zero_padding col-xs-12\" *ngFor=\"let comment of item.commentData; let k = index;\">\r\n\t\t\t\t\t\t<span class=\"name_comment\" style=\"\">\r\n\t\t\t\t\t\t\t<a class=\"color_thick member_name\" (click)=\"memberprofilee(comment)\" id=\"{{item.postId}}\" style=\"\">{{comment.commentedByUser}}</a>\r\n\t\t\t\t\t\t</span>\r\n\t\t\t\t\t\t<span class=\"name_comment1 color_thick color_opacity\" style=\"\" [innerHTML]=\"comment.commentBody\"></span>\r\n\t\t\t\t\t\t<!--<span class=\"name_comment1 color_thick color_opacity member_name\" style=\"color:#003569;\" (click)=\"membercaptionn(comment)\" *ngIf=\"comment[1].charAt(0) == '#'\">{{comment[1]}}</span>\r\n\t\t\t\t\t\t\t<span class=\"name_comment1 color_thick color_opacity member_name\" style=\"color:#003569;\" (click)=\"memberprofilecaption(comment)\" *ngIf=\"comment[1].charAt(0) == '@'\">{{comment[1]}}</span>\t\t\t\t\t\t-->\r\n\t\t\t\t\t\t<span class=\"name_comment1 color_thick color_opacity member_name delete_comment\" style=\"\" data-toggle=\"modal\" data-target=\"#myModal_delete\"\r\n\t\t\t\t\t\t (click)=\"commentdelete(comment, item.postId, item.postsType, i, k)\" *ngIf=\"comment.commentedByUser == username\">X</span>\r\n\t\t\t\t\t</li>\r\n\t\t\t\t\t<!--</div>-->\r\n\t\t\t\t\t<!--<div *ngIf=\"!item.commentFlagg==true\">\t\t\t\t\t\r\n\t\t\t\t\t\t<div *ngIf=\"!item.halfComments\">\t\t\t\t\t\r\n\t\t\t\t\t\t\t<li class=\"listcomment zero_padding col-xs-12\" *ngFor=\"let comment of item.comments; let k = index;\">\r\n\t\t\t\t\t\t\t\t<span class=\"name_comment\" style=\"\"><a class=\"color_thick member_name\" (click)=\"memberprofilee(comment)\" id=\"{{item.postId}}\" style=\"\">{{comment[0]}}</a></span>\r\n\t\t\t\t\t\t\t\t<span class=\"name_comment1 color_thick color_opacity\" style=\"\" [innerHTML]=\"comment[1]\"></span>-->\r\n\t\t\t\t\t<!--<span class=\"name_comment1 color_thick color_opacity member_name\" style=\"color:#003569;\" (click)=\"membercaptionn(comment)\" *ngIf=\"comment[1].charAt(0) == '#'\">{{comment[1]}}</span>\r\n\t\t\t\t\t\t\t\t<span class=\"name_comment1 color_thick color_opacity member_name\" style=\"color:#003569;\" (click)=\"memberprofilecaption(comment)\" *ngIf=\"comment[1].charAt(0) == '@'\">{{comment[1]}}</span>-->\r\n\t\t\t\t\t<!--<span class=\"name_comment1 color_thick color_opacity member_name delete_comment\" style=\"\" data-toggle=\"modal\" data-target=\"#myModal_delete\" (click)=\"commentdelete(comment, item.postId, item.postsType, i, k)\" *ngIf=\"comment[0] == username\">X</span>\r\n\t\t\t\t\t\t\t</li>\r\n\t\t\t\t\t\t</div>\r\n\t\t\t\t\t</div>\t\t\t\t-->\r\n\t\t\t\t\t<!--<h5>testing 5 comments</h5>-->\r\n\t\t\t\t\t<!--<div *ngIf=\"!item.commentFlagg==true\">\r\n\t\t\t\t\t\t<div *ngIf=\"item.halfComments\">\r\n\t\t\t\t\t\t\t<li class=\"listcomment zero_padding col-xs-12\" *ngFor=\"let comment of item.halfComments; let k = index;\">\r\n\t\t\t\t\t\t\t\t<div *ngIf=\"comment\">\r\n\t\t\t\t\t\t\t\t\t<span class=\"name_comment\"  style=\"\"><a class=\"color_thick member_name\" (click)=\"memberprofilee(comment)\" id=\"{{item.postId}}\" style=\"\">{{comment[0]}}</a></span>\t\t\t\t\t\t\t\t\r\n\t\t\t\t\t\t\t\t\t<span class=\"name_comment1 color_thick color_opacity\" style=\"\" [innerHTML]=\"comment[1]\"></span>-->\r\n\t\t\t\t\t<!--<span class=\"name_comment1 color_thick color_opacity member_name\" style=\"color:#003569;\" (click)=\"membercaptionn(comment)\" *ngIf=\"comment[1].charAt(0) == '#'\">{{comment[1]}}</span>\r\n\t\t\t\t\t\t\t\t\t<span class=\"name_comment1 color_thick color_opacity member_name\" style=\"color:#003569;\" (click)=\"memberprofilecaption(comment)\" *ngIf=\"comment[1].charAt(0) == '@'\">{{comment[1]}}</span>-->\r\n\t\t\t\t\t<!--<span class=\"name_comment1 color_thick color_opacity member_name delete_comment\" style=\"\" data-toggle=\"modal\" data-target=\"#myModal_delete\" (click)=\"commentdelete(comment, item.postId, item.postsType, i, k)\" *ngIf=\"comment[0] == username\">X</span>\r\n\t\t\t\t\t\t\t\t</div>-->\r\n\t\t\t\t\t<!--<span class=\"name_comment1 color_thick color_opacity\" style=\"\">{{lastcomment}}</span>-->\r\n\t\t\t\t\t<!--</li>\r\n\t\t\t\t\t\t</div>\r\n\t\t\t\t\t</div>-->\r\n\t\t\t\t\t<span class=\"col-xs-12\" style=\"background:#efefef;height:1px;margin-top: 3%;\"></span>\r\n\t\t\t\t</ul>\r\n\t\t\t</div>\r\n\t\t\t<div class=\"add_comment zero_padding col-xs-12\" style=\"padding: 0 30px 0px 24px;\">\r\n\t\t\t\t<i class=\"comment_icon comment_heart_icon add_heart_icon\" *ngIf=\"item.likeStatus!=1\" (click)=\"likeactive(item.postId, item.postsType,i)\"\r\n\t\t\t\t id=\"{{item.postId}}\"></i>\r\n\t\t\t\t<i class=\"comment_icon comment_heart_icon add_heart_icon active\" *ngIf=\"item.likeStatus==1\" (click)=\"likedeactive(item.postId, item.postsType,i)\"\r\n\t\t\t\t id=\"{{item.postId}}\"></i>\r\n\t\t\t\t<input type=\"text\" #input (keyup.enter)=\"usercommentSubmit(input.value, item.postId, item.postsType, i); input.value=''\"\r\n\t\t\t\t name=\"message\" placeholder=\"Add a comment\" id=\"{{item.postId}}\" class=\"col-xs-12 comment_textbox\" style=\"\">\r\n\t\t\t\t<i class=\"comment_icon comment_dotted_icon\" data-toggle=\"modal\" data-target=\"#myModall\" style=\"top: -10px;\"></i>\r\n\t\t\t</div>\r\n\t\t\t<!-- popup modal -->\r\n\t\t\t<div class=\"modal fade\" id=\"myModall\" role=\"dialog\">\r\n\t\t\t\t<div class=\"modal-dialog modal-md\">\r\n\t\t\t\t\t<div class=\"modal-content\">\r\n\t\t\t\t\t\t<div class=\"modal-body\" style=\"\">\r\n\t\t\t\t\t\t\t<span class=\"report_cancel col-xs-12\">Report inappropriate</span>\r\n\t\t\t\t\t\t\t<!--<span class=\"report_cancel col-xs-12\">Embed</span>-->\r\n\t\t\t\t\t\t\t<span class=\"report_cancel col-xs-12\" data-dismiss=\"modal\">Cancel</span>\r\n\t\t\t\t\t\t</div>\r\n\t\t\t\t\t</div>\r\n\t\t\t\t</div>\r\n\t\t\t</div>\r\n\t\t\t<!-- delete comment -->\r\n\t\t\t<div class=\"modal fade deletecomment\" id=\"myModal_delete\" role=\"dialog\">\r\n\t\t\t\t<div class=\"modal-dialog modal-md\">\r\n\t\t\t\t\t<div class=\"modal-content\">\r\n\t\t\t\t\t\t<div class=\"modal-body\" style=\"\">\r\n\t\t\t\t\t\t\t<span class=\"report_cancel col-xs-12 color_focus  member_name\" data-dismiss=\"modal\" (click)=\"commentmodaldelete()\">Delete Comment</span>\r\n\t\t\t\t\t\t\t<!--<span class=\"report_cancel col-xs-12\">Embed</span>-->\r\n\t\t\t\t\t\t\t<span class=\"report_cancel col-xs-12\" data-dismiss=\"modal\">Cancel</span>\r\n\t\t\t\t\t\t</div>\r\n\t\t\t\t\t</div>\r\n\t\t\t\t</div>\r\n\t\t\t</div>\r\n\t\t\t<!-- End popup modal -->\r\n\t\t</div>\r\n\t\t<div class=\"col-xs-12 loader_moreDetails\" [hidden]=\"!loadmoree\">\r\n\t\t\t<div class=\"loadmoreRound\" (click)=\"loadmore();\">\r\n\t\t\t\t<span class=\"loadmore_click\">loadmore</span>\r\n\t\t\t</div>\r\n\t\t</div>\r\n\t</div>\r\n\r\n\t<div class=\"container pico_content_total\" [hidden]=\"!nopost\">\r\n\t\t<h4 style=\"text-align:center;\">User and his followers have not posted anything</h4>\r\n\t</div>\r\n</div>";

/***/ },

/***/ 486:
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var core_1 = __webpack_require__(5);
	var router_1 = __webpack_require__(389);
	var router_2 = __webpack_require__(389);
	var person_service_1 = __webpack_require__(487);
	var PersonComponent = (function () {
	    function PersonComponent(_personService, _router, route) {
	        this._personService = _personService;
	        this._router = _router;
	        this.route = route;
	        this.posts = [];
	        this.loading = true;
	        this.buffer = false;
	        this.commnentdetails = [];
	        this.offset = 0;
	        this.persondata = false;
	        this.personnodata = false;
	    }
	    PersonComponent.prototype.ngOnInit = function () {
	        var _this = this;
	        jQuery(".modal-backdrop").css({ "display": "none" });
	        var username = localStorage.getItem('username');
	        this.username = username;
	        this.route.params.subscribe(function (params) {
	            _this.name = params['name'];
	            //console.log(this.name);
	            _this.loading = true;
	            _this._personService.personprofile(_this.name)
	                .subscribe(function (res) {
	                if (res.code == 1800) {
	                    _this.persondata = false;
	                    _this.personnodata = true;
	                }
	                if (res.code == 200) {
	                    _this.persondata = true;
	                    _this.personnodata = false;
	                    _this.loading = false;
	                    _this.data = res.memberProfileData[0];
	                    // //console.log(this.privatemember);
	                    // this.posts = res.memberPostsData;
	                    /** bio add tag**/
	                    var biotext = _this.data.bio;
	                    if (biotext) {
	                        var hashtag_regexp = /#([a-zA-Z0-9_]+)/g;
	                        var bio_detail = biotext.replace(hashtag_regexp, '<a href="home/personcaption/$1" class="hashtag member_name biohashtag">#$1</a>');
	                        var hashtag_regexpp = /@([a-zA-Z0-9_]+)/g;
	                        var bio_detaill = bio_detail.replace(hashtag_regexpp, '<a href="home/person/$1" class="hashtag member_name biohashtag">@$1</a>');
	                    }
	                    _this.data.bio = bio_detaill;
	                    _this.privatemember = _this.data.privateMember;
	                    _this.posts = [];
	                    _this.totaldata = res.memberPostsData;
	                    _this.offset = res.memberPostsData.length;
	                    _this.commentfunction();
	                    if (_this.offset >= 20)
	                        _this.loadmoree = true;
	                }
	            });
	            _this._personService.memberFollowing(_this.name)
	                .subscribe(function (res) {
	                _this.data1 = res.following;
	                _this.loading = false;
	            });
	            _this._personService.memberFollowers(_this.name)
	                .subscribe(function (res) {
	                _this.data2 = res.memberFollowers;
	                _this.loading = false;
	            });
	        });
	        jQuery(document).keyup(function (e) {
	            if (e.keyCode == 27) {
	                jQuery(".modal").css({ "display": "none" });
	                jQuery(".modal-backdrop").css({ "display": "none" });
	            }
	        });
	    };
	    PersonComponent.prototype.hashtagFunction = function () {
	        var len = this.totaldata.length;
	        for (var i = 0; i < len; i++) {
	            if (this.totaldata[i].commentData) {
	                var commenttext = this.totaldata[i].commentData;
	                for (var x = 0; x < commenttext.length; x++) {
	                    // commenttext.splice(x, 0);
	                    if (this.totaldata[i].commentData[x].commentBody) {
	                        var postCommentNodeArr1 = commenttext[x].commentBody;
	                        // //console.log(postCommentNodeArr1);
	                        var hashtag_regexp = /#([a-zA-Z0-9_]+)/g;
	                        var comment_text = postCommentNodeArr1.replace(hashtag_regexp, '<a href="home/personcaption/$1" class="hashtag member_name biohashtag">#$1</a>');
	                        var hashtag_regexp1 = /@([a-zA-Z0-9_]+)/g;
	                        var comment_textt = comment_text.replace(hashtag_regexp1, '<a href="home/person/$1" class="hashtag member_name biohashtag">@$1</a>');
	                        this.totaldata[i].commentData[x].commentBody = comment_textt;
	                    }
	                }
	            }
	        }
	    };
	    PersonComponent.prototype.commentfunction = function () {
	        this.hashtagFunction();
	        // alert("hi");
	        // this.posts=[];
	        var len = this.totaldata.length;
	        for (var i = 0; i < len; i++) {
	            // this.commentdata = [];
	            // if (this.totaldata[i].comments) {
	            //     var commenttext = this.totaldata[i].comments;
	            //     var hashtag_regexp = /#([a-zA-Z0-9_]+)/g;
	            //     var comment_text = commenttext.replace(
	            //         hashtag_regexp,
	            //         '<a href="home/personcaption/$1" class="hashtag member_name biohashtag">#$1</a>'
	            //     );
	            //     var hashtag_regexp1 = /@([a-zA-Z0-9_]+)/g;
	            //     var comment_textt = comment_text.replace(
	            //         hashtag_regexp1,
	            //         '<a href="home/person/$1" class="hashtag member_name biohashtag">@$1</a>'
	            //     );
	            //     var postCommentNodeArr = comment_textt.split('^^');
	            //     for (var x = 0; x < postCommentNodeArr.length; x++) {
	            //         postCommentNodeArr.splice(x, 0);
	            //         var postCommentNodeArr1 = postCommentNodeArr[x].split('$$');
	            //         if (postCommentNodeArr1.length == 2)
	            //             this.commentdata.push(postCommentNodeArr1);
	            //     }
	            // }
	            // this.totaldata[i].comments = this.commentdata;
	            var postCaption = [];
	            if (this.totaldata[i].postCaption) {
	                var postCaptionn = this.totaldata[i].postCaption.split(' ');
	                this.totaldata[i].postCaption = postCaptionn;
	            }
	            var postLikedBy = [];
	            if (this.totaldata[i].postLikedBy) {
	                var liked = this.totaldata[i].postLikedBy.split(',');
	                if (liked.length) {
	                    this.totaldata[i].postLikedBy = liked;
	                }
	            }
	            else {
	                this.totaldata[i].postLikedBy = [];
	            }
	            var usersTagged = [];
	            if (this.totaldata[i].usersTagged) {
	                usersTagged = this.totaldata[i].usersTagged;
	                this.totaldata[i].usersTagged = usersTagged;
	            }
	            var taggedUserCoordinates = [];
	            if (this.totaldata[i].taggedUserCoordinates) {
	                taggedUserCoordinates = this.totaldata[i].taggedUserCoordinates.split(',');
	                this.totaldata[i].taggedUserCoordinates = taggedUserCoordinates;
	            }
	            if (usersTagged[0] != 'undefined' && taggedUserCoordinates[0] != null) {
	                var lenn = usersTagged.length;
	                var tagsCords = [];
	                for (var j = 0; j < lenn; j++) {
	                    var userCords = {
	                        name: usersTagged[j],
	                        right: 0,
	                        top: 0
	                    };
	                    if (taggedUserCoordinates[j]) {
	                        var cordinates = taggedUserCoordinates[j].split('-');
	                        userCords.right = cordinates[0];
	                        userCords.top = cordinates[1];
	                        tagsCords.push(userCords);
	                    }
	                }
	                this.totaldata[i].coords = tagsCords;
	            }
	            var post = this.totaldata[i].postedOn;
	            var poston = Number(post);
	            var postdate = new Date(poston);
	            var currentdate = new Date();
	            var timeDiff = Math.abs(postdate.getTime() - currentdate.getTime());
	            var diffDays = Math.ceil(timeDiff / (1000 * 3600 * 24));
	            var diffHrs = Math.round((timeDiff % 86400000) / 3600000);
	            var diffMins = Math.round(((timeDiff % 86400000) % 3600000) / 60000);
	            if (1 < diffDays) {
	                this.totaldata[i].postedOn = diffDays + "d";
	            }
	            else if (1 <= diffHrs) {
	                this.totaldata[i].postedOn = diffHrs + "h";
	            }
	            else {
	                this.totaldata[i].postedOn = diffMins + "m";
	            }
	            this.posts.push(this.totaldata[i]);
	        }
	        // this.posts = this.totaldata;
	    };
	    PersonComponent.prototype.loadmore = function () {
	        var _this = this;
	        // //console.log(this.offset, this.name);
	        this.offset = this.posts.length;
	        this._personService.loadmore(this.offset, this.name)
	            .subscribe(function (res) {
	            // var len = res.memberPostsData.length;
	            // for (var i = 0; i < len; i++) {
	            //     this.posts.push(res.memberPostsData[i]);
	            // }
	            _this.totaldata = res.memberPostsData;
	            _this.commentfunction();
	            _this.offset = res.memberPostsData.length || 0;
	            if (_this.offset >= 20)
	                _this.loadmoree = true;
	            else
	                _this.loadmoree = false;
	        });
	    };
	    PersonComponent.prototype.timepost = function (item) {
	        var postsId = item.postId;
	        var followingUsername = this.name;
	        var link = ['home/homepost', followingUsername, postsId];
	        this._router.navigate(link);
	    };
	    PersonComponent.prototype.usertagged = function (i) {
	        this.posts[i].usertaggedFlagg = true;
	    };
	    PersonComponent.prototype.falseusertagged = function (i) {
	        this.posts[i].usertaggedFlagg = false;
	    };
	    PersonComponent.prototype.usertaggedname = function (tagged) {
	        // alert(item.postId);
	        var personname = tagged.name;
	        var username = localStorage.getItem('username');
	        if (username == personname) {
	            this._router.navigate(['home/profile']);
	        }
	        else {
	            var link = ['home/person', personname];
	            this._router.navigate(link);
	        }
	    };
	    PersonComponent.prototype.activeitem = function (id) {
	        // alert(id);
	        jQuery('.item').removeClass("active");
	        jQuery('#' + id + 'w').addClass("active");
	    };
	    PersonComponent.prototype.memberprofile = function (item) {
	        // alert(item.postsId);
	        var personname = item.username;
	        var username = localStorage.getItem('username');
	        if (username == personname) {
	            this._router.navigate(['home/profile']);
	        }
	        else {
	            var link = ['home/person', personname];
	            this._router.navigate(link);
	        }
	        // let link = ['/home/person', item.username];
	        // this._router.navigate(link);
	    };
	    PersonComponent.prototype.memberprofilee = function (comment) {
	        // alert(item.postsId);
	        var personname = comment.commentedByUser;
	        var username = localStorage.getItem('username');
	        if (username == personname) {
	            this._router.navigate(['home/profile']);
	        }
	        else {
	            var link = ['home/person', personname];
	            this._router.navigate(link);
	        }
	        // let link = ['home/person', comment[0]];
	        // this._router.navigate(link);
	    };
	    PersonComponent.prototype.membercaption = function (caption) {
	        var hashtagname = caption.split('#');
	        //   //console.log(hashtagname[1]);        
	        var link = ['home/personcaption', hashtagname[1]];
	        this._router.navigate(link);
	    };
	    PersonComponent.prototype.membercaptionn = function (comment) {
	        var hashtagname = comment[1].split('#');
	        //   //console.log(hashtagname[1]);        
	        var link = ['home/personcaption', hashtagname[1].replace(" ", "")];
	        this._router.navigate(link);
	    };
	    PersonComponent.prototype.memberprofilecaption = function (comment) {
	        // var hashtagname = comment[1].split('@');
	        //   //console.log(hashtagname[1]);        
	        // let link = ['home/personcaption', hashtagname[1].replace(" ","")];
	        // this._router.navigate(link); 
	        var personname = comment[1].split('@');
	        var username = localStorage.getItem('username');
	        if (username == personname[1]) {
	            this._router.navigate(['home/profile']);
	        }
	        else {
	            var link = ['home/person', personname[1].replace(" ", "")];
	            this._router.navigate(link);
	        }
	    };
	    PersonComponent.prototype.memberprofilecaptionn = function (caption) {
	        var personname = caption.split('@');
	        var username = localStorage.getItem('username');
	        if (username == personname[1]) {
	            this._router.navigate(['home/profile']);
	        }
	        else {
	            var link = ['home/person', personname[1].replace(" ", "")];
	            this._router.navigate(link);
	        }
	    };
	    PersonComponent.prototype.commentdelete = function (comment, id, postsType, i, k) {
	        //  //console.log(comment[0]+" ss "+comment[1]+" id "+id+" postsType "+postsType+" i "+i);
	        postsType = postsType.toString();
	        this.commnentdetails = ({ username: comment.commentedByUser, message: comment.commentBody, commentId: comment.commentId, id: id, postsType: postsType, i: i, k: k });
	    };
	    PersonComponent.prototype.commentmodaldelete = function () {
	        //  //console.log(this.commnentdetails);            
	        var commentlist = this.commnentdetails;
	        var commenttext = commentlist.message;
	        var hashtag_regexp = /<a[^>]*>([^<]+)<\/a>/g;
	        var comment_text = commenttext.replace(hashtag_regexp, '$1');
	        // //console.log({ comment_text: comment_text });
	        // //console.log(this.posts[commentlist.i].comments[commentlist.k]);     
	        this.posts[commentlist.i].commentData.splice([commentlist.k], 1);
	        this._personService.userdeletecomment({ username: commentlist.username, message: comment_text, commentId: commentlist.commentId, id: commentlist.id, postsType: commentlist.postsType })
	            .subscribe();
	    };
	    PersonComponent.prototype.likeStatus = function (liked) {
	        var personname = liked;
	        // alert(personname);
	        var username = localStorage.getItem('username');
	        if (username == personname) {
	            this._router.navigate(['home/profile']);
	        }
	        else {
	            var link = ['home/person', personname];
	            this._router.navigate(link);
	        }
	    };
	    PersonComponent.prototype.likedoubleClick = function (id, postsType, i) {
	        var _this = this;
	        // alert(id+'aa'+'bb'+postsType+'cc'+i);
	        if (this.posts[i].likeStatus == 0) {
	            this.posts[i].likeheartFlagg = true;
	            var username = localStorage.getItem('username');
	            this.posts[i].postLikedBy.unshift(username);
	            this.posts[i].likeStatus = 1;
	            this.posts[i].likes += 1;
	            this._personService.userlike(id, postsType)
	                .subscribe();
	            setTimeout(function () {
	                _this.posts[i].likeheartFlagg = false;
	            }, 500);
	        }
	    };
	    PersonComponent.prototype.likeactive = function (id, postsType, i) {
	        // alert(id);
	        var username = localStorage.getItem('username');
	        this.posts[i].postLikedBy.unshift(username);
	        this.posts[i].likeStatus = 1;
	        this.posts[i].likes += 1;
	        this._personService.userlike(id, postsType)
	            .subscribe();
	    };
	    PersonComponent.prototype.likedeactive = function (id, postsType, i) {
	        var username = localStorage.getItem('username');
	        var array = this.posts[i].postLikedBy;
	        var index = array.indexOf(username);
	        if (index > -1) {
	            array.splice(index, 1);
	        }
	        this.posts[i].likeStatus = 0;
	        this.posts[i].likes -= 1;
	        this._personService.userunlike(id, postsType)
	            .subscribe();
	    };
	    PersonComponent.prototype.following = function (item, i) {
	        var _this = this;
	        // alert(i+'ll'+username+'ff'+followFlag);
	        var username = item.username;
	        var memberPrivateFlag = item.memberPrivateFlag;
	        this.data2[i].loaderFlag = true;
	        if (memberPrivateFlag == 1) {
	            setTimeout(function () {
	                _this.data2[i].userFollowRequestStatus = 0;
	            }, 500);
	            this._personService.following(username)
	                .subscribe();
	            setTimeout(function () {
	                _this.data2[i].loaderFlag = false;
	            }, 500);
	        }
	        if (memberPrivateFlag != 1) {
	            setTimeout(function () {
	                _this.data2[i].userFollowRequestStatus = 1;
	            }, 500);
	            this._personService.following(username)
	                .subscribe();
	            setTimeout(function () {
	                _this.data2[i].loaderFlag = false;
	            }, 500);
	        }
	    };
	    PersonComponent.prototype.follow = function (item, i) {
	        var _this = this;
	        var username = item.username;
	        this.data2[i].loaderFlag = true;
	        setTimeout(function () {
	            _this.data2[i].userFollowRequestStatus = null;
	        }, 500);
	        this._personService.follow(username)
	            .subscribe();
	        setTimeout(function () {
	            _this.data2[i].loaderFlag = false;
	        }, 500);
	    };
	    PersonComponent.prototype.followingflag = function (item, i) {
	        var _this = this;
	        var username = item.username;
	        var memberPrivateFlag = item.memberPrivateFlag;
	        // alert(i+'ll'+username+'ff'+followFlag);
	        this.data1[i].loaderFlag = true;
	        if (memberPrivateFlag == 1) {
	            setTimeout(function () {
	                _this.data1[i].userFollowRequestStatus = 0;
	            }, 500);
	            this._personService.following(username)
	                .subscribe();
	            setTimeout(function () {
	                _this.data1[i].loaderFlag = false;
	            }, 500);
	        }
	        if (memberPrivateFlag != 1) {
	            setTimeout(function () {
	                _this.data1[i].userFollowRequestStatus = 1;
	            }, 500);
	            this._personService.following(username)
	                .subscribe();
	            setTimeout(function () {
	                _this.data1[i].loaderFlag = false;
	            }, 500);
	        }
	    };
	    PersonComponent.prototype.followflag = function (item, i) {
	        var _this = this;
	        var username = item.username;
	        this.data1[i].loaderFlag = true;
	        setTimeout(function () {
	            _this.data1[i].userFollowRequestStatus = null;
	        }, 500);
	        this._personService.follow(username)
	            .subscribe();
	        setTimeout(function () {
	            _this.data1[i].loaderFlag = false;
	        }, 500);
	    };
	    PersonComponent.prototype.followingfllag = function (name, i) {
	        var _this = this;
	        // alert(i+'ll'+username+'ff'+followFlag);
	        // //console.log(this.privatemember);
	        this.buffer = true;
	        if (this.privatemember == 1) {
	            setTimeout(function () {
	                _this.data.userFollowRequestStatus = 0;
	            }, 500);
	            this._personService.privateprofile(name, this.privatemember)
	                .subscribe();
	            setTimeout(function () {
	                _this.buffer = false;
	            }, 500);
	        }
	        if (this.privatemember != 1) {
	            setTimeout(function () {
	                _this.data.userFollowRequestStatus = 1;
	            }, 500);
	            this._personService.following(name)
	                .subscribe();
	            setTimeout(function () {
	                _this.buffer = false;
	            }, 500);
	        }
	    };
	    PersonComponent.prototype.followfllag = function (name, i) {
	        var _this = this;
	        this.buffer = true;
	        setTimeout(function () {
	            _this.data.userFollowRequestStatus = null;
	        }, 500);
	        this._personService.follow(name)
	            .subscribe();
	        setTimeout(function () {
	            _this.buffer = false;
	        }, 500);
	    };
	    PersonComponent.prototype.usercommentSubmit = function (value, id, postsType, i) {
	        var _this = this;
	        // //console.log('you submitted value:', value, id, postsType, i);
	        postsType = postsType.toString();
	        var username = localStorage.getItem('username');
	        var commenttext = value;
	        var hashtag_regexp = /#([a-zA-Z0-9_]+)/g;
	        var comment_text = commenttext.replace(hashtag_regexp, '<a href="home/personcaption/$1" class="hashtag member_name biohashtag">#$1</a>');
	        var hashtag_regexp1 = /@([a-zA-Z0-9_]+)/g;
	        var comment_textt = comment_text.replace(hashtag_regexp1, '<a href="home/person/$1" class="hashtag member_name biohashtag">@$1</a>');
	        if (value.length > 0) {
	            // this.posts[i].comments.push([username, comment_textt]);
	            this._personService.usercomment({ message: value, id: id, postsType: postsType })
	                .subscribe(function (res) {
	                _this.submitComment = res.data;
	                _this.posts[i].commentData.push(_this.submitComment[0].commentData[0]);
	                _this.hashtagFunction();
	            });
	        }
	    };
	    PersonComponent = __decorate([
	        core_1.Component({
	            selector: 'person',
	            template: __webpack_require__(488),
	            directives: [router_1.ROUTER_DIRECTIVES],
	            providers: [person_service_1.personService]
	        }), 
	        __metadata('design:paramtypes', [person_service_1.personService, router_2.Router, router_2.ActivatedRoute])
	    ], PersonComponent);
	    return PersonComponent;
	}());
	exports.PersonComponent = PersonComponent;


/***/ },

/***/ 487:
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var core_1 = __webpack_require__(5);
	var router_1 = __webpack_require__(389);
	var app_constants_1 = __webpack_require__(441);
	var http_1 = __webpack_require__(363);
	var personService = (function () {
	    function personService(_router, _http, _conf) {
	        this._router = _router;
	        this._http = _http;
	        this._conf = _conf;
	    }
	    personService.prototype.personprofile = function (name) {
	        var token = localStorage.getItem('authToken');
	        var body = { token: token, membername: name };
	        // console.log(this._conf.Url + 'profile/' + name);
	        return this._http.post(this._conf.Url + 'profile/' + name, body, { headers: this._conf.headers })
	            .map(function (res) { return res.json(); })
	            .map(function (res) {
	            // console.log(res);
	            // if (res.token) {
	            //     localStorage.setItem('user', res.token);
	            //     // this._router.navigate(['Pages']);
	            //     return res.code;
	            // }
	            return res;
	        });
	    };
	    personService.prototype.memberFollowing = function (name) {
	        var token = localStorage.getItem('authToken');
	        var body = { token: token, membername: name };
	        //console.log(body);
	        return this._http.post(this._conf.Url + 'getMemberFollowing', body, { headers: this._conf.headers })
	            .map(function (res) { return res.json(); })
	            .map(function (res) {
	            //console.log(res);
	            // if (res.token) {
	            //     localStorage.setItem('user', res.token);S
	            //     // this._router.navigate(['Pages']);
	            //     return res.code;
	            // }
	            return res;
	        });
	    };
	    personService.prototype.memberFollowers = function (name) {
	        var token = localStorage.getItem('authToken');
	        var body = { token: token, membername: name };
	        //console.log(body);
	        return this._http.post(this._conf.Url + 'getMemberFollowers', body, { headers: this._conf.headers })
	            .map(function (res) { return res.json(); })
	            .map(function (res) {
	            //console.log(res);
	            // if (res.token) {
	            //     localStorage.setItem('user', res.token);S
	            //     // this._router.navigate(['Pages']);
	            //     return res.code;
	            // }
	            return res;
	        });
	    };
	    personService.prototype.loadmore = function (offset, name) {
	        var token = localStorage.getItem('authToken');
	        var body = {
	            token: token,
	            membername: name,
	            offset: offset
	        };
	        //console.log(body);
	        return this._http.post(this._conf.Url + 'profile/' + name, body, { headers: this._conf.headers })
	            .map(function (res) { return res.json(); })
	            .map(function (res) {
	            //console.log(res);
	            // if (res.token) {
	            //     localStorage.setItem('user', res.token);S
	            //     // this._router.navigate(['Pages']);
	            //     return res.code;
	            // }
	            return res;
	        });
	    };
	    personService.prototype.userlike = function (id, postsType) {
	        var token = localStorage.getItem('authToken');
	        var body = {
	            token: token,
	            postId: id,
	            label: 'Photo'
	        };
	        if (postsType == 1)
	            body.label = 'Video';
	        //console.log(body);
	        return this._http.post(this._conf.Url + 'like', body, { headers: this._conf.headers })
	            .map(function (res) { return res.json(); })
	            .map(function (res) {
	            //console.log(res);
	            // if (res.token) {
	            //     localStorage.setItem('user', res.token);S
	            //     // this._router.navigate(['Pages']);
	            //     return res.code;
	            // }
	            return res;
	        });
	    };
	    personService.prototype.usercomment = function (value) {
	        var token = localStorage.getItem('authToken');
	        var body = {
	            comment: value.message,
	            type: value.postsType,
	            postId: value.id,
	            token: token
	        };
	        //console.log(body);
	        return this._http.post(this._conf.Url + 'comments', body, { headers: this._conf.headers })
	            .map(function (res) { return res.json(); })
	            .map(function (res) {
	            //console.log(res);
	            // if (res.token) {
	            //     localStorage.setItem('user', res.token);S
	            //     // this._router.navigate(['Pages']);
	            //     return res.code;
	            // }
	            return res;
	        });
	    };
	    personService.prototype.userdeletecomment = function (value) {
	        var token = localStorage.getItem('authToken');
	        var body = {
	            commentedByUser: value.username,
	            commentBody: value.message,
	            commentId: value.commentId,
	            type: value.postsType,
	            postId: value.id,
	            token: token
	        };
	        //console.log(body);
	        // return;
	        return this._http.post(this._conf.Url + 'deleteCommentsFromPost', body, { headers: this._conf.headers })
	            .map(function (res) { return res.json(); })
	            .map(function (res) {
	            //console.log(res);
	            // if (res.token) {
	            //     localStorage.setItem('user', res.token);S
	            //     // this._router.navigate(['Pages']);
	            //     return res.code;
	            // }
	            return res;
	        });
	    };
	    personService.prototype.userunlike = function (id, postsType) {
	        var token = localStorage.getItem('authToken');
	        var body = {
	            token: token,
	            postId: id,
	            label: 'Photo'
	        };
	        if (postsType == 1)
	            body.label = 'Video';
	        //console.log(body);
	        return this._http.post(this._conf.Url + 'unlike', body, { headers: this._conf.headers })
	            .map(function (res) { return res.json(); })
	            .map(function (res) {
	            //console.log(res);
	            // if (res.token) {
	            //     localStorage.setItem('user', res.token);S
	            //     // this._router.navigate(['Pages']);
	            //     return res.code;
	            // }
	            return res;
	        });
	    };
	    personService.prototype.following = function (username) {
	        var token = localStorage.getItem('authToken');
	        var body = {
	            token: token,
	            userNameToFollow: username
	        };
	        //console.log(body);
	        return this._http.post(this._conf.Url + 'follow', body, { headers: this._conf.headers })
	            .map(function (res) { return res.json(); })
	            .map(function (res) {
	            //console.log(res);
	            // if (res.token) {
	            //     localStorage.setItem('user', res.token);S
	            //     // this._router.navigate(['Pages']);
	            //     return res.code;
	            // }
	            return res;
	        });
	    };
	    personService.prototype.follow = function (username) {
	        var token = localStorage.getItem('authToken');
	        var body = {
	            token: token,
	            unfollowUserName: username
	        };
	        //console.log(body);
	        return this._http.post(this._conf.Url + 'unfollow', body, { headers: this._conf.headers })
	            .map(function (res) { return res.json(); })
	            .map(function (res) {
	            //console.log(res);
	            // if (res.token) {
	            //     localStorage.setItem('user', res.token);S
	            //     // this._router.navigate(['Pages']);
	            //     return res.code;
	            // }
	            return res;
	        });
	    };
	    personService.prototype.privateprofile = function (username, privateMmber) {
	        var token = localStorage.getItem('authToken');
	        var body = {
	            token: token,
	            userNameToFollow: username
	        };
	        //console.log(body);
	        return this._http.post(this._conf.Url + 'follow', body, { headers: this._conf.headers })
	            .map(function (res) { return res.json(); })
	            .map(function (res) {
	            //console.log(res);
	            // if (res.token) {
	            //     localStorage.setItem('user', res.token);S
	            //     // this._router.navigate(['Pages']);
	            //     return res.code;
	            // }
	            return res;
	        });
	    };
	    personService = __decorate([
	        core_1.Injectable(), 
	        __metadata('design:paramtypes', [router_1.Router, http_1.Http, app_constants_1.Configuration])
	    ], personService);
	    return personService;
	}());
	exports.personService = personService;


/***/ },

/***/ 488:
/***/ function(module, exports) {

	module.exports = "<!DOCTYPE html>\r\n<html>\r\n<head>\r\n\t<title>{{name}}</title>\r\n    <link rel=\"icon\" type=\"image/gif/png\" href=\"/public/images/picoTitleLogo.png\">\r\n</head>\r\n\r\n<div class=\"loader\" *ngIf=\"loading\"></div>\r\n<div class=\"container-fluid picogram_total\">\r\n    <div class=\"container pico_content_total profile_pico\" [hidden]=\"!persondata\"  *ngIf=\"data; let i = index\" style=\"max-width: 935px;padding: 50px 20px 0;\">\r\n        <div class=\"profile_file_name zero_padding col-xs-12\" style=\"margin-bottom:4%;\">\r\n            <div class=\"profile_image zero_padding col-xs-3 col-sm-4\" style=\"text-align: center;\">\r\n                <img class=\"img_profile\" src=\"{{data.profilePicUrl}}\" onError=\"this.src='/public/images/default.png';\" width=\"152px;\" height=\"152px;\">\t\t\t\t\r\n            </div>\r\n            <div class=\"profile_name_content zero_padding col-xs-9 col-sm-8\">\r\n                <div class=\"detail_name_pico zero_padding col-xs-12\">\r\n                    <span class=\"follow_name2\" style=\"\">{{name}}</span>\r\n\t\t\t\t\t<span class=\"buffer_gif\" *ngIf=\"buffer\"><img src=\"/public/images/ajax-loader2.gif\" alt=\"loader\"></span>\r\n\r\n\t\t\t\t\t\t<span class=\"zero_padding col-xs-3 col-sm-3 col-md-2 follow_button\" *ngIf=\"data.userFollowRequestStatus==null\" (click)=\"followingfllag(name);\" ><button class=\"follow\" style=\"width:100% !important;font-size: 13px;\">Follow</button></span>\t\t\t\t\t\r\n\t\t\t\t\t\t<span class=\"zero_padding col-xs-3 col-sm-3 col-md-2 follow_button\" *ngIf=\"data.userFollowRequestStatus==0\" (click)=\"followfllag(name);\"><button class=\"folllow\" style=\"margin-top:0px;width:100% !important;font-size: 13px;background-color:gray;border:1px solid gray;\">Requested</button></span>\r\n\t\t\t\t\t\t<span class=\"zero_padding col-xs-3 col-sm-3 col-md-2 follow_button\" *ngIf=\"data.userFollowRequestStatus==1\" (click)=\"followfllag(name);\" ><button class=\"folllow\" style=\"margin-top:0px;width:100% !important;font-size: 13px;\">Following</button></span>\r\n\t\t\t\t\t\r\n\t\t\t\t    <span class=\"zero_padding col-xs-3 report_dotted\" data-toggle=\"modal\" data-target=\"#myModal\" style=\"position: relative;cursor:pointer;right:0%;margin-top: -5px;\"></span>\r\n                </div>\r\n                <!-- popup modal -->\r\n                <div class=\"modal fade\" id=\"myModal\" role=\"dialog\">\r\n                    <div class=\"modal-dialog modal-md\">\r\n                        <div class=\"modal-content\">\r\n                            <div class=\"modal-body\" style=\"\">\r\n                                <span class=\"report_cancel col-xs-12 color_focus\">Report user</span>\r\n                                <span class=\"report_cancel col-xs-12\">Block this User</span>\r\n                                <span class=\"report_cancel col-xs-12\" data-dismiss=\"modal\">Cancel</span>\r\n                            </div>\r\n                        </div>\r\n                    </div>\r\n                </div>\r\n                <!-- End popup modal -->\r\n\t\t\t\t<div class=\"post_follow_followers zero_padding like_post col-xs-12 hidden-xs\" style=\"margin:3% 0% 0% 0%;\">\r\n\t\t\t\t\t<span class=\"post color_thick1 zero_padding\" style=\"margin-right: 5%;\">{{data.totalPosts}}<span class=\"color_opacity\"> posts</span></span>\r\n\t\t\t\t\t<span class=\"followers color_thick1 zero_padding\" data-toggle=\"modal\" data-target=\"#followers\" style=\"cursor:pointer;margin-right: 5%;\">{{data.followers}}<span class=\"color_opacity\"> followers</span></span>\r\n\t\t\t\t\t<span class=\"following color_thick1 zero_padding\" data-toggle=\"modal\" data-target=\"#following\" style=\"cursor:pointer;\">{{data.following}}<span class=\"color_opacity\"> following</span></span>\r\n\t\t\t\t</div>\r\n                <div class=\"profilename_comment zero_padding col-xs-12\">\r\n                    <span class=\"name_comment color_thick1\" style=\"\">{{data.fullName}}</span>\r\n                    <span class=\"name_comment1 color_thick1 color_opacity\" [innerHTML]=\"data.bio\" style=\"\"> </span>\r\n                    <span class=\"\"><a class=\"color_thick1\" target=\"_blank\" href=\"http://{{data.websiteUrl}}\" style=\"color:#003569;\">{{data.websiteUrl}}</a></span>\r\n                </div>\r\n            </div>\r\n\t\t\t<span class=\"col-xs-12 visible-xs\" style=\"background:#dbdbdb;height:1px;\"></span>\r\n            <div class=\"post_follow_followers zero_padding like_post col-xs-12 visible-xs\" style=\"text-align:center;\">\r\n                <span class=\"post color_thick1 zero_padding col-xs-4 col-sm-2\"><span class=\"col-xs-12 zero_padding\">{{data.totalPosts}}</span><span class=\"color_opacity col-xs-12 zero_padding\"> posts</span></span>\r\n                <span class=\"followers color_thick1 zero_padding col-xs-4 col-sm-2\" data-toggle=\"modal\" data-target=\"#followers\" style=\"cursor:pointer;\"><span class=\"col-xs-12 zero_padding\">{{data.followers}}</span><span class=\"color_opacity col-xs-12 zero_padding\"> followers</span></span>\r\n                <span class=\"following color_thick1 zero_padding col-xs-4 col-sm-2\" data-toggle=\"modal\" data-target=\"#following\" style=\"cursor:pointer;\"><span class=\"col-xs-12 zero_padding\">{{data.following}}</span><span class=\"color_opacity col-xs-12 zero_padding\"> following</span></span>\r\n            </div>\r\n            <!-- popup modal folllowers and following -->\r\n\t\t<div *ngIf=\"data.privateMember != 1\" class=\"\">\r\n            <div class=\"modal fade followers_modal\" id=\"followers\" role=\"dialog\">\r\n\t\t\t\t<div class=\"modal-dialog modal-md\" style=\"margin-top:5%;\">\r\n\t\t\t\t\t<div class=\"modal-content\">\r\n\t\t\t\t\t\t<div class=\"modal-header\" style=\"\">\r\n\t\t\t\t\t\t\t<h4 class=\"col-xs-12 zero_padding color_thick\">Followers</h4>\r\n\t\t\t\t\t\t</div>\r\n\t\t\t\t\t\t<div class=\"modal-body follow_followers_modal\" *ngIf=\"data2\" style=\"\">\r\n\t\t\t\t\t\t\t<div class=\"follow_details col-xs-12 zero_padding\" *ngFor=\"let item of data2; let i = index\">\r\n\t\t\t\t\t\t\t\t<span class=\"col-xs-2 col-sm-1 zero_padding\"><img class=\"suggestion_image\" src=\"{{item.profilePicUrl}}\" onError=\"this.src='/public/images/default.png';\"></span>\r\n\t\t\t\t\t\t\t\t<span class=\"col-xs-5 col-sm-8 zero_padding\">\r\n\t\t\t\t\t\t\t\t <h5 class=\"follow_name col-xs-12 zero_padding\"><a class=\"color_thick follow_font member_name\" data-dismiss=\"modal\" (click)=\"memberprofile(item)\">{{item.username}}</a></h5>\r\n\t\t\t\t\t\t\t\t <h6 class=\"follow_name col-xs-12 zero_padding color_thick color_opacity follow_font1\" style=\"\">{{item.fullname}}</h6>\t\t\t\r\n\t\t\t\t\t\t\t\t</span>\r\n\t\t\t\t\t\t\t\t<span class=\"bufferperson_gif\" *ngIf=\"item.loaderFlag==true\"><img src=\"/public/images/ajax-loader2.gif\" alt=\"loader\"></span>\r\n\t\t\t\t\t\t\t\t<span class=\"col-xs-5 col-sm-3 zero_padding\" *ngIf=\"item.userFollowRequestStatus==null\" (click)=\"following(item, i);\" style=\"text-align:center;\"><button class=\"follow_button\" style=\"font-size:14px;\">Follow</button></span>\r\n\t\t\t\t\t\t\t\t<span class=\"col-xs-5 col-sm-3 zero_padding\" *ngIf=\"item.userFollowRequestStatus==0\" (click)=\"follow(item, i);\" style=\"text-align:center;\"><button class=\"follow_button\" style=\"font-size:14px;background-color:gray;border:1px solid gray;color:white;\">Requested</button></span>\r\n\t\t\t\t\t\t\t\t<span class=\"col-xs-5 col-sm-3 zero_padding\" *ngIf=\"item.userFollowRequestStatus==1\" (click)=\"follow(item, i);\" style=\"text-align:center;\"><button class=\"folllow_button folow\" style=\"margin-top:0px;font-size:14px;\">Following</button></span>\r\n\t\t\t\t\t\t\t</div>\t\t\t\t\t\t\r\n\t\t\t\t\t\t</div>\r\n\t\t\t\t\t\t<div class=\"modal-body follow_followers_modal\" *ngIf=\"!data2\" style=\"\">\r\n\t\t\t\t\t\t\t<h4 class=\"col-xs-12 zero_padding color_thick\" style=\"text-align: center;padding: 5%;\">You don't have any followers</h4>\r\n\t\t\t\t\t\t</div>\r\n\t\t\t\t\t</div>\r\n\t\t\t\t</div>\r\n\t\t\t</div>\r\n           <div class=\"modal fade following_modal\" id=\"following\" role=\"dialog\">\r\n\t\t\t\t<div class=\"modal-dialog modal-md\" style=\"margin-top:5%;\">\r\n\t\t\t\t\t<div class=\"modal-content\">\r\n\t\t\t\t\t\t<div class=\"modal-header\" style=\"\">\r\n\t\t\t\t\t\t\t<h4 class=\"col-xs-12 zero_padding color_thick\">Following</h4>\r\n\t\t\t\t\t\t</div>\r\n\t\t\t\t\t\t<div class=\"modal-body follow_followers_modal\" *ngIf=\"data1\" style=\"\">\r\n\t\t\t\t\t\t\t<div class=\"follow_details col-xs-12 zero_padding\" *ngFor=\"let item of data1; let i = index\">\r\n\t\t\t\t\t\t\t\t<span class=\"col-xs-2 col-sm-1 zero_padding\"><img class=\"suggestion_image\" src=\"{{item.profilePicUrl}}\" onError=\"this.src='/public/images/default.png';\"></span>\r\n\t\t\t\t\t\t\t\t<span class=\"col-xs-5 col-sm-8 zero_padding\">\r\n\t\t\t\t\t\t\t\t <h5 class=\"follow_name col-xs-12 zero_padding\"><a class=\"color_thick follow_font member_name\" data-dismiss=\"modal\" (click)=\"memberprofile(item)\">{{item.username}}</a></h5>\r\n\t\t\t\t\t\t\t\t <h6 class=\"follow_name col-xs-12 zero_padding color_thick color_opacity follow_font1\" style=\"\">{{item.fullname}}</h6>\t\t\t\r\n\t\t\t\t\t\t\t\t</span>\r\n\t\t\t\t\t\t\t\t<span class=\"bufferperson_gif\" *ngIf=\"item.loaderFlag==true\"><img src=\"/public/images/ajax-loader2.gif\" alt=\"loader\"></span>\r\n\t\t\t\t\t\t\t\t<span class=\"col-xs-5 col-sm-3 zero_padding\" *ngIf=\"item.userFollowRequestStatus==null\" (click)=\"followingflag(item, i);\" style=\"text-align:center;\"><button class=\"follow_button\" style=\"font-size:14px;\">Follow</button></span>\r\n\t\t\t\t\t\t\t\t<span class=\"col-xs-5 col-sm-3 zero_padding\" *ngIf=\"item.userFollowRequestStatus==0\" (click)=\"followflag(item, i);\" style=\"text-align:center;\"><button class=\"follow_button\" style=\"font-size:14px;background-color:gray;border:1px solid gray;color:white;\">Requested</button></span>\r\n\t\t\t\t\t\t\t\t<span class=\"col-xs-5 col-sm-3 zero_padding\" *ngIf=\"item.userFollowRequestStatus==1\" (click)=\"followflag(item, i);\" style=\"text-align:center;\"><button class=\"folllow_button folow\" style=\"margin-top:0px;font-size:14px;\">Following</button></span>\r\n\t\t\t\t\t\t\t</div>\t\t\t\t\t\t\t\r\n\t\t\t\t\t\t</div>\r\n\t\t\t\t\t\t<div class=\"modal-body follow_followers_modal\" *ngIf=\"!data1\" style=\"\">\r\n\t\t\t\t\t\t\t<h4 class=\"col-xs-12 zero_padding color_thick\" style=\"text-align: center;padding: 5%;\">You are not following anyone</h4>\r\n\t\t\t\t\t\t</div>\r\n\t\t\t\t\t</div>\r\n\t\t\t\t</div>\r\n\t\t\t</div>\r\n\t  </div>\r\n            <!-- End popup modal -->\r\n        </div> \r\n\r\n        <!-- -->\r\n\t\t<div class=\"col-xs-12 zero_padding\" *ngIf=\"data.privateMember == 1\" style=\"text-align:center;margin-top:10%;\">\r\n\t\t\t<h4 style=\"margin-bottom:2%;\">This Account is Private</h4>\r\n\t\t\t<h5>Follow to see their photos and videos</h5>\r\n\t\t</div>\r\n\r\n<div class=\"\" *ngIf=\"data.privateMember != 1\">\r\n<div *ngIf=\"posts\" class=\"all_profile_upload zero_padding col-xs-12\" style=\"\">\r\n\t<div class=\"zero_padding col-xs-4 upload_photo\" *ngFor=\"let item of posts\" style=\"margin:0% 3% 3% 0%;width:30.3%;\">\r\n\t\t<span class=\"img-span zero_padding col-xs-12 carousel_click\" (click)=\"activeitem(item.postId)\" id=\"{{item.postId}}\" data-toggle=\"modal\" data-target=\".bs-example-modal-lg\">\r\n\t\t\t<span class=\"img_hov zero_padding col-xs-12\">\r\n\t\t\t\t<img class=\"uploadphoto\" id=\"\" *ngIf=\"item.postsType==0\" src=\"{{item.mainUrl}}\" onError=\"this.src='/public/images/default.png';\">\r\n\t\t\t\t<span class=\"videotag_img video_tag\" *ngIf=\"item.postsType==1\"></span>\r\n\t\t\t\t<video class=\"uploadphoto\" *ngIf=\"item.postsType==1\">\r\n\t\t\t\t\t<source src=\"{{item.mainUrl}}\" type=\"video/mp4\">\r\n\t\t\t\t\t<source src=\"{{item.mainUrl}}\" type=\"video/ogg\"> \r\n\t\t\t\t</video>\r\n\t\t\t</span>\r\n\t\t\t<span class=\"hover_image_effect hide_hover col-xs-12\" id=\"\" style=\"\">\r\n\t\t\t\t<div class=\"hover_div zero_padding col-xs-12 col-sm-6\" *ngIf=\"item.postsType==0\">\r\n\t\t\t\t\t<span class=\"hover_icon hovericon zero_padding\"></span>\r\n\t\t\t\t\t<span class=\"hover_number\">{{item.likes}}</span>\r\n\t\t\t\t</div>\r\n\t\t\t\t<div class=\"hover_div zero_padding col-xs-12 col-sm-6\" *ngIf=\"item.postsType==1\">\r\n\t\t\t\t\t<span class=\"hover_icon hover_videoicon zero_padding\"></span>\r\n\t\t\t\t\t<span class=\"hover_number\">{{item.likes}}</span>\r\n\t\t\t\t</div>\r\n\t\t\t\t<div class=\"hover_div zero_padding col-xs-12 col-sm-6\">\r\n\t\t\t\t\t<span class=\"hover_icon hovericon1\"></span>\r\n\t\t\t\t\t<span class=\"hover_number\">{{item.commentData.length}}</span>\r\n\t\t\t\t</div>\r\n\t\t\t</span>\r\n\t\t</span>\r\n\t</div>\r\n</div>\r\n\r\n<div class=\"col-xs-12 loader_moreDetails\" [hidden]=\"!loadmoree\">\r\n\t<div class=\"loadmoreRound\" (click)=\"loadmore();\">\r\n\t\t<span class=\"loadmore_click\">loadmore</span>\r\n\t</div>\r\n</div>\r\n<!--<div class=\"zero_padding col-xs-12 loadmore\" (click)=\"loadmore();\" [hidden]=\"!loadmoree\" style=\"cursor:pointer;text-align:center;height: 120px;width: 120px;margin-left: 40%;border: 2px solid #3897f0;border-radius: 50%;\">\r\n\t<span class=\"loadmore_click\" style=\"font-size:14px;position: absolute;top: 40%;left: 28%;color: #3897f0;font-size: 14px;\">loadmore</span>\r\n\r\n</div>-->\r\n\r\n\r\n<!-- empty data -->\r\n<div *ngIf=\"data.totalPosts == 0\" class=\"all_profile_upload zero_padding col-xs-12\" style=\"margin-top:5%;\">\r\n\t<div class=\"col-xs-12 col-sm-6 zero_padding\">\r\n\t\t<span class=\"\"><img src=\"/public/images/nopost.jpg\" style=\"width: 100%;\"></span>\r\n\t</div>\r\n\t<div class=\"col-xs-12 col-sm-6\">\r\n\t\t<div class=\"col-xs-12 zero_padding\" style=\"text-align: center;margin: 30% 0%;\">\r\n\t\t\t<h4 class=\"\"> Start capturing and sharing your moments. </h4>\r\n\t\t\t<h5 class=\" color_opacity\">Get the app to share your first photo or video.</h5>\r\n\t\t\t <span class=\"col-xs-6 zero_padding \"><img class=\"image_app\" src=\"/public/images/appstore.png\" alt=\"app store\" style=\"width: 75%;height: 50px;\"></span>\r\n             <span class=\"col-xs-6 zero_padding\"><img class=\"image_app\" src=\"/public/images/playstore.png\" alt=\"google play store\" style=\"width: 75%;height: 50px;\"></span>\r\n\t\t</div>\r\n\t</div>\r\n</div>\r\n\r\n</div>\r\n\r\n<!-- -->   \r\n\r\n        \r\n\r\n<!-- carousel -->\r\n\r\n<div class=\"container\" style=\"width:100%;\">\r\n\r\n\t<div class=\"modal fade bs-example-modal-lg carousel-model\" id=\"myModal\" tabindex=\"-1\" role=\"dialog\" aria-labelledby=\"myLargeModalLabel\" aria-hidden=\"true\">\r\n\t\t<div class=\"modal-dialog modal-lg\">\r\n\t\t\t<div class=\"modal-content\">\r\n\t\t\t\t<div id=\"carousel-example-generic\" *ngIf=\"posts\" class=\"carousel slide\" data-interval=\"false\">\r\n\r\n\t\t\t\t\t<!-- Wrapper for slides -->\r\n\t\t\t\t\t<div class=\"carousel-inner\">\r\n\t\t\t\t\t\t<div class=\"item\" *ngFor=\"let item of posts; let i = index\" id=\"{{item.postId}}w\">\r\n\t\t\t\t\t\t\t<div class=\"col-xs-12 col-md-7 zero_padding\">\r\n\t\t\t\t\t\t\t\t<!--<img class=\"img-responsive\" src=\"https://igcdn-photos-f-a.akamaihd.net/hphotos-ak-xpt1/t51.2885-15/e15/10809778_786506061406485_132431944_n.jpg?ig_cache_key=ODY1OTk3NTk4NzU0MjE4NDY5.2\"\r\n\t\t\t\t\t\t\t\t\talt=\"...\">-->\r\n\t\t\t\t\t\t\t\t\t<img class=\"img-responsive col-xs-12 zero_padding\" id=\"\" (click)=\"falseusertagged(i);\" (dblclick)=\"likedoubleClick(item.postId, item.postsType,i);\" *ngIf=\"item.postsType==0\" src=\"{{item.mainUrl}}\" onError=\"this.src='/public/images/default.png';\">\r\n\t\t\t\t\t\t\t\t\t<div class=\"doubleclick_heart\" *ngIf=\"item.likeheartFlagg==true\"> \r\n\t\t\t\t\t\t\t\t\t\t<span class=\"double_click_heart like_icon\"></span>\r\n\t\t\t\t\t\t\t\t\t</div>\r\n\t\t\t\t\t\t\t\t\t<video class=\"img-responsive\" (click)=\"falseusertagged(i);\" *ngIf=\"item.postsType==1\" controls>\r\n\t\t\t\t\t\t\t\t\t\t<source src=\"{{item.mainUrl}}\" type=\"video/mp4\">\r\n\t\t\t\t\t\t\t\t\t\t<source src=\"{{item.mainUrl}}\" type=\"video/ogg\"> \r\n\t\t\t\t\t\t\t\t\t</video>\r\n\t\t\t\t\t\t\t\t\t <div class=\"pico_contentdetails_tagged col-xs-12\">\r\n\t\t\t\t\t\t\t\t\t\t<div *ngIf=\"item.usertaggedFlagg==true\">\r\n\t\t\t\t\t\t\t\t\t\t\t<span *ngFor=\"let tagged of item.coords;\">\r\n\t\t\t\t\t\t\t\t\t\t\t\t<span class=\"tagg_color_name tagg_color\" data-dismiss=\"modal\" (click)=\"usertaggedname(tagged);\"  [ngStyle]=\"{'margin-left': tagged.right+'%', 'margin-top': '-'+tagged.top+'%'}\">\t\t\t\t\t\t\t\t\t\t\t\t\t\t\r\n\t\t\t\t\t\t\t\t\t\t\t\t\t<div class=\"tagg_arrowicon\"></div>\r\n\t\t\t\t\t\t\t\t\t\t\t\t\t{{tagged.name}}\t\t\t\t\t\t\t\t\t\t\t\t\t\t\r\n\t\t\t\t\t\t\t\t\t\t\t\t</span>\r\n\t\t\t\t\t\t\t\t\t\t\t</span>\r\n\t\t\t\t\t\t\t\t\t\t</div>\r\n\t\t\t\t\t\t\t\t\t\t<div class=\"\" *ngFor=\"let tagged of item.coords;\">\t\t\t\t\t\t\r\n\t\t\t\t\t\t\t\t\t\t\t<i class=\"usertag_icon tagged_icon\" (click)=\"usertagged(i);\"></i>\t\t\t\t\t\t\t\t\t\t\r\n\t\t\t\t\t\t\t\t\t\t</div>\r\n\t\t\t\t\t\t\t\t\t</div>\r\n\t\t\t\t\t\t\t</div>\r\n\t\t\t\t\t\t\t<div class=\"col-xs-12 col-md-5 zero_padding comment_text\">\r\n\t\t\t\t\t\t\t\t<div class=\"follow_details col-xs-12 zero_padding\" *ngIf=\"data\">\r\n\t\t\t\t\t\t\t\t\t<span class=\"col-xs-2 col-sm-2 col-md-1 zero_padding\"><img class=\"suggestion_image member_name\" data-dismiss=\"modal\" (click)=\"memberprofile()\" src=\"{{data.profilePicUrl}}\" onError=\"this.src='/public/images/default.png';\"></span>\r\n\t\t\t\t\t\t\t\t\t<span class=\"col-xs-4 col-sm-5 col-md-6 zero_padding slider_img\">\r\n\t\t\t\t\t\t\t\t\t\t<h5 class=\"follow_name col-xs-12 zero_padding\"><span class=\"color_thick member_name\" data-dismiss=\"modal\" (click)=\"memberprofile()\">{{name}}</span></h5>\r\n\t\t\t\t\t\t\t\t\t\t<h6 class=\"follow_name col-xs-12 zero_padding color_thick color_opacity\" style=\"\">{{data.fullName}}</h6>\t\t\t\r\n\t\t\t\t\t\t\t\t\t</span>\r\n\t\t\t\t\t\t\t\t\t<span class=\"buffer_gif\" *ngIf=\"buffer\"><img src=\"/public/images/ajax-loader2.gif\" alt=\"loader\"></span>\r\n\t\t\t\t\t\t\t\t\t<span class=\"col-xs-5 col-sm-4 zero_padding\" *ngIf=\"data.userFollowRequestStatus==null\" (click)=\"followingfllag(name);\" style=\"\"><button class=\"follow_button\" style=\"font-size: 13px;\">Follow</button></span>\r\n\t\t\t\t\t\t\t\t\t<span class=\"col-xs-5 col-sm-4 zero_padding\" *ngIf=\"data.userFollowRequestStatus==0\" (click)=\"followfllag(name);\" style=\"\"><button class=\"follow_button\" style=\"font-size: 13px;background-color:gray;border:1px solid gray;\">Requested</button></span>\r\n\t\t\t\t\t\t\t\t\t<span class=\"col-xs-5 col-sm-4 zero_padding\" *ngIf=\"data.userFollowRequestStatus==1\" (click)=\"followfllag(name);\" style=\"\"><button class=\"follow_buttonn folow\" style=\"margin-top:0px;font-size: 13px;\">Following</button></span>\r\n\t\t\t\t\t\t\t\t\t\r\n\t\t\t\t\t\t\t\t</div>\r\n\t\t\t\t\t\t\t\t<div class=\"pico_contentdetails_comment\" style=\"padding: 0% 0% 0% 5%;display: inline-block;width: 100%;\">\r\n\t\t\t\t\t\t\t\t\t<div class=\"col-xs-12 zero_padding\" style=\"margin: 2% 0%;\">\r\n\t\t\t\t\t\t\t\t\t\t<span class=\"col-xs-10 zero_padding\" *ngIf=\"item.postLikedBy.length < 6\">\r\n\t\t\t\t\t\t\t\t\t\t\t<div *ngIf=\"item.postLikedBy\">\r\n\t\t\t\t\t\t\t\t\t\t\t\t<span *ngFor=\"let liked of item.postLikedBy; let i = index;\">\r\n\t\t\t\t\t\t\t\t\t\t\t\t\t<span *ngIf=\"liked != 'null'\">\r\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t<span *ngIf=\"i != 0\" class=\"comma_moveleftside\">,</span>\r\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t<span class=\"add_liked color_thick member_name\" data-dismiss=\"modal\" (click)=\"likeStatus(liked)\" id=\"likecontent\">{{liked}}</span>\r\n\t\t\t\t\t\t\t\t\t\t\t\t\t</span>\r\n\t\t\t\t\t\t\t\t\t\t\t\t</span>\r\n\t\t\t\t\t\t\t\t\t\t\t\t<span class=\"color_opacity\" *ngIf=\"item.postLikedBy.length > 1 || item.likeStatus==1\" style=\"font-size: 14px;\">like this</span>\r\n\t\t\t\t\t\t\t\t\t\t\t</div>\r\n\t\t\t\t\t\t\t\t\t\t</span>\r\n\t\t\t\t\t\t\t\t\t\t<span class=\"col-xs-10 zero_padding\" *ngIf=\"item.postLikedBy.length > 6\"><span class=\"add_like color_thick\" id=\"like1content\" style=\"margin-right: 5%;\">{{item.likes}}</span><span class=\"color_thick\">likes</span></span>\r\n\t\t\t\t\t\t\t\t\t\t<span class=\"col-xs-6 color_thick color_opacity zero_padding member_name\" data-dismiss=\"modal\" (click)=\"timepost(item)\" style=\"color: #999;float:right;width: 10%;\">{{item.postedOn}}</span>\r\n\t\t\t\t\t\t\t\t\t</div>\r\n\t\t\t\t\t\t\t\t\t<ul class=\"comment_list carousel_comment zero_padding col-xs-12\">\r\n\t\t\t\t\t\t\t\t\t\t<!--<li class=\"listcomment zero_padding col-xs-12\">\r\n\t\t\t\t\t\t\t\t\t\t\t<span class=\"name_comment\" style=\"\"><span class=\"color_thick\" style=\"\" *ngIf=\"item.postCaption !='null'\">{{item.postCaption}}</span></span>\r\n\t\t\t\t\t\t\t\t\t\t\t\r\n\t\t\t\t\t\t\t\t\t\t</li>-->\r\n\t\t\t\t\t\t\t\t\t\t<li class=\"listcomment zero_padding col-xs-12\" >\r\n\t\t\t\t\t\t\t\t\t\t\t<span class=\"color_thick member_name\" *ngIf=\"item.postCaption !='null'\" id=\"{{item.postsId}}\">{{name}}</span>\r\n\t\t\t\t\t\t\t\t\t\t\t<span class=\"name_comment\" style=\"\" *ngFor=\"let caption of item.postCaption;\">\r\n\t\t\t\t\t\t\t\t\t\t\t\t<span *ngIf=\"caption != 'null'\">\r\n\t\t\t\t\t\t\t\t\t\t\t\t\t<span class=\"color_thick color_opacity member_name\" id=\"{{item.postsId}}\" *ngIf=\"caption.charAt(0) != '#' && caption.charAt(0) != '@'\" data-dismiss=\"modal\">{{caption}}</span>\t\t\t\t\t\t\t\t\t\t\t\t\t\r\n\t\t\t\t\t\t\t\t\t\t\t\t\t<span class=\"color_thick color_opacity member_name\" id=\"{{item.postsId}}\" data-dismiss=\"modal\" (click)=\"membercaption(caption)\" style=\"color:#003569;\" *ngIf=\"caption.charAt(0) == '#'\">{{caption}}</span>\r\n\t\t\t\t\t\t\t\t\t\t\t\t\t<span class=\"color_thick color_opacity member_name\" id=\"{{item.postsId}}\" data-dismiss=\"modal\" (click)=\"memberprofilecaptionn(caption)\" style=\"color:#003569;\" *ngIf=\"caption.charAt(0) == '@'\">{{caption}}</span>                                               \t\r\n\t\t\t\t\t\t\t\t\t\t\t\t</span>\r\n\t\t\t\t\t\t\t\t\t\t\t</span>\r\n\t\t\t\t\t\t\t\t\t\t</li>\r\n\t\t\t\t\t\t\t\t\t\t<li class=\"listcomment zero_padding col-xs-12\" *ngFor=\"let comment of item.commentData; let k = index;\">\r\n\t\t\t\t\t\t\t\t\t\t\t<span class=\"name_comment\" style=\"\"><span class=\"color_thick member_name\" data-dismiss=\"modal\" (click)=\"memberprofilee(comment)\" style=\"\">{{comment.commentedByUser}}</span></span>\r\n\t\t\t\t\t\t\t\t\t\t\t<span class=\"name_comment1 color_thick color_opacity\" style=\"\" [innerHTML]=\"comment.commentBody\"></span>\r\n\t\t\t\t\t\t\t\t\t\t\t<!--<span class=\"name_comment1 color_thick color_opacity member_name\" style=\"color:#003569;\" data-dismiss=\"modal\" (click)=\"membercaptionn(comment)\" *ngIf=\"comment[1].charAt(0) == '#'\">{{comment[1]}}</span>\r\n\t\t\t\t\t\t\t\t\t\t\t<span class=\"name_comment1 color_thick color_opacity member_name\" style=\"color:#003569;\" data-dismiss=\"modal\" (click)=\"memberprofilecaption(comment)\" *ngIf=\"comment[1].charAt(0) == '@'\">{{comment[1]}}</span>-->\r\n\t\t\t\t\t\t\t\t\t\t\t<span class=\"name_comment1 color_thick color_opacity member_name delete_comment\" style=\"\" data-toggle=\"modal\" data-target=\"#myModal_delete\" (click)=\"commentdelete(comment, item.postId, item.postsType, i, k)\" *ngIf=\"comment.commentedByUser == username\">X</span>\r\n\t\t\t\t\t\t\t\t\t\t</li>\t\t\t\t\t\t\t\t\t\r\n\t\t\t\t\t\t\t\t\t</ul>\r\n\t\t\t\t\t\t\t\t\t<span class=\"col-xs-11\" style=\"background:#efefef;height:1px;margin: 5px 0px 5px 0px\"></span>\r\n\t\t\t\t\t\t\t\t</div>\r\n\t\t\t\t\t\t\t\t<div class=\"add_comment col-xs-12 modal_comment_carousel\" style=\"padding: 5px 20px;\">\r\n\t\t\t\t\t\t\t\t\t<i class=\"comment_icon comment_heart_icon add_heart_icon\" *ngIf=\"item.likeStatus!=1\" (click)=\"likeactive(item.postId, item.postsType,i)\" id=\"{{item.postId}}\"></i>\r\n\t\t\t\t\t\t\t\t\t<i class=\"comment_icon comment_heart_icon add_heart_icon active\" *ngIf=\"item.likeStatus==1\" (click)=\"likedeactive(item.postId, item.postsType,i)\" id=\"{{item.postId}}\"></i>\r\n\t\t\t\t\t\t\t\t\t<input type=\"text\" #input (keyup.enter)=\"usercommentSubmit(input.value, item.postId, item.postsType, i); input.value=''\" name=\"message\" placeholder=\"Add a comment\"\r\n\t\t\t\t\t\t\t\t\tid=\"{{item.postsId}}\" class=\"col-xs-12 comment_textbox\" style=\"font-size:14px;\">\r\n\t\t\t\t\t\t\t\t\t<i class=\"comment_icon comment_dotted_icon\" data-toggle=\"modal\" data-target=\"#myModall\"></i>\r\n\t\t\t\t\t\t\t\t</div>\r\n\t\t\t\t\t\t\t</div>\r\n\t\t\t\t\t\t</div>\r\n\t\t\t\t\t</div>\r\n\t\t\t\t</div>\r\n\r\n\t\t\t\t<!-- Controls -->\r\n\t\t\t\t<a class=\"left carousel-control\" href=\"#carousel-example-generic\" role=\"button\" data-slide=\"prev\">\r\n\t\t\t\t\t<span class=\"glyphicon glyphicon-chevron-left\"></span>\r\n\t\t\t\t</a>\r\n\t\t\t\t<a class=\"right carousel-control\" href=\"#carousel-example-generic\" role=\"button\" data-slide=\"next\">\r\n\t\t\t\t\t<span class=\"glyphicon glyphicon-chevron-right\"></span>\r\n\t\t\t\t</a>\r\n\t\t\t</div>\r\n\t\t</div>\r\n\t</div>\r\n\r\n\t<!-- popup modal -->\r\n\t\t<div class=\"modal fade\" id=\"myModall\" role=\"dialog\">\r\n\t\t\t<div class=\"modal-dialog modal-md\">\r\n\t\t\t\t<div class=\"modal-content\">\r\n\t\t\t\t\t<div class=\"modal-body\" style=\"\">\r\n\t\t\t\t\t\t<span class=\"report_cancel col-xs-12\">Report inappropriate</span>\r\n\t\t\t\t\t\t<!--<span class=\"report_cancel col-xs-12\">Embed</span>-->\r\n\t\t\t\t\t\t<span class=\"report_cancel col-xs-12\" data-dismiss=\"modal\">Cancel</span>\r\n\t\t\t\t\t</div>\r\n\t\t\t\t</div>\r\n\t\t\t</div>\r\n\t\t</div>\r\n\t\t<!-- delete comment -->\r\n\t\t<div class=\"modal fade deletecomment\" id=\"myModal_delete\" role=\"dialog\">\r\n\t\t\t<div class=\"modal-dialog modal-md\">\r\n\t\t\t\t<div class=\"modal-content\">\r\n\t\t\t\t\t<div class=\"modal-body\" style=\"\">\r\n\t\t\t\t\t\t<span class=\"report_cancel col-xs-12 color_focus  member_name\" data-dismiss=\"modal\" (click)=\"commentmodaldelete()\">Delete Comment</span>\r\n\t\t\t\t\t\t<!--<span class=\"report_cancel col-xs-12\">Embed</span>-->\r\n\t\t\t\t\t\t<span class=\"report_cancel col-xs-12\" data-dismiss=\"modal\">Cancel</span>\r\n\t\t\t\t\t</div>\r\n\t\t\t\t</div>\r\n\t\t\t</div>\r\n\t\t</div>\r\n\t\t<!-- End popup modal -->\r\n\r\n</div>\r\n<!-- end carousel -->\r\n</div>\r\n<div class=\"container pico_content_total profile_pico\" [hidden]=\"!personnodata\" style=\"max-width: 935px;padding: 50px 20px 0;text-align:center;\">\r\n\t<h2> Sorry, this page isn't available</h2>\r\n\t<h5> The link you followed may be broken, or the page may have been removed. <a [routerLink]=\"['/home']\">Go back to picogram.</a></h5>\r\n</div>\r\n</div>\r\n\r\n</html>\r\n\r\n";

/***/ },

/***/ 489:
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var core_1 = __webpack_require__(5);
	var router_1 = __webpack_require__(389);
	var router_2 = __webpack_require__(389);
	var personlocation_service_1 = __webpack_require__(490);
	var PersonlocationComponent = (function () {
	    function PersonlocationComponent(_personService, _router, route) {
	        this._personService = _personService;
	        this._router = _router;
	        this.route = route;
	        this.posts = [];
	        this.loading = true;
	        this.buffer = false;
	        this.offset = 0;
	        this.commnentdetails = [];
	    }
	    PersonlocationComponent.prototype.ngOnInit = function () {
	        var _this = this;
	        jQuery(".modal-backdrop").css({ "display": "none" });
	        var username = localStorage.getItem('username');
	        this.username = username;
	        this.route.params.subscribe(function (params) {
	            _this.name = params['name'];
	            var locationname = _this.name.replace(/\+/g, '%20');
	            locationname = decodeURIComponent(locationname);
	            jQuery(".locatName").text(locationname);
	            // //console.log(locationname); 
	            _this.loading = true;
	            _this._personService.personprofile(locationname)
	                .subscribe(function (res) {
	                _this.loading = false;
	                // this.data = res.memberProfileData[0];
	                // this.posts = res.memberPostsData;
	                _this.posts = [];
	                _this.totaldata = res.data;
	                _this.offset = res.data.length;
	                _this.latitude = _this.totaldata[0].latitude;
	                _this.longitude = _this.totaldata[0].longitude;
	                _this.latlngfunction();
	                _this.commentfunction();
	                if (_this.offset >= 20)
	                    _this.loadmoree = true;
	            });
	        });
	        jQuery(document).keyup(function (e) {
	            if (e.keyCode == 27) {
	                jQuery(".modal").css({ "display": "none" });
	                jQuery(".modal-backdrop").css({ "display": "none" });
	            }
	        });
	    };
	    PersonlocationComponent.prototype.latlngfunction = function () {
	        var lat = this.latitude;
	        var lng = this.longitude;
	        // //console.log(lat+"aa"+lng);
	        var latlng = new google.maps.LatLng(lat, lng);
	        var map = new google.maps.Map(document.getElementById('googleMap'), {
	            center: latlng,
	            zoom: 15,
	            mapTypeId: google.maps.MapTypeId.ROADMAP
	        });
	        var marker = new google.maps.Marker({
	            position: latlng,
	            map: map,
	            title: 'Set lat/lon values for this property',
	            draggable: false
	        });
	    };
	    PersonlocationComponent.prototype.hashtagFunction = function () {
	        var len = this.totaldata.length;
	        for (var i = 0; i < len; i++) {
	            if (this.totaldata[i].commentData) {
	                var commenttext = this.totaldata[i].commentData;
	                for (var x = 0; x < commenttext.length; x++) {
	                    // commenttext.splice(x, 0);
	                    if (this.totaldata[i].commentData[x].commentBody) {
	                        var postCommentNodeArr1 = commenttext[x].commentBody;
	                        // //console.log(postCommentNodeArr1);
	                        var hashtag_regexp = /#([a-zA-Z0-9_]+)/g;
	                        var comment_text = postCommentNodeArr1.replace(hashtag_regexp, '<a href="home/personcaption/$1" class="hashtag member_name biohashtag">#$1</a>');
	                        var hashtag_regexp1 = /@([a-zA-Z0-9_]+)/g;
	                        var comment_textt = comment_text.replace(hashtag_regexp1, '<a href="home/person/$1" class="hashtag member_name biohashtag">@$1</a>');
	                        this.totaldata[i].commentData[x].commentBody = comment_textt;
	                    }
	                }
	            }
	        }
	    };
	    PersonlocationComponent.prototype.commentfunction = function () {
	        // alert("hi");
	        this.hashtagFunction();
	        var len = this.totaldata.length;
	        // this.posts=[];
	        for (var i = 0; i < len; i++) {
	            // this.commentdata = [];
	            // if (this.totaldata[i].comments) {
	            //     var commenttext = this.totaldata[i].comments;
	            //     var hashtag_regexp = /#([a-zA-Z0-9_]+)/g;
	            //     var comment_text = commenttext.replace(
	            //         hashtag_regexp,
	            //         '<a href="home/personcaption/$1" class="hashtag member_name biohashtag">#$1</a>'
	            //     );
	            //     var hashtag_regexp1 = /@([a-zA-Z0-9_]+)/g;
	            //     var comment_textt = comment_text.replace(
	            //         hashtag_regexp1,
	            //         '<a href="home/person/$1" class="hashtag member_name biohashtag">@$1</a>'
	            //     );
	            //     var postCommentNodeArr = comment_textt.split('^^');
	            //     for (var x = 0; x < postCommentNodeArr.length; x++) {
	            //         postCommentNodeArr.splice(x, 0);
	            //         var postCommentNodeArr1 = postCommentNodeArr[x].split('$$');
	            //         if (postCommentNodeArr1.length == 2)
	            //         this.commentdata.push(postCommentNodeArr1);
	            //     }
	            // }
	            // this.totaldata[i].comments = this.commentdata;
	            var postCaption = [];
	            if (this.totaldata[i].postCaption) {
	                var postCaptionn = this.totaldata[i].postCaption.split(' ');
	                this.totaldata[i].postCaption = postCaptionn;
	            }
	            var likedByUser = [];
	            if (this.totaldata[i].likedByUser) {
	                var liked = this.totaldata[i].likedByUser.split(',');
	                if (liked.length) {
	                    this.totaldata[i].likedByUser = liked;
	                }
	            }
	            else {
	                this.totaldata[i].likedByUser = [];
	            }
	            var usersTagged = [];
	            if (this.totaldata[i].usersTagged) {
	                usersTagged = this.totaldata[i].usersTagged.split(',');
	                this.totaldata[i].usersTagged = usersTagged;
	            }
	            var taggedUserCoordinates = [];
	            if (this.totaldata[i].taggedUserCoordinates) {
	                taggedUserCoordinates = this.totaldata[i].taggedUserCoordinates.split(',');
	                this.totaldata[i].taggedUserCoordinates = taggedUserCoordinates;
	            }
	            if (usersTagged[0] != 'undefined' && taggedUserCoordinates[0] != null) {
	                var lenn = usersTagged.length;
	                var tagsCords = [];
	                for (var j = 0; j < lenn; j++) {
	                    var userCords = {
	                        name: usersTagged[j],
	                        right: 0,
	                        top: 0
	                    };
	                    if (taggedUserCoordinates[j]) {
	                        var cordinates = taggedUserCoordinates[j].split('-');
	                        userCords.right = cordinates[0];
	                        userCords.top = cordinates[1];
	                        tagsCords.push(userCords);
	                    }
	                }
	                this.totaldata[i].coords = tagsCords;
	            }
	            var post = this.totaldata[i].postedOn;
	            var poston = Number(post);
	            var postdate = new Date(poston);
	            var currentdate = new Date();
	            var timeDiff = Math.abs(postdate.getTime() - currentdate.getTime());
	            var diffDays = Math.ceil(timeDiff / (1000 * 3600 * 24));
	            var diffHrs = Math.round((timeDiff % 86400000) / 3600000);
	            var diffMins = Math.round(((timeDiff % 86400000) % 3600000) / 60000);
	            if (1 < diffDays) {
	                this.totaldata[i].postedOn = diffDays + "d";
	            }
	            else if (1 <= diffHrs) {
	                this.totaldata[i].postedOn = diffHrs + "h";
	            }
	            else {
	                this.totaldata[i].postedOn = diffMins + "m";
	            }
	            this.posts.push(this.totaldata[i]);
	        }
	        // this.posts = this.totaldata;
	    };
	    PersonlocationComponent.prototype.loadmore = function () {
	        var _this = this;
	        // //console.log(this.offset, this.name);
	        this.offset = this.posts.length;
	        this._personService.loadmore(this.offset, this.name)
	            .subscribe(function (res) {
	            // var len = res.memberPostsData.length;
	            // for (var i = 0; i < len; i++) {
	            //     this.posts.push(res.memberPostsData[i]);
	            // }
	            _this.totaldata = res.data;
	            _this.commentfunction();
	            _this.offset = res.data.length || 0;
	            if (_this.offset >= 20)
	                _this.loadmoree = true;
	            else
	                _this.loadmoree = false;
	        });
	    };
	    PersonlocationComponent.prototype.timepost = function (item) {
	        var postsId = item.postId;
	        var followingUsername = item.username;
	        var link = ['home/homepost', followingUsername, postsId];
	        this._router.navigate(link);
	    };
	    PersonlocationComponent.prototype.usertagged = function (i) {
	        this.posts[i].usertaggedFlagg = true;
	    };
	    PersonlocationComponent.prototype.falseusertagged = function (i) {
	        this.posts[i].usertaggedFlagg = false;
	    };
	    PersonlocationComponent.prototype.usertaggedname = function (tagged) {
	        // alert(item.postId);
	        var personname = tagged.name;
	        var username = localStorage.getItem('username');
	        if (username == personname) {
	            this._router.navigate(['home/profile']);
	        }
	        else {
	            var link = ['home/person', personname];
	            this._router.navigate(link);
	        }
	    };
	    PersonlocationComponent.prototype.activeitem = function (id) {
	        // alert(id);
	        jQuery('.item').removeClass("active");
	        jQuery('#' + id + 'w').addClass("active");
	    };
	    PersonlocationComponent.prototype.memberprofile = function (item) {
	        // alert(item.postsId);
	        var personname = item.username;
	        var username = localStorage.getItem('username');
	        if (username == personname) {
	            this._router.navigate(['home/profile']);
	        }
	        else {
	            var link = ['home/person', personname];
	            this._router.navigate(link);
	        }
	        // let link = ['/home/person', item.username];
	        // this._router.navigate(link);
	    };
	    PersonlocationComponent.prototype.memberprofilee = function (comment) {
	        // alert(item.postsId);
	        var personname = comment.commentedByUser;
	        var username = localStorage.getItem('username');
	        if (username == personname) {
	            this._router.navigate(['home/profile']);
	        }
	        else {
	            var link = ['home/person', personname];
	            this._router.navigate(link);
	        }
	        // let link = ['home/person', comment[0]];
	        // this._router.navigate(link);
	    };
	    PersonlocationComponent.prototype.membercaption = function (caption) {
	        var hashtagname = caption.split('#');
	        //   //console.log(hashtagname[1]);        
	        var link = ['home/personcaption', hashtagname[1]];
	        this._router.navigate(link);
	    };
	    PersonlocationComponent.prototype.membercaptionn = function (comment) {
	        var hashtagname = comment[1].split('#');
	        //   //console.log(hashtagname[1]);        
	        var link = ['home/personcaption', hashtagname[1].replace(" ", "")];
	        this._router.navigate(link);
	    };
	    PersonlocationComponent.prototype.memberprofilecaption = function (comment) {
	        var personname = comment[1].split('@');
	        var username = localStorage.getItem('username');
	        if (username == personname[1]) {
	            this._router.navigate(['home/profile']);
	        }
	        else {
	            var link = ['home/person', personname[1].replace(" ", "")];
	            this._router.navigate(link);
	        }
	    };
	    PersonlocationComponent.prototype.memberprofilecaptionn = function (caption) {
	        var personname = caption.split('@');
	        var username = localStorage.getItem('username');
	        if (username == personname[1]) {
	            this._router.navigate(['home/profile']);
	        }
	        else {
	            var link = ['home/person', personname[1].replace(" ", "")];
	            this._router.navigate(link);
	        }
	    };
	    PersonlocationComponent.prototype.memberprofileplace = function (item) {
	        // alert(item.postsId);
	        var placename = item.place;
	        var link = ['home/personlocation', placename];
	        this._router.navigate(link);
	    };
	    PersonlocationComponent.prototype.commentdelete = function (comment, id, postsType, i, k) {
	        //  //console.log(comment[0]+" ss "+comment[1]+" id "+id+" postsType "+postsType+" i "+i);
	        postsType = postsType.toString();
	        this.commnentdetails = ({ username: comment.commentedByUser, message: comment.commentBody, commentId: comment.commentId, id: id, postsType: postsType, i: i, k: k });
	    };
	    PersonlocationComponent.prototype.commentmodaldelete = function () {
	        //console.log(this.commnentdetails);
	        var commentlist = this.commnentdetails;
	        var commenttext = commentlist.message;
	        var hashtag_regexp = /<a[^>]*>([^<]+)<\/a>/g;
	        var comment_text = commenttext.replace(hashtag_regexp, '$1');
	        //  //console.log(commentlist.i);
	        this.posts[commentlist.i].commentData.splice([commentlist.k], 1);
	        this._personService.userdeletecomment({ username: commentlist.username, message: comment_text, commentId: commentlist.commentId, id: commentlist.id, postsType: commentlist.postsType })
	            .subscribe();
	    };
	    PersonlocationComponent.prototype.likedbyuser = function (liked) {
	        var personname = liked;
	        // alert(personname);
	        var username = localStorage.getItem('username');
	        if (username == personname) {
	            this._router.navigate(['home/profile']);
	        }
	        else {
	            var link = ['home/person', personname];
	            this._router.navigate(link);
	        }
	    };
	    PersonlocationComponent.prototype.likedoubleClick = function (id, postsType, i) {
	        var _this = this;
	        // alert(id+'aa'+'bb'+type+'cc'+i);
	        if (this.posts[i].likeStatus == 0) {
	            this.posts[i].likeheartFlagg = true;
	            var username = localStorage.getItem('username');
	            this.posts[i].likedByUser.unshift(username);
	            this.posts[i].likeStatus = 1;
	            this.posts[i].likes += 1;
	            this._personService.userlike(id, postsType)
	                .subscribe();
	            setTimeout(function () {
	                _this.posts[i].likeheartFlagg = false;
	            }, 500);
	        }
	    };
	    PersonlocationComponent.prototype.likeactive = function (id, postsType, i) {
	        // alert(id);
	        var username = localStorage.getItem('username');
	        this.posts[i].likedByUser.unshift(username);
	        this.posts[i].likeStatus = 1;
	        this.posts[i].likes += 1;
	        this._personService.userlike(id, postsType)
	            .subscribe();
	    };
	    PersonlocationComponent.prototype.likedeactive = function (id, postsType, i) {
	        var username = localStorage.getItem('username');
	        var array = this.posts[i].likedByUser;
	        var index = array.indexOf(username);
	        if (index > -1) {
	            array.splice(index, 1);
	        }
	        this.posts[i].likeStatus = 0;
	        this.posts[i].likes -= 1;
	        this._personService.userunlike(id, postsType)
	            .subscribe();
	    };
	    PersonlocationComponent.prototype.followingfllag = function (item, i) {
	        var _this = this;
	        // alert(i+'ll'+username+'ff'+followFlag);
	        var username = item.postedByUserName;
	        var memberPrivate = item.memberPrivate;
	        this.buffer = true;
	        if (memberPrivate == 1) {
	            setTimeout(function () {
	                _this.posts[i].userFollowRequestStatus = 0;
	            }, 500);
	            this._personService.following(username)
	                .subscribe();
	            setTimeout(function () {
	                _this.buffer = false;
	            }, 500);
	        }
	        if (memberPrivate != 1) {
	            setTimeout(function () {
	                _this.posts[i].userFollowRequestStatus = 1;
	            }, 500);
	            this._personService.following(username)
	                .subscribe();
	            setTimeout(function () {
	                _this.buffer = false;
	            }, 500);
	        }
	    };
	    PersonlocationComponent.prototype.followfllag = function (item, i) {
	        var _this = this;
	        var username = item.postedByUserName;
	        this.buffer = true;
	        setTimeout(function () {
	            _this.posts[i].userFollowRequestStatus = null;
	        }, 500);
	        this._personService.follow(username)
	            .subscribe();
	        setTimeout(function () {
	            _this.buffer = false;
	        }, 500);
	    };
	    PersonlocationComponent.prototype.usercommentSubmit = function (value, id, postsType, i) {
	        var _this = this;
	        // //console.log('you submitted value:', value, id, type, i);
	        postsType = postsType.toString();
	        var username = localStorage.getItem('username');
	        var commenttext = value;
	        var hashtag_regexp = /#([a-zA-Z0-9_]+)/g;
	        var comment_text = commenttext.replace(hashtag_regexp, '<a href="home/personcaption/$1" class="hashtag member_name biohashtag">#$1</a>');
	        var hashtag_regexp1 = /@([a-zA-Z0-9_]+)/g;
	        var comment_textt = comment_text.replace(hashtag_regexp1, '<a href="home/person/$1" class="hashtag member_name biohashtag">@$1</a>');
	        if (value.length > 0) {
	            // this.posts[i].comments.push([username, comment_textt]);
	            this._personService.usercomment({ message: value, id: id, postsType: postsType })
	                .subscribe(function (res) {
	                _this.submitComment = res.data;
	                _this.posts[i].commentData.push(_this.submitComment[0].commentData[0]);
	                _this.hashtagFunction();
	            });
	        }
	    };
	    PersonlocationComponent = __decorate([
	        core_1.Component({
	            selector: 'person',
	            template: __webpack_require__(491),
	            directives: [router_1.ROUTER_DIRECTIVES],
	            providers: [personlocation_service_1.personlocationService]
	        }), 
	        __metadata('design:paramtypes', [personlocation_service_1.personlocationService, router_2.Router, router_2.ActivatedRoute])
	    ], PersonlocationComponent);
	    return PersonlocationComponent;
	}());
	exports.PersonlocationComponent = PersonlocationComponent;


/***/ },

/***/ 490:
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var core_1 = __webpack_require__(5);
	var router_1 = __webpack_require__(389);
	var app_constants_1 = __webpack_require__(441);
	var http_1 = __webpack_require__(363);
	var personlocationService = (function () {
	    function personlocationService(_router, _http, _conf) {
	        this._router = _router;
	        this._http = _http;
	        this._conf = _conf;
	    }
	    personlocationService.prototype.personprofile = function (name) {
	        var token = localStorage.getItem('authToken');
	        var body = { token: token, place: name };
	        //console.log(body);
	        return this._http.post(this._conf.Url + 'getPostsByLocation', body, { headers: this._conf.headers })
	            .map(function (res) { return res.json(); })
	            .map(function (res) {
	            //console.log(res);
	            // if (res.token) {
	            //     localStorage.setItem('user', res.token);
	            //     // this._router.navigate(['Pages']);
	            //     return res.code;
	            // }
	            return res;
	        });
	    };
	    personlocationService.prototype.loadmore = function (offset, name) {
	        var token = localStorage.getItem('authToken');
	        var body = {
	            token: token,
	            place: name,
	            offset: offset
	        };
	        //console.log(body);
	        return this._http.post(this._conf.Url + 'getPostsByLocation', body, { headers: this._conf.headers })
	            .map(function (res) { return res.json(); })
	            .map(function (res) {
	            //console.log(res);
	            // if (res.token) {
	            //     localStorage.setItem('user', res.token);S
	            //     // this._router.navigate(['Pages']);
	            //     return res.code;
	            // }
	            return res;
	        });
	    };
	    personlocationService.prototype.userlike = function (id, postsType) {
	        var token = localStorage.getItem('authToken');
	        var body = {
	            token: token,
	            postId: id,
	            label: 'Photo'
	        };
	        if (postsType == 1)
	            body.label = 'Video';
	        //console.log(body);
	        return this._http.post(this._conf.Url + 'like', body, { headers: this._conf.headers })
	            .map(function (res) { return res.json(); })
	            .map(function (res) {
	            //console.log(res);
	            // if (res.token) {
	            //     localStorage.setItem('user', res.token);S
	            //     // this._router.navigate(['Pages']);
	            //     return res.code;
	            // }
	            return res;
	        });
	    };
	    personlocationService.prototype.usercomment = function (value) {
	        var token = localStorage.getItem('authToken');
	        var body = {
	            comment: value.message,
	            type: value.postsType,
	            postId: value.id,
	            token: token
	        };
	        //console.log(body);
	        return this._http.post(this._conf.Url + 'comments', body, { headers: this._conf.headers })
	            .map(function (res) { return res.json(); })
	            .map(function (res) {
	            //console.log(res);
	            // if (res.token) {
	            //     localStorage.setItem('user', res.token);S
	            //     // this._router.navigate(['Pages']);
	            //     return res.code;
	            // }
	            return res;
	        });
	    };
	    personlocationService.prototype.userdeletecomment = function (value) {
	        var token = localStorage.getItem('authToken');
	        var body = {
	            commentedByUser: value.username,
	            commentBody: value.message,
	            commentId: value.commentId,
	            type: value.postsType,
	            postId: value.id,
	            token: token
	        };
	        //console.log(body);
	        // return;
	        return this._http.post(this._conf.Url + 'deleteCommentsFromPost', body, { headers: this._conf.headers })
	            .map(function (res) { return res.json(); })
	            .map(function (res) {
	            //console.log(res);
	            // if (res.token) {
	            //     localStorage.setItem('user', res.token);S
	            //     // this._router.navigate(['Pages']);
	            //     return res.code;
	            // }
	            return res;
	        });
	    };
	    personlocationService.prototype.userunlike = function (id, postsType) {
	        var token = localStorage.getItem('authToken');
	        var body = {
	            token: token,
	            postId: id,
	            label: 'Photo'
	        };
	        if (postsType == 1)
	            body.label = 'Video';
	        //console.log(body);
	        return this._http.post(this._conf.Url + 'unlike', body, { headers: this._conf.headers })
	            .map(function (res) { return res.json(); })
	            .map(function (res) {
	            //console.log(res);
	            // if (res.token) {
	            //     localStorage.setItem('user', res.token);S
	            //     // this._router.navigate(['Pages']);
	            //     return res.code;
	            // }
	            return res;
	        });
	    };
	    personlocationService.prototype.following = function (username) {
	        var token = localStorage.getItem('authToken');
	        var body = {
	            token: token,
	            userNameToFollow: username
	        };
	        //console.log(body);
	        return this._http.post(this._conf.Url + 'follow', body, { headers: this._conf.headers })
	            .map(function (res) { return res.json(); })
	            .map(function (res) {
	            //console.log(res);
	            // if (res.token) {
	            //     localStorage.setItem('user', res.token);S
	            //     // this._router.navigate(['Pages']);
	            //     return res.code;
	            // }
	            return res;
	        });
	    };
	    personlocationService.prototype.follow = function (username) {
	        var token = localStorage.getItem('authToken');
	        var body = {
	            token: token,
	            unfollowUserName: username
	        };
	        //console.log(body);
	        return this._http.post(this._conf.Url + 'unfollow', body, { headers: this._conf.headers })
	            .map(function (res) { return res.json(); })
	            .map(function (res) {
	            //console.log(res);
	            // if (res.token) {
	            //     localStorage.setItem('user', res.token);S
	            //     // this._router.navigate(['Pages']);
	            //     return res.code;
	            // }
	            return res;
	        });
	    };
	    personlocationService = __decorate([
	        core_1.Injectable(), 
	        __metadata('design:paramtypes', [router_1.Router, http_1.Http, app_constants_1.Configuration])
	    ], personlocationService);
	    return personlocationService;
	}());
	exports.personlocationService = personlocationService;


/***/ },

/***/ 491:
/***/ function(module, exports) {

	module.exports = "<!DOCTYPE html>\r\n<html>\r\n<head>\r\n\t<title>{{name}}</title>\r\n    <link rel=\"icon\" type=\"image/gif/png\" href=\"/public/images/picoTitleLogo.png\">\r\n</head>\r\n\r\n<div class=\"loader\" *ngIf=\"loading\"></div>\r\n<div class=\"container-fluid picogram_total\">\r\n\t<div id=\"googleMap\" style=\"width:100%;height:300px;\"></div>\r\n    <div class=\"container pico_content_total profile_pico\" style=\"max-width: 935px;padding: 50px 20px 0;\">\r\n\t\t<div class=\"profile_file_name zero_padding col-xs-12\" style=\"margin-bottom:8%;\">        \r\n\t\t\r\n\t\t<h2 class=\"locatName\" style=\"text-align:center;\"></h2>\r\n\t\t</div>\r\n        \r\n<h2 class=\"color_thick color_opacity\" *ngIf=\"!loading\" style=\"color: #999;font-size: 14px;font-weight: 400;margin-bottom: 16px;text-align: left;text-transform: uppercase;\">Top Posts</h2>\r\n<div *ngIf=\"posts\" class=\"all_profile_upload zero_padding col-xs-12\" style=\"\">\r\n\t<div class=\"zero_padding col-xs-4 upload_photo\" *ngFor=\"let item of posts\" style=\"margin:0% 3% 3% 0%;width:30.3%;\">\r\n\t\t<span class=\"img-span zero_padding col-xs-12 carousel_click\" (click)=\"activeitem(item.postId)\" id=\"{{item.postId}}\" data-toggle=\"modal\" data-target=\".bs-example-modal-lg\">\r\n\t\t\t<span class=\"img_hov zero_padding col-xs-12\">\r\n\t\t\t\t<img class=\"uploadphoto\" id=\"\" *ngIf=\"item.postsType==0\" src=\"{{item.mainUrl}}\" onError=\"this.src='/public/images/default.png';\">\r\n\t\t\t\t<span class=\"videotag_img video_tag\" *ngIf=\"item.postsType==1\"></span>\r\n\t\t\t\t<video class=\"uploadphoto\" *ngIf=\"item.postsType==1\">\r\n\t\t\t\t\t<source src=\"{{item.mainUrl}}\" type=\"video/mp4\">\r\n\t\t\t\t\t<source src=\"{{item.mainUrl}}\" type=\"video/ogg\"> \r\n\t\t\t\t</video>\r\n\t\t\t</span>\r\n\t\t\t<span class=\"hover_image_effect hide_hover col-xs-12\" id=\"\" style=\"\">\r\n\t\t\t\t<div class=\"hover_div zero_padding col-xs-12 col-sm-6\" *ngIf=\"item.postsType==0\">\r\n\t\t\t\t\t<span class=\"hover_icon hovericon zero_padding\"></span>\r\n\t\t\t\t\t<span class=\"hover_number\">{{item.likes}}</span>\r\n\t\t\t\t</div>\r\n\t\t\t\t<div class=\"hover_div zero_padding col-xs-12 col-sm-6\" *ngIf=\"item.postsType==1\">\r\n\t\t\t\t\t<span class=\"hover_icon hover_videoicon zero_padding\"></span>\r\n\t\t\t\t\t<span class=\"hover_number\">{{item.likes}}</span>\r\n\t\t\t\t</div>\r\n\t\t\t\t<div class=\"hover_div zero_padding col-xs-12 col-sm-6\">\r\n\t\t\t\t\t<span class=\"hover_icon hovericon1\"></span>\r\n\t\t\t\t\t<span class=\"hover_number\">{{item.commentData.length}}</span>\r\n\t\t\t\t</div>\r\n\t\t\t</span>\r\n\t\t</span>\r\n\t</div>\r\n</div>\r\n<div class=\"col-xs-12 loader_moreDetails\" [hidden]=\"!loadmoree\">\r\n\t<div class=\"loadmoreRound\" (click)=\"loadmore();\">\r\n\t\t<span class=\"loadmore_click\">loadmore</span>\r\n\t</div>\r\n</div>\r\n\r\n<!--<div class=\"zero_padding col-xs-12 loadmore\" (click)=\"loadmore();\" [hidden]=\"!loadmoree\" style=\"cursor:pointer;text-align:center;height: 120px;width: 120px;margin-left: 40%;border: 2px solid #3897f0;border-radius: 50%;\">\r\n\t<span class=\"loadmore_click\" style=\"font-size:14px;position: absolute;top: 40%;left: 28%;color: #3897f0;\">loadmore</span>\r\n\r\n</div>-->\r\n\r\n<!-- -->   \r\n\r\n        \r\n\r\n<!-- carousel -->\r\n\r\n<div class=\"container\" style=\"width:100%;\">\r\n\r\n\t<div class=\"modal fade bs-example-modal-lg carousel-model\" role=\"dialog\" aria-labelledby=\"myLargeModalLabel\" aria-hidden=\"true\">\r\n\t\t<div class=\"modal-dialog modal-lg\">\r\n\t\t\t<div class=\"modal-content\">\r\n\t\t\t\t<div id=\"carousel-example-generic\" *ngIf=\"posts\" class=\"carousel slide\" data-interval=\"false\">\r\n\r\n\t\t\t\t\t<!-- Wrapper for slides -->\r\n\t\t\t\t\t<div class=\"carousel-inner\">\r\n\t\t\t\t\t\t<div class=\"item\" *ngFor=\"let item of posts; let i = index\" id=\"{{item.postId}}w\">\r\n\t\t\t\t\t\t\t<div class=\"col-xs-12 col-md-7 zero_padding\">\r\n\t\t\t\t\t\t\t\t<!--<img class=\"img-responsive\" src=\"https://igcdn-photos-f-a.akamaihd.net/hphotos-ak-xpt1/t51.2885-15/e15/10809778_786506061406485_132431944_n.jpg?ig_cache_key=ODY1OTk3NTk4NzU0MjE4NDY5.2\"\r\n\t\t\t\t\t\t\t\t\talt=\"...\">-->\r\n\t\t\t\t\t\t\t\t\t<img class=\"img-responsive col-xs-12 zero_padding\" id=\"\" (click)=\"falseusertagged(i);\" (dblclick)=\"likedoubleClick(item.postId, item.postsType,i);\" *ngIf=\"item.postsType==0\" src=\"{{item.mainUrl}}\" onError=\"this.src='/public/images/default.png';\">\r\n\t\t\t\t\t\t\t\t\t<div class=\"doubleclick_heart\" *ngIf=\"item.likeheartFlagg==true\"> \r\n\t\t\t\t\t\t\t\t\t\t<span class=\"double_click_heart like_icon\"></span>\r\n\t\t\t\t\t\t\t\t\t</div>\r\n\t\t\t\t\t\t\t\t\t<video class=\"img-responsive\" (click)=\"falseusertagged(i);\" *ngIf=\"item.postsType==1\" controls>\r\n\t\t\t\t\t\t\t\t\t\t<source src=\"{{item.mainUrl}}\" type=\"video/mp4\">\r\n\t\t\t\t\t\t\t\t\t\t<source src=\"{{item.mainUrl}}\" type=\"video/ogg\"> \r\n\t\t\t\t\t\t\t\t\t</video>\r\n\r\n\t\t\t\t\t\t\t\t\t <div class=\"pico_contentdetails_tagged col-xs-12\">\r\n\t\t\t\t\t\t\t\t\t\t<div *ngIf=\"item.usertaggedFlagg==true\">\r\n\t\t\t\t\t\t\t\t\t\t\t<span *ngFor=\"let tagged of item.coords;\">\r\n\t\t\t\t\t\t\t\t\t\t\t\t<span class=\"tagg_color_name tagg_color\" data-dismiss=\"modal\" (click)=\"usertaggedname(tagged);\"  [ngStyle]=\"{'margin-left': tagged.right+'%', 'margin-top': '-'+tagged.top+'%'}\">\t\t\t\t\t\t\t\t\t\t\t\t\t\t\r\n\t\t\t\t\t\t\t\t\t\t\t\t\t<div class=\"tagg_arrowicon\"></div>\r\n\t\t\t\t\t\t\t\t\t\t\t\t\t{{tagged.name}}\t\t\t\t\t\t\t\t\t\t\t\t\t\t\r\n\t\t\t\t\t\t\t\t\t\t\t\t</span>\r\n\t\t\t\t\t\t\t\t\t\t\t</span>\r\n\t\t\t\t\t\t\t\t\t\t</div>\r\n\t\t\t\t\t\t\t\t\t\t<div class=\"\" *ngFor=\"let tagged of item.coords;\">\t\t\t\t\t\t\r\n\t\t\t\t\t\t\t\t\t\t\t<i class=\"usertag_icon tagged_icon\" (click)=\"usertagged(i);\"></i>\t\t\t\t\t\t\t\t\t\t\r\n\t\t\t\t\t\t\t\t\t\t</div>\r\n\t\t\t\t\t\t\t\t\t</div>\r\n\t\t\t\t\t\t\t</div>\r\n\t\t\t\t\t\t\t<div class=\"col-xs-12 col-md-5 zero_padding comment_text\">\r\n\t\t\t\t\t\t\t\t<div class=\"follow_details col-xs-12 zero_padding\">\r\n\t\t\t\t\t\t\t\t\t<span class=\"col-xs-2 col-sm-2 col-md-1 zero_padding\"><img class=\"suggestion_image member_name\" data-dismiss=\"modal\" (click)=\"memberprofile(item)\" src=\"{{item.profilePicUrl}}\" onError=\"this.src='/public/images/default.png';\"></span>\r\n\t\t\t\t\t\t\t\t\t<span class=\"col-xs-4 col-sm-5 col-md-6 zero_padding slider_img\">\r\n\t\t\t\t\t\t\t\t\t\t<h5 class=\"follow_name col-xs-12 zero_padding\"><span class=\"color_thick member_name\" data-dismiss=\"modal\" (click)=\"memberprofile(item)\">{{item.postedByUserName}}</span></h5>\r\n\t\t\t\t\t\t\t\t\t\t<h6 class=\"follow_name col-xs-12 zero_padding color_thick color_opacity member_name\" data-dismiss=\"modal\" (click)=\"memberprofileplace(item)\" *ngIf=\"item.place !='[object Object]'\">{{item.place}}</h6>\t\t\t\r\n\t\t\t\t\t\t\t\t\t</span>\r\n\t\t\t\t\t\t\t\t\t<span class=\"buffer_gif\" *ngIf=\"buffer\" style=\"left:-18%;\"><img src=\"/public/images/ajax-loader2.gif\" alt=\"loader\"></span>\r\n\t\t\t\t\t\t\t\t\t<span class=\"col-xs-5 col-sm-4 zero_padding\" *ngIf=\"item.userFollowRequestStatus==null\" (click)=\"followingfllag(item, i);\" style=\"\"><button class=\"follow_button\" style=\"font-size: 14px;\">Follow</button></span>\r\n\t\t\t\t\t\t\t\t\t<span class=\"col-xs-5 col-sm-4 zero_padding\" *ngIf=\"item.userFollowRequestStatus==0\" (click)=\"followfllag(item, i);\" style=\"\"><button class=\"follow_button\" style=\"font-size: 14px;background-color:gray;border:1px solid gray;color:white;\">Requested</button></span>\r\n\t\t\t\t\t\t\t\t\t<span class=\"col-xs-5 col-sm-4 zero_padding\" *ngIf=\"item.userFollowRequestStatus==1\" (click)=\"followfllag(item, i);\" style=\"\"><button class=\"follow_buttonn folow\" style=\"margin-top:0px;font-size: 14px;\">Following</button></span>\r\n\t\t\t\t\t\t\t\t\t<!--<span class=\"col-xs-5 col-sm-4 zero_padding\" style=\"\"><button class=\"follow_buttonn folow\">Following</button></span>-->\r\n\t\t\t\t\t\t\t\t</div>\r\n\t\t\t\t\t\t\t\t<div class=\"pico_contentdetails_comment\" style=\"padding: 0% 0% 0% 5%;display: inline-block;width: 100%;\">\r\n\t\t\t\t\t\t\t\t\t<div class=\"col-xs-12 zero_padding\" style=\"margin: 2% 0%;\">\r\n\t\t\t\t\t\t\t\t\t\t<span class=\"col-xs-10 zero_padding\" *ngIf=\"item.likedByUser.length < 6 && item.likedByUser != 'null'\">\r\n\t\t\t\t\t\t\t\t\t\t\t<div *ngIf=\"item.likedByUser\">\r\n\t\t\t\t\t\t\t\t\t\t\t\t<span *ngFor=\"let liked of item.likedByUser;let i=index;\">\r\n\t\t\t\t\t\t\t\t\t\t\t\t\t<span *ngIf=\"liked != 'null'\">\r\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t<span *ngIf=\"i != 0\" class=\"comma_moveleftside\">,</span>\r\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t<span class=\"add_liked color_thick member_name\" data-dismiss=\"modal\" (click)=\"likedbyuser(liked)\" id=\"likecontent\">{{liked}}</span>\r\n\t\t\t\t\t\t\t\t\t\t\t\t\t</span>\r\n\t\t\t\t\t\t\t\t\t\t\t\t</span>\r\n\t\t\t\t\t\t\t\t\t\t\t\t<span class=\"color_opacity\" *ngIf=\"item.likedByUser.length > 1 || item.likeStatus==1\" style=\"font-size:14px;\">like this</span>\r\n\t\t\t\t\t\t\t\t\t\t\t</div>\r\n\t\t\t\t\t\t\t\t\t\t</span>\r\n\t\t\t\t\t\t\t\t\t\t<span class=\"col-xs-10 zero_padding\" *ngIf=\"item.likedByUser.length > 6\"><span class=\"add_like color_thick\" id=\"like1content\" style=\"margin-right: 5%;\">{{item.likes}}</span><span class=\"color_thick\">likes</span></span>\r\n\t\t\t\t\t\t\t\t\t\t<span class=\"col-xs-6 color_thick color_opacity zero_padding member_name\" data-dismiss=\"modal\" (click)=\"timepost(item)\" style=\"color: #999;float:right;width: 10%;\">{{item.postedOn}}</span>\r\n\t\t\t\t\t\t\t\t\t</div>\r\n\t\t\t\t\t\t\t\t\t<ul class=\"comment_list carousel_comment zero_padding col-xs-12\">\r\n\t\t\t\t\t\t\t\t\t\t<!--<li class=\"listcomment zero_padding col-xs-12\">\r\n\t\t\t\t\t\t\t\t\t\t\t<span class=\"name_comment\" style=\"\"><span class=\"color_thick\" style=\"\" *ngIf=\"item.postCaption !='null'\">{{item.postCaption}}</span></span>\r\n\t\t\t\t\t\t\t\t\t\t\t\r\n\t\t\t\t\t\t\t\t\t\t</li>-->\r\n\t\t\t\t\t\t\t\t\t\t<li class=\"listcomment zero_padding col-xs-12\" >\r\n\t\t\t\t\t\t\t\t\t\t\t<span class=\"color_thick member_name\" *ngIf=\"item.postCaption !='null'\" id=\"{{item.postsId}}\">{{item.postedByUserName}}</span>\r\n                                            <span class=\"name_comment\" style=\"\" *ngFor=\"let caption of item.postCaption;\">\r\n                                                <span *ngIf=\"caption != 'null'\">\r\n\t\t\t\t\t\t\t\t\t\t\t\t\t<span class=\"color_thick color_opacity member_name\" id=\"{{item.postsId}}\" *ngIf=\"caption.charAt(0) != '#' && caption.charAt(0) != '@'\" data-dismiss=\"modal\">{{caption}}</span>\r\n                                                    <span class=\"color_thick color_opacity member_name\" id=\"{{item.postsId}}\" data-dismiss=\"modal\" (click)=\"membercaption(caption)\" style=\"color:#003569;\" *ngIf=\"caption.charAt(0) == '#'\">{{caption}}</span>\r\n\t\t\t\t\t\t\t\t\t\t\t\t\t<span class=\"color_thick color_opacity member_name\" id=\"{{item.postsId}}\" data-dismiss=\"modal\" (click)=\"memberprofilecaptionn(caption)\" style=\"color:#003569;\" *ngIf=\"caption.charAt(0) == '@'\">{{caption}}</span>\r\n                                                </span>\r\n                                            </span>\r\n                                        </li>\r\n\t\t\t\t\t\t\t\t\t\t<li class=\"listcomment zero_padding col-xs-12\" *ngFor=\"let comment of item.commentData; let k = index;\">\r\n\t\t\t\t\t\t\t\t\t\t\t<span class=\"name_comment\" style=\"\"><span class=\"color_thick member_name\" data-dismiss=\"modal\" (click)=\"memberprofilee(comment)\" style=\"\">{{comment.commentedByUser}}</span></span>\t\t\t\t\t\t\t\t\t\t\t\r\n\t\t\t\t\t\t\t\t\t\t\t<span class=\"name_comment1 color_thick color_opacity\" style=\"\" [innerHTML]=\"comment.commentBody\"></span>\t\t\t\t\t\t\t\t\t\t\t\r\n\t\t\t\t\t\t\t\t\t\t\t<span class=\"name_comment1 color_thick color_opacity member_name delete_comment\" style=\"\" data-toggle=\"modal\" data-target=\"#myModal_delete\" (click)=\"commentdelete(comment, item.postId, item.postsType, i, k)\" *ngIf=\"comment.commentedByUser == username\">X</span>\r\n\t\t\t\t\t\t\t\t\t\t</li>\r\n\t\t\t\t\t\t\t\t\t<!--<li class=\"listcomment zero_padding col-xs-12\">\r\n\t\t\t\t\t\t\t\t\t\t\t<span class=\"name_comment\" style=\"\"><a class=\"color_thick\" href=\"picogram_person_profile.php\" style=\"\">prabhvanimakkar</a></span>\r\n\t\t\t\t\t\t\t\t\t\t\t<span class=\"name_comment1 color_thick color_opacity\" style=\"\">That's perfect â¤ you both are the prettiest together </span>\r\n\t\t\t\t\t\t\t\t\t\t</li>\r\n\t\t\t\t\t\t\t\t\t\t<li class=\"listcomment zero_padding col-xs-12\">\r\n\t\t\t\t\t\t\t\t\t\t\t<span class=\"name_comment\" style=\"\"><a class=\"color_thick\" href=\"picogram_person_profile.php\" style=\"\">_.rheab._</a></span>\r\n\t\t\t\t\t\t\t\t\t\t\t<span class=\"name_comment1 color_thick color_opacity\" style=\"\"> O ma ei pic ta ki pretty dekh  they are looking so adorable ðŸ™ˆ</span>\r\n\t\t\t\t\t\t\t\t\t\t</li>-->\r\n\t\t\t\t\t\t\t\t\t</ul>\r\n\t\t\t\t\t\t\t\t\t<span class=\"col-xs-11\" style=\"background:#efefef;height:1px;margin: 5px 0px 5px 0px\"></span>\r\n\t\t\t\t\t\t\t\t</div>\r\n\t\t\t\t\t\t\t\t<div class=\"add_comment col-xs-12 modal_comment_carousel\" style=\"padding: 5px 20px;\">\r\n\t\t\t\t\t\t\t\t\t<i class=\"comment_icon comment_heart_icon add_heart_icon\" *ngIf=\"item.likeStatus!=1\" (click)=\"likeactive(item.postId, item.postsType,i)\" id=\"{{item.postId}}\"></i>\r\n\t\t\t\t\t\t\t\t\t<i class=\"comment_icon comment_heart_icon add_heart_icon active\" *ngIf=\"item.likeStatus==1\" (click)=\"likedeactive(item.postId, item.postsType,i)\" id=\"{{item.postId}}\"></i>\r\n\t\t\t\t\t\t\t\t\t<input type=\"text\" #input (keyup.enter)=\"usercommentSubmit(input.value, item.postId, item.postsType, i); input.value=''\" name=\"message\" placeholder=\"Add a comment\"\r\n\t\t\t\t\t\t\t\t\tid=\"{{item.postsId}}\" class=\"col-xs-12 comment_textbox\" style=\"font-size:14px;\">\r\n\t\t\t\t\t\t\t\t\t<i class=\"comment_icon comment_dotted_icon\" data-toggle=\"modal\" data-target=\"#myModall\"></i>\r\n\t\t\t\t\t\t\t\t</div>\r\n\t\t\t\t\t\t\t</div>\r\n\t\t\t\t\t\t</div>\r\n\t\t\t\t\t</div>\r\n\t\t\t\t</div>\r\n\r\n\t\t\t\t<!-- Controls -->\r\n\t\t\t\t<a class=\"left carousel-control\" href=\"#carousel-example-generic\" role=\"button\" data-slide=\"prev\">\r\n\t\t\t\t\t<span class=\"glyphicon glyphicon-chevron-left\"></span>\r\n\t\t\t\t</a>\r\n\t\t\t\t<a class=\"right carousel-control\" href=\"#carousel-example-generic\" role=\"button\" data-slide=\"next\">\r\n\t\t\t\t\t<span class=\"glyphicon glyphicon-chevron-right\"></span>\r\n\t\t\t\t</a>\r\n\t\t\t</div>\r\n\t\t</div>\r\n\t</div>\r\n\r\n\t\t<!-- popup modal -->\r\n\t\t<div class=\"modal fade\" id=\"myModall\" role=\"dialog\">\r\n\t\t\t<div class=\"modal-dialog modal-md\">\r\n\t\t\t\t<div class=\"modal-content\">\r\n\t\t\t\t\t<div class=\"modal-body\" style=\"\">\r\n\t\t\t\t\t\t<span class=\"report_cancel col-xs-12\">Report inappropriate</span>\r\n\t\t\t\t\t\t<!--<span class=\"report_cancel col-xs-12\">Embed</span>-->\r\n\t\t\t\t\t\t<span class=\"report_cancel col-xs-12\" data-dismiss=\"modal\">Cancel</span>\r\n\t\t\t\t\t</div>\r\n\t\t\t\t</div>\r\n\t\t\t</div>\r\n\t\t</div>\r\n\t\t<!-- delete comment -->\r\n\t\t<div class=\"modal fade deletecomment\" id=\"myModal_delete\" role=\"dialog\">\r\n\t\t\t<div class=\"modal-dialog modal-md\">\r\n\t\t\t\t<div class=\"modal-content\">\r\n\t\t\t\t\t<div class=\"modal-body\" style=\"\">\r\n\t\t\t\t\t\t<span class=\"report_cancel col-xs-12 color_focus  member_name\" data-dismiss=\"modal\" (click)=\"commentmodaldelete()\">Delete Comment</span>\r\n\t\t\t\t\t\t<!--<span class=\"report_cancel col-xs-12\">Embed</span>-->\r\n\t\t\t\t\t\t<span class=\"report_cancel col-xs-12\" data-dismiss=\"modal\">Cancel</span>\r\n\t\t\t\t\t</div>\r\n\t\t\t\t</div>\r\n\t\t\t</div>\r\n\t\t</div>\r\n\t\t<!-- End popup modal -->\r\n\r\n</div>\r\n<!-- end carousel -->\r\n</div>\r\n<!--<div class=\"container pico_content_total profile_pico\" *ngIf=\"!data\" style=\"max-width: 935px;padding: 50px 20px 0;text-align:center;\">\r\n\t<h4>Please post some photos or videos to see the feed.</h4>\r\n</div>-->\r\n</div>\r\n\r\n</html>\r\n\r\n";

/***/ },

/***/ 492:
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var core_1 = __webpack_require__(5);
	var router_1 = __webpack_require__(389);
	var router_2 = __webpack_require__(389);
	var personcaption_service_1 = __webpack_require__(493);
	var PersoncaptionComponent = (function () {
	    function PersoncaptionComponent(_personService, _router, route) {
	        this._personService = _personService;
	        this._router = _router;
	        this.route = route;
	        this.posts = [];
	        this.loading = true;
	        this.buffer = false;
	        this.datacation = false;
	        this.nocation = true;
	        this.commnentdetails = [];
	        this.offset = 0;
	    }
	    PersoncaptionComponent.prototype.ngOnInit = function () {
	        var _this = this;
	        jQuery(".modal-backdrop").css({ "display": "none" });
	        var username = localStorage.getItem('username');
	        this.username = username;
	        this.route.params.subscribe(function (params) {
	            _this.name = params['name'];
	            //console.log(this.name); 
	            _this.loading = true;
	            _this._personService.personprofile(_this.name)
	                .subscribe(function (res) {
	                if (res.code == 2981) {
	                    _this.nocation = false;
	                    _this.datacation = true;
	                }
	                _this.loading = false;
	                // this.data = res.memberProfileData[0];
	                // this.posts = res.memberPostsData;
	                _this.posts = [];
	                _this.totaldata = res.data;
	                _this.offset = res.data.length;
	                _this.commentfunction();
	                if (_this.offset >= 20) {
	                    _this.loadmoree = true;
	                }
	            });
	            // this._personService.memberFollowing(this.name)
	            //     .subscribe((res) => {
	            //         this.data1 = res.following;
	            //         this.loading = false;
	            //     });
	            // this._personService.memberFollowers(this.name)
	            //     .subscribe((res) => {
	            //         this.data2 = res.memberFollowers;
	            //         this.loading = false;
	            //     });      
	            jQuery(document).keyup(function (e) {
	                if (e.keyCode == 27) {
	                    jQuery(".modal").css({ "display": "none" });
	                    jQuery(".modal-backdrop").css({ "display": "none" });
	                }
	            });
	        });
	    };
	    PersoncaptionComponent.prototype.hashtagFunction = function () {
	        var len = this.totaldata.length;
	        for (var i = 0; i < len; i++) {
	            if (this.totaldata[i].commentData) {
	                var commenttext = this.totaldata[i].commentData;
	                for (var x = 0; x < commenttext.length; x++) {
	                    // commenttext.splice(x, 0);
	                    if (this.totaldata[i].commentData[x].commentBody) {
	                        var postCommentNodeArr1 = commenttext[x].commentBody;
	                        // //console.log(postCommentNodeArr1);
	                        var hashtag_regexp = /#([a-zA-Z0-9_]+)/g;
	                        var comment_text = postCommentNodeArr1.replace(hashtag_regexp, '<a href="home/personcaption/$1" class="hashtag member_name biohashtag">#$1</a>');
	                        var hashtag_regexp1 = /@([a-zA-Z0-9_]+)/g;
	                        var comment_textt = comment_text.replace(hashtag_regexp1, '<a href="home/person/$1" class="hashtag member_name biohashtag">@$1</a>');
	                        this.totaldata[i].commentData[x].commentBody = comment_textt;
	                    }
	                }
	            }
	        }
	    };
	    PersoncaptionComponent.prototype.commentfunction = function () {
	        this.hashtagFunction();
	        // alert("hi");
	        var len = this.totaldata.length;
	        // this.posts=[];
	        for (var i = 0; i < len; i++) {
	            var postCaption = [];
	            if (this.totaldata[i].postCaption) {
	                var postCaptionn = this.totaldata[i].postCaption.split(' ');
	                this.totaldata[i].postCaption = postCaptionn;
	            }
	            var likedByUser = [];
	            if (this.totaldata[i].likedByUser) {
	                var liked = this.totaldata[i].likedByUser.split(',');
	                if (liked.length) {
	                    this.totaldata[i].likedByUser = liked;
	                }
	            }
	            else {
	                this.totaldata[i].likedByUser = [];
	            }
	            var usersTagged = [];
	            if (this.totaldata[i].usersTagged) {
	                usersTagged = this.totaldata[i].usersTagged.split(',');
	                this.totaldata[i].usersTagged = usersTagged;
	            }
	            var taggedUserCoordinates = [];
	            if (this.totaldata[i].taggedUserCoordinates) {
	                taggedUserCoordinates = this.totaldata[i].taggedUserCoordinates.split(',');
	                this.totaldata[i].taggedUserCoordinates = taggedUserCoordinates;
	            }
	            if (usersTagged[0] != 'undefined' && taggedUserCoordinates[0] != null) {
	                var lenn = usersTagged.length;
	                var tagsCords = [];
	                for (var j = 0; j < lenn; j++) {
	                    var userCords = {
	                        name: usersTagged[j],
	                        right: 0,
	                        top: 0
	                    };
	                    if (taggedUserCoordinates[j]) {
	                        var cordinates = taggedUserCoordinates[j].split('-');
	                        userCords.right = cordinates[0];
	                        userCords.top = cordinates[1];
	                        tagsCords.push(userCords);
	                    }
	                }
	                this.totaldata[i].coords = tagsCords;
	            }
	            var post = this.totaldata[i].postedOn;
	            var poston = Number(post);
	            var postdate = new Date(poston);
	            var currentdate = new Date();
	            var timeDiff = Math.abs(postdate.getTime() - currentdate.getTime());
	            var diffDays = Math.ceil(timeDiff / (1000 * 3600 * 24));
	            var diffHrs = Math.round((timeDiff % 86400000) / 3600000);
	            var diffMins = Math.round(((timeDiff % 86400000) % 3600000) / 60000);
	            if (1 < diffDays) {
	                this.totaldata[i].postedOn = diffDays + "d";
	            }
	            else if (1 <= diffHrs) {
	                this.totaldata[i].postedOn = diffHrs + "h";
	            }
	            else {
	                this.totaldata[i].postedOn = diffMins + "m";
	            }
	            this.posts.push(this.totaldata[i]);
	        }
	        // this.posts = this.totaldata;
	    };
	    PersoncaptionComponent.prototype.loadmore = function () {
	        var _this = this;
	        // //console.log(this.offset, this.name);
	        this.offset = this.posts.length;
	        this._personService.loadmore(this.offset, this.name)
	            .subscribe(function (res) {
	            // var len = res.memberPostsData.length;
	            // for (var i = 0; i < len; i++) {
	            //     this.posts.push(res.memberPostsData[i]);
	            // }
	            _this.totaldata = res.data;
	            _this.commentfunction();
	            _this.offset = res.data.length || 0;
	            if (_this.offset >= 20)
	                _this.loadmoree = true;
	            else
	                _this.loadmoree = false;
	        });
	    };
	    PersoncaptionComponent.prototype.timepost = function (item) {
	        var postsId = item.postId;
	        var followingUsername = item.username;
	        var link = ['home/homepost', followingUsername, postsId];
	        this._router.navigate(link);
	    };
	    PersoncaptionComponent.prototype.usertagged = function (i) {
	        this.posts[i].usertaggedFlagg = true;
	    };
	    PersoncaptionComponent.prototype.falseusertagged = function (i) {
	        this.posts[i].usertaggedFlagg = false;
	    };
	    PersoncaptionComponent.prototype.usertaggedname = function (tagged) {
	        // alert(item.postId);
	        var personname = tagged.name;
	        var username = localStorage.getItem('username');
	        if (username == personname) {
	            this._router.navigate(['home/profile']);
	        }
	        else {
	            var link = ['home/person', personname];
	            this._router.navigate(link);
	        }
	    };
	    PersoncaptionComponent.prototype.activeitem = function (id) {
	        // alert(id);
	        jQuery('.item').removeClass("active");
	        jQuery('#' + id + 'w').addClass("active");
	    };
	    PersoncaptionComponent.prototype.memberprofile = function (item) {
	        // alert(item.postsId);
	        var personname = item.username;
	        var username = localStorage.getItem('username');
	        if (username == personname) {
	            this._router.navigate(['home/profile']);
	        }
	        else {
	            var link = ['home/person', personname];
	            this._router.navigate(link);
	        }
	        // let link = ['/home/person', item.username];
	        // this._router.navigate(link);
	    };
	    PersoncaptionComponent.prototype.memberprofilee = function (comment) {
	        // alert(item.postsId);
	        var personname = comment.commentedByUser;
	        var username = localStorage.getItem('username');
	        if (username == personname) {
	            this._router.navigate(['home/profile']);
	        }
	        else {
	            var link = ['home/person', personname];
	            this._router.navigate(link);
	        }
	        // let link = ['home/person', comment[0]];
	        // this._router.navigate(link);
	    };
	    PersoncaptionComponent.prototype.membercaption = function (caption) {
	        var hashtagname = caption.split('#');
	        //   //console.log(hashtagname[1]);        
	        var link = ['home/personcaption', hashtagname[1]];
	        this._router.navigate(link);
	    };
	    PersoncaptionComponent.prototype.membercaptionn = function (comment) {
	        var hashtagname = comment[1].split('#');
	        //   //console.log(hashtagname[1]);        
	        var link = ['home/personcaption', hashtagname[1].replace(" ", "")];
	        this._router.navigate(link);
	    };
	    PersoncaptionComponent.prototype.memberprofilecaption = function (comment) {
	        var personname = comment[1].split('@');
	        var username = localStorage.getItem('username');
	        if (username == personname[1]) {
	            this._router.navigate(['home/profile']);
	        }
	        else {
	            var link = ['home/person', personname[1].replace(" ", "")];
	            this._router.navigate(link);
	        }
	    };
	    PersoncaptionComponent.prototype.memberprofilecaptionn = function (caption) {
	        var personname = caption.split('@');
	        var username = localStorage.getItem('username');
	        if (username == personname[1]) {
	            this._router.navigate(['home/profile']);
	        }
	        else {
	            var link = ['home/person', personname[1].replace(" ", "")];
	            this._router.navigate(link);
	        }
	    };
	    PersoncaptionComponent.prototype.memberprofileplace = function (item) {
	        // alert(item.postsId);
	        var placename = item.place;
	        var link = ['home/personlocation', placename];
	        this._router.navigate(link);
	    };
	    PersoncaptionComponent.prototype.commentdelete = function (comment, id, postsType, i, k) {
	        //  //console.log(comment[0]+" ss "+comment[1]+" id "+id+" postsType "+postsType+" i "+i);
	        postsType = postsType.toString();
	        this.commnentdetails = ({ username: comment.commentedByUser, message: comment.commentBody, commentId: comment.commentId, id: id, postsType: postsType, i: i, k: k });
	    };
	    PersoncaptionComponent.prototype.commentmodaldelete = function () {
	        //console.log(this.commnentdetails);
	        var commentlist = this.commnentdetails;
	        var commenttext = commentlist.message;
	        var hashtag_regexp = /<a[^>]*>([^<]+)<\/a>/g;
	        var comment_text = commenttext.replace(hashtag_regexp, '$1');
	        //  //console.log(commentlist.i+'ghgf'+commentlist.k);
	        this.posts[commentlist.i].commentData.splice([commentlist.k], 1);
	        this._personService.userdeletecomment({ username: commentlist.username, message: comment_text, commentId: commentlist.commentId, id: commentlist.id, postsType: commentlist.postsType })
	            .subscribe();
	    };
	    PersoncaptionComponent.prototype.likedbyuser = function (liked) {
	        var personname = liked;
	        // alert(personname);
	        var username = localStorage.getItem('username');
	        if (username == personname) {
	            this._router.navigate(['home/profile']);
	        }
	        else {
	            var link = ['home/person', personname];
	            this._router.navigate(link);
	        }
	    };
	    PersoncaptionComponent.prototype.likedoubleClick = function (id, type, i) {
	        var _this = this;
	        // alert(id+'aa'+'bb'+type+'cc'+i);
	        if (this.posts[i].likeStatus == 0) {
	            this.posts[i].likeheartFlagg = true;
	            var username = localStorage.getItem('username');
	            this.posts[i].likedByUser.unshift(username);
	            this.posts[i].likeStatus = 1;
	            this.posts[i].likes += 1;
	            this._personService.userlike(id, type)
	                .subscribe();
	            setTimeout(function () {
	                _this.posts[i].likeheartFlagg = false;
	            }, 500);
	        }
	    };
	    PersoncaptionComponent.prototype.likeactive = function (id, type, i) {
	        // alert(id);
	        var username = localStorage.getItem('username');
	        this.posts[i].likedByUser.unshift(username);
	        this.posts[i].likeStatus = 1;
	        this.posts[i].likes += 1;
	        this._personService.userlike(id, type)
	            .subscribe();
	    };
	    PersoncaptionComponent.prototype.likedeactive = function (id, type, i) {
	        var username = localStorage.getItem('username');
	        var array = this.posts[i].likedByUser;
	        var index = array.indexOf(username);
	        if (index > -1) {
	            array.splice(index, 1);
	        }
	        this.posts[i].likeStatus = 0;
	        this.posts[i].likes -= 1;
	        this._personService.userunlike(id, type)
	            .subscribe();
	    };
	    PersoncaptionComponent.prototype.followingfllag = function (item, i) {
	        var _this = this;
	        // alert(i+'ll'+username+'ff'+followFlag);
	        var username = item.postedByUserName;
	        var memberPrivate = item.memberPrivate;
	        //console.log(memberPrivate);
	        this.buffer = true;
	        if (memberPrivate == 1) {
	            setTimeout(function () {
	                _this.posts[i].userFollowRequestStatus = 0;
	            }, 500);
	            this._personService.following(username)
	                .subscribe();
	            setTimeout(function () {
	                _this.buffer = false;
	            }, 500);
	        }
	        if (memberPrivate != 1) {
	            setTimeout(function () {
	                _this.posts[i].userFollowRequestStatus = 1;
	            }, 500);
	            this._personService.following(username)
	                .subscribe();
	            setTimeout(function () {
	                _this.buffer = false;
	            }, 500);
	        }
	    };
	    PersoncaptionComponent.prototype.followfllag = function (item, i) {
	        var _this = this;
	        var username = item.postedByUserName;
	        this.buffer = true;
	        setTimeout(function () {
	            _this.posts[i].userFollowRequestStatus = null;
	        }, 500);
	        this._personService.follow(username)
	            .subscribe();
	        setTimeout(function () {
	            _this.buffer = false;
	        }, 500);
	    };
	    PersoncaptionComponent.prototype.usercommentSubmit = function (value, id, postsType, i) {
	        var _this = this;
	        // //console.log('you submitted value:', value, id, postsType, i);
	        postsType = postsType.toString();
	        var username = localStorage.getItem('username');
	        var commenttext = value;
	        var hashtag_regexp = /#([a-zA-Z0-9_]+)/g;
	        var comment_text = commenttext.replace(hashtag_regexp, '<a href="home/personcaption/$1" class="hashtag member_name biohashtag">#$1</a>');
	        var hashtag_regexp1 = /@([a-zA-Z0-9_]+)/g;
	        var comment_textt = comment_text.replace(hashtag_regexp1, '<a href="home/person/$1" class="hashtag member_name biohashtag">@$1</a>');
	        if (value.length > 0) {
	            // this.posts[i].comments.push([username, comment_textt]);
	            this._personService.usercomment({ message: value, id: id, type: postsType })
	                .subscribe(function (res) {
	                _this.submitComment = res.data;
	                _this.posts[i].commentData.push(_this.submitComment[0].commentData[0]);
	                _this.hashtagFunction();
	            });
	        }
	    };
	    PersoncaptionComponent = __decorate([
	        core_1.Component({
	            selector: 'person',
	            template: __webpack_require__(494),
	            directives: [router_1.ROUTER_DIRECTIVES],
	            providers: [personcaption_service_1.personcaptionService]
	        }), 
	        __metadata('design:paramtypes', [personcaption_service_1.personcaptionService, router_2.Router, router_2.ActivatedRoute])
	    ], PersoncaptionComponent);
	    return PersoncaptionComponent;
	}());
	exports.PersoncaptionComponent = PersoncaptionComponent;


/***/ },

/***/ 493:
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var core_1 = __webpack_require__(5);
	var router_1 = __webpack_require__(389);
	var app_constants_1 = __webpack_require__(441);
	var http_1 = __webpack_require__(363);
	var personcaptionService = (function () {
	    function personcaptionService(_router, _http, _conf) {
	        this._router = _router;
	        this._http = _http;
	        this._conf = _conf;
	    }
	    personcaptionService.prototype.personprofile = function (name) {
	        var token = localStorage.getItem('authToken');
	        var body = { token: token, hashtag: name };
	        //console.log(body);
	        return this._http.post(this._conf.Url + 'getPostsOnHashTags', body, { headers: this._conf.headers })
	            .map(function (res) { return res.json(); })
	            .map(function (res) {
	            //console.log(res);
	            // if (res.token) {
	            //     localStorage.setItem('user', res.token);
	            //     // this._router.navigate(['Pages']);
	            //     return res.code;
	            // }
	            return res;
	        });
	    };
	    personcaptionService.prototype.loadmore = function (offset, name) {
	        var token = localStorage.getItem('authToken');
	        var body = {
	            token: token,
	            hashtag: name,
	            offset: offset
	        };
	        //console.log(body);
	        return this._http.post(this._conf.Url + 'getPostsOnHashTags', body, { headers: this._conf.headers })
	            .map(function (res) { return res.json(); })
	            .map(function (res) {
	            //console.log(res);
	            // if (res.token) {
	            //     localStorage.setItem('user', res.token);S
	            //     // this._router.navigate(['Pages']);
	            //     return res.code;
	            // }
	            return res;
	        });
	    };
	    personcaptionService.prototype.userlike = function (id, type) {
	        var token = localStorage.getItem('authToken');
	        var body = {
	            token: token,
	            postId: id,
	            label: 'Photo'
	        };
	        if (type == 1)
	            body.label = 'Video';
	        //console.log(body);
	        return this._http.post(this._conf.Url + 'like', body, { headers: this._conf.headers })
	            .map(function (res) { return res.json(); })
	            .map(function (res) {
	            //console.log(res);
	            // if (res.token) {
	            //     localStorage.setItem('user', res.token);S
	            //     // this._router.navigate(['Pages']);
	            //     return res.code;
	            // }
	            return res;
	        });
	    };
	    personcaptionService.prototype.usercomment = function (value) {
	        var token = localStorage.getItem('authToken');
	        var body = {
	            comment: value.message,
	            type: value.type,
	            postId: value.id,
	            token: token
	        };
	        //console.log(body);
	        return this._http.post(this._conf.Url + 'comments', body, { headers: this._conf.headers })
	            .map(function (res) { return res.json(); })
	            .map(function (res) {
	            //console.log(res);
	            // if (res.token) {
	            //     localStorage.setItem('user', res.token);S
	            //     // this._router.navigate(['Pages']);
	            //     return res.code;
	            // }
	            return res;
	        });
	    };
	    personcaptionService.prototype.userdeletecomment = function (value) {
	        var token = localStorage.getItem('authToken');
	        var body = {
	            commentedByUser: value.username,
	            commentBody: value.message,
	            commentId: value.commentId,
	            type: value.postsType,
	            postId: value.id,
	            token: token
	        };
	        //console.log(body);
	        // return;
	        return this._http.post(this._conf.Url + 'deleteCommentsFromPost', body, { headers: this._conf.headers })
	            .map(function (res) { return res.json(); })
	            .map(function (res) {
	            //console.log(res);
	            // if (res.token) {
	            //     localStorage.setItem('user', res.token);S
	            //     // this._router.navigate(['Pages']);
	            //     return res.code;
	            // }
	            return res;
	        });
	    };
	    personcaptionService.prototype.userunlike = function (id, type) {
	        var token = localStorage.getItem('authToken');
	        var body = {
	            token: token,
	            postId: id,
	            label: 'Photo'
	        };
	        if (type == 1)
	            body.label = 'Video';
	        //console.log(body);
	        return this._http.post(this._conf.Url + 'unlike', body, { headers: this._conf.headers })
	            .map(function (res) { return res.json(); })
	            .map(function (res) {
	            //console.log(res);
	            // if (res.token) {
	            //     localStorage.setItem('user', res.token);S
	            //     // this._router.navigate(['Pages']);
	            //     return res.code;
	            // }
	            return res;
	        });
	    };
	    personcaptionService.prototype.following = function (username) {
	        var token = localStorage.getItem('authToken');
	        var body = {
	            token: token,
	            userNameToFollow: username
	        };
	        //console.log(body);
	        return this._http.post(this._conf.Url + 'follow', body, { headers: this._conf.headers })
	            .map(function (res) { return res.json(); })
	            .map(function (res) {
	            //console.log(res);
	            // if (res.token) {
	            //     localStorage.setItem('user', res.token);S
	            //     // this._router.navigate(['Pages']);
	            //     return res.code;
	            // }
	            return res;
	        });
	    };
	    personcaptionService.prototype.follow = function (username) {
	        var token = localStorage.getItem('authToken');
	        var body = {
	            token: token,
	            unfollowUserName: username
	        };
	        //console.log(body);
	        return this._http.post(this._conf.Url + 'unfollow', body, { headers: this._conf.headers })
	            .map(function (res) { return res.json(); })
	            .map(function (res) {
	            //console.log(res);
	            // if (res.token) {
	            //     localStorage.setItem('user', res.token);S
	            //     // this._router.navigate(['Pages']);
	            //     return res.code;
	            // }
	            return res;
	        });
	    };
	    personcaptionService = __decorate([
	        core_1.Injectable(), 
	        __metadata('design:paramtypes', [router_1.Router, http_1.Http, app_constants_1.Configuration])
	    ], personcaptionService);
	    return personcaptionService;
	}());
	exports.personcaptionService = personcaptionService;


/***/ },

/***/ 494:
/***/ function(module, exports) {

	module.exports = "<!DOCTYPE html>\r\n<html>\r\n<head>\r\n\t<title>{{name}}</title>\r\n    <link rel=\"icon\" type=\"image/gif/png\" href=\"/public/images/picoTitleLogo.png\">\r\n</head>\r\n\r\n<div class=\"loader\" *ngIf=\"loading\"></div>\r\n<div class=\"container-fluid picogram_total\">\r\n    <div class=\"container pico_content_total profile_pico\" [hidden]=\"datacation\" style=\"max-width: 935px;padding: 50px 20px 0;\">\r\n        <div class=\"profile_file_name zero_padding col-xs-12\" style=\"margin-bottom:8%;\">\r\n            <h2 style=\"text-align:center;\">#{{name}}</h2>\r\n        </div>    \r\n\r\n<h2 class=\"color_thick color_opacity\" *ngIf=\"!loading\" style=\"color: #999;font-size: 14px;font-weight: 400;margin-bottom: 16px;text-align: left;text-transform: uppercase;\">Top Posts</h2>\r\n<div *ngIf=\"posts\" class=\"all_profile_upload zero_padding col-xs-12\" style=\"\">\r\n\t<div class=\"zero_padding col-xs-4 upload_photo\" *ngFor=\"let item of posts\" style=\"margin:0% 3% 3% 0%;width:30.3%;\">\r\n\t\t<span class=\"img-span zero_padding col-xs-12 carousel_click\" (click)=\"activeitem(item.postId)\" id=\"{{item.postId}}\" data-toggle=\"modal\" data-target=\".bs-example-modal-lg\">\r\n\t\t\t<span class=\"img_hov zero_padding col-xs-12\">\r\n\t\t\t\t<img class=\"uploadphoto\" id=\"\" *ngIf=\"item.postsType==0\" src=\"{{item.mainUrl}}\" onError=\"this.src='/public/images/default.png';\">\r\n\t\t\t\t<span class=\"videotag_img video_tag\" *ngIf=\"item.postsType==1\"></span>\r\n\t\t\t\t<video class=\"uploadphoto\" *ngIf=\"item.postsType==1\">\r\n\t\t\t\t\t<source src=\"{{item.mainUrl}}\" type=\"video/mp4\">\r\n\t\t\t\t\t<source src=\"{{item.mainUrl}}\" type=\"video/ogg\"> \r\n\t\t\t\t</video>\r\n\t\t\t</span>\r\n\t\t\t<span class=\"hover_image_effect hide_hover col-xs-12\" id=\"\" style=\"\">\r\n\t\t\t\t<div class=\"hover_div zero_padding col-xs-12 col-sm-6\" *ngIf=\"item.postsType==0\">\r\n\t\t\t\t\t<span class=\"hover_icon hovericon zero_padding\"></span>\r\n\t\t\t\t\t<span class=\"hover_number\">{{item.likes}}</span>\r\n\t\t\t\t</div>\r\n\t\t\t\t<div class=\"hover_div zero_padding col-xs-12 col-sm-6\" *ngIf=\"item.postsType==1\">\r\n\t\t\t\t\t<span class=\"hover_icon hover_videoicon zero_padding\"></span>\r\n\t\t\t\t\t<span class=\"hover_number\">{{item.likes}}</span>\r\n\t\t\t\t</div>\r\n\t\t\t\t<div class=\"hover_div zero_padding col-xs-12 col-sm-6\">\r\n\t\t\t\t\t<span class=\"hover_icon hovericon1\"></span>\r\n\t\t\t\t\t<span class=\"hover_number\">{{item.commentData.length}}</span>\r\n\t\t\t\t</div>\r\n\t\t\t</span>\r\n\t\t</span>\r\n\t</div>\r\n</div>\r\n<div class=\"col-xs-12 loader_moreDetails\" [hidden]=\"!loadmoree\">\r\n\t<div class=\"loadmoreRound\" (click)=\"loadmore();\">\r\n\t\t<span class=\"loadmore_click\">loadmore</span>\r\n\t</div>\r\n</div>\r\n\r\n<!--<div class=\"zero_padding col-xs-12 loadmore\" (click)=\"loadmore();\" [hidden]=\"!loadmoree\" style=\"cursor:pointer;text-align:center;height: 120px;width: 120px;margin-left: 40%;border: 2px solid #3897f0;border-radius: 50%;\">\r\n\t<span class=\"loadmore_click\" style=\"font-size:14px;position: absolute;top: 40%;left: 28%;color: #3897f0;\">loadmore</span>\r\n\r\n</div>-->\r\n<!-- -->       \r\n\r\n<!-- carousel -->\r\n\r\n<div class=\"container\" style=\"width:100%;\">\r\n\t<div class=\"modal fade bs-example-modal-lg carousel-model\" role=\"dialog\" aria-labelledby=\"myLargeModalLabel\" aria-hidden=\"true\">\r\n\t\t<div class=\"modal-dialog modal-lg\">\r\n\t\t\t<div class=\"modal-content\">\r\n\t\t\t\t<div id=\"carousel-example-generic\" *ngIf=\"posts\" class=\"carousel slide\" data-interval=\"false\">\r\n\r\n\t\t\t\t\t<!-- Wrapper for slides -->\r\n\t\t\t\t\t<div class=\"carousel-inner\">\r\n\t\t\t\t\t\t<div class=\"item\" *ngFor=\"let item of posts; let i = index\" id=\"{{item.postId}}w\">\r\n\t\t\t\t\t\t\t<div class=\"col-xs-12 col-md-7 zero_padding\">\r\n\t\t\t\t\t\t\t\t<!--<img class=\"img-responsive\" src=\"https://igcdn-photos-f-a.akamaihd.net/hphotos-ak-xpt1/t51.2885-15/e15/10809778_786506061406485_132431944_n.jpg?ig_cache_key=ODY1OTk3NTk4NzU0MjE4NDY5.2\"\r\n\t\t\t\t\t\t\t\t\talt=\"...\">-->\r\n\t\t\t\t\t\t\t\t\t<img class=\"img-responsive col-xs-12 zero_padding\" id=\"\" (click)=\"falseusertagged(i);\" (dblclick)=\"likedoubleClick(item.postId, item.postsType,i);\" *ngIf=\"item.postsType==0\" src=\"{{item.mainUrl}}\" onError=\"this.src='/public/images/default.png';\">\r\n\t\t\t\t\t\t\t\t\t<div class=\"doubleclick_heart\" *ngIf=\"item.likeheartFlagg==true\"> \r\n\t\t\t\t\t\t\t\t\t\t<span class=\"double_click_heart like_icon\"></span>\r\n\t\t\t\t\t\t\t\t\t</div>\r\n\t\t\t\t\t\t\t\t\t<video class=\"img-responsive\" (click)=\"falseusertagged(i);\" *ngIf=\"item.postsType==1\" controls>\r\n\t\t\t\t\t\t\t\t\t\t<source src=\"{{item.mainUrl}}\" type=\"video/mp4\">\r\n\t\t\t\t\t\t\t\t\t\t<source src=\"{{item.mainUrl}}\" type=\"video/ogg\"> \r\n\t\t\t\t\t\t\t\t\t</video>\r\n\t\t\t\t\t\t\t\t\t<div class=\"pico_contentdetails_tagged col-xs-12\">\r\n\t\t\t\t\t\t\t\t\t\t<div *ngIf=\"item.usertaggedFlagg==true\">\r\n\t\t\t\t\t\t\t\t\t\t\t<span *ngFor=\"let tagged of item.coords;\">\r\n\t\t\t\t\t\t\t\t\t\t\t\t<span class=\"tagg_color_name tagg_color\" data-dismiss=\"modal\" (click)=\"usertaggedname(tagged);\"  [ngStyle]=\"{'margin-left': tagged.right+'%', 'margin-top': '-'+tagged.top+'%'}\">\t\t\t\t\t\t\t\t\t\t\t\t\t\t\r\n\t\t\t\t\t\t\t\t\t\t\t\t\t<div class=\"tagg_arrowicon\"></div>\r\n\t\t\t\t\t\t\t\t\t\t\t\t\t{{tagged.name}}\t\t\t\t\t\t\t\t\t\t\t\t\t\t\r\n\t\t\t\t\t\t\t\t\t\t\t\t</span>\r\n\t\t\t\t\t\t\t\t\t\t\t</span>\r\n\t\t\t\t\t\t\t\t\t\t</div>\r\n\t\t\t\t\t\t\t\t\t\t<div class=\"\" *ngFor=\"let tagged of item.coords;\">\t\t\t\t\t\t\r\n\t\t\t\t\t\t\t\t\t\t\t<i class=\"usertag_icon tagged_icon\" (click)=\"usertagged(i);\"></i>\t\t\t\t\t\t\t\t\t\t\r\n\t\t\t\t\t\t\t\t\t\t</div>\r\n\t\t\t\t\t\t\t\t\t</div>\r\n\t\t\t\t\t\t\t</div>\r\n\t\t\t\t\t\t\t<div class=\"col-xs-12 col-md-5 zero_padding comment_text\">\r\n\t\t\t\t\t\t\t\t<div class=\"follow_details col-xs-12 zero_padding\">\r\n\t\t\t\t\t\t\t\t\t<span class=\"col-xs-2 col-sm-2 col-md-1 zero_padding\"><img class=\"suggestion_image member_name\" data-dismiss=\"modal\" (click)=\"memberprofile(item)\" src=\"{{item.profilePicUrl}}\" onError=\"this.src='/public/images/default.png';\"></span>\r\n\t\t\t\t\t\t\t\t\t<span class=\"col-xs-4 col-sm-5 col-md-6 zero_padding slider_img\">\r\n\t\t\t\t\t\t\t\t\t\t<h5 class=\"follow_name col-xs-12 zero_padding\"><span class=\"color_thick member_name\" data-dismiss=\"modal\" (click)=\"memberprofile(item)\">{{item.postedByUserName}}</span></h5>\r\n\t\t\t\t\t\t\t\t\t\t<h6 class=\"follow_name col-xs-12 zero_padding color_thick color_opacity member_name\" data-dismiss=\"modal\" (click)=\"memberprofileplace(item)\" *ngIf=\"item.place !='[object Object]'\">{{item.place}}</h6>\t\t\t\r\n\t\t\t\t\t\t\t\t\t</span>\r\n\t\t\t\t\t\t\t\t\t<span class=\"buffer_gif\" *ngIf=\"buffer\" style=\"left:-18%;\"><img src=\"/public/images/ajax-loader2.gif\" alt=\"loader\"></span>\r\n\t\t\t\t\t\t\t\t\t<span class=\"col-xs-5 col-sm-4 zero_padding\" *ngIf=\"item.userFollowRequestStatus==null\" (click)=\"followingfllag(item, i);\" style=\"\"><button class=\"follow_button\" style=\"font-size: 14px;\">Follow</button></span>\r\n\t\t\t\t\t\t\t\t\t<span class=\"col-xs-5 col-sm-4 zero_padding\" *ngIf=\"item.userFollowRequestStatus==0\" (click)=\"followfllag(item, i);\" style=\"\"><button class=\"follow_button\" style=\"font-size: 14px;background-color:gray;border:1px solid gray;color:white;\">Requested</button></span>\r\n\t\t\t\t\t\t\t\t\t<span class=\"col-xs-5 col-sm-4 zero_padding\" *ngIf=\"item.userFollowRequestStatus==1\" (click)=\"followfllag(item, i);\" style=\"\"><button class=\"follow_buttonn folow\" style=\"margin-top:0px;font-size: 14px;\">Following</button></span>\r\n\t\t\t\t\t\t\t\t\t<!--<span class=\"col-xs-5 col-sm-4 zero_padding\" style=\"\"><button class=\"follow_buttonn folow\">Following</button></span>-->\r\n\t\t\t\t\t\t\t\t</div>\r\n\t\t\t\t\t\t\t\t<div class=\"pico_contentdetails_comment\" style=\"padding: 0% 0% 0% 5%;display: inline-block;width: 100%;\">\r\n\t\t\t\t\t\t\t\t\t<div class=\"col-xs-12 zero_padding\" style=\"margin: 2% 0%;\">\r\n\t\t\t\t\t\t\t\t\t\t<span class=\"col-xs-10 zero_padding\" *ngIf=\"item.likedByUser.length < 6\">\r\n\t\t\t\t\t\t\t\t\t\t\t<div *ngIf=\"item.likedByUser\">\r\n\t\t\t\t\t\t\t\t\t\t\t\t<span *ngFor=\"let liked of item.likedByUser; let i=index;\">\r\n\t\t\t\t\t\t\t\t\t\t\t\t\t<span *ngIf=\"liked != 'null'\">\r\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t<span *ngIf=\"i != 0\" class=\"comma_moveleftside\">,</span>\r\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t<span class=\"add_liked color_thick member_name\" data-dismiss=\"modal\" (click)=\"likedbyuser(liked)\" id=\"likecontent\">{{liked}}</span>\r\n\t\t\t\t\t\t\t\t\t\t\t\t\t</span>\r\n\t\t\t\t\t\t\t\t\t\t\t\t</span>\r\n\t\t\t\t\t\t\t\t\t\t\t\t<span class=\"color_opacity\" *ngIf=\"item.likedByUser.length > 1 || item.likeStatus==1\" style=\"font-size:14px;\">like this</span>\r\n\t\t\t\t\t\t\t\t\t\t\t</div>\r\n\t\t\t\t\t\t\t\t\t\t</span>\r\n\t\t\t\t\t\t\t\t\t\t<span class=\"col-xs-10 zero_padding\" *ngIf=\"item.likedByUser.length > 6\"><span class=\"add_like color_thick\" id=\"like1content\" style=\"margin-right: 5%;\">{{item.likes}}</span><span class=\"color_thick\">likes</span></span>\r\n\t\t\t\t\t\t\t\t\t\t<span class=\"col-xs-6 color_thick color_opacity zero_padding member_name\" data-dismiss=\"modal\" (click)=\"timepost(item)\" style=\"color: #999;text-align:right;width: 10%;\">{{item.postedOn}}</span>\r\n\t\t\t\t\t\t\t\t\t</div>\r\n\t\t\t\t\t\t\t\t\t<ul class=\"comment_list carousel_comment zero_padding col-xs-12\">\r\n\t\t\t\t\t\t\t\t\t\t<!--<li class=\"listcomment zero_padding col-xs-12\">\r\n\t\t\t\t\t\t\t\t\t\t\t<span class=\"name_comment\" style=\"\"><span class=\"color_thick\" style=\"\" *ngIf=\"item.postCaption !='null'\">{{item.postCaption}}</span></span>\r\n\t\t\t\t\t\t\t\t\t\t\t\r\n\t\t\t\t\t\t\t\t\t\t</li>-->\r\n                                        <li class=\"listcomment zero_padding col-xs-12\" >\r\n\t\t\t\t\t\t\t\t\t\t\t<span class=\"color_thick member_name\" *ngIf=\"item.postCaption !='null'\" id=\"{{item.postsId}}\">{{item.postedByUserName}}</span>\r\n                                            <span class=\"name_comment\" style=\"\" *ngFor=\"let caption of item.postCaption;\">\r\n                                                <span *ngIf=\"caption != 'null'\">\r\n\t\t\t\t\t\t\t\t\t\t\t\t\t<span class=\"color_thick color_opacity member_name\" id=\"{{item.postsId}}\" *ngIf=\"caption.charAt(0) != '#' && caption.charAt(0) != '@'\" data-dismiss=\"modal\">{{caption}}</span>\r\n                                                    <span class=\"color_thick color_opacity member_name\" id=\"{{item.postId}}\" data-dismiss=\"modal\" (click)=\"membercaption(caption)\" style=\"color:#003569;\" *ngIf=\"caption.charAt(0) == '#'\">{{caption}}</span>\r\n\t\t\t\t\t\t\t\t\t\t\t\t\t<span class=\"color_thick color_opacity member_name\" id=\"{{item.postId}}\" data-dismiss=\"modal\" (click)=\"memberprofilecaptionn(caption)\" style=\"color:#003569;\" *ngIf=\"caption.charAt(0) == '@'\">{{caption}}</span>\r\n                                                </span>\r\n                                            </span>\r\n                                        </li>\r\n\t\t\t\t\t\t\t\t\t\t<li class=\"listcomment zero_padding col-xs-12\" *ngFor=\"let comment of item.commentData; let k = index;\">\r\n\t\t\t\t\t\t\t\t\t\t\t<span class=\"name_comment\" style=\"\"><span class=\"color_thick member_name\" data-dismiss=\"modal\" (click)=\"memberprofilee(comment)\" style=\"\">{{comment.commentedByUser}}</span></span>\r\n\t\t\t\t\t\t\t\t\t\t\t<span class=\"name_comment1 color_thick color_opacity\" style=\"\" [innerHTML]=\"comment.commentBody\"></span>\t\t\t\t\t\t\t\t\t\t\t\r\n\t\t\t\t\t\t\t\t\t\t\t<span class=\"name_comment1 color_thick color_opacity member_name delete_comment\" style=\"\" data-toggle=\"modal\" data-target=\"#myModal_delete\" (click)=\"commentdelete(comment, item.postId, item.postsType, i, k)\" *ngIf=\"comment.commentedByUser == username\">X</span>\r\n\t\t\t\t\t\t\t\t\t\t</li>\r\n\t\t\t\t\t\t\t\t\t<!--<li class=\"listcomment zero_padding col-xs-12\">\r\n\t\t\t\t\t\t\t\t\t\t\t<span class=\"name_comment\" style=\"\"><a class=\"color_thick\" href=\"picogram_person_profile.php\" style=\"\">prabhvanimakkar</a></span>\r\n\t\t\t\t\t\t\t\t\t\t\t<span class=\"name_comment1 color_thick color_opacity\" style=\"\">That's perfect â¤ you both are the prettiest together </span>\r\n\t\t\t\t\t\t\t\t\t\t</li>\r\n\t\t\t\t\t\t\t\t\t\t<li class=\"listcomment zero_padding col-xs-12\">\r\n\t\t\t\t\t\t\t\t\t\t\t<span class=\"name_comment\" style=\"\"><a class=\"color_thick\" href=\"picogram_person_profile.php\" style=\"\">_.rheab._</a></span>\r\n\t\t\t\t\t\t\t\t\t\t\t<span class=\"name_comment1 color_thick color_opacity\" style=\"\"> O ma ei pic ta ki pretty dekh  they are looking so adorable ðŸ™ˆ</span>\r\n\t\t\t\t\t\t\t\t\t\t</li>-->\r\n\t\t\t\t\t\t\t\t\t</ul>\r\n\t\t\t\t\t\t\t\t\t<span class=\"col-xs-11\" style=\"background:#efefef;height:1px;margin: 5px 0px 5px 0px\"></span>\r\n\t\t\t\t\t\t\t\t</div>\r\n\t\t\t\t\t\t\t\t<div class=\"add_comment col-xs-12 modal_comment_carousel\" style=\"padding: 5px 20px;\">\r\n\t\t\t\t\t\t\t\t\t<i class=\"comment_icon comment_heart_icon add_heart_icon\" *ngIf=\"item.likeStatus!=1\" (click)=\"likeactive(item.postId, item.postsType,i)\" id=\"{{item.postId}}\"></i>\r\n\t\t\t\t\t\t\t\t\t<i class=\"comment_icon comment_heart_icon add_heart_icon active\" *ngIf=\"item.likeStatus==1\" (click)=\"likedeactive(item.postId, item.postsType,i)\" id=\"{{item.postId}}\"></i>\r\n\t\t\t\t\t\t\t\t\t<input type=\"text\" #input (keyup.enter)=\"usercommentSubmit(input.value, item.postId, item.postsType, i); input.value=''\" name=\"message\" placeholder=\"Add a comment\"\r\n\t\t\t\t\t\t\t\t\tid=\"{{item.postId}}\" class=\"col-xs-12 comment_textbox\" style=\"font-size:14px;\">\r\n\t\t\t\t\t\t\t\t\t<i class=\"comment_icon comment_dotted_icon\" data-toggle=\"modal\" data-target=\"#myModall\"></i>\r\n\t\t\t\t\t\t\t\t</div>\t\t\t\t\t\t\t\t\r\n\t\t\t\t\t\t\t</div>\r\n\t\t\t\t\t\t</div>\r\n\t\t\t\t\t</div>\r\n\t\t\t\t</div>\r\n\r\n\t\t\t\t<!-- Controls -->\r\n\t\t\t\t<a class=\"left carousel-control\" href=\"#carousel-example-generic\" role=\"button\" data-slide=\"prev\">\r\n\t\t\t\t\t<span class=\"glyphicon glyphicon-chevron-left\"></span>\r\n\t\t\t\t</a>\r\n\t\t\t\t<a class=\"right carousel-control\" href=\"#carousel-example-generic\" role=\"button\" data-slide=\"next\">\r\n\t\t\t\t\t<span class=\"glyphicon glyphicon-chevron-right\"></span>\r\n\t\t\t\t</a>\r\n\t\t\t</div>\r\n\t\t</div>\r\n\t</div>\r\n\r\n\t<!-- popup modal -->\r\n\t\t<div class=\"modal fade\" id=\"myModall\" role=\"dialog\">\r\n\t\t\t<div class=\"modal-dialog modal-md\">\r\n\t\t\t\t<div class=\"modal-content\">\r\n\t\t\t\t\t<div class=\"modal-body\" style=\"\">\r\n\t\t\t\t\t\t<span class=\"report_cancel col-xs-12\">Report inappropriate</span>\r\n\t\t\t\t\t\t<!--<span class=\"report_cancel col-xs-12\">Embed</span>-->\r\n\t\t\t\t\t\t<span class=\"report_cancel col-xs-12\" data-dismiss=\"modal\">Cancel</span>\r\n\t\t\t\t\t</div>\r\n\t\t\t\t</div>\r\n\t\t\t</div>\r\n\t\t</div>\r\n\t\t<!-- delete comment -->\r\n\t\t<div class=\"modal fade deletecomment\" id=\"myModal_delete\" role=\"dialog\">\r\n\t\t\t<div class=\"modal-dialog modal-md\">\r\n\t\t\t\t<div class=\"modal-content\">\r\n\t\t\t\t\t<div class=\"modal-body\" style=\"\">\r\n\t\t\t\t\t\t<span class=\"report_cancel col-xs-12 color_focus  member_name\" data-dismiss=\"modal\" (click)=\"commentmodaldelete()\">Delete Comment</span>\r\n\t\t\t\t\t\t<!--<span class=\"report_cancel col-xs-12\">Embed</span>-->\r\n\t\t\t\t\t\t<span class=\"report_cancel col-xs-12\" data-dismiss=\"modal\">Cancel</span>\r\n\t\t\t\t\t</div>\r\n\t\t\t\t</div>\r\n\t\t\t</div>\r\n\t\t</div>\r\n\t\t<!-- End popup modal -->\r\n\r\n</div>\r\n<!-- end carousel -->\r\n</div>\r\n<div class=\"container pico_content_total profile_pico\" [hidden]=\"nocation\" style=\"max-width: 935px;padding: 50px 20px 0;text-align:center;\">\r\n\t <h2 style=\"text-align:center;\">#{{name}}</h2>\r\n\t  <h4 style=\"text-align:center;\">0 posts</h4>\r\n\r\n\t  <h4 style=\"margin-top:20%;\">No posts yet.</h4>\r\n</div>\r\n</div>\r\n\r\n</html>\r\n\r\n";

/***/ },

/***/ 495:
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var core_1 = __webpack_require__(5);
	var router_1 = __webpack_require__(389);
	var router_2 = __webpack_require__(389);
	var homepost_service_1 = __webpack_require__(496);
	var HomepostComponent = (function () {
	    function HomepostComponent(_homepostService, _router, route) {
	        this._homepostService = _homepostService;
	        this._router = _router;
	        this.route = route;
	        this.posts = [];
	        this.loading = true;
	        this.buffer = false;
	        this.sharePost = false;
	        this.offset = 0;
	        this.commnentdetails = [];
	    }
	    HomepostComponent.prototype.ngOnInit = function () {
	        var _this = this;
	        var token = localStorage.getItem('authToken');
	        var username = localStorage.getItem('username');
	        this.username = username;
	        this.route.params.subscribe(function (params) {
	            _this.name = params['name'];
	            _this.id = params['id'];
	            //console.log(this.id); 
	            _this.loading = true;
	            if (!token) {
	                _this._homepostService.personShareProfile(_this.name, _this.id)
	                    .subscribe(function (res) {
	                    _this.loading = false;
	                    _this.sharePost = true;
	                    _this.data = res.memberProfileData;
	                    // this.privatemember = this.data.privateMember
	                    // this.posts = res.memberPostsData;
	                    _this.posts = [];
	                    _this.totaldata = res.memberPostsData;
	                    _this.offset = res.memberPostsData.length;
	                    _this.commentfunction();
	                    if (_this.offset >= 20)
	                        _this.loadmoree = true;
	                });
	            }
	            else {
	                _this._homepostService.personprofile(_this.name)
	                    .subscribe(function (res) {
	                    _this.loading = false;
	                    _this.data = res.memberProfileData[0];
	                    _this.privatemember = _this.data.privateMember;
	                    // this.posts = res.memberPostsData;
	                    _this.posts = [];
	                    _this.totaldata = res.memberPostsData;
	                    _this.offset = res.memberPostsData.length;
	                    _this.commentfunction();
	                    if (_this.offset >= 20)
	                        _this.loadmoree = true;
	                });
	            }
	        });
	    };
	    HomepostComponent.prototype.hashtagFunction = function () {
	        var len = this.totaldata.length;
	        for (var i = 0; i < len; i++) {
	            if (this.totaldata[i].commentData) {
	                var commenttext = this.totaldata[i].commentData;
	                for (var x = 0; x < commenttext.length; x++) {
	                    // commenttext.splice(x, 0);
	                    if (this.totaldata[i].commentData[x].commentBody) {
	                        var postCommentNodeArr1 = commenttext[x].commentBody;
	                        // //console.log(postCommentNodeArr1);
	                        var hashtag_regexp = /#([a-zA-Z0-9_]+)/g;
	                        var comment_text = postCommentNodeArr1.replace(hashtag_regexp, '<a href="home/personcaption/$1" class="hashtag member_name biohashtag">#$1</a>');
	                        var hashtag_regexp1 = /@([a-zA-Z0-9_]+)/g;
	                        var comment_textt = comment_text.replace(hashtag_regexp1, '<a href="home/person/$1" class="hashtag member_name biohashtag">@$1</a>');
	                        this.totaldata[i].commentData[x].commentBody = comment_textt;
	                    }
	                }
	            }
	        }
	    };
	    HomepostComponent.prototype.commentfunction = function () {
	        this.hashtagFunction();
	        // alert("hi");
	        var len = this.totaldata.length;
	        for (var i = 0; i < len; i++) {
	            // this.commentdata = [];
	            // if (this.totaldata[i].comments) {
	            //     var commenttext = this.totaldata[i].comments;
	            //     var hashtag_regexp = /#([a-zA-Z0-9_]+)/g;
	            //      var token = localStorage.getItem('authToken');  
	            //     if(!token){
	            //          var comment_text = commenttext.replace(
	            //             hashtag_regexp,
	            //             '<a href="login" class="hashtag member_name biohashtag">#$1</a>'
	            //         );
	            //         var hashtag_regexp1 = /@([a-zA-Z0-9_]+)/g;
	            //         var comment_textt = comment_text.replace(
	            //             hashtag_regexp1,
	            //             '<a href="login" class="hashtag member_name biohashtag">@$1</a>'
	            //         );
	            //     } else{  
	            //         var comment_text = commenttext.replace(
	            //             hashtag_regexp,
	            //             '<a href="home/personcaption/$1" class="hashtag member_name biohashtag">#$1</a>'
	            //         );
	            //         var hashtag_regexp1 = /@([a-zA-Z0-9_]+)/g;
	            //         var comment_textt = comment_text.replace(
	            //             hashtag_regexp1,
	            //             '<a href="home/person/$1" class="hashtag member_name biohashtag">@$1</a>'
	            //         );
	            //     }
	            //     var postCommentNodeArr = comment_textt.split('^^');
	            //     for (var x = 0; x < postCommentNodeArr.length; x++) {
	            //         postCommentNodeArr.splice(x, 0);
	            //         var postCommentNodeArr1 = postCommentNodeArr[x].split('$$');
	            //         if (postCommentNodeArr1.length == 2)
	            //         this.commentdata.push(postCommentNodeArr1);
	            //     }
	            // }
	            // this.totaldata[i].comments = this.commentdata;
	            var postCaption = [];
	            if (this.totaldata[i].postCaption) {
	                var postCaptionn = this.totaldata[i].postCaption.split(' ');
	                this.totaldata[i].postCaption = postCaptionn;
	            }
	            var postLikedBy = [];
	            if (this.totaldata[i].postLikedBy) {
	                var liked = this.totaldata[i].postLikedBy.split(',');
	                if (liked.length) {
	                    this.totaldata[i].postLikedBy = liked;
	                }
	            }
	            else {
	                this.totaldata[i].postLikedBy = [];
	            }
	            var usersTagged = [];
	            if (this.totaldata[i].usersTagged) {
	                usersTagged = this.totaldata[i].usersTagged.split(',');
	                this.totaldata[i].usersTagged = usersTagged;
	            }
	            var taggedUserCoordinates = [];
	            if (this.totaldata[i].taggedUserCoordinates) {
	                taggedUserCoordinates = this.totaldata[i].taggedUserCoordinates.split(',');
	                this.totaldata[i].taggedUserCoordinates = taggedUserCoordinates;
	            }
	            if (usersTagged[0] != 'undefined' && taggedUserCoordinates[0] != null) {
	                var lenn = usersTagged.length;
	                var tagsCords = [];
	                for (var j = 0; j < lenn; j++) {
	                    var userCords = {
	                        name: usersTagged[j],
	                        right: 0,
	                        top: 0
	                    };
	                    if (taggedUserCoordinates[j]) {
	                        var cordinates = taggedUserCoordinates[j].split('-');
	                        userCords.right = cordinates[0];
	                        userCords.top = cordinates[1];
	                        tagsCords.push(userCords);
	                    }
	                }
	                this.totaldata[i].coords = tagsCords;
	            }
	            var post = this.totaldata[i].postedOn;
	            var poston = Number(post);
	            var postdate = new Date(poston);
	            var currentdate = new Date();
	            var timeDiff = Math.abs(postdate.getTime() - currentdate.getTime());
	            var diffDays = Math.ceil(timeDiff / (1000 * 3600 * 24));
	            var diffHrs = Math.round((timeDiff % 86400000) / 3600000);
	            var diffMins = Math.round(((timeDiff % 86400000) % 3600000) / 60000);
	            if (1 < diffDays) {
	                this.totaldata[i].postedOn = diffDays + "d";
	            }
	            else if (1 <= diffHrs) {
	                this.totaldata[i].postedOn = diffHrs + "h";
	            }
	            else {
	                this.totaldata[i].postedOn = diffMins + "m";
	            }
	            if (this.totaldata[i].postId == this.id) {
	                //  //console.log(this.totaldata[i].postId+"dd"+ this.id);
	                this.posts.push(this.totaldata[i]);
	            }
	        }
	        // this.posts = this.totaldata;
	    };
	    HomepostComponent.prototype.sharePostlogin = function () {
	        var link = ['login'];
	        this._router.navigate(link);
	    };
	    HomepostComponent.prototype.timepost = function (item) {
	        var token = localStorage.getItem('authToken');
	        if (!token) {
	            var link = ['login'];
	            this._router.navigate(link);
	        }
	        else {
	            var postsId = item.postId;
	            var followingUsername = this.name;
	            var link = ['home/homepost', followingUsername, postsId];
	            this._router.navigate(link);
	        }
	    };
	    HomepostComponent.prototype.usertagged = function (i) {
	        this.posts[i].usertaggedFlagg = true;
	    };
	    HomepostComponent.prototype.falseusertagged = function (i) {
	        this.posts[i].usertaggedFlagg = false;
	    };
	    HomepostComponent.prototype.usertaggedname = function (tagged) {
	        // alert(item.postId);
	        var token = localStorage.getItem('authToken');
	        if (!token) {
	            var link = ['login'];
	            this._router.navigate(link);
	        }
	        else {
	            var personname = tagged.name;
	            var username = localStorage.getItem('username');
	            if (username == personname) {
	                this._router.navigate(['home/profile']);
	            }
	            else {
	                var link = ['home/person', personname];
	                this._router.navigate(link);
	            }
	        }
	    };
	    HomepostComponent.prototype.memberprofile = function () {
	        // alert(item.postsId);
	        var token = localStorage.getItem('authToken');
	        if (!token) {
	            var link = ['login'];
	            this._router.navigate(link);
	        }
	        else {
	            var personname = this.name;
	            var username = localStorage.getItem('username');
	            if (username == personname) {
	                this._router.navigate(['home/profile']);
	            }
	            else {
	                var link = ['home/person', personname];
	                this._router.navigate(link);
	            }
	        }
	        // let link = ['/home/person', item.username];
	        // this._router.navigate(link);
	    };
	    HomepostComponent.prototype.memberprofilee = function (comment) {
	        var token = localStorage.getItem('authToken');
	        if (!token) {
	            var link = ['login'];
	            this._router.navigate(link);
	        }
	        else {
	            // alert(item.postsId);
	            var personname = comment.commentedByUser;
	            var username = localStorage.getItem('username');
	            if (username == personname) {
	                this._router.navigate(['home/profile']);
	            }
	            else {
	                var link = ['home/person', personname];
	                this._router.navigate(link);
	            }
	        }
	        // let link = ['home/person', comment[0]];
	        // this._router.navigate(link);
	    };
	    HomepostComponent.prototype.membercaption = function (caption) {
	        var token = localStorage.getItem('authToken');
	        if (!token) {
	            var link = ['login'];
	            this._router.navigate(link);
	        }
	        else {
	            var hashtagname = caption.split('#');
	            //   //console.log(hashtagname[1]);        
	            var link = ['home/personcaption', hashtagname[1]];
	            this._router.navigate(link);
	        }
	    };
	    HomepostComponent.prototype.membercaptionn = function (comment) {
	        var token = localStorage.getItem('authToken');
	        if (!token) {
	            var link = ['login'];
	            this._router.navigate(link);
	        }
	        else {
	            var hashtagname = comment[1].split('#');
	            //   //console.log(hashtagname[1]);        
	            var link = ['home/personcaption', hashtagname[1].replace(" ", "")];
	            this._router.navigate(link);
	        }
	    };
	    HomepostComponent.prototype.memberprofilecaption = function (comment) {
	        // var hashtagname = comment[1].split('@');
	        //   //console.log(hashtagname[1]);        
	        // let link = ['home/personcaption', hashtagname[1].replace(" ","")];
	        // this._router.navigate(link); 
	        var token = localStorage.getItem('authToken');
	        if (!token) {
	            var link = ['login'];
	            this._router.navigate(link);
	        }
	        else {
	            var personname = comment[1].split('@');
	            var username = localStorage.getItem('username');
	            if (username == personname[1]) {
	                this._router.navigate(['home/profile']);
	            }
	            else {
	                var link = ['home/person', personname[1].replace(" ", "")];
	                this._router.navigate(link);
	            }
	        }
	    };
	    HomepostComponent.prototype.memberprofilecaptionn = function (caption) {
	        var token = localStorage.getItem('authToken');
	        if (!token) {
	            var link = ['login'];
	            this._router.navigate(link);
	        }
	        else {
	            var personname = caption.split('@');
	            var username = localStorage.getItem('username');
	            if (username == personname[1]) {
	                this._router.navigate(['home/profile']);
	            }
	            else {
	                var link = ['home/person', personname[1].replace(" ", "")];
	                this._router.navigate(link);
	            }
	        }
	    };
	    HomepostComponent.prototype.commentdelete = function (comment, id, postsType, i) {
	        var token = localStorage.getItem('authToken');
	        if (!token) {
	            var link = ['login'];
	            this._router.navigate(link);
	        }
	        else {
	            //  //console.log(comment[0]+" ss "+comment[1]+" id "+id+" postsType "+postsType+" i "+i);
	            postsType = postsType.toString();
	            this.commnentdetails = ({ username: comment.commentedByUser, message: comment.commentBody, commentId: comment.commentId, id: id, postsType: postsType, i: i });
	        }
	    };
	    HomepostComponent.prototype.commentmodaldelete = function () {
	        var token = localStorage.getItem('authToken');
	        if (!token) {
	            var link = ['login'];
	            this._router.navigate(link);
	        }
	        else {
	            //console.log(this.commnentdetails);
	            var commentlist = this.commnentdetails;
	            var commenttext = commentlist.message;
	            var hashtag_regexp = /<a[^>]*>([^<]+)<\/a>/g;
	            var comment_text = commenttext.replace(hashtag_regexp, '$1');
	            //  //console.log(commentlist.i);
	            this.posts[commentlist.i].commentData.pop();
	            this._homepostService.userdeletecomment({ username: commentlist.username, message: comment_text, commentId: commentlist.commentId, id: commentlist.id, postsType: commentlist.postsType })
	                .subscribe();
	        }
	    };
	    HomepostComponent.prototype.likeStatus = function (liked) {
	        var token = localStorage.getItem('authToken');
	        if (!token) {
	            var link = ['login'];
	            this._router.navigate(link);
	        }
	        else {
	            var personname = liked;
	            // alert(personname);
	            var username = localStorage.getItem('username');
	            if (username == personname) {
	                this._router.navigate(['home/profile']);
	            }
	            else {
	                var link = ['home/person', personname];
	                this._router.navigate(link);
	            }
	        }
	    };
	    HomepostComponent.prototype.likedoubleClick = function (id, postsType, i) {
	        var _this = this;
	        var token = localStorage.getItem('authToken');
	        if (!token) {
	            var link = ['login'];
	            this._router.navigate(link);
	        }
	        else {
	            // alert(id+'aa'+'bb'+postsType+'cc'+i);
	            if (this.posts[i].likeStatus == 0) {
	                this.posts[i].likeheartFlagg = true;
	                var username = localStorage.getItem('username');
	                this.posts[i].postLikedBy.unshift(username);
	                this.posts[i].likeStatus = 1;
	                this.posts[i].likes += 1;
	                this._homepostService.userlike(id, postsType)
	                    .subscribe();
	                setTimeout(function () {
	                    _this.posts[i].likeheartFlagg = false;
	                }, 500);
	            }
	        }
	    };
	    HomepostComponent.prototype.likeactive = function (id, postsType, i) {
	        var token = localStorage.getItem('authToken');
	        if (!token) {
	            var link = ['login'];
	            this._router.navigate(link);
	        }
	        else {
	            // alert(id);
	            var username = localStorage.getItem('username');
	            this.posts[i].postLikedBy.unshift(username);
	            this.posts[i].likeStatus = 1;
	            this.posts[i].likes += 1;
	            this._homepostService.userlike(id, postsType)
	                .subscribe();
	        }
	    };
	    HomepostComponent.prototype.likedeactive = function (id, postsType, i) {
	        var token = localStorage.getItem('authToken');
	        if (!token) {
	            var link = ['login'];
	            this._router.navigate(link);
	        }
	        else {
	            var username = localStorage.getItem('username');
	            var array = this.posts[i].postLikedBy;
	            var index = array.indexOf(username);
	            if (index > -1) {
	                array.splice(index, 1);
	            }
	            this.posts[i].likeStatus = 0;
	            this.posts[i].likes -= 1;
	            this._homepostService.userunlike(id, postsType)
	                .subscribe();
	        }
	    };
	    HomepostComponent.prototype.followingfllag = function (name, i) {
	        // alert(i+'ll'+username+'ff'+followFlag);
	        var _this = this;
	        this.buffer = true;
	        if (this.privatemember == 1) {
	            setTimeout(function () {
	                _this.data.userFollowRequestStatus = 0;
	            }, 500);
	            this._homepostService.following(name)
	                .subscribe();
	            setTimeout(function () {
	                _this.buffer = false;
	            }, 500);
	        }
	        if (this.privatemember != 1) {
	            setTimeout(function () {
	                _this.data.userFollowRequestStatus = 1;
	            }, 500);
	            this._homepostService.following(name)
	                .subscribe();
	            setTimeout(function () {
	                _this.buffer = false;
	            }, 500);
	        }
	    };
	    HomepostComponent.prototype.followfllag = function (name, i) {
	        var _this = this;
	        this.buffer = true;
	        setTimeout(function () {
	            _this.data.userFollowRequestStatus = null;
	        }, 500);
	        this._homepostService.follow(name)
	            .subscribe();
	        setTimeout(function () {
	            _this.buffer = false;
	        }, 500);
	    };
	    HomepostComponent.prototype.usercommentSubmit = function (value, id, postsType, i) {
	        var _this = this;
	        var token = localStorage.getItem('authToken');
	        if (!token) {
	            var link = ['login'];
	            this._router.navigate(link);
	        }
	        else {
	            // //console.log('you submitted value:', value, id, postsType, i);
	            postsType = postsType.toString();
	            var username = localStorage.getItem('username');
	            var commenttext = value;
	            var hashtag_regexp = /#([a-zA-Z0-9_]+)/g;
	            var comment_text = commenttext.replace(hashtag_regexp, '<a href="home/personcaption/$1" class="hashtag member_name biohashtag">#$1</a>');
	            var hashtag_regexp1 = /@([a-zA-Z0-9_]+)/g;
	            var comment_textt = comment_text.replace(hashtag_regexp1, '<a href="home/person/$1" class="hashtag member_name biohashtag">@$1</a>');
	            if (value.length > 0) {
	                // this.posts[i].comments.push([username, comment_textt]);
	                this._homepostService.usercomment({ message: value, id: id, postsType: postsType })
	                    .subscribe(function (res) {
	                    _this.submitComment = res.data;
	                    _this.posts[i].commentData.push(_this.submitComment[0].commentData[0]);
	                    _this.hashtagFunction();
	                });
	            }
	        }
	    };
	    HomepostComponent = __decorate([
	        core_1.Component({
	            selector: 'homepost',
	            template: __webpack_require__(497),
	            directives: [router_1.ROUTER_DIRECTIVES],
	            providers: [homepost_service_1.homepostService]
	        }), 
	        __metadata('design:paramtypes', [homepost_service_1.homepostService, router_2.Router, router_2.ActivatedRoute])
	    ], HomepostComponent);
	    return HomepostComponent;
	}());
	exports.HomepostComponent = HomepostComponent;


/***/ },

/***/ 496:
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var core_1 = __webpack_require__(5);
	var router_1 = __webpack_require__(389);
	var app_constants_1 = __webpack_require__(441);
	var http_1 = __webpack_require__(363);
	var homepostService = (function () {
	    function homepostService(_router, _http, _conf) {
	        this._router = _router;
	        this._http = _http;
	        this._conf = _conf;
	    }
	    homepostService.prototype.personShareProfile = function (name, id) {
	        var body = {
	            membername: name,
	            postId: id
	        };
	        //console.log(body);
	        return this._http.post(this._conf.Url + 'getPostsBySharedUrl', body, { headers: this._conf.headers })
	            .map(function (res) { return res.json(); })
	            .map(function (res) {
	            //console.log(res);
	            // if (res.token) {
	            //     localStorage.setItem('user', res.token);
	            //     // this._router.navigate(['Pages']);
	            //     return res.code;
	            // }
	            return res;
	        });
	    };
	    homepostService.prototype.personprofile = function (name) {
	        var token = localStorage.getItem('authToken');
	        var body = { token: token, membername: name };
	        //console.log(body);
	        return this._http.post(this._conf.Url + 'profile/' + name, body, { headers: this._conf.headers })
	            .map(function (res) { return res.json(); })
	            .map(function (res) {
	            //console.log(res);
	            // if (res.token) {
	            //     localStorage.setItem('user', res.token);
	            //     // this._router.navigate(['Pages']);
	            //     return res.code;
	            // }
	            return res;
	        });
	    };
	    homepostService.prototype.userlike = function (id, postsType) {
	        var token = localStorage.getItem('authToken');
	        var body = {
	            token: token,
	            postId: id,
	            label: 'Photo'
	        };
	        if (postsType == 1)
	            body.label = 'Video';
	        //console.log(body);
	        return this._http.post(this._conf.Url + 'like', body, { headers: this._conf.headers })
	            .map(function (res) { return res.json(); })
	            .map(function (res) {
	            //console.log(res);
	            // if (res.token) {
	            //     localStorage.setItem('user', res.token);S
	            //     // this._router.navigate(['Pages']);
	            //     return res.code;
	            // }
	            return res;
	        });
	    };
	    homepostService.prototype.usercomment = function (value) {
	        var token = localStorage.getItem('authToken');
	        var body = {
	            comment: value.message,
	            type: value.postsType,
	            postId: value.id,
	            token: token
	        };
	        //console.log(body);
	        return this._http.post(this._conf.Url + 'comments', body, { headers: this._conf.headers })
	            .map(function (res) { return res.json(); })
	            .map(function (res) {
	            //console.log(res);
	            // if (res.token) {
	            //     localStorage.setItem('user', res.token);S
	            //     // this._router.navigate(['Pages']);
	            //     return res.code;
	            // }
	            return res;
	        });
	    };
	    homepostService.prototype.userdeletecomment = function (value) {
	        var token = localStorage.getItem('authToken');
	        var body = {
	            commentedByUser: value.username,
	            commentBody: value.message,
	            commentId: value.commentId,
	            type: value.postsType,
	            postId: value.id,
	            token: token
	        };
	        //console.log(body);
	        // return;
	        return this._http.post(this._conf.Url + 'deleteCommentsFromPost', body, { headers: this._conf.headers })
	            .map(function (res) { return res.json(); })
	            .map(function (res) {
	            //console.log(res);
	            // if (res.token) {
	            //     localStorage.setItem('user', res.token);S
	            //     // this._router.navigate(['Pages']);
	            //     return res.code;
	            // }
	            return res;
	        });
	    };
	    homepostService.prototype.userunlike = function (id, postsType) {
	        var token = localStorage.getItem('authToken');
	        var body = {
	            token: token,
	            postId: id,
	            label: 'Photo'
	        };
	        if (postsType == 1)
	            body.label = 'Video';
	        //console.log(body);
	        return this._http.post(this._conf.Url + 'unlike', body, { headers: this._conf.headers })
	            .map(function (res) { return res.json(); })
	            .map(function (res) {
	            //console.log(res);
	            // if (res.token) {
	            //     localStorage.setItem('user', res.token);S
	            //     // this._router.navigate(['Pages']);
	            //     return res.code;
	            // }
	            return res;
	        });
	    };
	    homepostService.prototype.following = function (username) {
	        var token = localStorage.getItem('authToken');
	        var body = {
	            token: token,
	            userNameToFollow: username
	        };
	        //console.log(body);
	        return this._http.post(this._conf.Url + 'follow', body, { headers: this._conf.headers })
	            .map(function (res) { return res.json(); })
	            .map(function (res) {
	            //console.log(res);
	            // if (res.token) {
	            //     localStorage.setItem('user', res.token);S
	            //     // this._router.navigate(['Pages']);
	            //     return res.code;
	            // }
	            return res;
	        });
	    };
	    homepostService.prototype.follow = function (username) {
	        var token = localStorage.getItem('authToken');
	        var body = {
	            token: token,
	            unfollowUserName: username
	        };
	        //console.log(body);
	        return this._http.post(this._conf.Url + 'unfollow', body, { headers: this._conf.headers })
	            .map(function (res) { return res.json(); })
	            .map(function (res) {
	            //console.log(res);
	            // if (res.token) {
	            //     localStorage.setItem('user', res.token);S
	            //     // this._router.navigate(['Pages']);
	            //     return res.code;
	            // }
	            return res;
	        });
	    };
	    homepostService = __decorate([
	        core_1.Injectable(), 
	        __metadata('design:paramtypes', [router_1.Router, http_1.Http, app_constants_1.Configuration])
	    ], homepostService);
	    return homepostService;
	}());
	exports.homepostService = homepostService;


/***/ },

/***/ 497:
/***/ function(module, exports) {

	module.exports = "<!DOCTYPE html>\r\n<html>\r\n<head>\r\n\t<title>{{name}}</title>\r\n    <!-- <link rel=\"icon\" type=\"image/gif/png\" href=\"/public/images/picoTitleLogo.png\"> -->\r\n</head>\r\n\r\n<div class=\"loader\" *ngIf=\"loading\"></div>\r\n<div class=\"container-fluid picogram_total\">\r\n    <div class=\"container pico_content_total profile_pico\" style=\"max-width: 935px;padding: 50px 20px 0;\">\r\n        <div class=\"post_homepage\" *ngIf=\"posts\">\r\n            <div class=\"\" *ngIf=\"sharePost\" style=\"text-align:center;color:blue;font-size:18px;margin-bottom: 1%;cursor:pointer;\">\r\n                <span (click)=\"sharePostlogin();\" class=\"\">SignUp</span> |\r\n                <span (click)=\"sharePostlogin();\" class=\"\">Login</span>\r\n            </div>\r\n        <div class=\"item\" *ngFor=\"let item of posts; let i = index\" style=\"background: white;display:inline-block;width:100%;border:solid 1px #efefef\">\r\n            <div class=\"col-xs-12 col-sm-7 zero_padding\">\r\n                <!--<img class=\"img-responsive\" src=\"https://igcdn-photos-f-a.akamaihd.net/hphotos-ak-xpt1/t51.2885-15/e15/10809778_786506061406485_132431944_n.jpg?ig_cache_key=ODY1OTk3NTk4NzU0MjE4NDY5.2\"\r\n                    alt=\"...\">-->\r\n                    <img class=\"img-responsive col-xs-12 zero_padding\" id=\"\" (click)=\"falseusertagged(i);\" (dblclick)=\"likedoubleClick(item.postId, item.postsType,i);\" *ngIf=\"item.postsType==0\" src=\"{{item.mainUrl}}\">\r\n                    <div class=\"doubleclick_heart\" *ngIf=\"item.likeheartFlagg==true\"> \r\n                        <span class=\"double_click_heart like_icon\"></span>\r\n                    </div>\r\n                    <video class=\"img-responsive col-xs-12 zero_padding\" (click)=\"falseusertagged(i);\" *ngIf=\"item.postsType==1\" controls>\r\n                        <source src=\"{{item.mainUrl}}\" type=\"video/mp4\">\r\n                        <source src=\"{{item.mainUrl}}\" type=\"video/ogg\"> \r\n                    </video>\r\n\r\n                <div class=\"pico_contentdetails_tagged col-xs-12\">\r\n\t\t\t\t\t<div *ngIf=\"item.usertaggedFlagg==true\">\r\n\t\t\t\t\t\t<span *ngFor=\"let tagged of item.coords;\">\r\n\t\t\t\t\t\t\t<span class=\"tagg_color_name tagg_color\" (click)=\"usertaggedname(tagged);\"  [ngStyle]=\"{'margin-left': tagged.right+'%', 'margin-top': '-'+tagged.top+'%'}\">\t\t\t\t\t\t\t\t\t\t\t\t\t\t\r\n\t\t\t\t\t\t\t\t<div class=\"tagg_arrowicon\"></div>\r\n\t\t\t\t\t\t\t\t{{tagged.name}}\t\t\t\t\t\t\t\t\t\t\t\t\t\t\r\n\t\t\t\t\t\t\t</span>\r\n\t\t\t\t\t\t</span>\r\n\t\t\t\t\t</div>\r\n\t\t\t\t\t<div class=\"\" *ngFor=\"let tagged of item.coords;\">\t\t\t\t\t\t\r\n\t\t\t\t\t\t<i class=\"usertag_icon tagged_icon\" (click)=\"usertagged(i);\"></i>\t\t\t\t\t\t\t\t\t\t\r\n\t\t\t\t\t</div>\r\n\t\t\t\t</div>\r\n            </div>\r\n            <div class=\"col-xs-12 col-sm-5 zero_padding comment_text\" style=\"border-left:solid 1px #efefef;\">\r\n\r\n                <div class=\"follow_details col-xs-12 zero_padding\" *ngIf=\"sharePost\">\r\n                    <span class=\"col-xs-2 col-sm-2 col-md-1 zero_padding\"><img class=\"suggestion_image member_name\" (click)=\"sharePostlogin()\" src=\"{{item.memberProfilePicUrl}}\" onError=\"this.src='/public/images/default.png';\"></span>\r\n                    <span class=\"col-xs-4 col-sm-5 col-md-6 zero_padding slider_img\">\r\n                        <h5 class=\"follow_name col-xs-12 zero_padding\"><span class=\"color_thick member_name\" (click)=\"sharePostlogin()\">{{item.membername}}</span></h5>\r\n                        <h6 class=\"follow_name col-xs-12 zero_padding color_thick color_opacity\" style=\"\">{{item.memberfullName}}</h6>\t\t\t\r\n                    </span>\r\n                    <span class=\"bufferhomepost_gif\" *ngIf=\"buffer\"><img src=\"/public/images/ajax-loader2.gif\" alt=\"loader\"></span>\r\n                    <div *ngIf=\"name != username\">\r\n                    <span class=\"col-xs-5 col-sm-4 zero_padding\" (click)=\"sharePostlogin();\" style=\"\"><button class=\"follow_button\" style=\"font-size:14px;\">Follow</button></span>\r\n                    <!--<span class=\"col-xs-5 col-sm-4 zero_padding\" *ngIf=\"data.userFollowRequestStatus==0\" (click)=\"followfllag(name);\" style=\"\"><button class=\"follow_button\" style=\"font-size:14px;background-color:gray;border:1px solid gray;color:white;\">Requested</button></span>\r\n                    <span class=\"col-xs-5 col-sm-4 zero_padding\" *ngIf=\"data.userFollowRequestStatus==1\" (click)=\"followfllag(name);\" style=\"\"><button class=\"follow_buttonn folow\" style=\"margin-top:0px;font-size:14px;\">Following</button></span>-->\r\n                    </div>\r\n                </div>\r\n\r\n                <div class=\"follow_details col-xs-12 zero_padding\" *ngIf=\"data\">\r\n                    <span class=\"col-xs-2 col-sm-2 col-md-1 zero_padding\"><img class=\"suggestion_image member_name\" (click)=\"memberprofile()\" src=\"{{data.profilePicUrl}}\" onError=\"this.src='/public/images/default.png';\"></span>\r\n                    <span class=\"col-xs-4 col-sm-5 col-md-6 zero_padding slider_img\">\r\n                        <h5 class=\"follow_name col-xs-12 zero_padding\"><span class=\"color_thick member_name\" (click)=\"memberprofile()\">{{name}}</span></h5>\r\n                        <h6 class=\"follow_name col-xs-12 zero_padding color_thick color_opacity\" style=\"\">{{data.fullName}}</h6>\t\t\t\r\n                    </span>\r\n                    <span class=\"bufferhomepost_gif\" *ngIf=\"buffer\"><img src=\"/public/images/ajax-loader2.gif\" alt=\"loader\"></span>\r\n                    <div *ngIf=\"name != username\">\r\n                    <span class=\"col-xs-5 col-sm-4 zero_padding\" *ngIf=\"data.userFollowRequestStatus==null\" (click)=\"followingfllag(name);\" style=\"\"><button class=\"follow_button\" style=\"font-size:14px;\">Follow</button></span>\r\n                    <span class=\"col-xs-5 col-sm-4 zero_padding\" *ngIf=\"data.userFollowRequestStatus==0\" (click)=\"followfllag(name);\" style=\"\"><button class=\"follow_button\" style=\"font-size:14px;background-color:gray;border:1px solid gray;color:white;\">Requested</button></span>\r\n                    <span class=\"col-xs-5 col-sm-4 zero_padding\" *ngIf=\"data.userFollowRequestStatus==1\" (click)=\"followfllag(name);\" style=\"\"><button class=\"follow_buttonn folow\" style=\"margin-top:0px;font-size:14px;\">Following</button></span>\r\n                    </div>\r\n                </div>\r\n                <div class=\"pico_contentdetails_comment\" style=\"padding: 0% 0% 0% 5%;display: inline-block;width: 100%;\">\r\n                    <div class=\"col-xs-12 zero_padding\" style=\"margin: 2% 0%;\">\r\n                        <span class=\"col-xs-10 zero_padding\" *ngIf=\"item.postLikedBy.length < 6\">\r\n                            <div *ngIf=\"item.postLikedBy\">\r\n                                <span *ngFor=\"let liked of item.postLikedBy; let i = index;\">\r\n                                    <span *ngIf=\"liked != 'null'\">\r\n                                        <span *ngIf=\"i != 0\" class=\"comma_moveleftside\">,</span>\r\n                                        <span class=\"add_liked color_thick member_name\" (click)=\"likeStatus(liked)\" id=\"likecontent\">{{liked}}</span>\r\n                                    </span>\r\n                                </span>\r\n                                <span class=\"color_opacity\" *ngIf=\"item.postLikedBy.length > 1 || item.likeStatus==1\" style=\"font-size:14px;\">like this</span>\r\n                            </div>\r\n                        </span>\r\n                        <span class=\"col-xs-10 zero_padding\" *ngIf=\"item.postLikedBy.length > 6\"><span class=\"add_like color_thick\" id=\"like1content\" style=\"margin-right: 5%;\">{{item.likes}}</span><span class=\"color_thick\">likes</span></span>\r\n                        <span class=\"col-xs-2 color_thick color_opacity zero_padding member_name\" (click)=\"timepost(item)\" style=\"color: #999;text-align:right;width: 10%;\">{{item.postedOn}}</span>\r\n                    </div>\r\n                    <ul class=\"comment_list carousel_comment zero_padding col-xs-12\">\r\n                        <!--<li class=\"listcomment zero_padding col-xs-12\">\r\n                            <span class=\"name_comment\" style=\"\"><span class=\"color_thick\" style=\"\" *ngIf=\"item.postCaption !='null'\">{{item.postCaption}}</span></span>\r\n                            \r\n                        </li>-->\r\n                        <li class=\"listcomment zero_padding col-xs-12\" >\r\n                            <span class=\"color_thick member_name\" *ngIf=\"item.postCaption !='null'\" id=\"{{item.postsId}}\">{{name}}</span>\r\n                            <span class=\"name_comment\" style=\"\" *ngFor=\"let caption of item.postCaption;\">\r\n                                <span *ngIf=\"caption != 'null'\">\r\n                                    <span class=\"color_thick color_opacity member_name\" id=\"{{item.postsId}}\" *ngIf=\"caption.charAt(0) != '#' && caption.charAt(0) != '@'\">{{caption}}</span>\t\t\t\t\t\t\t\t\t\t\t\t\t\r\n                                    <span class=\"color_thick member_name\" id=\"{{item.postsId}}\"  (click)=\"membercaption(caption)\" style=\"color:#003569;\" *ngIf=\"caption.charAt(0) == '#'\">{{caption}}</span>\r\n                                    <span class=\"color_thick member_name\" id=\"{{item.postsId}}\" (click)=\"memberprofilecaptionn(caption)\" style=\"color:#003569;\" *ngIf=\"caption.charAt(0) == '@'\">{{caption}}</span> \r\n                                    \r\n                                </span>\r\n                            </span>\r\n                        </li>\r\n                        <li class=\"listcomment zero_padding col-xs-12\" *ngFor=\"let comment of item.commentData;\">\r\n                            <span class=\"name_comment\" style=\"\"><span class=\"color_thick member_name\" data-dismiss=\"modal\" (click)=\"memberprofilee(comment)\" style=\"\">{{comment.commentedByUser}}</span></span>\r\n                            <span class=\"name_comment1 color_thick color_opacity\" style=\"\" [innerHTML]=\"comment.commentBody\"></span>\t\t\t\t\t\t\t\r\n                            <span class=\"name_comment1 color_thick color_opacity member_name delete_comment\" style=\"\" data-toggle=\"modal\" data-target=\"#myModal_delete\" (click)=\"commentdelete(comment, item.postId, item.postsType,i)\" *ngIf=\"comment.commentedByUser == username\">X</span>\r\n                        </li>                    \r\n                    </ul>\r\n                    <span class=\"col-xs-11\" style=\"background:#efefef;height:1px;margin: 5px 0px 5px 0px\"></span>\r\n                </div>\r\n                \r\n                <div class=\"add_comment col-xs-12 modal_comment_carousel\" style=\"padding: 5px 20px;\">\r\n                    <i class=\"comment_icon comment_heart_icon add_heart_icon\" *ngIf=\"item.likeStatus!=1\" (click)=\"likeactive(item.postId, item.postsType,i)\" id=\"{{item.postId}}\"></i>\r\n                    <i class=\"comment_icon comment_heart_icon add_heart_icon active\" *ngIf=\"item.likeStatus==1\" (click)=\"likedeactive(item.postId, item.postsType,i)\" id=\"{{item.postId}}\"></i>\r\n                    <input type=\"text\" #input (keyup.enter)=\"usercommentSubmit(input.value, item.postId, item.postsType, i); input.value=''\" name=\"message\" placeholder=\"Add a comment\"\r\n                    id=\"{{item.postId}}\" class=\"col-xs-12 comment_textbox\" style=\"font-size:14px;\">\r\n                    <i class=\"comment_icon comment_dotted_icon\" data-toggle=\"modal\" data-target=\"#myModall\"></i>\r\n                </div>\r\n\r\n                <!-- popup modal -->\r\n\t\t\t<div class=\"modal fade\" id=\"myModall\" role=\"dialog\">\r\n\t\t\t\t<div class=\"modal-dialog modal-md\">\r\n\t\t\t\t\t<div class=\"modal-content\">\r\n\t\t\t\t\t\t<div class=\"modal-body\" style=\"\">\r\n\t\t\t\t\t\t\t<span class=\"report_cancel col-xs-12\">Report inappropriate</span>\r\n\t\t\t\t\t\t\t<!--<span class=\"report_cancel col-xs-12\">Embed</span>-->\r\n\t\t\t\t\t\t\t<span class=\"report_cancel col-xs-12\" data-dismiss=\"modal\">Cancel</span>\r\n\t\t\t\t\t\t</div>\r\n\t\t\t\t\t</div>\r\n\t\t\t\t</div>\r\n\t\t\t</div>\r\n\t\t\t<!-- delete comment -->\r\n\t\t\t<div class=\"modal fade deletecomment\" id=\"myModal_delete\" role=\"dialog\">\r\n\t\t\t\t<div class=\"modal-dialog modal-md\">\r\n\t\t\t\t\t<div class=\"modal-content\">\r\n\t\t\t\t\t\t<div class=\"modal-body\" style=\"\">\r\n\t\t\t\t\t\t\t<span class=\"report_cancel col-xs-12 color_focus  member_name\" data-dismiss=\"modal\" (click)=\"commentmodaldelete()\">Delete Comment</span>\r\n\t\t\t\t\t\t\t<!--<span class=\"report_cancel col-xs-12\">Embed</span>-->\r\n\t\t\t\t\t\t\t<span class=\"report_cancel col-xs-12\" data-dismiss=\"modal\">Cancel</span>\r\n\t\t\t\t\t\t</div>\r\n\t\t\t\t\t</div>\r\n\t\t\t\t</div>\r\n\t\t\t</div>\r\n\t\t\t<!-- End popup modal -->\r\n\r\n            </div>\r\n        </div>\r\n    </div>\r\n    </div>\r\n</div>\r\n\r\n</html>";

/***/ },

/***/ 498:
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var core_1 = __webpack_require__(5);
	var discoverpost_service_1 = __webpack_require__(499);
	var router_1 = __webpack_require__(389);
	var DiscoverpostComponent = (function () {
	    // private buffer = false;
	    function DiscoverpostComponent(_discoverService, _router) {
	        this._discoverService = _discoverService;
	        this._router = _router;
	        this.loading = true;
	        this.offset = 0;
	    }
	    DiscoverpostComponent.prototype.ngOnInit = function () {
	        var _this = this;
	        var token = localStorage.getItem('authToken');
	        if (!token)
	            this._router.navigate(["login"]);
	        this._discoverService.discoverpeople()
	            .subscribe(function (res) {
	            _this.data = res.discoverData;
	            if (_this.data) {
	                _this.offset = _this.data.length;
	            }
	            _this.loading = false;
	            if (_this.offset >= 20)
	                _this.loadmoree = true;
	        });
	    };
	    DiscoverpostComponent.prototype.loadmore = function () {
	        var _this = this;
	        this.offset = this.data.length;
	        //console.log(this.offset);
	        this._discoverService.loadmore(this.offset)
	            .subscribe(function (res) {
	            var len = res.discoverData.length;
	            for (var i = 0; i < len; i++) {
	                _this.data.push(res.discoverData[i]);
	            }
	            _this.offset = res.discoverData.length || 0;
	            if (_this.offset >= 20)
	                _this.loadmoree = true;
	            else
	                _this.loadmoree = false;
	        });
	    };
	    DiscoverpostComponent.prototype.memberprofile = function (username) {
	        // alert(item.postsId);
	        var personname = username.toLowerCase();
	        var currentusername = localStorage.getItem('username');
	        if (currentusername == personname) {
	            this._router.navigate(['home/profile']);
	        }
	        else {
	            var link = ['home/person', personname];
	            this._router.navigate(link);
	        }
	        // let link = ['home/person', username.toLowerCase()];
	        // this._router.navigate(link);
	    };
	    DiscoverpostComponent.prototype.following = function (username, i) {
	        var _this = this;
	        // alert(i+'ll'+username+'ff'+followFlag);
	        //  this.buffer = true;
	        var privateProfile = this.data[i].privateProfile;
	        // //console.log(privateProfile);
	        if (privateProfile == 1) {
	            this.data[i].loaderFlag = true;
	            setTimeout(function () {
	                _this.data[i].followsFlag = 2;
	            }, 500);
	            this._discoverService.following(username)
	                .subscribe();
	            setTimeout(function () {
	                _this.data[i].loaderFlag = false;
	            }, 500);
	        }
	        else {
	            this.data[i].loaderFlag = true;
	            setTimeout(function () {
	                _this.data[i].followsFlag = 1;
	            }, 500);
	            this._discoverService.following(username)
	                .subscribe();
	            setTimeout(function () {
	                _this.data[i].loaderFlag = false;
	            }, 500);
	        }
	    };
	    DiscoverpostComponent.prototype.follow = function (username, i) {
	        var _this = this;
	        this.data[i].loaderFlag = true;
	        setTimeout(function () {
	            _this.data[i].followsFlag = 0;
	        }, 500);
	        this._discoverService.follow(username)
	            .subscribe();
	        setTimeout(function () {
	            _this.data[i].loaderFlag = false;
	        }, 500);
	    };
	    DiscoverpostComponent = __decorate([
	        core_1.Component({
	            selector: 'discover',
	            template: __webpack_require__(500),
	            providers: [discoverpost_service_1.DiscoverpostService]
	        }), 
	        __metadata('design:paramtypes', [discoverpost_service_1.DiscoverpostService, router_1.Router])
	    ], DiscoverpostComponent);
	    return DiscoverpostComponent;
	}());
	exports.DiscoverpostComponent = DiscoverpostComponent;


/***/ },

/***/ 499:
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var core_1 = __webpack_require__(5);
	var router_1 = __webpack_require__(389);
	var app_constants_1 = __webpack_require__(441);
	var http_1 = __webpack_require__(363);
	var DiscoverpostService = (function () {
	    function DiscoverpostService(_router, _http, _conf) {
	        this._router = _router;
	        this._http = _http;
	        this._conf = _conf;
	    }
	    DiscoverpostService.prototype.discoverpeople = function () {
	        var token = localStorage.getItem('authToken');
	        var body = { token: token };
	        //console.log(body);
	        return this._http.post(this._conf.Url + 'discover-people-website', body, { headers: this._conf.headers })
	            .map(function (res) { return res.json(); })
	            .map(function (res) {
	            //console.log(res);
	            // if (res.token) {
	            //     localStorage.setItem('user', res.token);S
	            //     // this._router.navigate(['Pages']);
	            //     return res.code;
	            // }
	            return res;
	        });
	    };
	    DiscoverpostService.prototype.loadmore = function (offset) {
	        var token = localStorage.getItem('authToken');
	        var body = {
	            token: token,
	            offset: offset
	        };
	        //console.log(body);
	        return this._http.post(this._conf.Url + 'discover-people-website', body, { headers: this._conf.headers })
	            .map(function (res) { return res.json(); })
	            .map(function (res) {
	            //console.log(res);
	            // if (res.token) {
	            //     localStorage.setItem('user', res.token);S
	            //     // this._router.navigate(['Pages']);
	            //     return res.code;
	            // }
	            return res;
	        });
	    };
	    DiscoverpostService.prototype.following = function (username) {
	        var token = localStorage.getItem('authToken');
	        var body = {
	            token: token,
	            userNameToFollow: username
	        };
	        //console.log(body);
	        return this._http.post(this._conf.Url + 'follow', body, { headers: this._conf.headers })
	            .map(function (res) { return res.json(); })
	            .map(function (res) {
	            //console.log(res);
	            // if (res.token) {
	            //     localStorage.setItem('user', res.token);S
	            //     // this._router.navigate(['Pages']);
	            //     return res.code;
	            // }
	            return res;
	        });
	    };
	    DiscoverpostService.prototype.follow = function (username) {
	        var token = localStorage.getItem('authToken');
	        var body = {
	            token: token,
	            unfollowUserName: username
	        };
	        //console.log(body);
	        return this._http.post(this._conf.Url + 'unfollow', body, { headers: this._conf.headers })
	            .map(function (res) { return res.json(); })
	            .map(function (res) {
	            //console.log(res);
	            // if (res.token) {
	            //     localStorage.setItem('user', res.token);S
	            //     // this._router.navigate(['Pages']);
	            //     return res.code;
	            // }
	            return res;
	        });
	    };
	    DiscoverpostService = __decorate([
	        core_1.Injectable(), 
	        __metadata('design:paramtypes', [router_1.Router, http_1.Http, app_constants_1.Configuration])
	    ], DiscoverpostService);
	    return DiscoverpostService;
	}());
	exports.DiscoverpostService = DiscoverpostService;


/***/ },

/***/ 500:
/***/ function(module, exports) {

	module.exports = "<!DOCTYPE html>\r\n<html>\r\n<head>\r\n\t<title>Sportemage</title>\r\n    <!-- <link rel=\"icon\" type=\"image/gif/png\" href=\"/public/images/picoTitleLogo.png\"> -->\r\n</head>\r\n\r\n<div class=\"loader\" *ngIf=\"loading\"></div>\r\n\r\n<div class=\"container-fluid picogram_total\" *ngIf=\"data\">\r\n\t<div class=\"container pico_content_total\" *ngIf=\"data.length != 0\" style=\"border: solid 1px #efefef;margin: 4% auto;padding: 0%;\">\r\n\t\t<div class=\"col-xs-12 zero_padding\" style=\"text-align:center;margin-bottom:10%;margin-top:2%;\">\r\n            <span class=\"emptydiscover homediscover_icon\"></span>\r\n            <h4 class=\"\"> Welcome to Sportemage! </h4>\r\n\t\t\t<h5 class=\" color_opacity\">Follow accounts to see photos and videos in your feed.</h5>\r\n        </div>\r\n\t\t<div class=\"follow_details suggestion zero_padding col-xs-12\" style=\"padding: 2% 5%;\">\r\n\t\t\t<h2 class=\"for_u_suggestion zero_padding col-xs-12\">SUGGESTIONS FOR YOU</h2>\r\n\t\t</div>\r\n\r\n\t\t<div class=\"pico_contentdetails zero_padding col-xs-12\" *ngFor=\"let item of data; let i = index\" style=\"margin-bottom:1%;padding: 16px 20px;border-bottom: solid 1px #efefef;\">\r\n\t\t\t<div class=\"pico_contentdetailss_name follow_details zero_padding col-xs-12\" style=\"padding: 1% 0%;border:0;\">\r\n\t\t\t\t<span class=\"follow_detailss col-xs-2 col-sm-1 zero_padding\"><img class=\"suggestion_image member_name\" (click)=\"memberprofile(item.postedByUserName)\" src=\"{{item.profilePicUrl}}\" onError=\"this.src='/public/images/default.png';\" style=\"margin-bottom:10%;\" style=\"margin-bottom:10%;\"></span>\r\n\t\t\t\t<span class=\"col-xs-8 col-sm-9 zero_padding\">\r\n\t\t\t\t\t<h5 class=\"follow_name1 zero_padding col-xs-12 color_thick\" style=\"\"><a class=\"color_thick member_name\" (click)=\"memberprofile(item.postedByUserName)\" id=\"{{item.postsId}}\">{{item.postedByUserName}}</a></h5>\r\n\t\t\t\t\t<h5 class=\"follow_name1 col-xs-12 zero_padding color_thick color_opacity\" style=\"\">{{item.postedByUserFullName}}</h5>\r\n\t\t\t\t</span>\r\n\t\t\t\t<span class=\"bufferdiscover_gif\"  *ngIf=\"item.loaderFlag==true\" id=\"{{i}}\"><img src=\"/public/images/ajax-loader2.gif\" alt=\"loader\"></span>\r\n\t\t\t\t<span class=\"col-xs-2 col-sm-2 zero_padding\" *ngIf=\"item.followsFlag==0\" (click)=\"following(item.postedByUserName, i);\" style=\"text-align:right;\"><button class=\"follow_button\" style=\"line-height: 25px;font-size:14px;\">Follow</button></span>\t\t\t\t\r\n\t\t\t\t<span class=\"col-xs-2 col-sm-2 zero_padding\" *ngIf=\"item.followsFlag==2\" (click)=\"follow(item.postedByUserName, i);\" style=\"text-align:right;\"><button class=\"folllow_button folow\" style=\"margin-top:0px;padding: 0%;line-height: 25px;font-size:14px;background-color:gray;border:1px solid gray;\">Requested</button></span>\t\r\n\t\t\t\t<span class=\"col-xs-2 col-sm-2 zero_padding\" *ngIf=\"item.followsFlag==1\" (click)=\"follow(item.postedByUserName, i);\" style=\"text-align:right;\"><button class=\"folllow_button folow\" style=\"margin-top:0px;padding: 0%;line-height: 25px;font-size:14px;\">Following</button></span>\r\n\t\t\t</div>\r\n\t\t\t<!--<h1>{{item.likes}}  hi</h1>-->\r\n\t\t\t<div class=\"discover_image zero_padding col-xs-12 upload_photo\" *ngIf=\"item.privateProfile != 1\">\r\n\t\t\t\t<span class=\" profile_person_img zero_padding col-xs-4\" style=\"margin-right:1%;\" *ngFor=\"let user of item.postData\">\r\n\t\t\t\t\t<!--<img class=\"uploadphoto \" id=\" \" src=\"{{user.mainUrl}} \" style=\"width:192px;height:192px;\">-->\r\n\t\t\t\t\t<img class=\"uploadphoto\" id=\"\" *ngIf=\"user.postsType==0\" src=\"{{user.mainUrl}}\">\r\n\t\t\t\t\t<!--<img class=\"uploadphoto\" id=\"\" *ngIf=\"user.postType==1\" src=\"{{user.mainUrl}}\" style=\"width:192px;height:192px;\">-->\r\n\t\t\t\t\t<span class=\"videotag_img video_tag\" *ngIf=\"user.postsType==1\"></span>\r\n\t\t\t\t\t<video class=\"uploadphoto\" *ngIf=\"user.postsType==1\" controls>\r\n\t\t\t\t\t\t<source src=\"{{user.mainUrl}}\" type=\"video/mp4\">\r\n\t\t\t\t\t\t<source src=\"{{user.mainUrl}}\" type=\"video/ogg\"> \r\n\t\t\t\t\t</video>\r\n\t\t\t\t</span>\r\n\t\t\t\t<!--<span class=\"profile_person_img zero_padding up_profile col-xs-4 \"><img class=\"uploadphoto \" id=\" \" src=\"https://igcdn-photos-g-a.akamaihd.net/hphotos-ak-xpl1/t51.2885-15/s640x640/sh0.08/e35/13531872_293684160978438_326868190_n.jpg?ig_cache_key=MTI4MTI0OTE5NDcwMjYyMDA3Ng%3D%3D.2 \"></span>\r\n\t\t\t\t<span class=\"profile_person_img zero_padding col-xs-4 \"><img class=\"uploadphoto \" id=\" \" src=\"https://igcdn-photos-h-a.akamaihd.net/hphotos-ak-xaf1/t51.2885-15/s640x640/sh0.08/e35/13414121_1722211758027439_1626159635_n.jpg?ig_cache_key=MTI4MDYyOTE3MzU1MDg3NzkwMw%3D%3D.2 \"></span>-->\r\n\t\t\t   <!--<span class=\" profile_person_img zero_padding col-xs-4\" style=\"margin-right:1%;\" *ngIf=\"!item.postData\">\r\n\t\t\t  <h2>no post</h2>\r\n\t\t\t   </span>-->\r\n\t\t\t</div>\r\n\t\t\t<div class=\"discover_image zero_padding col-xs-12 upload_photo\" *ngIf=\"item.privateProfile == 1\" style=\"text-align:center;margin: 5% 0%;\">\r\n\t\t\t\t<h4 style=\"margin-bottom:2%;\">This Account is Private</h4>\r\n\t\t\t\t<h5>Follow to see their photos and videos</h5>\r\n\t\t\t</div>\r\n\t\t\t\r\n\t\t</div>\t\r\n\t</div>\r\n\t<div class=\"col-xs-12 loader_moreDetails\" [hidden]=\"!loadmoree\">\r\n\t\t<div class=\"loadmoreRound\" (click)=\"loadmore();\">\r\n\t\t\t<span class=\"loadmore_click\">loadmore</span>\r\n\t\t</div>\r\n\t</div>\r\n\t<!--<div class=\"zero_padding col-xs-12 loadmore\" (click)=\"loadmore();\" [hidden]=\"!loadmoree\" style=\"cursor:pointer;text-align:center;height: 120px;width: 120px;margin-left: 40%;border: 2px solid #3897f0;border-radius: 50%;\">\r\n\t\t<span class=\"loadmore_click\" style=\"font-size: 14px;position: absolute;top: 40%;left: 28%;color: #3897f0;\">loadmore</span>\r\n\t</div>-->\r\n\t<!--<div class=\"container pico_content_total \" *ngIf=\"data.length == 0 || !data && !loading\" style=\"text-align:center; \">\t\r\n\t\t<h4 style=\"margin-top:20%;\">No posts yet.</h4>\r\n\t</div>-->\r\n\t<div class=\"\" *ngIf=\"data\">\r\n\t\t<div class=\"container pico_content_total\" *ngIf=\"data.length == 0 || !data && !loading\" style=\"text-align:center; \">\t\t\r\n\t\t\t<h4 style=\"margin-top:20%;\">No posts yet.</h4>\r\n\t\t</div>\r\n\t</div>\r\n</div>\r\n\r\n\r\n\r\n</html>";

/***/ },

/***/ 501:
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var core_1 = __webpack_require__(5);
	var discover_service_1 = __webpack_require__(502);
	var router_1 = __webpack_require__(389);
	var DiscoverComponent = (function () {
	    // private buffer = false;
	    function DiscoverComponent(_discoverService, _router) {
	        this._discoverService = _discoverService;
	        this._router = _router;
	        this.loading = true;
	        this.data = [];
	        this.offset = 0;
	    }
	    DiscoverComponent.prototype.ngOnInit = function () {
	        var _this = this;
	        var token = localStorage.getItem('authToken');
	        if (!token)
	            this._router.navigate(["login"]);
	        this._discoverService.discoverpeople()
	            .subscribe(function (res) {
	            _this.data = res.discoverData;
	            _this.offset = _this.data.length;
	            _this.loading = false;
	            if (_this.offset >= 20)
	                _this.loadmoree = true;
	        });
	    };
	    DiscoverComponent.prototype.loadmore = function () {
	        var _this = this;
	        this.offset = this.data.length;
	        //console.log(this.offset);
	        this._discoverService.loadmore(this.offset)
	            .subscribe(function (res) {
	            var len = res.discoverData.length;
	            for (var i = 0; i < len; i++) {
	                _this.data.push(res.discoverData[i]);
	            }
	            _this.offset = res.discoverData.length || 0;
	            if (_this.offset >= 20)
	                _this.loadmoree = true;
	            else
	                _this.loadmoree = false;
	        });
	    };
	    DiscoverComponent.prototype.memberprofile = function (username) {
	        // alert(item.postsId);
	        var personname = username.toLowerCase();
	        var currentusername = localStorage.getItem('username');
	        if (currentusername == personname) {
	            this._router.navigate(['home/profile']);
	        }
	        else {
	            var link = ['home/person', personname];
	            this._router.navigate(link);
	        }
	        // let link = ['home/person', username.toLowerCase()];
	        // this._router.navigate(link);
	    };
	    DiscoverComponent.prototype.following = function (username, i) {
	        var _this = this;
	        // alert(i+'ll'+username+'ff'+followFlag);
	        //  this.buffer = true;
	        var privateProfile = this.data[i].privateProfile;
	        // //console.log(privateProfile);
	        if (privateProfile == 1) {
	            this.data[i].loaderFlag = true;
	            setTimeout(function () {
	                _this.data[i].followsFlag = 2;
	            }, 500);
	            this._discoverService.following(username)
	                .subscribe();
	            setTimeout(function () {
	                _this.data[i].loaderFlag = false;
	            }, 500);
	        }
	        else {
	            this.data[i].loaderFlag = true;
	            setTimeout(function () {
	                _this.data[i].followsFlag = 1;
	            }, 500);
	            this._discoverService.following(username)
	                .subscribe();
	            setTimeout(function () {
	                _this.data[i].loaderFlag = false;
	            }, 500);
	        }
	    };
	    DiscoverComponent.prototype.follow = function (username, i) {
	        var _this = this;
	        this.data[i].loaderFlag = true;
	        setTimeout(function () {
	            _this.data[i].followsFlag = 0;
	        }, 500);
	        this._discoverService.follow(username)
	            .subscribe();
	        setTimeout(function () {
	            _this.data[i].loaderFlag = false;
	        }, 500);
	    };
	    DiscoverComponent = __decorate([
	        core_1.Component({
	            selector: 'discover',
	            template: __webpack_require__(503),
	            providers: [discover_service_1.DiscoverpeopleService]
	        }), 
	        __metadata('design:paramtypes', [discover_service_1.DiscoverpeopleService, router_1.Router])
	    ], DiscoverComponent);
	    return DiscoverComponent;
	}());
	exports.DiscoverComponent = DiscoverComponent;


/***/ },

/***/ 502:
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var core_1 = __webpack_require__(5);
	var router_1 = __webpack_require__(389);
	var app_constants_1 = __webpack_require__(441);
	var http_1 = __webpack_require__(363);
	var DiscoverpeopleService = (function () {
	    function DiscoverpeopleService(_router, _http, _conf) {
	        this._router = _router;
	        this._http = _http;
	        this._conf = _conf;
	    }
	    DiscoverpeopleService.prototype.discoverpeople = function () {
	        var token = localStorage.getItem('authToken');
	        var body = { token: token };
	        //console.log(body);
	        return this._http.post(this._conf.Url + 'discover-people-website', body, { headers: this._conf.headers })
	            .map(function (res) { return res.json(); })
	            .map(function (res) {
	            //console.log(res);
	            // if (res.token) {
	            //     localStorage.setItem('user', res.token);S
	            //     // this._router.navigate(['Pages']);
	            //     return res.code;
	            // }
	            return res;
	        });
	    };
	    DiscoverpeopleService.prototype.loadmore = function (offset) {
	        var token = localStorage.getItem('authToken');
	        var body = {
	            token: token,
	            offset: offset
	        };
	        //console.log(body);
	        return this._http.post(this._conf.Url + 'discover-people-website', body, { headers: this._conf.headers })
	            .map(function (res) { return res.json(); })
	            .map(function (res) {
	            //console.log(res);
	            // if (res.token) {
	            //     localStorage.setItem('user', res.token);S
	            //     // this._router.navigate(['Pages']);
	            //     return res.code;
	            // }
	            return res;
	        });
	    };
	    DiscoverpeopleService.prototype.following = function (username) {
	        var token = localStorage.getItem('authToken');
	        var body = {
	            token: token,
	            userNameToFollow: username
	        };
	        //console.log(body);
	        return this._http.post(this._conf.Url + 'follow', body, { headers: this._conf.headers })
	            .map(function (res) { return res.json(); })
	            .map(function (res) {
	            //console.log(res);
	            // if (res.token) {
	            //     localStorage.setItem('user', res.token);S
	            //     // this._router.navigate(['Pages']);
	            //     return res.code;
	            // }
	            return res;
	        });
	    };
	    DiscoverpeopleService.prototype.follow = function (username) {
	        var token = localStorage.getItem('authToken');
	        var body = {
	            token: token,
	            unfollowUserName: username
	        };
	        //console.log(body);
	        return this._http.post(this._conf.Url + 'unfollow', body, { headers: this._conf.headers })
	            .map(function (res) { return res.json(); })
	            .map(function (res) {
	            //console.log(res);
	            // if (res.token) {
	            //     localStorage.setItem('user', res.token);S
	            //     // this._router.navigate(['Pages']);
	            //     return res.code;
	            // }
	            return res;
	        });
	    };
	    DiscoverpeopleService = __decorate([
	        core_1.Injectable(), 
	        __metadata('design:paramtypes', [router_1.Router, http_1.Http, app_constants_1.Configuration])
	    ], DiscoverpeopleService);
	    return DiscoverpeopleService;
	}());
	exports.DiscoverpeopleService = DiscoverpeopleService;


/***/ },

/***/ 503:
/***/ function(module, exports) {

	module.exports = "<!DOCTYPE html>\r\n<html>\r\n<head>\r\n\t<title>Sportemage</title>\r\n    <!-- <link rel=\"icon\" type=\"image/gif/png\" href=\"/public/images/picoTitleLogo.png\"> -->\r\n</head>\r\n\r\n<div class=\"loader\" *ngIf=\"loading\"></div>\r\n\r\n<div class=\"container-fluid picogram_total\" *ngIf=\"data\">\r\n\t<div class=\"container pico_content_total\" *ngIf=\"data.length != 0\" style=\"border: solid 1px #efefef;margin: 4% auto;padding: 0%;\">\r\n\t\t<div class=\"follow_details suggestion zero_padding col-xs-12\" style=\"padding: 2% 5%;\">\r\n\t\t\t<h2 class=\"for_u_suggestion zero_padding col-xs-12\">DISCOVER PEOPLE</h2>\r\n\t\t</div>\r\n\r\n\t\t<div class=\"pico_contentdetails zero_padding col-xs-12\" *ngFor=\"let item of data; let i = index\" style=\"margin-bottom:1%;padding: 16px 20px;border-bottom: solid 1px #efefef;\">\r\n\t\t\t<div class=\"pico_contentdetailss_name follow_details zero_padding col-xs-12\" style=\"padding: 1% 0%;border:0;\">\r\n\t\t\t\t<span class=\"follow_detailss col-xs-2 col-sm-1 zero_padding\"><img class=\"suggestion_image member_name\" (click)=\"memberprofile(item.postedByUserName)\" src=\"{{item.profilePicUrl}}\" onError=\"this.src='/public/images/default.png';\" style=\"margin-bottom:10%;\" style=\"margin-bottom:10%;\"></span>\r\n\t\t\t\t<span class=\"col-xs-8 col-sm-9 zero_padding\">\r\n\t\t\t\t\t<h5 class=\"follow_name1 zero_padding col-xs-12 color_thick\" style=\"\"><a class=\"color_thick member_name\" (click)=\"memberprofile(item.postedByUserName)\" id=\"{{item.postsId}}\">{{item.postedByUserName}}</a></h5>\r\n\t\t\t\t\t<h5 class=\"follow_name1 col-xs-12 zero_padding color_thick color_opacity\" style=\"\">{{item.postedByUserFullName}}</h5>\r\n\t\t\t\t</span>\r\n\t\t\t\t<span class=\"bufferdiscover_gif\"  *ngIf=\"item.loaderFlag==true\" id=\"{{i}}\"><img src=\"/public/images/ajax-loader2.gif\" alt=\"loader\"></span>\r\n\t\t\t\t<span class=\"col-xs-2 col-sm-2 zero_padding\" *ngIf=\"item.followsFlag==0\" (click)=\"following(item.postedByUserName, i);\" style=\"text-align:right;\"><button class=\"follow_button\" style=\"line-height: 25px;font-size:14px;\">Follow</button></span>\t\t\t\t\r\n\t\t\t\t<span class=\"col-xs-2 col-sm-2 zero_padding\" *ngIf=\"item.followsFlag==2\" (click)=\"follow(item.postedByUserName, i);\" style=\"text-align:right;\"><button class=\"folllow_button folow\" style=\"margin-top:0px;padding: 0%;line-height: 25px;font-size:14px;background-color:gray;border:1px solid gray;\">Requested</button></span>\t\r\n\t\t\t\t<span class=\"col-xs-2 col-sm-2 zero_padding\" *ngIf=\"item.followsFlag==1\" (click)=\"follow(item.postedByUserName, i);\" style=\"text-align:right;\"><button class=\"folllow_button folow\" style=\"margin-top:0px;padding: 0%;line-height: 25px;font-size:14px;\">Following</button></span>\r\n\t\t\t</div>\r\n\t\t\t<!--<h1>{{item.likes}}  hi</h1>-->\r\n\t\t\t<div class=\"discover_image zero_padding col-xs-12 upload_photo\" *ngIf=\"item.privateProfile != 1\">\r\n\t\t\t\t<span class=\" profile_person_img zero_padding col-xs-4\" style=\"margin-right:1%;\" *ngFor=\"let user of item.postData\">\r\n\t\t\t\t\t<!--<img class=\"uploadphoto \" id=\" \" src=\"{{user.mainUrl}} \" style=\"width:192px;height:192px;\">-->\r\n\t\t\t\t\t<img class=\"uploadphoto\" id=\"\" *ngIf=\"user.postsType==0\" src=\"{{user.mainUrl}}\">\r\n\t\t\t\t\t<!--<img class=\"uploadphoto\" id=\"\" *ngIf=\"user.postType==1\" src=\"{{user.mainUrl}}\" style=\"width:192px;height:192px;\">-->\r\n\t\t\t\t\t<span class=\"videotag_img video_tag\" *ngIf=\"user.postsType==1\"></span>\r\n\t\t\t\t\t<video class=\"uploadphoto\" *ngIf=\"user.postsType==1\" controls>\r\n\t\t\t\t\t\t<source src=\"{{user.mainUrl}}\" type=\"video/mp4\">\r\n\t\t\t\t\t\t<source src=\"{{user.mainUrl}}\" type=\"video/ogg\"> \r\n\t\t\t\t\t</video>\r\n\t\t\t\t</span>\t\t\t\t\r\n\t\t\t\t<!--<span class=\"profile_person_img zero_padding up_profile col-xs-4 \"><img class=\"uploadphoto \" id=\" \" src=\"https://igcdn-photos-g-a.akamaihd.net/hphotos-ak-xpl1/t51.2885-15/s640x640/sh0.08/e35/13531872_293684160978438_326868190_n.jpg?ig_cache_key=MTI4MTI0OTE5NDcwMjYyMDA3Ng%3D%3D.2 \"></span>\r\n\t\t\t\t<span class=\"profile_person_img zero_padding col-xs-4 \"><img class=\"uploadphoto \" id=\" \" src=\"https://igcdn-photos-h-a.akamaihd.net/hphotos-ak-xaf1/t51.2885-15/s640x640/sh0.08/e35/13414121_1722211758027439_1626159635_n.jpg?ig_cache_key=MTI4MDYyOTE3MzU1MDg3NzkwMw%3D%3D.2 \"></span>-->\r\n\t\t\t   <!--<span class=\" profile_person_img zero_padding col-xs-4\" style=\"margin-right:1%;\" *ngIf=\"!item.postData\">\r\n\t\t\t  <h2>no post</h2>\r\n\t\t\t   </span>-->\r\n\t\t\t</div>\r\n\t\t\t<div class=\"discover_image zero_padding col-xs-12 upload_photo\" *ngIf=\"item.privateProfile == 1\" style=\"text-align:center;margin: 5% 0%;\">\r\n\t\t\t\t<h4 style=\"margin-bottom:2%;\">This Account is Private</h4>\r\n\t\t\t\t<h5>Follow to see their photos and videos</h5>\r\n\t\t\t</div>\r\n\t\t\t\r\n\t\t</div>\r\n\t</div>\r\n\t<div class=\"col-xs-12 loader_moreDetails\" [hidden]=\"!loadmoree\">\r\n\t\t<div class=\"loadmoreRound\" (click)=\"loadmore();\">\r\n\t\t\t<span class=\"loadmore_click\">loadmore</span>\r\n\t\t</div>\r\n\t</div>\r\n\t<!--<div class=\"zero_padding col-xs-12 loadmore\" (click)=\"loadmore();\" [hidden]=\"!loadmoree\" style=\"cursor:pointer;text-align:center;height: 120px;width: 120px;margin-left: 40%;border: 2px solid #3897f0;border-radius: 50%;\">\r\n\t\t<span class=\"loadmore_click\" style=\"font-size: 14px;position: absolute;top: 40%;left: 28%;color: #3897f0;\">loadmore</span>\r\n\t</div>-->\r\n\t<!--<div class=\"container pico_content_total \" *ngIf=\"data.length == 0 || !data && !loading\" style=\"text-align:center; \">\t\t\r\n\t\t<h4 style=\"margin-top:20%;\">No posts yet.</h4>\r\n\t</div>-->\r\n\t<div class=\"\" *ngIf=\"data || !data\">\r\n\t\t<div class=\"container pico_content_total\" *ngIf=\"data.length == 0 || !data && !loading\" style=\"text-align:center; \">\t\t\r\n\t\t\t<h4 style=\"margin-top:20%;\">No posts yet.</h4>\r\n\t\t</div>\r\n\t</div>\r\n</div>\r\n\r\n\r\n</html>";

/***/ },

/***/ 504:
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var core_1 = __webpack_require__(5);
	var profile_service_1 = __webpack_require__(505);
	var router_1 = __webpack_require__(389);
	var router_2 = __webpack_require__(389);
	var ProfileComponent = (function () {
	    function ProfileComponent(_profileService, _router) {
	        this._profileService = _profileService;
	        this._router = _router;
	        this.posts = [];
	        this.loading = true;
	        this.commnentdetails = [];
	        this.offset = 0;
	    }
	    ProfileComponent.prototype.ngOnInit = function () {
	        var _this = this;
	        jQuery(".modal-backdrop").css({ "display": "none" });
	        //  this.token = 'eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJuYW1lIjoia2FseWFuIiwiZW1haWwiOiJ2YW1zaUBnbWFpbC5jb20iLCJpYXQiOjE0NzAyOTg2MjcsImV4cCI6MTQ3NTQ4MjYyN30.ZYzOydphDJNr5EPeKNsDP0bxjFSAseyeo_yBBudaxz8';
	        var username = localStorage.getItem('username');
	        this.username = username;
	        var token = localStorage.getItem('authToken');
	        if (!token)
	            this._router.navigate(["login"]);
	        var username = localStorage.getItem('username');
	        this.userprofile_name = username;
	        this._profileService.profile()
	            .subscribe(function (res) {
	            if (res.code == 9200) {
	                var token = localStorage.removeItem('authToken');
	                var username = localStorage.removeItem('username');
	                _this._router.navigate(['login']);
	            }
	            _this.loading = false;
	            _this.data = res.memberProfileData[0];
	            /** bio add tag**/
	            var biotext = _this.data.bio;
	            if (biotext) {
	                var hashtag_regexp = /#([a-zA-Z0-9_]+)/g;
	                var bio_detail = biotext.replace(hashtag_regexp, '<a href="home/personcaption/$1" class="hashtag member_name biohashtag">#$1</a>');
	                // this.data.bio =bio_detail;
	                // var biotext1 = this.data.bio;
	                var hashtag_regexpp = /@([a-zA-Z0-9_]+)/g;
	                var bio_detaill = bio_detail.replace(hashtag_regexpp, '<a href="home/person/$1" class="hashtag member_name biohashtag">@$1</a>');
	            }
	            _this.data.bio = bio_detaill;
	            // this.posts = res.data[1];
	            _this.posts = [];
	            _this.totaldata = res.memberPostsData;
	            // var commenttext = res.memberPostsData.comments;               
	            _this.offset = res.memberPostsData.length;
	            _this.commentfunction();
	            // console.log(this.offset);
	            if (_this.offset >= 20)
	                _this.loadmoree = true;
	        });
	        this._profileService.userFollowing()
	            .subscribe(function (res) {
	            _this.data1 = res.result;
	            _this.loading = false;
	        });
	        this._profileService.userFollowers()
	            .subscribe(function (res) {
	            _this.data2 = res.followers;
	            _this.loading = false;
	        });
	        jQuery(document).keyup(function (e) {
	            if (e.keyCode == 27) {
	                jQuery(".modal").css({ "display": "none" });
	                jQuery(".modal-backdrop").css({ "display": "none" });
	            }
	        });
	    };
	    ProfileComponent.prototype.hashtagFunction = function () {
	        var len = this.totaldata.length;
	        for (var i = 0; i < len; i++) {
	            if (this.totaldata[i].commentData) {
	                var commenttext = this.totaldata[i].commentData;
	                for (var x = 0; x < commenttext.length; x++) {
	                    // commenttext.splice(x, 0);
	                    if (this.totaldata[i].commentData[x].commentBody) {
	                        var postCommentNodeArr1 = commenttext[x].commentBody;
	                        // console.log(postCommentNodeArr1);
	                        var hashtag_regexp = /#([a-zA-Z0-9_]+)/g;
	                        var comment_text = postCommentNodeArr1.replace(hashtag_regexp, '<a href="home/personcaption/$1" class="hashtag member_name biohashtag">#$1</a>');
	                        var hashtag_regexp1 = /@([a-zA-Z0-9_]+)/g;
	                        var comment_textt = comment_text.replace(hashtag_regexp1, '<a href="home/person/$1" class="hashtag member_name biohashtag">@$1</a>');
	                        this.totaldata[i].commentData[x].commentBody = comment_textt;
	                    }
	                }
	            }
	        }
	    };
	    ProfileComponent.prototype.commentfunction = function () {
	        this.hashtagFunction();
	        // alert("hi");
	        var len = this.totaldata.length;
	        // this.posts=[];
	        for (var i = 0; i < len; i++) {
	            // this.commentdata = [];
	            // if (this.totaldata[i].comments) {
	            //     var commenttext = this.totaldata[i].comments;
	            //     var hashtag_regexp = /#([a-zA-Z0-9]+)/g;                
	            //     var comment_text = commenttext.replace(
	            //         hashtag_regexp,
	            //         '<a href="home/personcaption/$1" class="hashtag member_name biohashtag">#$1</a>' 
	            //     );
	            //     var hashtag_regexp1 = /@([a-zA-Z0-9]+)/g;                
	            //     var comment_textt = comment_text.replace(
	            //         hashtag_regexp1,
	            //         '<a href="home/person/$1" class="hashtag member_name biohashtag">@$1</a>' 
	            //     );
	            //     var postCommentNodeArr = comment_textt.split('^^');
	            //     for (var x = 0; x < postCommentNodeArr.length; x++) {
	            //         postCommentNodeArr.splice(x, 0);
	            //         var postCommentNodeArr1 = postCommentNodeArr[x].split('$$');
	            //         if (postCommentNodeArr1.length == 2)
	            //         this.commentdata.push(postCommentNodeArr1);
	            //     }
	            // }
	            // this.totaldata[i].comments = this.commentdata;           
	            var postCaption = [];
	            if (this.totaldata[i].postCaption) {
	                var postCaptionn = this.totaldata[i].postCaption.split(' ');
	                this.totaldata[i].postCaption = postCaptionn;
	            }
	            var postLikedBy = [];
	            if (this.totaldata[i].postLikedBy) {
	                var liked = this.totaldata[i].postLikedBy.split(',');
	                if (liked.length) {
	                    this.totaldata[i].postLikedBy = liked;
	                }
	            }
	            else {
	                this.totaldata[i].postLikedBy = [];
	            }
	            var usersTagged = [];
	            if (this.totaldata[i].usersTagged) {
	                usersTagged = this.totaldata[i].usersTagged.split(',');
	                this.totaldata[i].usersTagged = usersTagged;
	            }
	            var taggedUserCoordinates = [];
	            if (this.totaldata[i].taggedUserCoordinates) {
	                taggedUserCoordinates = this.totaldata[i].taggedUserCoordinates.split(',');
	                this.totaldata[i].taggedUserCoordinates = taggedUserCoordinates;
	            }
	            if (usersTagged[0] != 'undefined' && taggedUserCoordinates[0] != null) {
	                var lenn = usersTagged.length;
	                var tagsCords = [];
	                for (var j = 0; j < lenn; j++) {
	                    var userCords = {
	                        name: usersTagged[j],
	                        right: 0,
	                        top: 0
	                    };
	                    if (taggedUserCoordinates[j]) {
	                        var cordinates = taggedUserCoordinates[j].split('-');
	                        userCords.right = cordinates[0];
	                        userCords.top = cordinates[1];
	                        tagsCords.push(userCords);
	                    }
	                }
	                this.totaldata[i].coords = tagsCords;
	            }
	            var post = this.totaldata[i].postedOn;
	            var poston = Number(post);
	            var postdate = new Date(poston);
	            var currentdate = new Date();
	            var timeDiff = Math.abs(postdate.getTime() - currentdate.getTime());
	            var diffDays = Math.ceil(timeDiff / (1000 * 3600 * 24));
	            var diffHrs = Math.round((timeDiff % 86400000) / 3600000);
	            var diffMins = Math.round(((timeDiff % 86400000) % 3600000) / 60000);
	            if (1 < diffDays) {
	                this.totaldata[i].postedOn = diffDays + "d";
	            }
	            else if (1 <= diffHrs) {
	                this.totaldata[i].postedOn = diffHrs + "h";
	            }
	            else {
	                this.totaldata[i].postedOn = diffMins + "m";
	            }
	            this.posts.push(this.totaldata[i]);
	        }
	        // this.posts = this.totaldata;
	    };
	    ProfileComponent.prototype.loadmore = function () {
	        // console.log(this.offset);
	        var _this = this;
	        this.offset = this.posts.length;
	        this._profileService.loadmore(this.offset)
	            .subscribe(function (res) {
	            // var len = res.data[1].length;
	            // for (var i = 0; i < len; i++) {
	            //     this.posts.push(res.data[1][i]);
	            // }
	            _this.totaldata = res.data[1];
	            _this.commentfunction();
	            _this.offset = res.data[1].length || 0;
	            if (_this.offset >= 20)
	                _this.loadmoree = true;
	            else
	                _this.loadmoree = false;
	        });
	    };
	    ProfileComponent.prototype.timepost = function (item) {
	        var postsId = item.postId;
	        var followingUsername = this.data.username;
	        var link = ['home/homepost', followingUsername, postsId];
	        this._router.navigate(link);
	    };
	    ProfileComponent.prototype.usertagged = function (i) {
	        this.posts[i].usertaggedFlagg = true;
	    };
	    ProfileComponent.prototype.falseusertagged = function (i) {
	        this.posts[i].usertaggedFlagg = false;
	    };
	    ProfileComponent.prototype.usertaggedname = function (tagged) {
	        // alert(item.postId);
	        var personname = tagged.name;
	        var username = localStorage.getItem('username');
	        if (username == personname) {
	            this._router.navigate(['home/profile']);
	        }
	        else {
	            var link = ['home/person', personname];
	            this._router.navigate(link);
	        }
	    };
	    ProfileComponent.prototype.logout = function () {
	        // this._profileService.logout();
	        var token = localStorage.removeItem('authToken');
	        var username = localStorage.removeItem('username');
	        this._router.navigate(['login']);
	    };
	    ProfileComponent.prototype.activeitem = function (id) {
	        // alert(id);
	        jQuery('.item').removeClass("active");
	        jQuery('#' + id + 'w').addClass("active");
	    };
	    ProfileComponent.prototype.memberprofile = function (item) {
	        // alert(item.postsId);
	        var personname = item.username;
	        var username = localStorage.getItem('username');
	        if (username == personname) {
	            this._router.navigate(['home/profile']);
	        }
	        else {
	            var link = ['home/person', personname];
	            this._router.navigate(link);
	        }
	        // let link = ['home/person', item.username];
	        // this._router.navigate(link);
	    };
	    ProfileComponent.prototype.memberprofilee = function (comment) {
	        // alert(item.postsId);
	        var personname = comment.commentedByUser;
	        var username = localStorage.getItem('username');
	        if (username == personname) {
	            this._router.navigate(['home/profile']);
	        }
	        else {
	            var link = ['home/person', personname];
	            this._router.navigate(link);
	        }
	        // let link = ['home/person', comment[0]];
	        // this._router.navigate(link);
	    };
	    ProfileComponent.prototype.membercaption = function (caption) {
	        var hashtagname = caption.split('#');
	        //   console.log(hashtagname[1]);        
	        var link = ['home/personcaption', hashtagname[1]];
	        this._router.navigate(link);
	    };
	    ProfileComponent.prototype.membercaptionn = function (comment) {
	        var hashtagname = comment[1].split('#');
	        //   console.log(hashtagname[1]);        
	        var link = ['home/personcaption', hashtagname[1].replace(" ", "")];
	        this._router.navigate(link);
	    };
	    ProfileComponent.prototype.memberprofilecaption = function (comment) {
	        // var hashtagname = comment[1].split('@');
	        //   console.log(hashtagname[1]);        
	        // let link = ['home/personcaption', hashtagname[1].replace(" ","")];
	        // this._router.navigate(link); 
	        var personname = comment[1].split('@');
	        var username = localStorage.getItem('username');
	        if (username == personname[1]) {
	            this._router.navigate(['home/profile']);
	        }
	        else {
	            var link = ['home/person', personname[1].replace(" ", "")];
	            this._router.navigate(link);
	        }
	    };
	    ProfileComponent.prototype.memberprofilecaptionn = function (caption) {
	        var personname = caption.split('@');
	        var username = localStorage.getItem('username');
	        if (username == personname[1]) {
	            this._router.navigate(['home/profile']);
	        }
	        else {
	            var link = ['home/person', personname[1].replace(" ", "")];
	            this._router.navigate(link);
	        }
	    };
	    // websitelink(data:any){
	    //     alert(data.websiteUrl);
	    //     let link = [data.websiteUrl];
	    //      this._router.navigate(link);
	    // }
	    ProfileComponent.prototype.commentdelete = function (comment, id, postsType, i, k) {
	        //  console.log(comment[0]+" ss "+comment[1]+" id "+id+" postsType "+postsType+" i "+i);
	        postsType = postsType.toString();
	        this.commnentdetails = ({ username: comment.commentedByUser, message: comment.commentBody, commentId: comment.commentId, id: id, postsType: postsType, i: i, k: k });
	    };
	    ProfileComponent.prototype.commentmodaldelete = function () {
	        //  console.log(this.commnentdetails);
	        var commentlist = this.commnentdetails;
	        var commenttext = commentlist.message;
	        // var hashtag_regexp = /<a href=.*?>(.*?)<\/a>/;                
	        // var comment_text = commenttext.replace(hashtag_regexp, '$1');
	        // var hashtag_regexp = /<a href=.*?>(.*?)<\/a>/;                
	        // var comment_textt = comment_text.replace(hashtag_regexp, '$1');
	        var hashtag_regexp = /<a[^>]*>([^<]+)<\/a>/g;
	        var comment_text = commenttext.replace(hashtag_regexp, '$1');
	        // console.log(this.posts[commentlist.i].comments[commentlist.k]);     
	        this.posts[commentlist.i].commentData.splice([commentlist.k], 1);
	        this._profileService.userdeletecomment({ username: commentlist.username, message: comment_text, commentId: commentlist.commentId, id: commentlist.id, postsType: commentlist.postsType })
	            .subscribe();
	    };
	    ProfileComponent.prototype.likeStatus = function (liked) {
	        var personname = liked;
	        // alert(personname);
	        var username = localStorage.getItem('username');
	        if (username == personname) {
	            this._router.navigate(['home/profile']);
	        }
	        else {
	            var link = ['home/person', personname];
	            this._router.navigate(link);
	        }
	    };
	    ProfileComponent.prototype.likedoubleClick = function (id, postsType, i) {
	        var _this = this;
	        // alert(id+'aa'+'bb'+postsType+'cc'+i);
	        if (this.posts[i].likeStatus == 0) {
	            this.posts[i].likeheartFlagg = true;
	            var username = localStorage.getItem('username');
	            this.posts[i].postLikedBy.unshift(username);
	            this.posts[i].likeStatus = 1;
	            this.posts[i].likes += 1;
	            this._profileService.userlike(id, postsType)
	                .subscribe();
	            setTimeout(function () {
	                _this.posts[i].likeheartFlagg = false;
	            }, 500);
	        }
	    };
	    ProfileComponent.prototype.likeactive = function (id, postsType, i) {
	        // alert(id);
	        var username = localStorage.getItem('username');
	        this.posts[i].postLikedBy.unshift(username);
	        this.posts[i].likeStatus = 1;
	        this.posts[i].likes += 1;
	        this._profileService.userlike(id, postsType)
	            .subscribe();
	    };
	    ProfileComponent.prototype.likedeactive = function (id, postsType, i) {
	        var username = localStorage.getItem('username');
	        var array = this.posts[i].postLikedBy;
	        var index = array.indexOf(username);
	        if (index > -1) {
	            array.splice(index, 1);
	        }
	        this.posts[i].likeStatus = 0;
	        this.posts[i].likes -= 1;
	        this._profileService.userunlike(id, postsType)
	            .subscribe();
	    };
	    ProfileComponent.prototype.following = function (item, i) {
	        var _this = this;
	        // alert(i+'ll'+username+'ff'+followFlag);
	        var username = item.username;
	        var memberPrivateFlag = item.memberPrivateFlag;
	        this.data2[i].loaderFlag = true;
	        if (memberPrivateFlag == 1) {
	            setTimeout(function () {
	                _this.data2[i].userFollowRequestStatus = 0;
	            }, 500);
	            this._profileService.following(username)
	                .subscribe();
	            setTimeout(function () {
	                _this.data2[i].loaderFlag = false;
	            }, 500);
	        }
	        if (memberPrivateFlag != 1) {
	            setTimeout(function () {
	                _this.data2[i].userFollowRequestStatus = 1;
	            }, 500);
	            this._profileService.following(username)
	                .subscribe();
	            setTimeout(function () {
	                _this.data2[i].loaderFlag = false;
	            }, 500);
	        }
	    };
	    ProfileComponent.prototype.follow = function (item, i) {
	        var _this = this;
	        var username = item.username;
	        this.data2[i].loaderFlag = true;
	        setTimeout(function () {
	            _this.data2[i].userFollowRequestStatus = null;
	        }, 500);
	        this._profileService.follow(username)
	            .subscribe();
	        setTimeout(function () {
	            _this.data2[i].loaderFlag = false;
	        }, 500);
	    };
	    ProfileComponent.prototype.followingflag = function (item, i) {
	        var _this = this;
	        var username = item.username;
	        var memberPrivateFlag = item.memberPrivateFlag;
	        // alert(i+'ll'+username+'ff'+followFlag);
	        this.data1[i].loaderFlag = true;
	        if (memberPrivateFlag == 1) {
	            setTimeout(function () {
	                _this.data1[i].userFollowRequestStatus = 0;
	            }, 500);
	            this._profileService.following(username)
	                .subscribe();
	            setTimeout(function () {
	                _this.data1[i].loaderFlag = false;
	            }, 500);
	        }
	        if (memberPrivateFlag != 1) {
	            setTimeout(function () {
	                _this.data1[i].userFollowRequestStatus = 1;
	            }, 500);
	            this._profileService.following(username)
	                .subscribe();
	            setTimeout(function () {
	                _this.data1[i].loaderFlag = false;
	            }, 500);
	        }
	    };
	    ProfileComponent.prototype.followflag = function (item, i) {
	        var _this = this;
	        var username = item.username;
	        this.data1[i].loaderFlag = true;
	        setTimeout(function () {
	            _this.data1[i].userFollowRequestStatus = null;
	        }, 500);
	        this._profileService.follow(username)
	            .subscribe();
	        setTimeout(function () {
	            _this.data1[i].loaderFlag = false;
	        }, 500);
	    };
	    ProfileComponent.prototype.usercommentSubmit = function (value, id, postsType, i) {
	        var _this = this;
	        // console.log('you submitted value:', value, id, postsType, i);
	        postsType = postsType.toString();
	        var username = localStorage.getItem('username');
	        var commenttext = value;
	        var hashtag_regexp = /#([a-zA-Z0-9_]+)/g;
	        var comment_text = commenttext.replace(hashtag_regexp, '<a href="home/personcaption/$1" class="hashtag member_name biohashtag">#$1</a>');
	        var hashtag_regexp1 = /@([a-zA-Z0-9_]+)/g;
	        var comment_textt = comment_text.replace(hashtag_regexp1, '<a href="home/person/$1" class="hashtag member_name biohashtag">@$1</a>');
	        if (value.length > 0) {
	            // this.posts[i].comments.push([username, comment_textt]);
	            this._profileService.usercomment({ message: value, id: id, postsType: postsType })
	                .subscribe(function (res) {
	                _this.submitComment = res.data;
	                _this.posts[i].commentData.push(_this.submitComment[0].commentData[0]);
	                _this.hashtagFunction();
	            });
	        }
	    };
	    ProfileComponent.prototype.removePhoto = function () {
	        jQuery(".suggestion_image").attr("src", "");
	        this.data.profilePicUrl = "";
	        jQuery(".modal").modal("hide");
	    };
	    ProfileComponent = __decorate([
	        core_1.Component({
	            selector: 'profile',
	            template: __webpack_require__(506),
	            directives: [router_1.ROUTER_DIRECTIVES],
	            providers: [profile_service_1.ProfileService]
	        }), 
	        __metadata('design:paramtypes', [profile_service_1.ProfileService, router_2.Router])
	    ], ProfileComponent);
	    return ProfileComponent;
	}());
	exports.ProfileComponent = ProfileComponent;


/***/ },

/***/ 505:
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var core_1 = __webpack_require__(5);
	var router_1 = __webpack_require__(389);
	var app_constants_1 = __webpack_require__(441);
	var http_1 = __webpack_require__(363);
	var ProfileService = (function () {
	    function ProfileService(_router, _http, _conf) {
	        this._router = _router;
	        this._http = _http;
	        this._conf = _conf;
	    }
	    ProfileService.prototype.profile = function () {
	        var token = localStorage.getItem('authToken');
	        var body = {
	            token: token
	        };
	        // console.log(body);
	        return this._http.post(this._conf.Url + 'profile', body, { headers: this._conf.headers })
	            .map(function (res) { return res.json(); })
	            .map(function (res) {
	            // console.log("profile",res);
	            // if (res.token) {
	            //     localStorage.setItem('user', res.token);S
	            //     // this._router.navigate(['Pages']);
	            //     return res.code;
	            // }
	            return res;
	        });
	    };
	    ProfileService.prototype.userFollowing = function () {
	        var token = localStorage.getItem('authToken');
	        var body = { token: token };
	        //console.log(body);
	        return this._http.post(this._conf.Url + 'getFollowing', body, { headers: this._conf.headers })
	            .map(function (res) { return res.json(); })
	            .map(function (res) {
	            //console.log(res);
	            // if (res.token) {
	            //     localStorage.setItem('user', res.token);S
	            //     // this._router.navigate(['Pages']);
	            //     return res.code;
	            // }
	            return res;
	        });
	    };
	    ProfileService.prototype.userFollowers = function () {
	        var token = localStorage.getItem('authToken');
	        var body = { token: token };
	        //console.log(body);
	        return this._http.post(this._conf.Url + 'getFollowers', body, { headers: this._conf.headers })
	            .map(function (res) { return res.json(); })
	            .map(function (res) {
	            //console.log(res);
	            // if (res.token) {
	            //     localStorage.setItem('user', res.token);S
	            //     // this._router.navigate(['Pages']);
	            //     return res.code;
	            // }
	            return res;
	        });
	    };
	    ProfileService.prototype.loadmore = function (offset) {
	        var token = localStorage.getItem('authToken');
	        var body = {
	            token: token,
	            offset: offset
	        };
	        //console.log(body);
	        return this._http.post(this._conf.Url + 'profile', body, { headers: this._conf.headers })
	            .map(function (res) { return res.json(); })
	            .map(function (res) {
	            //console.log(res);
	            // if (res.token) {
	            //     localStorage.setItem('user', res.token);S
	            //     // this._router.navigate(['Pages']);
	            //     return res.code;
	            // }
	            return res;
	        });
	    };
	    ProfileService.prototype.usercomment = function (value) {
	        var token = localStorage.getItem('authToken');
	        var body = {
	            comment: value.message,
	            type: value.postsType,
	            postId: value.id,
	            token: token
	        };
	        //console.log(body);
	        return this._http.post(this._conf.Url + 'comments', body, { headers: this._conf.headers })
	            .map(function (res) { return res.json(); })
	            .map(function (res) {
	            //console.log(res);
	            // if (res.token) {
	            //     localStorage.setItem('user', res.token);S
	            //     // this._router.navigate(['Pages']);
	            //     return res.code;
	            // }
	            return res;
	        });
	    };
	    ProfileService.prototype.userdeletecomment = function (value) {
	        var token = localStorage.getItem('authToken');
	        var body = {
	            commentedByUser: value.username,
	            commentBody: value.message,
	            commentId: value.commentId,
	            type: value.postsType,
	            postId: value.id,
	            token: token
	        };
	        //console.log(body);
	        // return;
	        return this._http.post(this._conf.Url + 'deleteCommentsFromPost', body, { headers: this._conf.headers })
	            .map(function (res) { return res.json(); })
	            .map(function (res) {
	            //console.log(res);
	            // if (res.token) {
	            //     localStorage.setItem('user', res.token);S
	            //     // this._router.navigate(['Pages']);
	            //     return res.code;
	            // }
	            return res;
	        });
	    };
	    ProfileService.prototype.userlike = function (id, postsType) {
	        var token = localStorage.getItem('authToken');
	        var body = {
	            token: token,
	            postId: id,
	            label: 'Photo'
	        };
	        if (postsType == 1)
	            body.label = 'Video';
	        //console.log(body);
	        return this._http.post(this._conf.Url + 'like', body, { headers: this._conf.headers })
	            .map(function (res) { return res.json(); })
	            .map(function (res) {
	            //console.log(res);
	            // if (res.token) {
	            //     localStorage.setItem('user', res.token);S
	            //     // this._router.navigate(['Pages']);
	            //     return res.code;
	            // }
	            return res;
	        });
	    };
	    ProfileService.prototype.userunlike = function (id, postsType) {
	        var token = localStorage.getItem('authToken');
	        var body = {
	            token: token,
	            postId: id,
	            label: 'Photo'
	        };
	        if (postsType == 1)
	            body.label = 'Video';
	        //console.log(body);
	        return this._http.post(this._conf.Url + 'unlike', body, { headers: this._conf.headers })
	            .map(function (res) { return res.json(); })
	            .map(function (res) {
	            //console.log(res);
	            // if (res.token) {
	            //     localStorage.setItem('user', res.token);S
	            //     // this._router.navigate(['Pages']);
	            //     return res.code;
	            // }
	            return res;
	        });
	    };
	    ProfileService.prototype.following = function (username) {
	        var token = localStorage.getItem('authToken');
	        var body = {
	            token: token,
	            userNameToFollow: username
	        };
	        //console.log(body);
	        return this._http.post(this._conf.Url + 'follow', body, { headers: this._conf.headers })
	            .map(function (res) { return res.json(); })
	            .map(function (res) {
	            //console.log(res);
	            // if (res.token) {
	            //     localStorage.setItem('user', res.token);S
	            //     // this._router.navigate(['Pages']);
	            //     return res.code;
	            // }
	            return res;
	        });
	    };
	    ProfileService.prototype.follow = function (username) {
	        var token = localStorage.getItem('authToken');
	        var body = {
	            token: token,
	            unfollowUserName: username
	        };
	        //console.log(body);
	        return this._http.post(this._conf.Url + 'unfollow', body, { headers: this._conf.headers })
	            .map(function (res) { return res.json(); })
	            .map(function (res) {
	            //console.log(res);
	            // if (res.token) {
	            //     localStorage.setItem('user', res.token);S
	            //     // this._router.navigate(['Pages']);
	            //     return res.code;
	            // }
	            return res;
	        });
	    };
	    ProfileService = __decorate([
	        core_1.Injectable(), 
	        __metadata('design:paramtypes', [router_1.Router, http_1.Http, app_constants_1.Configuration])
	    ], ProfileService);
	    return ProfileService;
	}());
	exports.ProfileService = ProfileService;


/***/ },

/***/ 506:
/***/ function(module, exports) {

	module.exports = "<!DOCTYPE html>\r\n<html>\r\n\r\n<head>\r\n\t<title>Sportemage</title>\r\n\t<link rel=\"icon\" type=\"image/gif/png\" href=\"/public/images/picoTitleLogo.png\">\r\n</head>\r\n<div class=\"loader\" *ngIf=\"loading\"></div>\r\n<div class=\"container-fluid picogram_total\">\r\n\t<div class=\"container pico_content_total profile_pico\" *ngIf=\"data;\" style=\"max-width: 935px;padding: 50px 20px 0;\">\r\n\t\t<div class=\"profile_file_name zero_padding col-xs-12\" style=\"margin-bottom:2%;\">\r\n\t\t\t<div class=\"profile_image zero_padding col-xs-3 col-sm-4\" style=\"text-align: center;\" data-toggle=\"modal\" data-target=\"#profilepico\">\r\n\t\t\t\t<img class=\"img_profile suggestion_image\" src=\"{{data.profilePicUrl}}\" onError=\"this.src='/public/images/default.png';\" width=\"152px;\"\r\n\t\t\t\t height=\"152px;\">\r\n\t\t\t</div>\r\n\r\n\t\t\t<!-- popup modal profile -->\r\n\t\t\t<div class=\"modal fade\" id=\"profilepico\" role=\"dialog\">\r\n\t\t\t\t<div class=\"modal-dialog modal-md\">\r\n\t\t\t\t\t<div class=\"modal-content\">\r\n\t\t\t\t\t\t<div class=\"modal-body\" style=\"\">\r\n\t\t\t\t\t\t\t<span class=\"report_cancel col-xs-12\" style=\"color: #999;\">\r\n\t\t\t\t\t\t\t\t<input type=\"file\" class=\"fileHidden\" (change)=\"uploadImg($event)\"> Change Profile Picture\r\n\t\t\t\t\t\t\t</span>\r\n\t\t\t\t\t\t\t<span class=\"report_cancel col-xs-12 color_focus\" (click)=\"removePhoto()\">Remove Current Photo</span>\r\n\t\t\t\t\t\t\t<!-- <span class=\"report_cancel col-xs-12\">Upload Photo</span> -->\r\n\t\t\t\t\t\t\t<span class=\"report_cancel col-xs-12\" data-dismiss=\"modal\">Cancel</span>\r\n\t\t\t\t\t\t</div>\r\n\t\t\t\t\t</div>\r\n\t\t\t\t</div>\r\n\t\t\t</div>\r\n\t\t\t<!-- End popup modal -->\r\n\r\n\t\t\t<div class=\"profile_name_content zero_padding col-xs-9 col-sm-8\">\r\n\t\t\t\t<div class=\"detail_name_pico zero_padding col-xs-12\">\r\n\t\t\t\t\t<span class=\"follow_name2\" style=\"\">{{data.username}}</span>\r\n\t\t\t\t\t<a [routerLink]=\"['../profile-edit']\">\r\n\t\t\t\t\t\t<span class=\"zero_padding col-xs-4 col-sm-3 col-md-2 follow_button\">\r\n\t\t\t\t\t\t\t<button class=\"edit_profile\" style=\"width:100% !important;font-size:13px;\">Edit Profile</button>\r\n\t\t\t\t\t\t</span>\r\n\t\t\t\t\t</a>\r\n\t\t\t\t\t<span class=\"zero_padding col-xs-2 report_dotted\" data-toggle=\"modal\" data-target=\"#myModal\" style=\"position: relative;cursor:pointer;right:0%;\"></span>\r\n\t\t\t\t</div>\r\n\t\t\t\t<!-- popup modal -->\r\n\t\t\t\t<div class=\"modal fade logout\" id=\"myModal\" role=\"dialog\">\r\n\t\t\t\t\t<div class=\"modal-dialog modal-md\">\r\n\t\t\t\t\t\t<div class=\"modal-content\">\r\n\t\t\t\t\t\t\t<div class=\"modal-body\" style=\"\">\r\n\t\t\t\t\t\t\t\t<span class=\"report_cancel col-xs-12 color_focus\" data-dismiss=\"modal\" (click)=\"logout();\">Log out</span>\r\n\t\t\t\t\t\t\t\t<span class=\"report_cancel col-xs-12\" data-dismiss=\"modal\">Cancel</span>\r\n\t\t\t\t\t\t\t</div>\r\n\t\t\t\t\t\t</div>\r\n\t\t\t\t\t</div>\r\n\t\t\t\t</div>\r\n\t\t\t\t<!-- End popup modal -->\r\n\t\t\t\t<div class=\"post_follow_followers zero_padding like_post col-xs-12 hidden-xs\" style=\"margin:3% 0% 0% 0%;\">\r\n\t\t\t\t\t<span class=\"post color_thick1 zero_padding\" style=\"margin-right: 5%;\">{{data.totalPosts}}\r\n\t\t\t\t\t\t<span class=\"color_opacity\"> posts</span>\r\n\t\t\t\t\t</span>\r\n\t\t\t\t\t<span class=\"followers color_thick1 zero_padding\" data-toggle=\"modal\" data-target=\"#followers\" style=\"cursor:pointer;margin-right: 5%;\">{{data.followers}}\r\n\t\t\t\t\t\t<span class=\"color_opacity\"> followers</span>\r\n\t\t\t\t\t</span>\r\n\t\t\t\t\t<span class=\"following color_thick1 zero_padding\" data-toggle=\"modal\" data-target=\"#following\" style=\"cursor:pointer;\">{{data.following}}\r\n\t\t\t\t\t\t<span class=\"color_opacity\"> following</span>\r\n\t\t\t\t\t</span>\r\n\t\t\t\t</div>\r\n\t\t\t\t<div class=\"profilename_comment zero_padding col-xs-12\">\r\n\t\t\t\t\t<span class=\"name_comment color_thick1\" style=\"\">{{data.fullname}}</span>\r\n\t\t\t\t\t<span class=\"name_comment1 color_thick1 color_opacity\" id=\"biohashtag\" [innerHTML]=\"data.bio\" style=\"\"> </span>\r\n\t\t\t\t\t<span class=\"\">\r\n\t\t\t\t\t\t<a class=\"color_thick1 member_name\" target=\"_blank\" href=\"http://{{data.websiteUrl}}\" style=\"color:#003569;\">{{data.websiteUrl}}</a>\r\n\t\t\t\t\t</span>\r\n\t\t\t\t</div>\r\n\t\t\t</div>\r\n\t\t\t<span class=\"col-xs-12 visible-xs\" style=\"background:#dbdbdb;height:1px;\"></span>\r\n\t\t\t<div class=\"post_follow_followers zero_padding like_post col-xs-12 visible-xs\" style=\"text-align:center;\">\r\n\t\t\t\t<span class=\"post color_thick1 zero_padding col-xs-4 col-sm-2\">\r\n\t\t\t\t\t<span class=\"col-xs-12 zero_padding\">{{data.totalPosts}}</span>\r\n\t\t\t\t\t<span class=\"color_opacity col-xs-12 zero_padding\"> posts</span>\r\n\t\t\t\t</span>\r\n\t\t\t\t<span class=\"followers color_thick1 zero_padding col-xs-4 col-sm-2\" data-toggle=\"modal\" data-target=\"#followers\" style=\"cursor:pointer;\">\r\n\t\t\t\t\t<span class=\"col-xs-12 zero_padding\">{{data.followers}}</span>\r\n\t\t\t\t\t<span class=\"color_opacity col-xs-12 zero_padding\"> followers</span>\r\n\t\t\t\t</span>\r\n\t\t\t\t<span class=\"following color_thick1 zero_padding col-xs-4 col-sm-2\" data-toggle=\"modal\" data-target=\"#following\" style=\"cursor:pointer;\">\r\n\t\t\t\t\t<span class=\"col-xs-12 zero_padding\">{{data.following}}</span>\r\n\t\t\t\t\t<span class=\"color_opacity col-xs-12 zero_padding\"> following</span>\r\n\t\t\t\t</span>\r\n\t\t\t</div>\r\n\t\t\t<!-- popup modal folllowers and following -->\r\n\t\t\t<div class=\"modal fade followers_modal\" id=\"followers\" role=\"dialog\">\r\n\t\t\t\t<div class=\"modal-dialog modal-md\" style=\"margin-top:5%;\">\r\n\t\t\t\t\t<div class=\"modal-content\">\r\n\t\t\t\t\t\t<div class=\"modal-header\" style=\"\">\r\n\t\t\t\t\t\t\t<h4 class=\"col-xs-12 zero_padding color_thick\">Followers</h4>\r\n\t\t\t\t\t\t</div>\r\n\t\t\t\t\t\t<div class=\"modal-body follow_followers_modal\" *ngIf=\"data2\" style=\"\">\r\n\t\t\t\t\t\t\t<div class=\"follow_details col-xs-12 zero_padding\" *ngFor=\"let item of data2; let i = index\">\r\n\t\t\t\t\t\t\t\t<span class=\"col-xs-2 col-sm-1 zero_padding\">\r\n\t\t\t\t\t\t\t\t\t<img class=\"suggestion_image\" src=\"{{item.profilePicUrl}}\" onError=\"this.src='/public/images/default.png';\">\r\n\t\t\t\t\t\t\t\t</span>\r\n\t\t\t\t\t\t\t\t<span class=\"col-xs-5 col-sm-8 zero_padding\">\r\n\t\t\t\t\t\t\t\t\t<h5 class=\"follow_name col-xs-12 zero_padding\">\r\n\t\t\t\t\t\t\t\t\t\t<a class=\"color_thick follow_font member_name\" data-dismiss=\"modal\" (click)=\"memberprofile(item)\">{{item.username}}</a>\r\n\t\t\t\t\t\t\t\t\t</h5>\r\n\t\t\t\t\t\t\t\t\t<h6 class=\"follow_name col-xs-12 zero_padding color_thick color_opacity follow_font1\" style=\"\">{{item.fullName}}</h6>\r\n\t\t\t\t\t\t\t\t</span>\r\n\t\t\t\t\t\t\t\t<span class=\"bufferperson_gif\" *ngIf=\"item.loaderFlag==true\">\r\n\t\t\t\t\t\t\t\t\t<img src=\"/public/images/ajax-loader2.gif\" alt=\"loader\">\r\n\t\t\t\t\t\t\t\t</span>\r\n\t\t\t\t\t\t\t\t<span class=\"col-xs-5 col-sm-3 zero_padding\" *ngIf=\"item.userFollowRequestStatus==null\" (click)=\"following(item, i);\" style=\"text-align:center;\">\r\n\t\t\t\t\t\t\t\t\t<button class=\"follow_button\" style=\"font-size:14px;\">Follow</button>\r\n\t\t\t\t\t\t\t\t</span>\r\n\t\t\t\t\t\t\t\t<span class=\"col-xs-5 col-sm-3 zero_padding\" *ngIf=\"item.userFollowRequestStatus==0\" (click)=\"follow(item, i);\" style=\"text-align:center;\">\r\n\t\t\t\t\t\t\t\t\t<button class=\"follow_button\" style=\"font-size:14px;background-color:gray;border:1px solid gray;color:white;\">Requested</button>\r\n\t\t\t\t\t\t\t\t</span>\r\n\t\t\t\t\t\t\t\t<span class=\"col-xs-5 col-sm-3 zero_padding\" *ngIf=\"item.userFollowRequestStatus==1\" (click)=\"follow(item, i);\" style=\"text-align:center;\">\r\n\t\t\t\t\t\t\t\t\t<button class=\"folllow_button folow\" style=\"margin-top:0px;font-size:14px;\">Following</button>\r\n\t\t\t\t\t\t\t\t</span>\r\n\t\t\t\t\t\t\t</div>\r\n\t\t\t\t\t\t</div>\r\n\t\t\t\t\t\t<div class=\"modal-body follow_followers_modal\" *ngIf=\"!data2\" style=\"\">\r\n\t\t\t\t\t\t\t<h4 class=\"col-xs-12 zero_padding color_thick\" style=\"text-align: center;padding: 5%;\">You don't have any followers</h4>\r\n\t\t\t\t\t\t</div>\r\n\t\t\t\t\t</div>\r\n\t\t\t\t</div>\r\n\t\t\t</div>\r\n\r\n\t\t\t<div class=\"modal fade following_modal\" id=\"following\" role=\"dialog\">\r\n\t\t\t\t<div class=\"modal-dialog modal-md\" style=\"margin-top:5%;\">\r\n\t\t\t\t\t<div class=\"modal-content\">\r\n\t\t\t\t\t\t<div class=\"modal-header\" style=\"\">\r\n\t\t\t\t\t\t\t<h4 class=\"col-xs-12 zero_padding color_thick\">Following</h4>\r\n\t\t\t\t\t\t</div>\r\n\t\t\t\t\t\t<div class=\"modal-body follow_followers_modal\" *ngIf=\"data1\" style=\"\">\r\n\t\t\t\t\t\t\t<div class=\"follow_details col-xs-12 zero_padding\" *ngFor=\"let item of data1; let i = index\">\r\n\t\t\t\t\t\t\t\t<span class=\"col-xs-2 col-sm-1 zero_padding\">\r\n\t\t\t\t\t\t\t\t\t<img class=\"suggestion_image\" src=\"{{item.profilePicUrl}}\" onError=\"this.src='/public/images/default.png';\">\r\n\t\t\t\t\t\t\t\t</span>\r\n\t\t\t\t\t\t\t\t<span class=\"col-xs-5 col-sm-8 zero_padding\">\r\n\t\t\t\t\t\t\t\t\t<h5 class=\"follow_name col-xs-12 zero_padding\">\r\n\t\t\t\t\t\t\t\t\t\t<a class=\"color_thick follow_font member_name\" data-dismiss=\"modal\" (click)=\"memberprofile(item)\">{{item.username}}</a>\r\n\t\t\t\t\t\t\t\t\t</h5>\r\n\t\t\t\t\t\t\t\t\t<h6 class=\"follow_name col-xs-12 zero_padding color_thick color_opacity follow_font1\" style=\"\">{{item.fullName}}</h6>\r\n\t\t\t\t\t\t\t\t</span>\r\n\t\t\t\t\t\t\t\t<span class=\"bufferperson_gif\" *ngIf=\"item.loaderFlag==true\">\r\n\t\t\t\t\t\t\t\t\t<img src=\"/public/images/ajax-loader2.gif\" alt=\"loader\">\r\n\t\t\t\t\t\t\t\t</span>\r\n\t\t\t\t\t\t\t\t<span class=\"col-xs-5 col-sm-3 zero_padding\" *ngIf=\"item.userFollowRequestStatus==null\" (click)=\"followingflag(item, i);\"\r\n\t\t\t\t\t\t\t\t style=\"text-align:center;\">\r\n\t\t\t\t\t\t\t\t\t<button class=\"follow_button\" style=\"font-size:14px;\">Follow</button>\r\n\t\t\t\t\t\t\t\t</span>\r\n\t\t\t\t\t\t\t\t<span class=\"col-xs-5 col-sm-3 zero_padding\" *ngIf=\"item.userFollowRequestStatus==0\" (click)=\"followflag(item, i);\" style=\"text-align:center;\">\r\n\t\t\t\t\t\t\t\t\t<button class=\"follow_button\" style=\"font-size:14px;background-color:gray;border:1px solid gray;color:white;\">Requested</button>\r\n\t\t\t\t\t\t\t\t</span>\r\n\t\t\t\t\t\t\t\t<span class=\"col-xs-5 col-sm-3 zero_padding\" *ngIf=\"item.userFollowRequestStatus==1\" (click)=\"followflag(item, i);\" style=\"text-align:center;\">\r\n\t\t\t\t\t\t\t\t\t<button class=\"folllow_button folow\" style=\"margin-top:0px;font-size:14px;\">Following</button>\r\n\t\t\t\t\t\t\t\t</span>\r\n\t\t\t\t\t\t\t</div>\r\n\t\t\t\t\t\t</div>\r\n\t\t\t\t\t\t<div class=\"modal-body follow_followers_modal\" *ngIf=\"!data1\" style=\"\">\r\n\t\t\t\t\t\t\t<h4 class=\"col-xs-12 zero_padding color_thick\" style=\"text-align: center;padding: 5%;\">You are not following anyone</h4>\r\n\t\t\t\t\t\t</div>\r\n\t\t\t\t\t</div>\r\n\t\t\t\t</div>\r\n\t\t\t</div>\r\n\t\t\t<!-- End popup modal -->\r\n\t\t</div>\r\n\r\n\t\t<!-- -->\r\n\t\t<!--<div class=\"col-xs-12 zero_padding\" *ngIf=\"data.private == 1\" style=\"text-align:center;margin-top:10%;\">\r\n\t\t\t<h4 style=\"margin-bottom:2%;\">This Account is Private</h4>\r\n\t\t\t<h5>Follow to see their photos and videos</h5>\r\n\t\t</div>-->\r\n\r\n\t\t<!--<div class=\"\" *ngIf=\"data.private != 1\">-->\r\n\r\n\t\t<div *ngIf=\"posts\" class=\"all_profile_upload zero_padding col-xs-12\" style=\"\">\r\n\t\t\t<div class=\"zero_padding col-xs-4 upload_photo\" *ngFor=\"let item of posts\" style=\"margin:0% 3% 3% 0%;width:30.3%;\">\r\n\t\t\t\t<span class=\"img-span zero_padding col-xs-12 carousel_click\" (click)=\"activeitem(item.postId)\" id=\"{{item.postId}}\" data-toggle=\"modal\"\r\n\t\t\t\t data-target=\".bs-example-modal-lg\">\r\n\t\t\t\t\t<span class=\"img_hov zero_padding col-xs-12\">\r\n\t\t\t\t\t\t<img class=\"uploadphoto\" id=\"\" *ngIf=\"item.postsType==0\" src=\"{{item.mainUrl}}\" onError=\"this.src='/public/images/default.png';\">\r\n\t\t\t\t\t\t<span class=\"videotag_img video_tag\" *ngIf=\"item.postsType==1\"></span>\r\n\t\t\t\t\t\t<video class=\"uploadphoto\" *ngIf=\"item.postsType==1\">\r\n\t\t\t\t\t\t\t<source src=\"{{item.mainUrl}}\" type=\"video/mp4\">\r\n\t\t\t\t\t\t\t<source src=\"{{item.mainUrl}}\" type=\"video/ogg\">\r\n\t\t\t\t\t\t</video>\r\n\t\t\t\t\t</span>\r\n\t\t\t\t\t<span class=\"hover_image_effect hide_hover col-xs-12\" id=\"\" style=\"\">\r\n\t\t\t\t\t\t<div class=\"hover_div zero_padding col-xs-12 col-sm-6\" *ngIf=\"item.postsType==0\">\r\n\t\t\t\t\t\t\t<span class=\"hover_icon hovericon zero_padding\"></span>\r\n\t\t\t\t\t\t\t<span class=\"hover_number\">{{item.likes}}</span>\r\n\t\t\t\t\t\t</div>\r\n\t\t\t\t\t\t<div class=\"hover_div zero_padding col-xs-12 col-sm-6\" *ngIf=\"item.postsType==1\">\r\n\t\t\t\t\t\t\t<span class=\"hover_icon hover_videoicon zero_padding\"></span>\r\n\t\t\t\t\t\t\t<span class=\"hover_number\">{{item.likes}}</span>\r\n\t\t\t\t\t\t</div>\r\n\t\t\t\t\t\t<div class=\"hover_div zero_padding col-xs-12 col-sm-6\">\r\n\t\t\t\t\t\t\t<span class=\"hover_icon hovericon1\"></span>\r\n\t\t\t\t\t\t\t<span class=\"hover_number\">{{item.commentData.length}}</span>\r\n\t\t\t\t\t\t</div>\r\n\t\t\t\t\t</span>\r\n\t\t\t\t</span>\r\n\t\t\t</div>\r\n\t\t</div>\r\n\t\t<!--</div>-->\r\n\t\t<div class=\"col-xs-12 loader_moreDetails\" [hidden]=\"!loadmoree\">\r\n\t\t\t<div class=\"loadmoreRound\" (click)=\"loadmore();\">\r\n\t\t\t\t<span class=\"loadmore_click\">loadmore</span>\r\n\t\t\t</div>\r\n\t\t</div>\r\n\r\n\t\t<!--<div class=\"zero_padding col-xs-12 loadmore\" (click)=\"loadmore();\" [hidden]=\"!loadmoree\" style=\"cursor:pointer;text-align:center;height: 120px;width: 120px;margin-left: 40%;border: 2px solid #3897f0;border-radius: 50%;\">\r\n\t<span class=\"loadmore_click\" style=\"font-size:14px;position: absolute;top: 40%;left: 28%;color: #3897f0;\">loadmore</span>\r\n\r\n</div>-->\r\n\r\n\t\t<!-- empty data -->\r\n\t\t<div *ngIf=\"posts==''\" class=\"all_profile_upload zero_padding col-xs-12\" style=\"margin-top:5%;\">\r\n\t\t\t<div class=\"col-xs-12 col-sm-6 zero_padding\">\r\n\t\t\t\t<span class=\"\">\r\n\t\t\t\t\t<img src=\"/public/images/nopost.jpg\" style=\"width: 100%;\">\r\n\t\t\t\t</span>\r\n\t\t\t</div>\r\n\t\t\t<div class=\"col-xs-12 col-sm-6\">\r\n\t\t\t\t<div class=\"col-xs-12 zero_padding\" style=\"text-align: center;margin: 30% 0%;\">\r\n\t\t\t\t\t<h4 class=\"\"> Start capturing and sharing your moments. </h4>\r\n\t\t\t\t\t<h5 class=\" color_opacity\">Get the app to share your first photo or video.</h5>\r\n\t\t\t\t\t<span class=\"col-xs-6 zero_padding \">\r\n\t\t\t\t\t\t<img class=\"image_app\" src=\"/public/images/appstore.png\" alt=\"app store\" style=\"width: 75%;height: 50px;\">\r\n\t\t\t\t\t</span>\r\n\t\t\t\t\t<span class=\"col-xs-6 zero_padding\">\r\n\t\t\t\t\t\t<img class=\"image_app\" src=\"/public/images/playstore.png\" alt=\"google play store\" style=\"width: 75%;height: 50px;\">\r\n\t\t\t\t\t</span>\r\n\t\t\t\t</div>\r\n\t\t\t</div>\r\n\t\t</div>\r\n\r\n\t\t<!-- -->\r\n\r\n\t\t<!-- carousel-->\r\n\t\t<div class=\"container\" style=\"width:100%;\">\r\n\r\n\t\t\t<div class=\"modal fade bs-example-modal-lg carousel-model\" role=\"dialog\" aria-labelledby=\"myLargeModalLabel\" aria-hidden=\"true\">\r\n\t\t\t\t<div class=\"modal-dialog modal-lg\">\r\n\t\t\t\t\t<div class=\"modal-content\">\r\n\t\t\t\t\t\t<div id=\"carousel-example-generic\" *ngIf=\"posts\" class=\"carousel slide\" data-interval=\"false\">\r\n\r\n\t\t\t\t\t\t\t<!-- Wrapper for slides -->\r\n\t\t\t\t\t\t\t<div class=\"carousel-inner\">\r\n\t\t\t\t\t\t\t\t<div class=\"item\" *ngFor=\"let item of posts; let i = index\" id=\"{{item.postId}}w\">\r\n\t\t\t\t\t\t\t\t\t<div class=\"col-xs-12 col-md-7 zero_padding\">\r\n\t\t\t\t\t\t\t\t\t\t<!--<img class=\"img-responsive\" src=\"https://igcdn-photos-f-a.akamaihd.net/hphotos-ak-xpt1/t51.2885-15/e15/10809778_786506061406485_132431944_n.jpg?ig_cache_key=ODY1OTk3NTk4NzU0MjE4NDY5.2\"\r\n\t\t\t\t\t\t\t\t\talt=\"...\">-->\r\n\t\t\t\t\t\t\t\t\t\t<img class=\"img-responsive col-xs-12 zero_padding\" id=\"\" (click)=\"falseusertagged(i);\" (dblclick)=\"likedoubleClick(item.postId, item.postsType,i);\"\r\n\t\t\t\t\t\t\t\t\t\t *ngIf=\"item.postsType==0\" src=\"{{item.mainUrl}}\" onError=\"this.src='/public/images/default.png';\">\r\n\t\t\t\t\t\t\t\t\t\t<div class=\"doubleclick_heart\" *ngIf=\"item.likeheartFlagg==true\">\r\n\t\t\t\t\t\t\t\t\t\t\t<span class=\"double_click_heart like_icon\"></span>\r\n\t\t\t\t\t\t\t\t\t\t</div>\r\n\t\t\t\t\t\t\t\t\t\t<video class=\"img-responsive\" (click)=\"falseusertagged(i);\" *ngIf=\"item.postsType==1\" controls>\r\n\t\t\t\t\t\t\t\t\t\t\t<source src=\"{{item.mainUrl}}\" type=\"video/mp4\">\r\n\t\t\t\t\t\t\t\t\t\t\t<source src=\"{{item.mainUrl}}\" type=\"video/ogg\">\r\n\t\t\t\t\t\t\t\t\t\t</video>\r\n\t\t\t\t\t\t\t\t\t\t<div class=\"pico_contentdetails_tagged col-xs-12\">\r\n\t\t\t\t\t\t\t\t\t\t\t<div *ngIf=\"item.usertaggedFlagg==true\">\r\n\t\t\t\t\t\t\t\t\t\t\t\t<span *ngFor=\"let tagged of item.coords;\">\r\n\t\t\t\t\t\t\t\t\t\t\t\t\t<span class=\"tagg_color_name tagg_color\" data-dismiss=\"modal\" (click)=\"usertaggedname(tagged);\" [ngStyle]=\"{'margin-left': tagged.right+'%', 'margin-top': '-'+tagged.top+'%'}\">\r\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t<div class=\"tagg_arrowicon\"></div>\r\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t{{tagged.name}}\r\n\t\t\t\t\t\t\t\t\t\t\t\t\t</span>\r\n\t\t\t\t\t\t\t\t\t\t\t\t</span>\r\n\t\t\t\t\t\t\t\t\t\t\t</div>\r\n\t\t\t\t\t\t\t\t\t\t\t<div class=\"\" *ngFor=\"let tagged of item.coords;\">\r\n\t\t\t\t\t\t\t\t\t\t\t\t<i class=\"usertag_icon tagged_icon\" (click)=\"usertagged(i);\"></i>\r\n\t\t\t\t\t\t\t\t\t\t\t</div>\r\n\t\t\t\t\t\t\t\t\t\t</div>\r\n\t\t\t\t\t\t\t\t\t</div>\r\n\t\t\t\t\t\t\t\t\t<div class=\"col-xs-12 col-md-5 zero_padding comment_text\">\r\n\t\t\t\t\t\t\t\t\t\t<div class=\"follow_details col-xs-12 zero_padding\" *ngIf=\"data\">\r\n\t\t\t\t\t\t\t\t\t\t\t<span class=\"col-xs-2 col-sm-2 col-md-1 zero_padding\">\r\n\t\t\t\t\t\t\t\t\t\t\t\t<img class=\"suggestion_image member_name\" data-dismiss=\"modal\" src=\"{{data.profilePicUrl}}\" onError=\"this.src='/public/images/default.png';\">\r\n\t\t\t\t\t\t\t\t\t\t\t</span>\r\n\t\t\t\t\t\t\t\t\t\t\t<span class=\"col-xs-4 col-sm-5 col-md-6 zero_padding slider_img\">\r\n\t\t\t\t\t\t\t\t\t\t\t\t<h5 class=\"follow_name col-xs-12 zero_padding\">\r\n\t\t\t\t\t\t\t\t\t\t\t\t\t<span class=\"color_thick member_name\" data-dismiss=\"modal\">{{data.username}}</span>\r\n\t\t\t\t\t\t\t\t\t\t\t\t</h5>\r\n\t\t\t\t\t\t\t\t\t\t\t\t<h6 class=\"follow_name col-xs-12 zero_padding color_thick color_opacity\" style=\"\">{{data.fullName}}</h6>\r\n\t\t\t\t\t\t\t\t\t\t\t</span>\r\n\t\t\t\t\t\t\t\t\t\t\t<!--<span class=\"col-xs-5 col-sm-4 zero_padding\" style=\"\"><button class=\"follow_buttonn folow\">Following</button></span>-->\r\n\t\t\t\t\t\t\t\t\t\t</div>\r\n\t\t\t\t\t\t\t\t\t\t<div class=\"pico_contentdetails_comment\" style=\"padding: 0% 0% 0% 5%;display: inline-block;width: 100%;\">\r\n\t\t\t\t\t\t\t\t\t\t\t<div class=\"col-xs-12 zero_padding\" style=\"margin: 2% 0%;\">\r\n\t\t\t\t\t\t\t\t\t\t\t\t<span class=\"col-xs-10 zero_padding\" *ngIf=\"item.postLikedBy.length < 6\">\r\n\t\t\t\t\t\t\t\t\t\t\t\t\t<div *ngIf=\"item.postLikedBy\">\r\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t<span *ngFor=\"let liked of item.postLikedBy; let i=index;\">\r\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<span *ngIf=\"liked != 'null'\">\r\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<span *ngIf=\"i != 0\" class=\"comma_moveleftside\">,</span>\r\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<span class=\"add_liked color_thick member_name\" data-dismiss=\"modal\" (click)=\"likeStatus(liked)\" id=\"likecontent\">{{liked}}</span>\r\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t</span>\r\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t</span>\r\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t<span class=\"color_opacity\" *ngIf=\"item.postLikedBy.length > 1 || item.likeStatus==1\" style=\"font-size:14px;\">like this</span>\r\n\t\t\t\t\t\t\t\t\t\t\t\t\t</div>\r\n\t\t\t\t\t\t\t\t\t\t\t\t</span>\r\n\t\t\t\t\t\t\t\t\t\t\t\t<span class=\"col-xs-10 zero_padding\" *ngIf=\"item.postLikedBy.length > 6\">\r\n\t\t\t\t\t\t\t\t\t\t\t\t\t<span class=\"add_like color_thick\" id=\"like1content\" style=\"margin-right: 5%;\">{{item.likes}}</span>\r\n\t\t\t\t\t\t\t\t\t\t\t\t\t<span class=\"color_thick\">likes</span>\r\n\t\t\t\t\t\t\t\t\t\t\t\t</span>\r\n\t\t\t\t\t\t\t\t\t\t\t\t<span class=\"col-xs-6 color_thick color_opacity zero_padding member_name\" data-dismiss=\"modal\" (click)=\"timepost(item)\" style=\"color: #999;text-align:right;width: 10%;\">{{item.postedOn}}</span>\r\n\t\t\t\t\t\t\t\t\t\t\t</div>\r\n\t\t\t\t\t\t\t\t\t\t\t<ul class=\"comment_list carousel_comment zero_padding col-xs-12\">\r\n\t\t\t\t\t\t\t\t\t\t\t\t<!--<li class=\"listcomment zero_padding col-xs-12\">\r\n\t\t\t\t\t\t\t\t\t\t\t<span class=\"name_comment\" style=\"\"><span class=\"color_thick\" style=\"\" *ngIf=\"item.postCaption !='null'\">{{item.postCaption}}</span></span>\r\n\t\t\t\t\t\t\t\t\t\t\t\r\n\t\t\t\t\t\t\t\t\t\t</li>-->\r\n\t\t\t\t\t\t\t\t\t\t\t\t<li class=\"listcomment zero_padding col-xs-12\">\r\n\t\t\t\t\t\t\t\t\t\t\t\t\t<span class=\"color_thick member_name\" *ngIf=\"item.postCaption !='null'\" id=\"{{item.postsId}}\">{{data.username}}</span>\r\n\t\t\t\t\t\t\t\t\t\t\t\t\t<span class=\"name_comment\" style=\"font-size:14px;\" *ngFor=\"let caption of item.postCaption;\">\r\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t<span *ngIf=\"caption != 'null'\">\r\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<span class=\"color_thick color_opacity member_name\" id=\"{{item.postsId}}\" *ngIf=\"caption.charAt(0) != '#' && caption.charAt(0) != '@'\"\r\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t data-dismiss=\"modal\">{{caption}}</span>\r\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<span class=\"color_thick color_opacity member_name\" id=\"{{item.postsId}}\" data-dismiss=\"modal\" (click)=\"membercaption(caption)\"\r\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t style=\"color:#003569;\" *ngIf=\"caption.charAt(0) == '#'\">{{caption}}</span>\r\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<span class=\"color_thick color_opacity member_name\" id=\"{{item.postsId}}\" data-dismiss=\"modal\" (click)=\"memberprofilecaptionn(caption)\"\r\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t style=\"color:#003569;\" *ngIf=\"caption.charAt(0) == '@'\">{{caption}}</span>\r\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t</span>\r\n\t\t\t\t\t\t\t\t\t\t\t\t\t</span>\r\n\t\t\t\t\t\t\t\t\t\t\t\t</li>\r\n\t\t\t\t\t\t\t\t\t\t\t\t<li class=\"listcomment zero_padding col-xs-12\" *ngFor=\"let comment of item.commentData; let k = index;\">\r\n\t\t\t\t\t\t\t\t\t\t\t\t\t<span class=\"name_comment\" style=\"\">\r\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t<span class=\"color_thick member_name\" data-dismiss=\"modal\" (click)=\"memberprofilee(comment)\" style=\"\">{{comment.commentedByUser}}</span>\r\n\t\t\t\t\t\t\t\t\t\t\t\t\t</span>\r\n\t\t\t\t\t\t\t\t\t\t\t\t\t<span class=\"name_comment1 color_thick color_opacity\" style=\"\" [innerHTML]=\"comment.commentBody\"></span>\r\n\t\t\t\t\t\t\t\t\t\t\t\t\t<span class=\"name_comment1 color_thick color_opacity member_name delete_comment\" style=\"\" data-toggle=\"modal\" data-target=\"#myModal_delete\"\r\n\t\t\t\t\t\t\t\t\t\t\t\t\t (click)=\"commentdelete(comment, item.postId, item.postsType, i, k)\" *ngIf=\"comment.commentedByUser == username\">X</span>\r\n\t\t\t\t\t\t\t\t\t\t\t\t</li>\r\n\t\t\t\t\t\t\t\t\t\t\t</ul>\r\n\t\t\t\t\t\t\t\t\t\t\t<span class=\"col-xs-11\" style=\"background:#efefef;height:1px;margin: 5px 0px 5px 0px\"></span>\r\n\t\t\t\t\t\t\t\t\t\t</div>\r\n\t\t\t\t\t\t\t\t\t\t<div class=\"add_comment col-xs-12 modal_comment_carousel\" style=\"padding: 5px 20px;\">\r\n\t\t\t\t\t\t\t\t\t\t\t<i class=\"comment_icon comment_heart_icon add_heart_icon\" *ngIf=\"item.likeStatus!=1\" (click)=\"likeactive(item.postId, item.postsType,i)\"\r\n\t\t\t\t\t\t\t\t\t\t\t id=\"{{item.postId}}\"></i>\r\n\t\t\t\t\t\t\t\t\t\t\t<i class=\"comment_icon comment_heart_icon add_heart_icon active\" *ngIf=\"item.likeStatus==1\" (click)=\"likedeactive(item.postId, item.postsType,i)\"\r\n\t\t\t\t\t\t\t\t\t\t\t id=\"{{item.postId}}\"></i>\r\n\t\t\t\t\t\t\t\t\t\t\t<input type=\"text\" #input (keyup.enter)=\"usercommentSubmit(input.value, item.postId, item.postsType, i); input.value=''\"\r\n\t\t\t\t\t\t\t\t\t\t\t name=\"message\" placeholder=\"Add a comment\" id=\"{{item.postsId}}\" class=\"col-xs-12 comment_textbox\" style=\"font-size:14px;\">\r\n\t\t\t\t\t\t\t\t\t\t\t<i class=\"comment_icon comment_dotted_icon\" data-toggle=\"modal\" data-target=\"#myModall\"></i>\r\n\t\t\t\t\t\t\t\t\t\t</div>\r\n\t\t\t\t\t\t\t\t\t</div>\r\n\t\t\t\t\t\t\t\t</div>\r\n\t\t\t\t\t\t\t</div>\r\n\t\t\t\t\t\t</div>\r\n\r\n\t\t\t\t\t\t<!-- Controls -->\r\n\t\t\t\t\t\t<a class=\"left carousel-control\" href=\"#carousel-example-generic\" role=\"button\" data-slide=\"prev\">\r\n\t\t\t\t\t\t\t<span class=\"glyphicon glyphicon-chevron-left\"></span>\r\n\t\t\t\t\t\t</a>\r\n\t\t\t\t\t\t<a class=\"right carousel-control\" href=\"#carousel-example-generic\" role=\"button\" data-slide=\"next\">\r\n\t\t\t\t\t\t\t<span class=\"glyphicon glyphicon-chevron-right\"></span>\r\n\t\t\t\t\t\t</a>\r\n\t\t\t\t\t</div>\r\n\t\t\t\t</div>\r\n\t\t\t</div>\r\n\r\n\t\t\t<!-- popup modal -->\r\n\t\t\t<div class=\"modal fade\" id=\"myModall\" role=\"dialog\">\r\n\t\t\t\t<div class=\"modal-dialog modal-md\">\r\n\t\t\t\t\t<div class=\"modal-content\">\r\n\t\t\t\t\t\t<div class=\"modal-body\" style=\"\">\r\n\t\t\t\t\t\t\t<span class=\"report_cancel col-xs-12\">Report inappropriate</span>\r\n\t\t\t\t\t\t\t<!--<span class=\"report_cancel col-xs-12\">Embed</span>-->\r\n\t\t\t\t\t\t\t<span class=\"report_cancel col-xs-12\" data-dismiss=\"modal\">Cancel</span>\r\n\t\t\t\t\t\t</div>\r\n\t\t\t\t\t</div>\r\n\t\t\t\t</div>\r\n\t\t\t</div>\r\n\t\t\t<!-- delete comment -->\r\n\t\t\t<div class=\"modal fade deletecomment\" id=\"myModal_delete\" role=\"dialog\">\r\n\t\t\t\t<div class=\"modal-dialog modal-md\">\r\n\t\t\t\t\t<div class=\"modal-content\">\r\n\t\t\t\t\t\t<div class=\"modal-body\" style=\"\">\r\n\t\t\t\t\t\t\t<span class=\"report_cancel col-xs-12 color_focus  member_name\" data-dismiss=\"modal\" (click)=\"commentmodaldelete()\">Delete Comment</span>\r\n\t\t\t\t\t\t\t<!--<span class=\"report_cancel col-xs-12\">Embed</span>-->\r\n\t\t\t\t\t\t\t<span class=\"report_cancel col-xs-12\" data-dismiss=\"modal\">Cancel</span>\r\n\t\t\t\t\t\t</div>\r\n\t\t\t\t\t</div>\r\n\t\t\t\t</div>\r\n\t\t\t</div>\r\n\t\t\t<!-- End popup modal -->\r\n\r\n\t\t</div>\r\n\t\t<!-- end carousel-->\r\n\t</div>\r\n\t<div class=\"container pico_content_total profile_pico\" *ngIf=\"!data && !loading\" style=\"max-width: 935px;padding: 50px 20px 0;text-align:center;\">\r\n\t\t<!--<h4>Please post some photos or videos to see the feed.</h4>-->\r\n\t</div>\r\n\r\n</div>\r\n\r\n\r\n</html>";

/***/ },

/***/ 507:
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var core_1 = __webpack_require__(5);
	var editprofile_service_1 = __webpack_require__(508);
	var router_1 = __webpack_require__(389);
	var router_2 = __webpack_require__(389);
	var forms_1 = __webpack_require__(326);
	var login_message_component_1 = __webpack_require__(454);
	var ProfileeditComponent = (function () {
	    // cloudinaryOptions: CloudinaryOptions = new CloudinaryOptions({
	    //   cloud_name: 'picogram',
	    //   upload_preset: 'uju4rpbl',
	    //   autoUpload: true
	    // });
	    // profileImageuploader: CloudinaryUploader = new CloudinaryUploader(this.cloudinaryOptions);
	    function ProfileeditComponent(_editprofileService, _router, formBuilder) {
	        this._editprofileService = _editprofileService;
	        this._router = _router;
	        this.formBuilder = formBuilder;
	        this.authorizedd1 = true;
	        this.authorizedd2 = true;
	        this.profileusername = false;
	        this.bufferprofile = false;
	        this.passwordsuccess = true;
	        this.passworderror = true;
	        this.passwordolderror = true;
	        this.email_phone = false;
	        this.bio_details = false;
	        this.mobile_details = false;
	        this.loading = true;
	        this.saveuser = false;
	        this.resetpasswordForm = this.formBuilder.group({
	            'oldPassword': ['', [forms_1.Validators.required]],
	            'newPassword': ['', [forms_1.Validators.required]],
	            'confirmPassword': ['', [forms_1.Validators.required]]
	        });
	        // this.profileImageuploader.onSuccessItem = function (item: any, response: any, status: number, headers: any) {
	        //   this.cloudinaryImage = JSON.parse(response);
	        //    this.data.profilePicUrl = this.cloudinaryImage.url
	        //   return { item, response, status, headers };
	        // };
	        // this.saveprofileForm = this.formBuilder.group({
	        //        'fullName': ['', [Validators.required]],
	        //        'username': ['', [Validators.required]], 
	        //        'websiteUrl': ['', [Validators.required]],
	        //        'bio': ['', [Validators.required]],
	        //        'email': ['', [Validators.required]], 
	        //        'phoneNumber': ['', [Validators.required]],
	        //        'gender': ['', [Validators.required]]                                            
	        //     });
	    }
	    ProfileeditComponent.prototype.ngOnInit = function () {
	        var _this = this;
	        var token = localStorage.getItem('authToken');
	        if (!token)
	            this._router.navigate(["login"]);
	        this._editprofileService.editprofile()
	            .subscribe(function (res) {
	            _this.data = res.data;
	            _this.loading = false;
	        });
	    };
	    ProfileeditComponent.prototype.revoke1 = function () {
	        this.authorizedd1 = false;
	    };
	    ProfileeditComponent.prototype.revoke2 = function () {
	        this.authorizedd2 = false;
	    };
	    ProfileeditComponent.prototype.revoke11 = function () {
	        this.authorizedd1 = true;
	    };
	    ProfileeditComponent.prototype.revoke22 = function () {
	        this.authorizedd2 = true;
	    };
	    ProfileeditComponent.prototype.usernamehide = function () {
	        // alert("hi");
	        this.profileusername = true;
	    };
	    ProfileeditComponent.prototype.usernameehide = function () {
	        // alert("hi");
	        this.profileusername = false;
	    };
	    ProfileeditComponent.prototype.changePrivate = function (val) {
	        if (val == true) {
	            this.data.private = 1;
	        }
	        else {
	            this.data.private = 0;
	        }
	    };
	    ProfileeditComponent.prototype.saveUser = function () {
	        var _this = this;
	        // console.log(this.data);
	        function ValidateEmail(email) {
	            var expr = /^([\w-\.]+)@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.)|(([\w-]+\.)+))([a-zA-Z]{2,4}|[0-9]{1,3})(\]?)$/;
	            return expr.test(email);
	        }
	        var profile = jQuery(".suggestion_image").attr("src");
	        this.data.profilePicUrl = profile;
	        var username_profile = jQuery(".username_profile").val();
	        var bio_profile = jQuery(".bio_profile").val();
	        if (bio_profile) {
	            if (bio_profile.length <= 150) {
	                this.bio_details = false;
	            }
	            else {
	                this.bio_details = true;
	                this.email_phone = false;
	                this.saveuser = false;
	                return;
	            }
	        }
	        else {
	            this.bio_details = false;
	        }
	        var email_profile = jQuery(".email_profile").val();
	        if (!ValidateEmail(email_profile)) {
	            this.email_phone = true;
	            this.bio_details = false;
	            this.saveuser = false;
	            return;
	        }
	        else {
	            this.email_phone = false;
	        }
	        var mobile_profile = jQuery(".mobile_profile").val();
	        // //console.log(mobile_profile);
	        if (mobile_profile) {
	            if (jQuery.isNumeric(mobile_profile)) {
	                if (mobile_profile.charAt(0) == '+') {
	                    if (mobile_profile.length != 13) {
	                        this.mobile_details = true;
	                        this.saveuser = false;
	                        return;
	                    }
	                    else {
	                        this.mobile_details = false;
	                    }
	                }
	                else {
	                    if (mobile_profile.length != 10) {
	                        this.mobile_details = true;
	                        this.saveuser = false;
	                        return;
	                    }
	                    else {
	                        this.mobile_details = false;
	                    }
	                }
	            }
	            else {
	                this.mobile_details = true;
	                return;
	            }
	        }
	        else {
	            this.mobile_details = false;
	        }
	        this.websiteUrl = this.data.websiteUrl;
	        // //console.log(username_profile+"aa"+bio_profile.length+"bb"+email_profile);
	        if (username_profile && ValidateEmail(email_profile)) {
	            this.saveuser = false;
	            this.data = this.data;
	            if (this.websiteUrl) {
	                this.data.website = this.data.websiteUrl;
	            }
	            this._editprofileService.saveprofile(this.data)
	                .subscribe(function (res) {
	                _this.bufferprofile = true;
	                setTimeout(function () {
	                    _this.bufferprofile = false;
	                }, 500);
	                if (res.code == 200) {
	                    setTimeout(function () {
	                        _this.saveuser = true;
	                    }, 500);
	                }
	            });
	        }
	    };
	    ProfileeditComponent.prototype.removePhoto = function () {
	        jQuery(".suggestion_image").attr("src", "");
	        this.data.profilePicUrl = "";
	        jQuery(".modal").modal("hide");
	    };
	    ProfileeditComponent.prototype.uploadImg = function (fileInput) {
	        var _this = this;
	        var input = fileInput.srcElement;
	        if (input.files && input.files[0]) {
	            var reader = new FileReader();
	            reader.onload = function (e) {
	                // $('.imgProfile').attr("src", e.target.result);
	                // jQuery(".suggestion_image").attr("src", e.target.result);
	                // $('#uploadImg').val(e.target.result);
	                var img = e.target.result.split(",");
	                _this.uploadImgList(e.target.result);
	            };
	            reader.readAsDataURL(input.files[0]);
	        }
	    };
	    ProfileeditComponent.prototype.uploadImgList = function (list) {
	        jQuery(".loaderImg").show();
	        jQuery(".modal").modal("hide");
	        setTimeout(function () {
	            jQuery(".loaderImg").hide();
	        }, 2000);
	        this._editprofileService.changePhoto(list)
	            .subscribe(function (res) {
	            if (res.code == 200) {
	                jQuery(".suggestion_image").attr("src", res.mobileImage);
	                setTimeout(function () {
	                    jQuery(".loaderImg").hide();
	                }, 1000);
	            }
	            else {
	                jQuery(".loaderImg").hide();
	            }
	            // this.url = res.mobileImage;
	            // this.thumbnailImage = res.thumbnailImage;
	            console.log("res", res);
	        });
	    };
	    ProfileeditComponent.prototype.changePassword = function () {
	        var _this = this;
	        // //console.log(this.data);
	        this._editprofileService.savepasswordprofile({
	            oldPassword: this.oldPassword,
	            newPassword: this.newPassword,
	            confirmPassword: this.confirmPassword
	        })
	            .subscribe(function (res) {
	            if (res.code == 200) {
	                _this.passwordsuccess = false;
	                _this.passwordolderror = true;
	                _this.passworderror = true;
	            }
	            if (res.code == 9158) {
	                _this.passwordolderror = false;
	                _this.passwordsuccess = true;
	                _this.passworderror = true;
	            }
	            if (res.code == 9159) {
	                _this.passworderror = false;
	                _this.passwordsuccess = true;
	                _this.passwordolderror = true;
	            }
	        });
	    };
	    ProfileeditComponent = __decorate([
	        core_1.Component({
	            selector: 'profileedit',
	            template: __webpack_require__(509),
	            directives: [router_1.ROUTER_DIRECTIVES, forms_1.REACTIVE_FORM_DIRECTIVES, login_message_component_1.ControlMessages],
	            providers: [editprofile_service_1.EditProfileService]
	        }), 
	        __metadata('design:paramtypes', [editprofile_service_1.EditProfileService, router_2.Router, forms_1.FormBuilder])
	    ], ProfileeditComponent);
	    return ProfileeditComponent;
	}());
	exports.ProfileeditComponent = ProfileeditComponent;


/***/ },

/***/ 508:
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var core_1 = __webpack_require__(5);
	var router_1 = __webpack_require__(389);
	var app_constants_1 = __webpack_require__(441);
	var http_1 = __webpack_require__(363);
	var EditProfileService = (function () {
	    function EditProfileService(_router, _http, _conf) {
	        this._router = _router;
	        this._http = _http;
	        this._conf = _conf;
	    }
	    EditProfileService.prototype.editprofile = function () {
	        var token = localStorage.getItem('authToken');
	        var body = { token: token };
	        //console.log(body);
	        return this._http.post(this._conf.Url + 'editProfile', body, { headers: this._conf.headers })
	            .map(function (res) { return res.json(); })
	            .map(function (res) {
	            console.log(res);
	            // if (res.token) {
	            //     localStorage.setItem('user', res.token);S
	            //     // this._router.navigate(['Pages']);
	            //     return res.code;
	            // }
	            return res;
	        });
	    };
	    EditProfileService.prototype.changePhoto = function (list) {
	        var token = localStorage.getItem('authToken');
	        var body = { token: token, image: list };
	        console.log(body);
	        return this._http.post(this._conf.Url + 'imageUpload', body, { headers: this._conf.headers })
	            .map(function (res) { return res.json(); })
	            .map(function (res) {
	            // console.log(res);
	            // if (res.token) {
	            //     localStorage.setItem('user', res.token);S
	            //     // this._router.navigate(['Pages']);
	            //     return res.code;
	            // }
	            return res;
	        });
	    };
	    EditProfileService.prototype.saveprofile = function (user) {
	        var token = localStorage.getItem('authToken');
	        var body = user;
	        body.token = token;
	        console.log(body);
	        return this._http.post(this._conf.Url + 'saveProfile', body, { headers: this._conf.headers })
	            .map(function (res) { return res.json(); })
	            .map(function (res) {
	            //console.log(res);
	            // if (res.token) {
	            //     localStorage.setItem('user', res.token);S
	            //     // this._router.navigate(['Pages']);
	            //     return res.code;
	            // }
	            return res;
	        });
	    };
	    EditProfileService.prototype.savepasswordprofile = function (password) {
	        var token = localStorage.getItem('authToken');
	        //    var username = localStorage.getItem('username');
	        var body = password;
	        body.token = token;
	        // body.username = username;
	        //console.log(body);
	        return this._http.post(this._conf.Url + 'password-update', body, { headers: this._conf.headers })
	            .map(function (res) { return res.json(); })
	            .map(function (res) {
	            //console.log(res);
	            // if (res.token) {
	            //     localStorage.setItem('user', res.token);S
	            //     // this._router.navigate(['Pages']);
	            //     return res.code;
	            // }
	            return res;
	        });
	    };
	    EditProfileService = __decorate([
	        core_1.Injectable(), 
	        __metadata('design:paramtypes', [router_1.Router, http_1.Http, app_constants_1.Configuration])
	    ], EditProfileService);
	    return EditProfileService;
	}());
	exports.EditProfileService = EditProfileService;


/***/ },

/***/ 509:
/***/ function(module, exports) {

	module.exports = "<!DOCTYPE html>\r\n<html>\r\n\r\n<head>\r\n\t<title>Sportemage</title>\r\n\t<!-- <link rel=\"icon\" type=\"image/gif/png\" href=\"/public/images/picoTitleLogo.png\"> -->\r\n</head>\r\n\r\n<div class=\"loader\" *ngIf=\"loading\"></div>\r\n<div class=\"container-fluid picogram_total\">\r\n\t<div class=\"container pico_content_total edit_profile_pico\" style=\"\">\r\n\t\t<div class=\"col-xs-4 col-sm-3 color_thick color_opacity zero_padding hidden-xs\">\r\n\t\t\t<ul class=\"list_edit_details nav nav-pills\">\r\n\t\t\t\t<li class=\"list_edit active\">\r\n\t\t\t\t\t<a data-toggle=\"pill\" (click)=\"usernameehide();\" href=\"#edit_profile\">Edit Profile</a>\r\n\t\t\t\t</li>\r\n\t\t\t\t<li class=\"list_edit\">\r\n\t\t\t\t\t<a data-toggle=\"pill\" (click)=\"usernameehide();\" href=\"#change_password\">Change Password</a>\r\n\t\t\t\t</li>\r\n\t\t\t\t<!--<li class=\"list_edit\"><a data-toggle=\"pill\" (click)=\"usernamehide();\" href=\"#authorized\">Authorized Applications</a></li>\r\n\t\t<li class=\"list_edit\"><a data-toggle=\"pill\" (click)=\"usernamehide();\" href=\"#preferences\">Email Preferences</a></li>-->\r\n\t\t\t</ul>\r\n\t\t</div>\r\n\t\t<div class=\"totaledit_profiledata col-xs-12 col-sm-9\" *ngIf=\"data\" style=\"border-left: 1px solid #dbdbdb;max-height:820px;overflow:hidden;\">\r\n\t\t\t<div class=\"edit_profileheader col-xs-12 zero_padding hide_profile\" [hidden]=\"profileusername\">\r\n\t\t\t\t<span class=\"profileedit_image col-xs-1 col-sm-1 zero_padding follow_detailss\" data-toggle=\"modal\" data-target=\"#profilepico\"\r\n\t\t\t\t style=\"cursor:pointer;\">\r\n\t\t\t\t\t<div class=\"bufferprofile_gif loaderImg\" style=\"display:none;left: 12%;top: 25%;\">\r\n\t\t\t\t\t\t<img src=\"/public/images/ajax-loader2.gif\" alt=\"loader\">\r\n\t\t\t\t\t</div>\r\n\t\t\t\t\t<img class=\"suggestion_image\" src=\"{{data.profilePicUrl}}\" onError=\"this.src='/public/images/default.png';\">\r\n\t\t\t\t</span>\r\n\t\t\t\t<h2 class=\"profileedit_username zero_padding col-xs-10 col-sm-11\" style=\"font-size:24px;\">{{data.username}}</h2>\r\n\t\t\t</div>\r\n\r\n\t\t\t<!-- popup modal profile -->\r\n\t\t\t<div class=\"modal fade\" id=\"profilepico\" role=\"dialog\">\r\n\t\t\t\t<div class=\"modal-dialog modal-md\">\r\n\t\t\t\t\t<div class=\"modal-content\">\r\n\t\t\t\t\t\t<div class=\"modal-body\" style=\"\">\r\n\t\t\t\t\t\t\t<!--<span class=\"report_cancel col-xs-12\" style=\"color: #999;\"><input type=\"file\" class=\"edit-profileUpload\" (change)=\"fileSelect();\">Change Profile Picture</span>-->\r\n\t\t\t\t\t\t\t<span class=\"report_cancel col-xs-12\" style=\"color: #999;\">\r\n\t\t\t\t\t\t\t\t<input type=\"file\" class=\"fileHidden\" (change)=\"uploadImg($event)\"> Change Profile Picture\r\n\t\t\t\t\t\t\t</span>\r\n\t\t\t\t\t\t\t<span class=\"report_cancel col-xs-12 color_focus\" (click)=\"removePhoto()\">Remove Current Photo</span>\r\n\t\t\t\t\t\t\t<!-- <span class=\"report_cancel col-xs-12\">Upload Photo</span> -->\r\n\t\t\t\t\t\t\t<span class=\"report_cancel col-xs-12\" data-dismiss=\"modal\">Cancel</span>\r\n\t\t\t\t\t\t</div>\r\n\t\t\t\t\t</div>\r\n\t\t\t\t</div>\r\n\t\t\t</div>\r\n\t\t\t<!-- End popup modal -->\r\n\r\n\t\t\t<div class=\"form_total_register edit_detailprofiles col-xs-12 zero_padding fade in active\" id=\"edit_profile\" style=\"position:relative;\">\r\n\r\n\t\t\t\t<!--<form #saveprofileForm=\"ngForm\">-->\r\n\t\t\t\t<div class=\"form-group\">\r\n\t\t\t\t\t<span class=\"col-xs-12 col-sm-3 edit_labelname edit_profilethick\">Name</span>\r\n\t\t\t\t\t<span class=\"col-xs-12 col-sm-6 zero_padding\">\r\n\t\t\t\t\t\t<input type=\"text\" class=\"form-control input-sm edit_profileopacity\" [(ngModel)]=\"data.fullName\" name=\"fullName\" #fullName=\"ngModel\">\r\n\t\t\t\t\t</span>\r\n\t\t\t\t</div>\r\n\t\t\t\t<div class=\"form-group\">\r\n\t\t\t\t\t<span class=\"col-xs-12 col-sm-3 edit_labelname edit_profilethick\">Username</span>\r\n\t\t\t\t\t<span class=\"col-xs-12 col-sm-6 zero_padding\">\r\n\t\t\t\t\t\t<input type=\"text\" class=\"username_profile form-control input-sm edit_profileopacity\" [(ngModel)]=\"data.username\" required\r\n\t\t\t\t\t\t name=\"username\" #username=\"ngModel\" readonly>\r\n\t\t\t\t\t</span>\r\n\t\t\t\t\t<div [hidden]=\"username.valid || username.pristine\" class=\"edit_profilerequired col-xs-12\" style=\"font-size:14px\">\r\n\t\t\t\t\t\tUserName is required\r\n\t\t\t\t\t</div>\r\n\t\t\t\t</div>\r\n\t\t\t\t<div class=\"form-group\">\r\n\t\t\t\t\t<span class=\"col-xs-12 col-sm-3 edit_labelname edit_profilethick\">Website</span>\r\n\t\t\t\t\t<span class=\"col-xs-12 col-sm-6 zero_padding\">\r\n\t\t\t\t\t\t<input type=\"text\" class=\"form-control input-sm edit_profileopacity\" [(ngModel)]=\"data.websiteUrl\" name=\"websiteUrl\" #website=\"ngModel\">\r\n\t\t\t\t\t</span>\r\n\t\t\t\t</div>\r\n\t\t\t\t<div class=\"form-group\">\r\n\t\t\t\t\t<span class=\"col-xs-12 col-sm-3 edit_labelname edit_profilethick\">Bio</span>\r\n\t\t\t\t\t<span class=\"col-xs-12 col-sm-6 zero_padding\">\r\n\t\t\t\t\t\t<textarea class=\"bio_profile form-control input-sm edit_profileopacity\" [(ngModel)]=\"data.bio\" name=\"bio\" #bio=\"ngModel\"\r\n\t\t\t\t\t\t cols=\"5\" rows=\"3\" maxlength=\"150\"></textarea>\r\n\t\t\t\t\t</span>\r\n\t\t\t\t\t<!--<div [hidden]=\"bio.pristine\" class=\"edit_profilerequired col-xs-12\" style=\"font-size:14px\"> \r\n\t\t\t\t   use 150 words is only...\r\n\t\t\t\t</div>\t\t\t\t-->\r\n\t\t\t\t</div>\r\n\t\t\t\t<div class=\"form-group\">\r\n\t\t\t\t\t<span class=\"col-xs-12 col-sm-3 edit_labelname\"></span>\r\n\t\t\t\t\t<span class=\"col-xs-12 col-sm-6 zero_padding\" style=\"\">\r\n\t\t\t\t\t\t<h6 style=\"font-weight: 600;color: #999;\">PRIVATE INFORMATION</h6>\r\n\t\t\t\t\t</span>\r\n\t\t\t\t</div>\r\n\t\t\t\t<div class=\"form-group\">\r\n\t\t\t\t\t<span class=\"col-xs-12 col-sm-3 edit_labelname edit_profilethick\">Private Account</span>\r\n\t\t\t\t\t<span class=\"col-xs-12 col-sm-6 zero_padding\">\r\n\t\t\t\t\t\t<label class=\"switch\">\r\n\t\t\t\t\t\t\t<input type=\"checkbox\" [checked]=\"data.private == 1\" #st (change)=\"changePrivate(st.checked)\">\r\n\t\t\t\t\t\t\t<span class=\"slider round\"></span>\r\n\t\t\t\t\t\t</label>\r\n\t\t\t\t\t</span>\r\n\t\t\t\t\t<!--<div [hidden]=\"email.valid || email.pristine\" class=\"edit_profilerequired col-xs-12\" style=\"font-size:14px\">\r\n\t\t\t\t   Email is required\r\n\t\t\t\t</div>-->\r\n\t\t\t\t</div>\r\n\t\t\t\t<div class=\"form-group\">\r\n\t\t\t\t\t<span class=\"col-xs-12 col-sm-3 edit_labelname edit_profilethick\">Email</span>\r\n\t\t\t\t\t<span class=\"col-xs-12 col-sm-6 zero_padding\">\r\n\t\t\t\t\t\t<input type=\"email\" class=\"email_profile form-control input-sm edit_profileopacity\" [(ngModel)]=\"data.email\" name=\"email\"\r\n\t\t\t\t\t\t #email=\"ngModel\">\r\n\t\t\t\t\t</span>\r\n\t\t\t\t\t<!--<div [hidden]=\"email.valid || email.pristine\" class=\"edit_profilerequired col-xs-12\" style=\"font-size:14px\">\r\n\t\t\t\t   Email is required\r\n\t\t\t\t</div>-->\r\n\t\t\t\t</div>\r\n\t\t\t\t<div class=\"form-group\">\r\n\t\t\t\t\t<span class=\"col-xs-12 col-sm-3 edit_labelname edit_profilethick\">Phone Number</span>\r\n\t\t\t\t\t<span class=\"col-xs-12 col-sm-6 zero_padding\">\r\n\t\t\t\t\t\t<input type=\"text\" class=\"mobile_profile form-control input-sm edit_profileopacity\" [(ngModel)]=\"data.phoneNumber\" name=\"phoneNumber\"\r\n\t\t\t\t\t\t #phoneNumber=\"ngModel\" readonly>\r\n\t\t\t\t\t</span>\r\n\t\t\t\t\t<!--<div [hidden]=\"phoneNumber.valid || phoneNumber.pristine\" class=\"edit_profilerequired col-xs-12\">\r\n\t\t\t\t   PhoneNumber is required\r\n\t\t\t\t</div>-->\r\n\t\t\t\t</div>\r\n\t\t\t\t<div class=\"form-group\">\r\n\t\t\t\t\t<span class=\"col-xs-12 col-sm-3 edit_labelname edit_profilethick\">Gender</span>\r\n\t\t\t\t\t<span class=\"col-xs-12 col-sm-6 zero_padding\">\r\n\t\t\t\t\t\t<select class=\"form-control input-sm edit_profileopacity\" [(ngModel)]=\"data.gender\" name=\"gender\" #gender=\"ngModel\">\r\n\t\t\t\t\t\t\t<option value=\"form-control\">Not Specified</option>\r\n\t\t\t\t\t\t\t<option value=\"Male\">Male</option>\r\n\t\t\t\t\t\t\t<option value=\"Female\">Female</option>\r\n\t\t\t\t\t\t</select>\r\n\t\t\t\t\t</span>\r\n\t\t\t\t</div>\r\n\t\t\t\t<!--<div class=\"form-group\">\r\n\t\t\t\t<span class=\"col-xs-12 col-sm-3 edit_labelname edit_profilethick\">Similar Account Suggestions</span>\r\n\t\t\t\t<span class=\"col-xs-12 col-sm-6 zero_padding\"><input type=\"checkbox\" name=\"\" value=\"\"><span class=\"checktext edit_profileopacity\" style=\"margin: 6px 10px;\">Include your account when recommending similar accounts people might want to follow.</span></span>\r\n\t\t\t</div>-->\r\n\t\t\t\t<div class=\"form-group\">\r\n\t\t\t\t\t<span class=\"col-xs-12 col-sm-3 edit_labelname\"></span>\r\n\t\t\t\t\t<span class=\"col-xs-12 col-sm-6 zero_padding\" style=\"\">\r\n\t\t\t\t\t\t<div class=\"bufferprofile_gif\" *ngIf=\"bufferprofile\">\r\n\t\t\t\t\t\t\t<img src=\"/public/images/ajax-loader2.gif\" alt=\"loader\">\r\n\t\t\t\t\t\t</div>\r\n\t\t\t\t\t\t<button type=\"submit\" class=\"edit_submitbutton btn\" (click)=\"saveUser();\">Submit</button>\r\n\t\t\t\t\t\t<!--<a class=\"temporary_link\" href=\"https://www.instagram.com/accounts/remove/request/temporary/\" style=\"font-size:14px\">Temporarily disable my account</a>-->\r\n\t\t\t\t\t</span>\r\n\t\t\t\t</div>\r\n\t\t\t\t<div style=\"color:#FF5A5F;margin-left: 25%;font-size:14px\" class=\"email_phone\" [hidden]=\"!email_phone\">You need an email or confirmed phone number.!</div>\r\n\t\t\t\t<div style=\"color:#FF5A5F;margin-left: 25%;font-size:14px\" class=\"bio_details\" [hidden]=\"!bio_details\">Your bio must be 150 characters or fewer.</div>\r\n\t\t\t\t<div style=\"color:#FF5A5F;margin-left: 25%;font-size:14px\" class=\"biod_details\" [hidden]=\"!mobile_details\">Looks like your phone number may be incorrect. Please try entering your full number, including the country code.</div>\r\n\t\t\t\t<div style=\"color:green;margin-left: 25%;font-size:14px\" *ngIf=\"saveuser\">Profile saved!</div>\r\n\r\n\t\t\t\t<!--</form>\t\t\t-->\r\n\t\t\t</div>\r\n\r\n\t\t\t<div class=\"col-xs-12 zero_padding form_total_register edit_detailprofiles password_register fade\" id=\"change_password\">\r\n\t\t\t\t<form [formGroup]=\"resetpasswordForm\">\r\n\t\t\t\t\t<div class=\"form-group\">\r\n\t\t\t\t\t\t<span class=\"col-xs-12 col-sm-3 edit_labelname color_thick\">Old Password</span>\r\n\t\t\t\t\t\t<span class=\"col-xs-12 col-sm-6 zero_padding\">\r\n\t\t\t\t\t\t\t<input type=\"password\" [(ngModel)]=\"oldPassword\" name=\"oldPassword\" value=\"\" class=\"text_password1 form-control input-sm color_thick color_opacity\">\r\n\t\t\t\t\t\t</span>\r\n\t\t\t\t\t\t<!--<control-messages [control]=\"resetpasswordForm.controls.oldPassword\"></control-messages>-->\r\n\t\t\t\t\t</div>\r\n\t\t\t\t\t<div class=\"form-group\">\r\n\t\t\t\t\t\t<span class=\"col-xs-12 col-sm-3 edit_labelname color_thick\">New Password</span>\r\n\t\t\t\t\t\t<span class=\"col-xs-12 col-sm-6 zero_padding\">\r\n\t\t\t\t\t\t\t<input type=\"password\" [(ngModel)]=\"newPassword\" name=\"newPassword\" value=\"\" class=\"text_password2 form-control input-sm color_thick color_opacity\">\r\n\t\t\t\t\t\t</span>\r\n\t\t\t\t\t\t<!--<control-messages [control]=\"resetpasswordForm.controls.newPassword\"></control-messages>-->\r\n\t\t\t\t\t</div>\r\n\t\t\t\t\t<div class=\"form-group\">\r\n\t\t\t\t\t\t<span class=\"col-xs-12 col-sm-3 edit_labelname color_thick\">New Password, Again</span>\r\n\t\t\t\t\t\t<span class=\"col-xs-12 col-sm-6 zero_padding\">\r\n\t\t\t\t\t\t\t<input type=\"password\" [(ngModel)]=\"confirmPassword\" name=\"confirmPassword\" value=\"\" class=\"text_password3 form-control input-sm color_thick color_opacity\">\r\n\t\t\t\t\t\t</span>\r\n\t\t\t\t\t\t<!--<control-messages [control]=\"resetpasswordForm.controls.confirmPassword\"></control-messages>-->\r\n\t\t\t\t\t</div>\r\n\t\t\t\t\t<div class=\"form-group\">\r\n\t\t\t\t\t\t<span class=\"col-xs-12 col-sm-3 edit_labelname\"></span>\r\n\t\t\t\t\t\t<span class=\"col-xs-12 col-sm-6 zero_padding\" style=\"\">\r\n\t\t\t\t\t\t\t<button class=\"edit_submitbutton button_chagepassword btn\" type=\"submit\" [disabled]=\"!resetpasswordForm.valid\" (click)=\"changePassword();\">Change Password</button>\r\n\t\t\t\t\t\t</span>\r\n\t\t\t\t\t</div>\r\n\t\t\t\t\t<div style=\"color:green;margin-left: 25%;\" [hidden]=\"passwordsuccess\">success, password updated</div>\r\n\t\t\t\t\t<div style=\"color:#FF5A5F;margin-left: 25%;\" [hidden]=\"passwordolderror\">old password does not match</div>\r\n\t\t\t\t\t<div style=\"color:#FF5A5F;margin-left: 25%;\" [hidden]=\"passworderror\">new password and confirm password does not match</div>\r\n\t\t\t\t</form>\r\n\t\t\t</div>\r\n\t\t\t<div class=\"col-xs-12 zero_padding edit_detailprofiles revoke_access fade\" id=\"authorized\">\r\n\t\t\t\t<div class=\"col-xs-12 zero_padding edit_message\">\r\n\t\t\t\t\t<h2 class=\"col-xs-12 zero_padding color_thick\">InMessage</h2>\r\n\t\t\t\t\t<p class=\"col-xs-12 zero_padding revoke_paragraph\" style=\"\">iOS InMessage allows you to connect directly with anyone you like on Instagram, privately! Now with Mingler you can\r\n\t\t\t\t\t\tenjoy a totally private conversation with any Instagram user whose photos attract you the most. </p>\r\n\t\t\t\t\t<h2 class=\"col-xs-12 zero_padding color_thick\" style=\"color: #999;\">PERMISSIONS</h2>\r\n\t\t\t\t\t<ul class=\"col-xs-12 zero_padding list_edit_details\">\r\n\t\t\t\t\t\t<li class=\"col-xs-12 zero_padding list_revoke\">\r\n\t\t\t\t\t\t\t<span class=\"color_thick col-xs-6\">Access your basic information</span>\r\n\t\t\t\t\t\t\t<span class=\"color_thick color_opacity col-xs-6\">Your media & profile info</span>\r\n\t\t\t\t\t\t</li>\r\n\t\t\t\t\t</ul>\r\n\t\t\t\t\t<div class=\"form-group\">\r\n\t\t\t\t\t\t<span class=\"col-xs-12 zero_padding\" style=\"\">\r\n\t\t\t\t\t\t\t<button class=\"edit_submitbutton btn revokee\" id=\"revoke1\" type=\"submit\" (click)=\"revoke1();\">Revoke Access</button>\r\n\t\t\t\t\t\t</span>\r\n\t\t\t\t\t</div>\r\n\t\t\t\t\t<div class=\"col-xs-5 zero_padding revoke_popup_small\" id=\"revoke1content\" [hidden]=\"authorizedd1\">\r\n\t\t\t\t\t\t<div class=\"revoke_para col-xs-12 zero_padding\">\r\n\t\t\t\t\t\t\t<span class=\"color_thick color_opacity\">Are you sure you want to revoke this app's access?</span>\r\n\t\t\t\t\t\t</div>\r\n\t\t\t\t\t\t<div class=\"col-xs-12 zero_padding\" style=\"margin-top:5%;\">\r\n\t\t\t\t\t\t\t<span class=\"col-xs-6 zero_padding\">\r\n\t\t\t\t\t\t\t\t<button class=\"edit_submitbutton btn\" type=\"submit\">Yes</button>\r\n\t\t\t\t\t\t\t</span>\r\n\t\t\t\t\t\t\t<span class=\"col-xs-6 zero_padding\">\r\n\t\t\t\t\t\t\t\t<button class=\"edit_submitbutton btn revoke_cancel\" type=\"submit\" (click)=\"revoke11();\">No</button>\r\n\t\t\t\t\t\t\t</span>\r\n\t\t\t\t\t\t</div>\r\n\t\t\t\t\t</div>\r\n\t\t\t\t</div>\r\n\t\t\t\t<div class=\"col-xs-12 zero_padding edit_message\">\r\n\t\t\t\t\t<h2 class=\"col-xs-12 zero_padding color_thick\">Dash Hudson</h2>\r\n\t\t\t\t\t<p class=\"col-xs-12 zero_padding revoke_paragraph\" style=\"\">Dash Hudson is a visual marketing platform working with aspirational, content focused brands to deepen engagement, manage\r\n\t\t\t\t\t\tmedia, partner with publishers, and create content. We work with leading brands in apparel, luxury, publishing, beauty,\r\n\t\t\t\t\t\tconsumer electronics, and food to be more successful on Instagram. </p>\r\n\t\t\t\t\t<h2 class=\"col-xs-12 zero_padding color_thick\" style=\"color: #999;\">PERMISSIONS</h2>\r\n\t\t\t\t\t<ul class=\"col-xs-12 zero_padding list_edit_details\">\r\n\t\t\t\t\t\t<li class=\"col-xs-12 zero_padding list_revoke\">\r\n\t\t\t\t\t\t\t<span class=\"color_thick col-xs-6\">Access your basic information</span>\r\n\t\t\t\t\t\t\t<span class=\"color_thick color_opacity col-xs-6\">Your media & profile info</span>\r\n\t\t\t\t\t\t</li>\r\n\t\t\t\t\t\t<li class=\"col-xs-12 zero_padding list_revoke\">\r\n\t\t\t\t\t\t\t<span class=\"color_thick col-xs-6\">Like photos</span>\r\n\t\t\t\t\t\t\t<span class=\"color_thick color_opacity col-xs-6\">Post and delete likes on your behalf</span>\r\n\t\t\t\t\t\t</li>\r\n\t\t\t\t\t\t<li class=\"col-xs-12 zero_padding list_revoke\">\r\n\t\t\t\t\t\t\t<span class=\"color_thick col-xs-6\">Follow accounts</span>\r\n\t\t\t\t\t\t\t<span class=\"color_thick color_opacity col-xs-6\">Follow and unfollow accounts on your behalf.</span>\r\n\t\t\t\t\t\t</li>\r\n\t\t\t\t\t</ul>\r\n\t\t\t\t\t<div class=\"form-group\">\r\n\t\t\t\t\t\t<span class=\"col-xs-12 zero_padding\" style=\"\">\r\n\t\t\t\t\t\t\t<button class=\"edit_submitbutton btn revokee\" id=\"revoke2\" type=\"submit\" (click)=\"revoke2();\">Revoke Access</button>\r\n\t\t\t\t\t\t</span>\r\n\t\t\t\t\t</div>\r\n\t\t\t\t\t<div class=\"col-xs-5 zero_padding revoke_popup_small\" id=\"revoke2content\" [hidden]=\"authorizedd2\">\r\n\t\t\t\t\t\t<div class=\"revoke_para col-xs-12 zero_padding\">\r\n\t\t\t\t\t\t\t<span class=\"color_thick color_opacity\">Are you sure you want to revoke this app's access?</span>\r\n\t\t\t\t\t\t</div>\r\n\t\t\t\t\t\t<div class=\"col-xs-12 zero_padding\" style=\"margin-top:5%;\">\r\n\t\t\t\t\t\t\t<span class=\"col-xs-6 zero_padding\">\r\n\t\t\t\t\t\t\t\t<button class=\"edit_submitbutton btn\" type=\"submit\">Yes</button>\r\n\t\t\t\t\t\t\t</span>\r\n\t\t\t\t\t\t\t<span class=\"col-xs-6 zero_padding\">\r\n\t\t\t\t\t\t\t\t<button class=\"edit_submitbutton btn revoke_cancel\" type=\"submit\" (click)=\"revoke22();\">No</button>\r\n\t\t\t\t\t\t\t</span>\r\n\t\t\t\t\t\t</div>\r\n\t\t\t\t\t</div>\r\n\t\t\t\t</div>\r\n\t\t\t</div>\r\n\t\t\t<div class=\"col-xs-12 zero_padding edit_detailprofiles subscribe_access fade\" id=\"preferences\">\r\n\t\t\t\t<h3 class=\"col-xs-12\">Subscribe to:</h3>\r\n\t\t\t\t<div class=\"col-xs-12 zero_padding div_subscribeto\">\r\n\t\t\t\t\t<span class=\"col-xs-1 zero_padding check_subscribe\">\r\n\t\t\t\t\t\t<input type=\"checkbox\" name=\"\" value=\"\" class=\"form-control input-sm\" style=\"height:20px;outline:0;\">\r\n\t\t\t\t\t</span>\r\n\t\t\t\t\t<span class=\"col-xs-11 zero_padding\">\r\n\t\t\t\t\t\t<h5 class=\"col-xs-12 zero_padding color_thick subscribe_label\">News emails</h5>\r\n\t\t\t\t\t\t<h6 class=\"col-xs-12 zero_padding color_thick color_opacity\">Find out first about new products.</h6>\r\n\t\t\t\t\t</span>\r\n\t\t\t\t</div>\r\n\t\t\t\t<div class=\"col-xs-12 zero_padding div_subscribeto\">\r\n\t\t\t\t\t<span class=\"col-xs-1 zero_padding check_subscribe\">\r\n\t\t\t\t\t\t<input type=\"checkbox\" name=\"\" value=\"\" class=\"form-control input-sm\" style=\"height:20px;outline:0;\">\r\n\t\t\t\t\t</span>\r\n\t\t\t\t\t<span class=\"col-xs-11 zero_padding\">\r\n\t\t\t\t\t\t<h5 class=\"col-xs-12 zero_padding color_thick subscribe_label\">Reminder emails</h5>\r\n\t\t\t\t\t\t<h6 class=\"col-xs-12 zero_padding color_thick color_opacity\">Stay up to date with things you may have missed.</h6>\r\n\t\t\t\t\t</span>\r\n\t\t\t\t</div>\r\n\t\t\t\t<div class=\"col-xs-12 zero_padding div_subscribeto\">\r\n\t\t\t\t\t<span class=\"col-xs-1 zero_padding check_subscribe\">\r\n\t\t\t\t\t\t<input type=\"checkbox\" name=\"\" value=\"\" class=\"form-control input-sm\" style=\"height:20px;outline:0;\">\r\n\t\t\t\t\t</span>\r\n\t\t\t\t\t<span class=\"col-xs-11 zero_padding\">\r\n\t\t\t\t\t\t<h5 class=\"col-xs-12 zero_padding color_thick subscribe_label\">Product emails</h5>\r\n\t\t\t\t\t\t<h6 class=\"col-xs-12 zero_padding color_thick color_opacity\">Get tips on using Instagram's tools.</h6>\r\n\t\t\t\t\t</span>\r\n\t\t\t\t</div>\r\n\t\t\t\t<div class=\"col-xs-12 zero_padding div_subscribeto\">\r\n\t\t\t\t\t<span class=\"col-xs-1 zero_padding check_subscribe\">\r\n\t\t\t\t\t\t<input type=\"checkbox\" name=\"\" value=\"\" class=\"form-control input-sm\" style=\"height:20px;outline:0;\">\r\n\t\t\t\t\t</span>\r\n\t\t\t\t\t<span class=\"col-xs-11 zero_padding\">\r\n\t\t\t\t\t\t<h5 class=\"col-xs-12 zero_padding color_thick subscribe_label\">Research emails</h5>\r\n\t\t\t\t\t\t<h6 class=\"col-xs-12 zero_padding color_thick color_opacity\">Provide feedback and participate in research studies.</h6>\r\n\t\t\t\t\t</span>\r\n\t\t\t\t</div>\r\n\t\t\t</div>\r\n\r\n\t\t</div>\r\n\t</div>\r\n</div>\r\n\r\n</html>";

/***/ },

/***/ 510:
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var core_1 = __webpack_require__(5);
	var router_1 = __webpack_require__(389);
	var footer_component_1 = __webpack_require__(453);
	var forms_1 = __webpack_require__(326);
	var login_message_component_1 = __webpack_require__(454);
	var auth_service_1 = __webpack_require__(456);
	var ResetpasswordComponent = (function () {
	    function ResetpasswordComponent(formBuilder, _authService, _router, route) {
	        this.formBuilder = formBuilder;
	        this._authService = _authService;
	        this._router = _router;
	        this.route = route;
	        this.resetpassSuccess = false;
	        this.bufferlogin = false;
	        this.retypepasswordForm = this.formBuilder.group({
	            'newPassword': ['', [forms_1.Validators.required]],
	            'confirmPassword': ['', [forms_1.Validators.required]]
	        });
	    }
	    ResetpasswordComponent.prototype.ngOnInit = function () {
	        var _this = this;
	        this.route.params.subscribe(function (params) {
	            _this.reset_token = params['reset_token'];
	            //console.log(this.reset_token); 
	        });
	    };
	    ResetpasswordComponent.prototype.changePassword = function () {
	        var _this = this;
	        this.bufferlogin = true;
	        this._authService.changePassword({
	            password: this.newPassword,
	            repeatPassword: this.confirmPassword,
	            passwordResetLink: this.reset_token
	        }).subscribe(function (res) {
	            if (res.code == 200) {
	                //   alert(res.message);
	                setTimeout(function () {
	                    _this.bufferlogin = false;
	                }, 500);
	                _this.resetpasserror = false;
	                _this.resetpassSuccess = true;
	                setTimeout(function () {
	                    _this._router.navigate(['login']);
	                }, 1500);
	            }
	            if (res.code == 1981) {
	                setTimeout(function () {
	                    _this.bufferlogin = false;
	                }, 500);
	                _this.resetpasserror = res.message;
	            }
	            if (res.code == 1983) {
	                setTimeout(function () {
	                    _this.bufferlogin = false;
	                }, 500);
	                _this.resetpasserror = "password reset link invalid";
	            }
	        });
	    };
	    ResetpasswordComponent = __decorate([
	        core_1.Component({
	            selector: 'reset',
	            template: __webpack_require__(511),
	            directives: [footer_component_1.FooterComponent, forms_1.REACTIVE_FORM_DIRECTIVES, login_message_component_1.ControlMessages],
	            providers: [auth_service_1.AuthService]
	        }), 
	        __metadata('design:paramtypes', [forms_1.FormBuilder, auth_service_1.AuthService, router_1.Router, router_1.ActivatedRoute])
	    ], ResetpasswordComponent);
	    return ResetpasswordComponent;
	}());
	exports.ResetpasswordComponent = ResetpasswordComponent;


/***/ },

/***/ 511:
/***/ function(module, exports) {

	module.exports = "<!DOCTYPE html>\r\n<html>\r\n<head>\r\n\t<title>Sportemage</title>\r\n    <link rel=\"icon\" type=\"image/gif/png\" href=\"/public/images/picoTitleLogo.png\">\r\n</head>\r\n\r\n<div class=\"container-fluid picogram_total\">\r\n    <div class=\"container landing_login_signup login_mobile_imgg\" style=\"\">\r\n        <div class=\"col-xs-12 hidden-xs hidden-sm col-sm-6 col-md-6 zero_padding mobile_image\">\r\n            <div id=\"carouselHacked\" class=\"carousel slide carousel-fade\" data-ride=\"carousel\">\r\n                <!-- Wrapper for slides -->\r\n                <div class=\"carousel-inner\" role=\"listbox\">\r\n                    <div class=\"item active\">\r\n                        <img class=\"change_image img-responsive\" src=\"https://instagramstatic-a.akamaihd.net/h1/images/homepage/screenshot1.jpg/aafd8c6b005d.jpg\">\r\n                    </div>\r\n                    <div class=\"item\">\r\n                        <img class=\"change_image img-responsive\" src=\"https://instagramstatic-a.akamaihd.net/h1/images/homepage/screenshot2.jpg/2d9d7248af43.jpg\">\r\n                    </div>\r\n                    <div class=\"item\">\r\n                        <img class=\"change_image img-responsive\" src=\"https://instagramstatic-a.akamaihd.net/h1/images/homepage/screenshot3.jpg/629d23a3c7b2.jpg\">\r\n                    </div>\r\n                    <div class=\"item\">\r\n                        <img class=\"change_image img-responsive\" src=\"https://instagramstatic-a.akamaihd.net/h1/images/homepage/screenshot4.jpg/001bc33056c1.jpg\">\r\n                    </div>\r\n                    <div class=\"item\">\r\n                        <img class=\"change_image img-responsive\" src=\"https://instagramstatic-a.akamaihd.net/h1/images/homepage/screenshot5.jpg/f5ae123ab1e2.jpg\">\r\n                    </div>\r\n                </div>\r\n            </div>\r\n        </div>\r\n        <div class=\"col-xs-12 col-md-6 zero_padding login_mobile_img\">\r\n             <div class=\"login_pico_logo col-xs-12 zero_padding\" style=\"text-align:center;\">\r\n                <span class=\"\"><img src=\"/public/images/pico_logo.png\" alt=\"Sportemage\"></span>               \r\n            </div>\r\n            <h2 class=\"col-xs-12\" style=\"text-align:center;display: inline-block;\">RESET PASSWORD</h2>\r\n            <form [formGroup]=\"retypepasswordForm\">\r\n            <div class=\"col-xs-12 zero_padding signup_form form-group\">\r\n                <label for=\"Password\" style=\"font-size:14px;\">Password</label>\r\n                <span class=\"\"><input type=\"password\" [(ngModel)]=\"newPassword\" name=\"newPassword\" id=\"password\" value=\"\" class=\"sign_validation3 form-control color_thick color_opacity icon_err_right\" placeholder=\"Password\"><i class=\"icon_err_right\"></i></span>\r\n                <control-messages [control]=\"retypepasswordForm.controls.newPassword\" style=\"font-size:14px;text-align:center;\"></control-messages>\r\n            </div>\r\n            <div class=\"col-xs-12 zero_padding signup_form form-group\">\r\n                <label for=\"Re-Password\" style=\"font-size:14px;\">Retype-Password</label>\r\n                <span class=\"\"><input type=\"password\" [(ngModel)]=\"confirmPassword\" name=\"confirmPassword\" id=\"repassword\" value=\"\" class=\"sign_validation3 form-control color_thick color_opacity icon_err_right\" placeholder=\"RetypePassword\"><i class=\"icon_err_right\"></i></span>        \r\n                <control-messages [control]=\"retypepasswordForm.controls.confirmPassword\" style=\"font-size:14px;text-align:center;\"></control-messages>                \r\n            </div>\r\n            \r\n            <div class=\"col-xs-12 zero_padding signup_form\">\r\n                <span class=\"bufferlogin_gif\" *ngIf=\"bufferlogin\"><img src=\"/public/images/ajax-loader2.gif\" alt=\"loader\"></span>\r\n                <span class=\"col-xs-12 zero_padding\"><button type=\"submit\" [disabled]=\"!retypepasswordForm.valid\" (click)=\"changePassword();\" class=\"landing_click login_click col-xs-12 zero_padding\" style=\"font-size:14px;\">Submit</button></span>\r\n            </div>\r\n            <div style=\"font-size:14px;color:#FF5A5F;text-align: center;\" *ngIf=\"resetpasserror\">{{resetpasserror}}</div>\r\n            <div style=\"font-size:14px;color:green;text-align: center;\" *ngIf=\"resetpassSuccess\">Passwords update!</div>\r\n            </form>\r\n        </div>\r\n    </div>\r\n</div>\r\n\r\n<!--<footer></footer>-->\r\n</html>";

/***/ },

/***/ 512:
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var core_1 = __webpack_require__(5);
	var PrivacyComponent = (function () {
	    function PrivacyComponent() {
	    }
	    PrivacyComponent = __decorate([
	        core_1.Component({
	            selector: 'privacy',
	            template: __webpack_require__(513),
	        }), 
	        __metadata('design:paramtypes', [])
	    ], PrivacyComponent);
	    return PrivacyComponent;
	}());
	exports.PrivacyComponent = PrivacyComponent;


/***/ },

/***/ 513:
/***/ function(module, exports) {

	module.exports = "<div class=\"container\">\r\n\r\n\t<h2>Privacy Policy</h2>\r\n\t<p>This policy describes the information we process to support Sportemage, and other products and features offered by\r\n\t\tSportemage (<u>Sportemage Products</u>&nbsp;or Products). You can find additional tools and information in the&nbsp;<u>Sportemage\r\n\t\t\tSettings</u>.</p>\r\n\t<ol>\r\n\t\t<li><strong> What kinds of information do we collect?</strong></li>\r\n\t</ol>\r\n\t<p>To provide the Sportemage Products, we must process information about you. The types of information we collect\r\n\t\tdepend on how you use our Products. You can learn how to access and delete information we collect by visiting\r\n\t\tthe&nbsp;<u>Sportemage Settings</u>.</p>\r\n\t<p>&nbsp;</p>\r\n\t<p><strong>Things you and others do and provide.</strong></p>\r\n\t<ul>\r\n\t\t<li><strong>Information and content you provide.</strong>We collect the content, communications and other information\r\n\t\t\tyou provide when you use our Products, including when you sign up for an account, create or share content, and\r\n\t\t\tmessage or communicate with others. This can include information in or about the content you provide (like\r\n\t\t\tmetadata), such as the location of a photo or the date a file was created. It can also include what you see through\r\n\t\t\tfeatures we provide, such as our&nbsp;<u>camera</u>, so we can do things like suggest masks and filters that you\r\n\t\t\tmight like, or give you tips on using portrait mode. Our systems automatically process content and communications\r\n\t\t\tyou and others provide to analyze context and what's in them for the purposes described&nbsp;<u>below</u>. Learn\r\n\t\t\tmore about how you can control who can see the things you&nbsp;<u>share</u>.\r\n\t\t\t<ul>\r\n\t\t\t\t<li>Data with special protections: You can choose to provide information in your Sportemage&nbsp;<u>profile fields</u>or\r\n\t\t\t\t\tLife Events about your religious views, political views, who you are \"interested in,\" or your health. This and\r\n\t\t\t\t\tother information (such as racial or ethnic origin, philosophical beliefs or trade union membership) is subject to\r\n\t\t\t\t\tspecial protections under EU law.</li>\r\n\t\t\t</ul>\r\n\t\t</li>\r\n\t\t<li><strong>Networks and connections.</strong>We collect information about the people,&nbsp;<u>Pages</u>,\r\n\t\t\taccounts,&nbsp;<u>hashtags</u>&nbsp;and groups you are connected to and how you interact with them across our\r\n\t\t\tProducts, such as people you communicate with the most or groups you are part of. We also collect contact\r\n\t\t\tinformation if you&nbsp;<u>choose to upload, sync or import it from a device</u>&nbsp;(such as an address book or\r\n\t\t\tcall log or SMS log history), which we use for things like helping you and others find people you may know and for\r\n\t\t\tthe other purposes listed&nbsp;<u>below</u>.</li>\r\n\t\t<li><strong>Your usage.</strong>We collect information about how you use our Products, such as the types of content\r\n\t\t\tyou view or engage with; the features you use; the actions you take; the people or accounts you interact with; and\r\n\t\t\tthe time, frequency and duration of your activities. For example, we log when you're using and have last used our\r\n\t\t\tProducts, and what posts, videos and other content you view on our Products. We also collect information about how\r\n\t\t\tyou use features like our camera.</li>\r\n\t\t<li><strong>Information about transactions made on our Products.</strong>If you use our Products for&nbsp;<u>purchases</u>&nbsp;or\r\n\t\t\tother financial transactions (such as when you make a purchase in a game or make a&nbsp;<u>donation</u>), we collect\r\n\t\t\tinformation about the purchase or transaction. This includes payment information, such as your credit or debit card\r\n\t\t\tnumber and other card information; other account and authentication information; and billing, shipping and contact\r\n\t\t\tdetails.</li>\r\n\t\t<li><strong>Things others do and information they provide about you.</strong>We also receive and analyze content,\r\n\t\t\tcommunications and information that other people provide when they use our Products. This can include information\r\n\t\t\tabout you, such as when others share or comment on a photo of you, send a message to you, or upload, sync or import\r\n\t\t\tyour contact information.</li>\r\n\t</ul>\r\n\t<p><strong>Device Information</strong></p>\r\n\t<p>As described below, we collect information from and about the computers, phones, connected TVs and other\r\n\t\tweb-connected devices you use that integrate with our Products, and we combine this information across different\r\n\t\tdevices you use. For example, we use information collected about your use of our Products on your phone to better\r\n\t\tpersonalize the content (including&nbsp;<u>ads</u>) or features you see when you use our Products on another device,\r\n\t\tsuch as your laptop or tablet, or to measure whether you took an action in response to an ad we showed you on your\r\n\t\tphone on a different device.</p>\r\n\t<p>Information we obtain from these devices includes:</p>\r\n\t<ul>\r\n\t\t<li><strong>Device attributes:</strong>information such as the operating system, hardware and software versions,\r\n\t\t\tbattery level, signal strength, available storage space, browser type, app and file names and types, and plugins.</li>\r\n\t\t<li><strong>Device operations:</strong>information about operations and behaviors performed on the device, such as\r\n\t\t\twhether a window is foregrounded or backgrounded, or mouse movements (which can help distinguish humans from bots).</li>\r\n\t\t<li><strong>Identifiers:</strong>unique identifiers, device IDs, and other identifiers, such as from games, apps or\r\n\t\t\taccounts you use, and Family Device IDs (or other identifiers unique to&nbsp;<u>Sportemage Company Products</u>&nbsp;associated\r\n\t\t\twith the same device or account).</li>\r\n\t\t<li><strong>Device signals:</strong>Bluetooth signals, and information about nearby Wi-Fi access points, beacons, and\r\n\t\t\tcell towers.</li>\r\n\t\t<li><strong>Data from device settings:</strong>information you allow us to receive through device settings you turn\r\n\t\t\ton, such as access to your GPS location, camera or photos.</li>\r\n\t\t<li><strong>Network and connections:</strong>information such as the name of your mobile operator or ISP, language,\r\n\t\t\ttime zone, mobile phone number, IP address, connection speed and, in some cases, information about other devices\r\n\t\t\tthat are nearby or on your network, so we can do things like help you&nbsp;<u>stream a video from your phone to your\r\n\t\t\t\tTV</u>.</li>\r\n\t\t<li><strong>Cookie data:</strong>data from cookies stored on your device, including cookie IDs and settings. Learn\r\n\t\t\tmore about how we use cookies in the&nbsp;<u>Sportemage Cookies Policy</u>&nbsp;and&nbsp;<u>Sportemage Cookies\r\n\t\t\t\tPolicy</u>.</li>\r\n\t</ul>\r\n\t<p>&nbsp;</p>\r\n\t<p><strong>Information from partners.</strong></p>\r\n\t<p>Advertisers,&nbsp;<u>app</u>&nbsp;developers, and publishers can send us information through&nbsp;<u>Sportemage\r\n\t\t\tBusiness Tools</u>&nbsp;they use, including our social plug-ins (such as the Like button), Sportemage Login,\r\n\t\tour&nbsp;<u>APIs and SDKs</u>, or the Sportemage&nbsp;<u>pixel</u>. These partners provide information about your\r\n\t\tactivities off Sportemage&mdash;including information about your device, websites you visit, purchases you make, the\r\n\t\tads you see, and how you use their services&mdash;whether or not you have a Sportemage account or are logged into\r\n\t\tSportemage. For example, a game developer could use our API to tell us what games you play, or a business could tell\r\n\t\tus about a purchase you made in its store. We also receive information about your online and offline actions and\r\n\t\tpurchases from third-party data providers who have the rights to provide us with your information.</p>\r\n\t<p>Partners receive your data when you visit or use their services or through third parties they work with. We require\r\n\t\teach of these partners to have lawful rights to collect, use and share your data before providing any data to\r\n\t\tus.&nbsp;<u>Learn more</u>&nbsp;about the types of partners we receive data from.</p>\r\n\t<p>To learn more about how we use cookies in connection with Sportemage Business Tools, review the&nbsp;<u>Sportemage\r\n\t\t\tCookies Policy</u>&nbsp;and&nbsp;<u>Sportemage Cookies Policy</u>.</p>\r\n\t<ol>\r\n\t\t<li><strong> How do we use this information?</strong></li>\r\n\t</ol>\r\n\t<p>We use the information we have (subject to choices you make) as described below and to provide and support the\r\n\t\tSportemage Products and related services described in the&nbsp;<u>Sportemage Terms</u>. Here's how:</p>\r\n\t<p><strong>Provide, personalize and improve our Products.</strong></p>\r\n\t<p>We use the information we have to deliver our Products, including to personalize features and content (including\r\n\t\tyour&nbsp;<u>News Feed</u>,&nbsp;<u>Sportemage Feed</u>, Sportemage Stories and ads) and make suggestions for you\r\n\t\t(such as groups or&nbsp;<u>events</u>&nbsp;you may be interested in or topics you may want to follow) on and off our\r\n\t\tProducts. To create personalized Products that are unique and relevant to you, we use your connections, preferences,\r\n\t\tinterests and activities based on the data we collect and learn from you and others (including any&nbsp;<u>data with\r\n\t\t\tspecial protections</u>&nbsp;you choose to provide where you have given your explicit consent); how you use and\r\n\t\tinteract with our Products; and the people, places, or things you're connected to and interested in on and off our\r\n\t\tProducts. Learn more about how we use information about you to personalize your Sportemage and Sportemage experience,\r\n\t\tincluding features, content and recommendations in Sportemage Products; you can also learn more about how we choose\r\n\t\tthe&nbsp;<u>ads </u>that you see.</p>\r\n\t<ul>\r\n\t\t<li><strong>Information across Sportemage Products and devices:</strong>We connect information about your activities\r\n\t\t\ton different Sportemage Products and devices to provide a more tailored and consistent experience on all Sportemage\r\n\t\t\tProducts you use, wherever you use them. For example, we can suggest that you join a group on Sportemage that\r\n\t\t\tincludes people you follow on Sportemage or communicate with using Sportemage products. We can also make your\r\n\t\t\texperience more seamless, for example, by automatically filling in your registration information (such as your phone\r\n\t\t\tnumber) from one Sportemage Product when you sign up for an account on a different Product.</li>\r\n\t\t<li><strong>Location-related information:</strong>We use&nbsp;<u>location-related information</u>-such as your\r\n\t\t\tcurrent location, where you live, the places you like to go, and the businesses and people you're near-to provide,\r\n\t\t\tpersonalize and improve our Products,&nbsp;<u>including ads</u>, for you and others. Location-related information\r\n\t\t\tcan be based on things like precise device location (if you've allowed us to collect it), IP addresses, and\r\n\t\t\tinformation from your and others' use of Sportemage Products (such as check-ins or events you attend).</li>\r\n\t\t<li><strong>Product research and development:</strong>We use the information we have to develop, test and improve our\r\n\t\t\tProducts, including by conducting surveys and research, and testing and troubleshooting new products and features.</li>\r\n\t\t<li><strong>Face recognition:</strong>If you have it turned on, we use face recognition technology to recognize you\r\n\t\t\tin photos, videos and camera experiences. The face-recognition templates we create are&nbsp;<u>data with special\r\n\t\t\t\tprotections</u>&nbsp;under EU law. Learn more about&nbsp;<u>how we use face recognition technology</u>, or control\r\n\t\t\tour use of this technology in&nbsp;<u>Sportemage Settings</u>. If we introduce face-recognition technology to your\r\n\t\t\tSportemage experience, we will let you know first, and you will have control over whether we use this technology for\r\n\t\t\tyou.</li>\r\n\t\t<li><strong>Ads and other sponsored content:</strong>We use the information we have about you-including information\r\n\t\t\tabout your interests, actions and connections-to select and personalize ads, offers and other sponsored content that\r\n\t\t\twe show you. Learn more about how we&nbsp;<u>select and personalize ads</u>, and your choices over the data we use\r\n\t\t\tto select ads and other sponsored content for you in the&nbsp;<u>Sportemage Settings</u>&nbsp;.</li>\r\n\t</ul>\r\n\t<p>&nbsp;</p>\r\n\t<p><strong>Provide measurement, analytics, and other business services.</strong></p>\r\n\t<p>We use the information we have (including your activity off our Products, such as the websites you visit and ads\r\n\t\tyou see) to help advertisers and other partners measure the effectiveness and distribution of their ads and services,\r\n\t\tand understand the types of people who use their services and how people interact with their websites, apps, and\r\n\t\tservices.&nbsp;<u>Learn how we share information</u>&nbsp;with these partners.</p>\r\n\t<p><strong>Promote safety, integrity and security.</strong></p>\r\n\t<p>We use the information we have to verify accounts and activity, combat harmful conduct, detect and prevent spam and\r\n\t\tother bad experiences, maintain the integrity of our Products, and promote safety and security on and off of\r\n\t\tSportemage Products. For example, we use data we have to investigate suspicious activity or violations of our terms\r\n\t\tor policies, or to&nbsp;<u>detect when someone needs help</u>.</p>\r\n\t<p>&nbsp;</p>\r\n\t<p><strong>Communicate with you.</strong></p>\r\n\t<p>We use the information we have to send you marketing communications, communicate with you about our Products, and\r\n\t\tlet you know about our policies and terms. We also use your information to respond to you when you contact us.</p>\r\n\t<p>&nbsp;</p>\r\n\t<p><strong>Research and innovate for social good.</strong></p>\r\n\t<p>We use the information we have (including from research partners we collaborate with) to conduct and support&nbsp;<u>research</u>&nbsp;and\r\n\t\tinnovation on topics of general social welfare, technological advancement, public interest, health and well-being.\r\n\t\tFor example,&nbsp;<u>we analyze information we have about migration patterns during crises</u>&nbsp;to aid relief\r\n\t\tefforts.&nbsp;</p>\r\n\t<p>&nbsp;</p>\r\n\t<p><strong>III. How is this information shared?</strong></p>\r\n\t<p>Your information is shared with others in the following ways:</p>\r\n\t<p><strong>Sharing on Sportemage Products</strong></p>\r\n\t<p><strong>People and accounts you share and communicate with</strong></p>\r\n\t<p>When you share and communicate using our Products,&nbsp;<u>you choose the audience for what you share</u>. For\r\n\t\texample, when you post on Sportemage, you select the audience for the post, such as a group, all of your friends, the\r\n\t\tpublic, or a customized list of people. Similarly, when you use Sportemage to communicate with people or businesses,\r\n\t\tthose people and businesses can see the content you send. Your network can also see actions you have taken on our\r\n\t\tProducts, including engagement with ads and sponsored content. We also let other accounts see who has viewed their\r\n\t\tSportemage or Sportemage Stories.</p>\r\n\t<p><strong><u>Public information</u></strong>&nbsp;can be seen by anyone, on or off our Products, including if they\r\n\t\tdon't have an account. This includes your Sportemage username; any information you share with a public audience;\r\n\t\tinformation in your&nbsp;<u>public profile on Sportemage</u>; and content you share on a Sportemage Page,&nbsp;<u>public\r\n\t\t\tSportemage account</u>&nbsp;or any other public forum, such as&nbsp;<u>Sportemage Marketplace</u>. You, other people\r\n\t\tusing Sportemage and Sportemage, and we can provide access to or send public information to anyone on or off our\r\n\t\tProducts, including in other Sportemage Company Products, in search results, or through tools and APIs. Public\r\n\t\tinformation can also be seen, accessed, reshared or downloaded through third-party services such as search engines,\r\n\t\tAPIs, and offline media such as TV, and by apps, websites and other services that integrate with our Products.</p>\r\n\t<p>Learn more about what information is public and how to control your visibility on&nbsp;<u>Sportemage</u>\r\n\t\therebelow&nbsp;:</p>\r\n\t<p>&nbsp;</p>\r\n\t<p>Something that&rsquo;s public can be seen by anyone. That includes people who aren&rsquo;t your friends, people off\r\n\t\tof Sportemage and people who use different media such as print, broadcast (ex: television) and other sites on the\r\n\t\tInternet. For example, if you use our services to provide a real-time public comment to a television show, that may\r\n\t\tappear on the show or elsewhere on Sportemage.</p>\r\n\t<h1><u>What information is public?</u></h1>\r\n\t<p>Information you share that is always public: Some of the information you give us when you fill out your profile is\r\n\t\tpublic, such as your age range, language and country. We also use a part of your profile, called your Public Profile,\r\n\t\tto help connect you with friends and family. Your Public Profile includes your name, gender, username and user ID\r\n\t\t(account number), profile picture, cover photo and networks. This info is also public. Some of the ways this helps us\r\n\t\tconnect you are:</p>\r\n\t<ul>\r\n\t\t<li>Your name, profile picture and cover photo help people recognize you</li>\r\n\t\t<li>Gender helps us describe you (ex: \"Add her as a friend\")</li>\r\n\t\t<li>Listing your networks (ex: school, workplace) allows others to find you more easily</li>\r\n\t\t<li>Username and user ID (ex: your account number) are in the URL of your profile</li>\r\n\t\t<li>Age range helps provide you with age-appropriate content</li>\r\n\t\t<li>Language and country help us provide appropriate content and experiences</li>\r\n\t</ul>\r\n\t<p>Information you share publicly: When you choose to share something with Public (ex: when you select Public from the\r\n\t\taudience selector), it&rsquo;s considered public information. If you share something and you don&rsquo;t see an\r\n\t\taudience selector or another privacy setting, that information is also public. Learn more about using the audience\r\n\t\tselector to control who you share with when you post to Sportemage.</p>\r\n\t<p>Stuff other people share: If other people share info about you, even if it&rsquo;s something you shared with them\r\n\t\tbut did not make public, they can choose to make it public. Also when you comment on other people&rsquo;s public\r\n\t\tposts, your comment is public as well.</p>\r\n\t<p>Posts on Sportemage Pages or public groups: Sportemage Pages and public groups are public spaces. Anyone who can\r\n\t\tsee the Page or group can see your post or comment. Generally, when you post or comment on a Page or to a public\r\n\t\tgroup, a story can be published in News Feed as well as other places on or off Sportemage.</p>\r\n\t<p><strong>Content others share or reshare about you</strong></p>\r\n\t<p>You should consider who you choose to share with, because people who can see your activity on our Products can\r\n\t\tchoose to share it with others on and off our Products, including people and businesses outside the audience you\r\n\t\tshared with. For example, when you share a post or send a message to specific friends or accounts, they can download,\r\n\t\tscreenshot, or reshare that content to others across or off our Products, in person or in virtual reality experiences\r\n\t\tsuch as&nbsp;<u>Sportemage Spaces</u>. Also, when you comment on someone else's post or react to their content, your\r\n\t\tcomment or reaction is visible to anyone who can see the other person's content, and that person can change the\r\n\t\taudience later.</p>\r\n\t<p>People can also use our Products to create and share content about you with the audience they choose. For example,\r\n\t\tpeople can share a photo of you in a Story, mention or tag you at a location in a post, or share information about\r\n\t\tyou in their posts or messages. If you are uncomfortable with what others have shared about you on our Products, you\r\n\t\tcan learn how to&nbsp;<u>report the content</u>.</p>\r\n\t<p><strong>Information about your active status or presence on our Products.</strong></p>\r\n\t<p>People in your networks can see signals telling them whether you are active on our Products, including whether you\r\n\t\tare currently active on&nbsp;<u>Sportemage</u> or when you last used our Products.</p>\r\n\t<p><strong>Apps, websites, and third-party integrations on or using our Products.</strong></p>\r\n\t<p>When you choose to use third-party apps, websites, or other services that use, or are integrated with, our\r\n\t\tProducts, they can receive information about what you post or share. For example, when you play a game with your\r\n\t\tSportemage friends or use a Sportemage Comment or Share button on a website, the game developer or website can\r\n\t\treceive information about your activities in the game or receive a comment or link that you share from the website on\r\n\t\tSportemage. Also, when you download or use such third-party services, they can access your public profile on\r\n\t\tSportemage, and any information that you share with them. Apps and websites you use may receive your list of\r\n\t\tSportemage friends if you choose to share it with them. But apps and websites you use will not be able to receive any\r\n\t\tother information about your Sportemage friends from you, or information about any of your Sportemage followers\r\n\t\t(although your friends and followers may, of course, choose to share this information themselves). Information\r\n\t\tcollected by these third-party services is subject to their own terms and policies, not this one.</p>\r\n\t<p>Devices and operating systems providing native versions of Sportemage and Sportemage (i.e. where we have not\r\n\t\tdeveloped our own first-party apps) will have access to all information you choose to share with them, including\r\n\t\tinformation your friends share with you, so they can provide our core functionality to you.</p>\r\n\t<p><em>Note: We are in the process of restricting developers&rsquo; data access even further to help prevent abuse.\r\n\t\t\tFor example, we will remove developers' access to your Sportemage and Sportemage data if you haven't used their app\r\n\t\t\tin 3 months, and we are changing Login, so that in the next version, we will reduce the data that an app can request\r\n\t\t\twithout app review to include only name, Sportemage username and bio, profile photo and email address. Requesting\r\n\t\t\tany other data will require our approval.</em></p>\r\n\t<p><strong>New owner.</strong></p>\r\n\t<p>If the ownership or control of all or part of our Products or their assets changes, we may transfer your\r\n\t\tinformation to the new owner.</p>\r\n\t<p>&nbsp;</p>\r\n\t<p><strong>Sharing with Third-Party Partners</strong></p>\r\n\t<p>We work with third-party partners who help us provide and improve our Products or who use Sportemage Business Tools\r\n\t\tto grow their businesses, which makes it possible to operate our companies and provide free services to people around\r\n\t\tthe world. We don't sell any of your information to anyone, and we never will. We also impose strict restrictions on\r\n\t\thow our partners can use and disclose the data we provide. Here are the types of third parties we share information\r\n\t\twith:</p>\r\n\t<p><strong>Partners who use our analytics services.</strong></p>\r\n\t<p>We provide aggregated statistics and insights that help people and businesses understand how people are engaging\r\n\t\twith their posts, listings, Pages, videos and other content on and off the Sportemage Products. For example, Page\r\n\t\tadmins and Sportemage business profiles receive information about the number of people or accounts who viewed,\r\n\t\treacted to, or commented on their posts, as well as aggregate demographic and other information that helps them\r\n\t\tunderstand interactions with their Page or account.</p>\r\n\t<p><strong>Advertisers.</strong></p>\r\n\t<p>We provide advertisers with reports about the kinds of people seeing their ads and how their ads are performing,\r\n\t\tbut we don't share information that personally identifies you (information such as your name or email address that by\r\n\t\titself can be used to contact you or identifies who you are) unless you give us permission. For example, we provide\r\n\t\tgeneral demographic and interest information to advertisers (for example, that an ad was seen by a woman between the\r\n\t\tages of 25 and 34 who lives in Madrid and likes software engineering) to help them better understand their audience.\r\n\t\tWe also confirm which Sportemage ads led you to make a purchase or take an action with an advertiser.</p>\r\n\t<p><strong>Measurement partners.</strong></p>\r\n\t<p>We share information about you with companies that aggregate it to provide analytics and measurement reports to our\r\n\t\tpartners.</p>\r\n\t<p><strong>Partners offering goods and services in our Products.</strong></p>\r\n\t<p>When you subscribe to receive premium content, or buy something from a seller in our Products, the content creator\r\n\t\tor seller can receive your public information and other information you share with them, as well as the information\r\n\t\tneeded to complete the transaction, including shipping and contact details.</p>\r\n\t<p><strong>Vendors and service providers.</strong></p>\r\n\t<p>We provide information and content to vendors and service providers who support our business, such as by providing\r\n\t\ttechnical infrastructure services, analyzing how our Products are used, providing customer service, facilitating\r\n\t\tpayments or conducting surveys.</p>\r\n\t<p><strong>Researchers and academics.</strong></p>\r\n\t<p>We also provide information and content to research partners and&nbsp;<u>academics </u>to conduct research that\r\n\t\tadvances scholarship and innovation that support our business or mission, and enhances discovery and innovation on\r\n\t\ttopics of general social welfare, technological advancement, public interest, health and well-being.</p>\r\n\t<p><strong>Law enforcement or legal requests.</strong></p>\r\n\t<p>We share information with law enforcement or in response to legal requests in the circumstances outlined below.</p>\r\n\t<p>Learn more about how you can control the information about you that you or others share with third-party partners\r\n\t\tin the&nbsp;<u>Sportemage Settings</u>.</p>\r\n\t<ol>\r\n\t\t<li><strong> How do the Sportemage Companies work together?</strong></li>\r\n\t</ol>\r\n\t<p>Sportemage shares infrastructure, systems and technology with other&nbsp;<u>Sportemage Companies</u>&nbsp;to\r\n\t\tprovide an innovative, relevant, consistent and safe experience across all&nbsp;<u>Sportemage Company Products</u>&nbsp;you\r\n\t\tuse. We also process information about you across the Sportemage Companies for these purposes, as permitted by\r\n\t\tapplicable law and in accordance with their terms and policies. For example, we process information from Sportemage\r\n\t\tabout accounts sending spam on its service so we can take appropriate action against those accounts on Sportemage. We\r\n\t\talso work to understand how people use and interact with Sportemage Company Products, such as understanding the\r\n\t\tnumber of unique users on different Sportemage Company Products.</p>\r\n\t<p>&nbsp;</p>\r\n\t<ol>\r\n\t\t<li><strong> What is our legal basis for processing data?</strong></li>\r\n\t</ol>\r\n\t<p>We collect, use and share the data that we have in the ways described above:</p>\r\n\t<ul>\r\n\t\t<li>as necessary to fulfill our&nbsp;&nbsp;<u>Sportemage Terms of Use</u>;</li>\r\n\t\t<li>consistent with your consent, which you may revoke at any time through the&nbsp;<u>Sportemage Settings</u>;</li>\r\n\t\t<li>as necessary to comply with our legal obligations</li>\r\n\t\t<li>to protect your vital interests, or those of others;</li>\r\n\t\t<li>as necessary in the public interest; and</li>\r\n\t\t<li>as necessary for our (or others') legitimate interests, including our interests in providing an innovative,\r\n\t\t\tpersonalized, safe, and profitable service to our users and partners, unless those interests are overridden by your\r\n\t\t\tinterests or fundamental rights and freedoms that require protection of personal data.</li>\r\n\t</ul>\r\n\t<p>&nbsp;</p>\r\n\t<ol>\r\n\t\t<li><strong> How can you exercise your rights provided under the GDPR?</strong></li>\r\n\t</ol>\r\n\t<p>Under the General Data Protection Regulation, you have the right to access, rectify, port and erase your data.\r\n\t\tLearn more about these rights, and find out how you can exercise your rights in the&nbsp;<u>Sportemage Settings</u>.\r\n\t\tYou also have the&nbsp;<u>right to object to</u>&nbsp;and restrict certain processing of your data. This includes:</p>\r\n\t<ul>\r\n\t\t<li>the right to object to our processing of your data for direct marketing, which you can exercise by using the\r\n\t\t\t\"unsubscribe\" link in such marketing communications; and</li>\r\n\t\t<li>the right to object to our processing of your data where we are performing a task in the public interest or\r\n\t\t\tpursuing our legitimate interests or those of a third party. You can exercise this right on Sportemage and on\r\n\t\t\tSportemage.</li>\r\n\t</ul>\r\n\t<p>&nbsp;</p>\r\n\t<p><strong>VII. Data retention, account deactivation and deletion</strong></p>\r\n\t<p>We store data until it is no longer necessary to provide our services and Sportemage Products, or until your\r\n\t\taccount is deleted - whichever comes first. This is a case-by-case determination that depends on things like the\r\n\t\tnature of the data, why it is collected and processed, and relevant legal or operational retention needs. For\r\n\t\texample, when you search for something on Sportemage, you can access and delete that query from within your search\r\n\t\thistory at any time, but the log of that search is deleted after 6 months. If you submit a copy of your\r\n\t\tgovernment-issued ID for account verification purposes, we delete that copy 30 days after submission. Learn more\r\n\t\tabout deletion of&nbsp;<u>content you have shared</u>&nbsp;and&nbsp;<u>cookie data obtained through social plugins</u>.</p>\r\n\t<p>When you delete your account, we&nbsp;<u>delete things</u>&nbsp;you have posted, such as your photos and status\r\n\t\tupdates, and you won't be able to recover that information later. Information that others have shared about you isn't\r\n\t\tpart of your account and won't be deleted. If you don't want to delete your account but want to temporarily stop\r\n\t\tusing the Products, you can deactivate your account instead. To delete your account at any time, please visit\r\n\t\tthe&nbsp;<u>Sportemage Settings</u>.</p>\r\n\t<p>&nbsp;</p>\r\n\t<p><strong>VIII. How do we respond to legal requests or prevent harm?</strong></p>\r\n\t<p>We access, preserve and share your information with regulators, law enforcement or others:</p>\r\n\t<ul>\r\n\t\t<li>In response to a legal request, if we have a good-faith belief that the law requires us to do so. We can also\r\n\t\t\trespond to legal requests when we have a good-faith belief that the response is required by law in that\r\n\t\t\tjurisdiction, affects users in that jurisdiction, and is consistent with internationally recognized standards.</li>\r\n\t\t<li>When we have a good-faith belief it is necessary to: detect, prevent and address fraud, unauthorized use of the\r\n\t\t\tProducts, violations of our terms or policies, or other harmful or illegal activity; to protect ourselves (including\r\n\t\t\tour rights, property or Products), you or others, including as part of investigations or regulatory inquiries; or to\r\n\t\t\tprevent death or imminent bodily harm. For example, if relevant, we provide information to and receive information\r\n\t\t\tfrom third-party partners about the reliability of your account to prevent fraud, abuse and other harmful activity\r\n\t\t\ton and off our Products.</li>\r\n\t</ul>\r\n\t<p>Information we receive about you (including financial transaction data related to purchases made with Sportemage)\r\n\t\tcan be accessed and preserved for an extended period when it is the subject of a legal request or obligation,\r\n\t\tgovernmental investigation, or investigations of possible violations of our terms or policies, or otherwise to\r\n\t\tprevent harm. We also retain information from accounts disabled for terms violations for at least a year to prevent\r\n\t\trepeat abuse or other term violations.</p>\r\n\t<ol>\r\n\t\t<li><strong> How do we operate and transfer data as part of our global services?</strong></li>\r\n\t</ol>\r\n\t<p>We share information globally, both internally within the Sportemage Companies and externally with our partners and\r\n\t\twith those you connect and share with around the world in accordance with this policy. Information controlled by\r\n\t\tSportemage Ireland will be transferred or transmitted to, or stored and processed in, the United States or other\r\n\t\tcountries outside of where you live for the purposes as described in this policy. These data transfers are necessary\r\n\t\tto provide the services set forth in the&nbsp;<u>Sportemage Terms</u>&nbsp;and to globally operate and provide our\r\n\t\tProducts to you. We utilize&nbsp;<u>standard contractual clauses</u>&nbsp;approved by the European Commission and\r\n\t\trely on the European Commission's&nbsp;<u>adequacy decisions</u>&nbsp;about certain countries, as applicable, for\r\n\t\tdata transfers from the EEA to the United States and other countries.</p>\r\n\t<p>&nbsp;</p>\r\n\t<ol>\r\n\t\t<li><strong> How will we notify you of changes to this policy?</strong></li>\r\n\t</ol>\r\n\t<p>We'll notify you before we make changes to this policy and give you the opportunity to review the revised policy\r\n\t\tbefore you choose to continue using our Products.</p>\r\n\t<p>&nbsp;</p>\r\n\t<ol>\r\n\t\t<li><strong> How to contact Sportemage with questions</strong></li>\r\n\t</ol>\r\n\t<p>If you have questions about this policy, you can contact us as described below.</p>\r\n\t<p>The data controller responsible for your information is Sportemage, which you can&nbsp;<u>contact online</u>, or by\r\n\t\tmail at:&nbsp;</p>\r\n\t<p>&nbsp;</p>\r\n\t<p>sportemage@sportemage.com</p>\r\n\t<p>&nbsp;</p>\r\n\t<p>&nbsp;<br /> <u>Contact the Data Protection Officer for Sportemage</u>&nbsp;: sportemage@sportemage.com</p>\r\n\t<p><br /> You also have the right to lodge a complaint with Sportemage lead supervisory authority, the Data Protection\r\n\t\tCommissioner, or your local supervisory authority.</p>\r\n\r\n\r\n</div>";

/***/ },

/***/ 514:
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var core_1 = __webpack_require__(5);
	var TermsComponent = (function () {
	    function TermsComponent() {
	    }
	    TermsComponent = __decorate([
	        core_1.Component({
	            selector: 'terms',
	            template: __webpack_require__(515),
	        }), 
	        __metadata('design:paramtypes', [])
	    ], TermsComponent);
	    return TermsComponent;
	}());
	exports.TermsComponent = TermsComponent;


/***/ },

/***/ 515:
/***/ function(module, exports) {

	module.exports = "<div class=\"container\">\r\n\t<h2>Terms of Use</h2>\r\n\t<p>Welcome to Sportemage !&nbsp;<br /> <br /> These Terms of Use govern your use of&nbsp;Sportemage and provide\r\n\t\tinformation about the&nbsp;Sportemage Service, outlined below. When you create a&nbsp;Sportemage account or\r\n\t\tuse&nbsp;Sportemage, you agree to these terms.&nbsp;<br /> <br /> These Terms of Use therefore constitute an\r\n\t\tagreement between you and Sportemage Service.&nbsp;</p>\r\n\t<p><strong>The&nbsp;Sportemage Service</strong></p>\t\r\n\t<p>We agree to provide you with the Sportemage Service. The service includes all of the Sportemage products, features,\r\n\t\tapplications, services, technologies, and software that we provide to advance Sportemage's mission: To bring you\r\n\t\tcloser to the people and the <strong>sports</strong> you love. The Service is made up of the following aspects (the\r\n\t\tService):</p>\r\n\t<ul>\r\n\t\t<li><strong>Offering personalized opportunities to create, connect, communicate, discover, and share.</strong><br />\r\n\t\t\tPeople are different. We want to strengthen your relationships through shared experiences you actually care about.\r\n\t\t\tSo we build systems that try to understand who and what you and others care about, and use that information to help\r\n\t\t\tyou create, find, join, and share in experiences that matter to you. Part of that is highlighting content, features,\r\n\t\t\toffers, and accounts you might be interested in, and offering ways for you to experience Sportemage, based on things\r\n\t\t\tyou and others do on and off Sportemage.</li>\r\n\t</ul>\r\n\t<p>&nbsp;</p>\r\n\t<ul>\r\n\t\t<li><strong>Fostering a positive, inclusive, and safe environment.</strong><br /> We develop and use tools and offer\r\n\t\t\tresources to our community members that help make their experiences positive and inclusive, including when we think\r\n\t\t\tthey might need help. We also have teams and systems that work to combat abuse and violations of our Terms and\r\n\t\t\tpolicies, as well as harmful and deceptive behavior. We use all the information we have -including your information-\r\n\t\t\tto try to keep our platform secure. We also may share information about misuse or harmful content with other\r\n\t\t\tSportemage Companies or law enforcement. Learn more in the&nbsp;<strong>Data Policy</strong>.</li>\r\n\t</ul>\r\n\t<p>&nbsp;</p>\r\n\t<ul>\r\n\t\t<li><strong>Developing and using technologies that help us consistently serve our growing community.</strong><br />\r\n\t\t\tOrganizing and analyzing information for our growing community is central to our Service. A big part of our Service\r\n\t\t\tis creating and using cutting-edge technologies that help us customize, protect, and improve our Service on an\r\n\t\t\tincredibly large scale for a broad global community. Technologies like artificial intelligence and machine learning\r\n\t\t\tgive us the power to apply complex processes across our Service. Automated technologies also help us ensure the\r\n\t\t\tfunctionality and integrity of our Service.</li>\r\n\t</ul>\r\n\t<p>&nbsp;</p>\r\n\t<ul>\r\n\t\t<li><strong>Providing consistent and seamless experiences across other Sportemage Company Products.</strong><br />\r\n\t\t\tSportemage is part of the Sportemage Companies, which share technology, systems, insights, and information-including\r\n\t\t\tthe information we have about you (learn more in the&nbsp;<strong>Data Policy</strong>) in order to provide services\r\n\t\t\tthat are better, safer, and more secure. We also provide ways to interact across the Sportemage Company Products\r\n\t\t\tthat you use, and designed systems to achieve a seamless and consistent experience across the Sportemage Company\r\n\t\t\tProducts.</li>\r\n\t</ul>\r\n\t<p>&nbsp;</p>\r\n\t<ul>\r\n\t\t<li><strong>Ensuring a stable global infrastructure for our Service.</strong><br /> To provide our global Service, we\r\n\t\t\tmust store and transfer data across our systems around the world, including outside of your country of residence.\r\n\t\t\tThis infrastructure may be owned or operated by Sportemage Inc. or their affiliates.</li>\r\n\t</ul>\r\n\t<p>&nbsp;</p>\r\n\t<ul>\r\n\t\t<li><strong>Connecting you with brands, products, and services in ways you care about.</strong><br /> We use data\r\n\t\t\tfrom Sportemage and other Sportemage Company Products, as well as from third-party partners, to show you ads,\r\n\t\t\toffers, and other sponsored content that we believe will be meaningful to you. And we try to make that content as\r\n\t\t\trelevant as all your other experiences on Sportemage.</li>\r\n\t</ul>\r\n\t<p>&nbsp;</p>\r\n\t<p><strong>Research and innovation.</strong><br /> We use the information we have to study our Service and collaborate\r\n\t\twith others on research to make our Service better and contribute to the well-being of our community.</p>\r\n\r\n\t<h3>The Data Policy</h3>\r\n\t\r\n\t<h3>Your Commitments</h3>\r\n\t<p>In return for our commitment to provide the Service, we require you to make the below commitments to us.</p>\r\n\t<p><strong>Who Can Use Sportemage.</strong>&nbsp;We want our Service to be as open and inclusive as possible, but we\r\n\t\talso want it to be safe, secure, and in accordance with the law. So, we need you to commit to a few restrictions in\r\n\t\torder to be part of the Sportemage community.</p>\r\n\t<ul>\r\n\t\t<li>You must be at least 13 years old.</li>\r\n\t\t<li>You must not be prohibited from receiving any aspect of our Service under applicable laws or engaging in payments\r\n\t\t\trelated Services if you are on an applicable denied party listing.</li>\r\n\t\t<li>We must not have previously disabled your account for violation of law or any of our policies.</li>\r\n\t\t<li>You must not be a convicted sex offender.</li>\r\n\t</ul>\r\n\t<p><strong>How You Can't Use Sportemage.</strong>&nbsp;Providing a safe and open Service for a broad community\r\n\t\trequires that we all do our part.</p>\r\n\t<ul>\r\n\t\t<li><strong>You can't impersonate others or provide inaccurate information.</strong><br /> You don't have to disclose\r\n\t\t\tyour identity on Sportemage, but you must provide us with accurate and up to date information (including\r\n\t\t\tregistration information). Also, you may not impersonate someone you aren't, and you can't create an account for\r\n\t\t\tsomeone else unless you have their express permission.</li>\r\n\t\t<li><strong>You can't do anything unlawful, misleading, or fraudulent or for an illegal or unauthorized purpose.</strong></li>\r\n\t\t<li><strong>You can't violate (or help or encourage others to violate) these Terms or our policies, including in\r\n\t\t\t\tparticular the&nbsp;Sportemage Community Guidelines,&nbsp;Sportemage Platform Policy, and&nbsp;general Guidelines.</strong>Learn\r\n\t\t\thow to report conduct or content in our&nbsp;Help Center.</li>\r\n\t\t<li><strong>You can't do anything to interfere with or impair the intended operation of the Service.</strong></li>\r\n\t\t<li><strong>You can't attempt to create accounts or access or collect information in unauthorized ways.</strong><br />\r\n\t\t\tThis includes creating accounts or collecting information in an automated way without our express permission.</li>\r\n\t\t<li><strong>You can't attempt to buy, sell, or transfer any aspect of your account (including your username) or\r\n\t\t\t\tsolicit, collect, or use login credentials or badges of other users.</strong></li>\r\n\t\t<li><strong>You can't post private or confidential information or do anything that violates someone else's rights,\r\n\t\t\t\tincluding intellectual property.</strong><br /> Learn more, including how to report content that you think\r\n\t\t\tinfringes your intellectual property rights.</li>\r\n\t\t<li><strong>You can't use a domain name or URL in your username without our prior written consent.</strong></li>\r\n\t</ul>\r\n\t<p><strong>Permissions You Give to Us.</strong>&nbsp;As part of our agreement, you also give us permissions that we\r\n\t\tneed to provide the Service.</p>\r\n\t<ul>\r\n\t\t<li><strong>We do not claim ownership of your content, but you grant us a license to use it.</strong><br /> Nothing\r\n\t\t\tis changing about your rights in your content. We do not claim ownership of your content that you post on or through\r\n\t\t\tthe Service. Instead, when you share, post, or upload content that is covered by intellectual property rights (like\r\n\t\t\tphotos or videos) on or in connection with our Service, you hereby grant to us a non-exclusive, royalty-free,\r\n\t\t\ttransferable, sub-licensable, worldwide license to host, use, distribute, modify, run, copy, publicly perform or\r\n\t\t\tdisplay, translate, and create derivative works of your content (consistent with your privacy and application\r\n\t\t\tsettings). You can end this license anytime by deleting your content or account. However, content will continue to\r\n\t\t\tappear if you shared it with others and they have not deleted it. To learn more about how we use information, and\r\n\t\t\thow to control or delete your content, review the&nbsp;Data Policy&nbsp;and visit the&nbsp;Sportemage Help Center.</li>\r\n\t\t<li><strong>Permission to use your username, profile picture, and information about your relationships and actions\r\n\t\t\t\twith accounts, ads, and sponsored content.</strong><br /> You give us permission to show your username, profile\r\n\t\t\tpicture, and information about your actions (such as likes) or relationships (such as follows) next to or in\r\n\t\t\tconnection with accounts, ads, offers, and other sponsored content that you follow or engage with that are displayed\r\n\t\t\ton Sportemage Products, without any compensation to you. For example, we may show that you liked a sponsored post\r\n\t\t\tcreated by a brand that has paid us to display its ads on Sportemage. As with actions on other content and follows\r\n\t\t\tof other accounts, actions on sponsored content and follows of sponsored accounts can be seen only by people who\r\n\t\t\thave permission to see that content or follow. We will also respect your ad settings if any.</li>\r\n\t\t<li><strong>You agree that we can download and install updates to the Service on your device.</strong></li>\r\n\t</ul>\r\n\t<p>&nbsp;</p>\r\n\t<h3>Additional Rights We Retain</h3>\r\n\t<ul>\r\n\t\t<li>If you select a username or similar identifier for your account, we may change it if we believe it is appropriate\r\n\t\t\tor necessary (for example, if it infringes someone's intellectual property or impersonates another user).</li>\r\n\t\t<li>If you use content covered by intellectual property rights that we have and make available in our Service (for\r\n\t\t\texample, images, designs, videos, or sounds we provide that you add to content you create or share), we retain all\r\n\t\t\trights to our content (but not yours).</li>\r\n\t\t<li>You can only use our intellectual property and trademarks or similar marks as expressly permitted by\r\n\t\t\tour&nbsp;Brand Guidelines&nbsp;or with our prior written permission.</li>\r\n\t\t<li>You must obtain written permission from us or under an open source license to modify, create derivative works of,\r\n\t\t\tdecompile, or otherwise attempt to extract source code from us.</li>\r\n\t</ul>\r\n\r\n\t<h3>Content Removal and Disabling or Terminating Your Account</h3>\r\n\t<ul>\r\n\t\t<li>We can remove any content or information you share on the Service if we believe that it violates these Terms of\r\n\t\t\tUse, our policies (including our&nbsp;Sportemage Community Guidelines), or we are required to do so by law. We can\r\n\t\t\trefuse to provide or stop providing all or part of the Service to you (including terminating or disabling your\r\n\t\t\taccount) immediately if you: clearly, seriously or repeatedly violate these Terms of Use, our policies (including\r\n\t\t\tour&nbsp;Sportemage Community Guidelines), if you repeatedly infringe other people's intellectual property rights,\r\n\t\t\tor where we are required to do so by law. If we take action to remove your content for violating our Community\r\n\t\t\tGuidelines, or disable or terminate your account, we will notify you where appropriate. If you believe your account\r\n\t\t\thas been terminated in error, or you want to disable or permanently delete your account, consult our&nbsp;Help\r\n\t\t\tCenter.</li>\r\n\t\t<li>Content you delete may persist for a limited period of time in backup copies and will still be visible where\r\n\t\t\tothers have shared it. This paragraph, and the section below called \"Our Agreement and What Happens if We Disagree,\"\r\n\t\t\twill still apply even after your account is terminated or deleted.</li>\r\n\t</ul>\r\n\t<p>&nbsp;</p>\r\n\t<h3>Our Agreement and What Happens if We Disagree</h3>\r\n\t<p><strong>Our Agreement.</strong></p>\r\n\t<ul>\r\n\t\t<li>Your use of music on the Service is also subject to our Guidelines, and your use of our API is subject to\r\n\t\t\tour&nbsp;Platform Policy. If you use certain other features or related services, you will be provided with an\r\n\t\t\topportunity to agree to additional terms that will also become a part of our agreement. For example, if you use\r\n\t\t\tpayment features, you will be asked to agree to the&nbsp;Community Payment Terms. If any of those terms conflict\r\n\t\t\twith this agreement, those other terms will govern.</li>\r\n\t\t<li>If any aspect of this agreement is unenforceable, the rest will remain in effect.</li>\r\n\t\t<li>Any amendment or waiver to our agreement must be in writing and signed by us. If we fail to enforce any aspect of\r\n\t\t\tthis agreement, it will not be a waiver.</li>\r\n\t\t<li>We reserve all rights not expressly granted to you.</li>\r\n\t</ul>\r\n\t<p>&nbsp;</p>\r\n\t<p><strong>Who Has Rights Under this Agreement.</strong></p>\r\n\t<ul>\r\n\t\t<li>This agreement does not give rights to any third parties.</li>\r\n\t\t<li>You cannot transfer your rights or obligations under this agreement without our consent.</li>\r\n\t\t<li>Our rights and obligations can be assigned to others. For example, this could occur if our ownership changes (as\r\n\t\t\tin a merger, acquisition, or sale of assets) or by law.</li>\r\n\t</ul>\r\n\t<p><strong>Who Is Responsible if Something Happens.</strong></p>\r\n\t<ul>\r\n\t\t<li>We will use reasonable skill and care in providing our Service to you and in keeping a safe, secure, and\r\n\t\t\terror-free environment, but we cannot guarantee that our Service will always function without disruptions, delays,\r\n\t\t\tor imperfections. Provided we have acted with reasonable skill and care, we do not accept responsibility for: losses\r\n\t\t\tnot caused by our breach of these Terms or otherwise by our acts; losses which are not reasonably foreseeable by you\r\n\t\t\tand us at the time of entering into these Terms; any offensive, inappropriate, obscene, unlawful, or otherwise\r\n\t\t\tobjectionable content posted by others that you may encounter on our Service; and events beyond our reasonable\r\n\t\t\tcontrol.</li>\r\n\t\t<li>The above does not exclude or limit our liability for death, personal injury, or fraudulent misrepresentation\r\n\t\t\tcaused by our negligence. It also does not exclude or limit our liability for any other things where the law does\r\n\t\t\tnot permit us to do so.</li>\r\n\t</ul>\r\n\t<p><strong>How We Will Handle Disputes.</strong></p>\r\n\t<p>If you are a consumer and habitually reside in a Member State of the European Union, the laws of that Member State\r\n\t\twill apply to any claim, cause of action, or dispute you have against us that arises out of or relates to these Terms\r\n\t\t(\"claim\"), and you may resolve your claim in any competent court in that Member State that has jurisdiction over the\r\n\t\tclaim. In all other cases, you agree that the claim must be resolved in a competent court in the French Republic and\r\n\t\tthat French law will govern these Terms and any claim, without regard to conflict of law provisions.</p>\r\n\t<p><strong>Unsolicited Material.</strong></p>\r\n\t<p>We always appreciate feedback or other suggestions, but may use them without any restrictions or obligation to\r\n\t\tcompensate you for them, and are under no obligation to keep them confidential.</p>\r\n\t<p>&nbsp;</p>\r\n\t<h3>Updating These Terms</h3>\r\n\t<p>We may change our Service and policies, and we may need to make changes to these Terms so that they accurately\r\n\t\treflect our Service and policies. Unless otherwise required by law, we will notify you (for example, through our\r\n\t\tService) at least 30 days before we make changes to these Terms and give you an opportunity to review them before\r\n\t\tthey go into effect. Then, if you continue to use the Service, you will be bound by the updated Terms. If you do not\r\n\t\twant to agree to these or any updated Terms, you can delete your account, by simple request.</p>\r\n</div>";

/***/ },

/***/ 516:
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var core_1 = __webpack_require__(5);
	var EulaComponent = (function () {
	    function EulaComponent() {
	    }
	    EulaComponent = __decorate([
	        core_1.Component({
	            selector: 'eula',
	            template: __webpack_require__(517),
	        }), 
	        __metadata('design:paramtypes', [])
	    ], EulaComponent);
	    return EulaComponent;
	}());
	exports.EulaComponent = EulaComponent;


/***/ },

/***/ 517:
/***/ function(module, exports) {

	module.exports = "<!DOCTYPE HTML PUBLIC \"-//W3C//DTD HTML 4.0 Transitional//EN\">\r\n<html>\r\n<head>\r\n\t<title>EULA</title>\r\n    <link rel=\"icon\" type=\"image/gif/png\" href=\"/public/images/picoTitleLogo.png\">\r\n</head>\r\n<body lang=\"en-IN\" link=\"#0000ff\" dir=\"ltr\">\r\n<div title=\"header\">\r\n\t<p style=\"margin-top:2%;\"><img src=\"/public/images/pico_logo.png\" alt=\"EULA\"></p>\r\n\t<!--<p align=\"center\" style=\"margin-bottom: 0cm; line-height: 100%\"><br>\r\n\t</p>\r\n\t<p align=\"center\" style=\"margin-bottom: 0cm; line-height: 100%\"><br>\r\n\t</p>-->\r\n\t<p align=\"right\"><b>Sportemage\r\n\tEULA</b></p>\r\n</div>\r\n<p style=\"margin-top: 0.53cm; margin-bottom: 0.79cm; line-height: 0.42cm\">\r\n<font color=\"#333332\"><font face=\"Helvetica, serif\"><font size=\"5\" style=\"font-size: 18pt\">Sportemage\r\nEULA</font></font></font></p>\r\n<p style=\"margin-top: 0.53cm; margin-bottom: 0cm; line-height: 0.64cm\">\r\n<font color=\"#333332\"><font face=\"Helvetica, serif\"><font size=\"2\" style=\"font-size: 10pt\">This\r\nPrivacy Policy describes how and when Sportemage collects, uses, and\r\nshares your information when you use Sportemage, including our\r\nmobile applications and websites (the &quot;Services&quot;).\r\nSportemage receives your information through our mobile\r\napplications, websites, email notifications, and other interactions\r\nwith our Services. When using any of our Services you consent to the\r\ncollection, transfer, manipulation, storage, disclosure and other\r\nuses of your information as described in this Privacy Policy.\r\nIrrespective of which country you reside in or supply information\r\nfrom, you authorize Sportemage to use your information in the United\r\nStates and any other country where Sportemage operates.</font></font></font></p>\r\n<p style=\"margin-top: 0.53cm; margin-bottom: 0cm; line-height: 0.42cm\">\r\n<font color=\"#333332\"><font face=\"Helvetica, serif\"><font size=\"3\" style=\"font-size: 13pt\">Information\r\nCollection and Use</font></font></font></p>\r\n<p style=\"margin-top: 0.49cm; margin-bottom: 0cm; line-height: 0.64cm\">\r\n<font color=\"#333332\"><font face=\"Helvetica, serif\"><font size=\"2\" style=\"font-size: 10pt\"><b>Creating\r\na Sportemage Account and Profile Information:</b></font></font></font><font color=\"#333332\"><font face=\"Helvetica, serif\"><font size=\"2\" style=\"font-size: 10pt\">&nbsp;When\r\nyou create a Sportemage account, you must provide access credentials\r\neither in the form of an email address and password or by\r\nauthentication using another service, such as Twitter. You may\r\noptionally provide us with additional profile information, including\r\na short bio, location, and profile picture. If you create your\r\nSportemage account by connecting through another service, we may use\r\npublic information from that connected account to help complete your\r\nSportemage profile. You may update or modify your profile\r\ninformation and contact information at any time. Profile information\r\nis available publicly on our Services, such as on your profile page.</font></font></font></p>\r\n<p style=\"margin-top: 0.49cm; margin-bottom: 0cm; line-height: 0.64cm\">\r\n<font color=\"#333332\"><font face=\"Helvetica, serif\"><font size=\"2\" style=\"font-size: 10pt\"><b>Contact\r\nInformation:</b></font></font></font><font color=\"#333332\"><font face=\"Helvetica, serif\"><font size=\"2\" style=\"font-size: 10pt\">&nbsp;In\r\naddition to using your contact information to create your account, we\r\nmay use this information to send you information about our Services,\r\nrespond to your requests and facilitate your use of the Services. We\r\nmay use the contact information (such as your phone number or email\r\naddress) to help connect you with other Sportemage users, even if\r\nthat information is not publicly displayed. Some contact information\r\nmay be required in order to use certain Services. For example, you\r\nmust have a verified phone number attached to your account in order\r\nto send a Sportemage Message to someone who does not follow you.</font></font></font></p>\r\n<p style=\"margin-top: 0.49cm; margin-bottom: 0cm; line-height: 0.64cm\">\r\n<font color=\"#333332\"><font face=\"Helvetica, serif\"><font size=\"2\" style=\"font-size: 10pt\"><b>Finding\r\nFriends and Connecting to Other Services:</b></font></font></font><font color=\"#333332\"><font face=\"Helvetica, serif\"><font size=\"2\" style=\"font-size: 10pt\">&nbsp;Our\r\nServices include several features to help connect you to the accounts\r\nof people you already know. For example, you may upload information\r\nfrom your address book or connect your Sportemage account to your\r\naccount on another service such as Twitter. Sportemage will match\r\nthe information you provide with the contact information of other\r\nSportemage users in order to provide and improve the Services, for\r\nexample by making recommendations and routing Sportemage messages.\r\nYou may remove address book data from Sportemage at any time through\r\nthe settings in your Sportemage app. When you connect your </font></font></font>\r\n</p>\r\n<p style=\"margin-top: 0.49cm; margin-bottom: 0cm; line-height: 0.64cm\">\r\n<font color=\"#333332\"><font face=\"Helvetica, serif\"><font size=\"2\" style=\"font-size: 10pt\">Sportemage\r\naccount to other services, you are able to post your Content to those\r\nservices as well. You may disconnect your Sportemage account from\r\nyour account on the other services at any time. Disconnecting your\r\nSportemage account will immediately revoke our authorization to\r\ncross-post on your behalf or otherwise access that account and we\r\nwill delete information obtained from that connection (other than\r\ninformation that was publicly posted on Sportemage, such as profile\r\ninformation), which may take some time.</font></font></font></p>\r\n<p style=\"margin-top: 0.49cm; margin-bottom: 0cm; line-height: 0.64cm\">\r\n<font color=\"#333332\"><font face=\"Helvetica, serif\"><font size=\"2\" style=\"font-size: 10pt\"><b>Content,\r\nFollowing, and other Public Information:</b></font></font></font><font color=\"#333332\"><font face=\"Helvetica, serif\"><font size=\"2\" style=\"font-size: 10pt\">&nbsp;Sportemage\r\nis a photo and video sharing platform, so most of the information you\r\nprovide us is information that you choose to be made public. This\r\nincludes not only the Content that you post and data provided with\r\nsuch Content, such as when it was posted, but also the accounts you\r\nfollow, the Content that you like or comment on, and other public\r\ninteractions on the Services. Your public information is broadly and\r\ninstantly disseminated. For instance, your profile information and\r\npublic Content are immediately delivered to a wide range of users and\r\nother services that access Sportemage. When you share information or\r\nContent via the Services, you should think carefully about what you\r\nare making public.</font></font></font></p>\r\n<p style=\"margin-top: 0.49cm; margin-bottom: 0cm; line-height: 0.64cm\">\r\n<font color=\"#333332\"><font face=\"Helvetica, serif\"><font size=\"2\" style=\"font-size: 10pt\"><b>Location\r\nInformation:</b></font></font></font><font color=\"#333332\"><font face=\"Helvetica, serif\"><font size=\"2\" style=\"font-size: 10pt\">&nbsp;In\r\naddition to profile information, you may also tell us your exact\r\nlocation if you choose to enable your computer or mobile device to\r\nsend us location information. We may use and store information about\r\nyour location to provide features of our Services, such as tagging a\r\nvideo with a location, and to improve and customize the Services, for\r\nexample, with Content that has been tagged near your location.</font></font></font></p>\r\n<p style=\"margin-top: 0.49cm; margin-bottom: 0cm; line-height: 0.64cm\">\r\n<font color=\"#333332\"><font face=\"Helvetica, serif\"><font size=\"2\" style=\"font-size: 10pt\"><b>Links:</b></font></font></font><font color=\"#333332\"><font face=\"Helvetica, serif\"><font size=\"2\" style=\"font-size: 10pt\">&nbsp;We\r\nmay keep track of how you interact with links across our Services,\r\nincluding our email notifications, third-party services, and client\r\napplications, by redirecting clicks or through other means. We do\r\nthis to help improve our Services, for example to provide relevant\r\nadvertising, and to be able to share aggregate click statistics such\r\nas how many times a particular link was clicked on.</font></font></font></p>\r\n<p style=\"margin-top: 0.49cm; margin-bottom: 0cm; line-height: 0.64cm\">\r\n<font color=\"#333332\"><font face=\"Helvetica, serif\"><font size=\"2\" style=\"font-size: 10pt\"><b>Cookies:</b></font></font></font><font color=\"#333332\"><font face=\"Helvetica, serif\"><font size=\"2\" style=\"font-size: 10pt\">&nbsp;Like\r\nmany websites, we use &quot;cookie&quot; technology to collect\r\nadditional website usage data and to improve our Services, but we do\r\nnot require cookies for many parts of our Services such as viewing\r\npublic videos. A cookie is a small data file that is transferred to\r\nyour computer's hard disk. Sportemage may use both session cookies\r\nand persistent cookies to better understand how you interact with our\r\nServices, to monitor aggregate usage by our users and web traffic\r\nrouting on our Services, and to customize and improve our Services.\r\nMost Internet browsers automatically accept cookies. If you do not\r\nwant cookies from Sportemage or other websites, you can instruct\r\nyour browser, by changing its settings, to stop accepting cookies or\r\nto prompt you before accepting a cookie from the websites you visit.\r\nHowever, some Services may not function properly if you disable\r\ncookies.</font></font></font></p>\r\n<p style=\"margin-top: 0.49cm; margin-bottom: 0cm; line-height: 0.64cm\">\r\n<font color=\"#333332\"><font face=\"Helvetica, serif\"><font size=\"2\" style=\"font-size: 10pt\"><b>Log\r\nData:</b></font></font></font><font color=\"#333332\"><font face=\"Helvetica, serif\"><font size=\"2\" style=\"font-size: 10pt\">&nbsp;Our\r\nservers automatically record information (&quot;</font></font></font><font color=\"#333332\"><font face=\"Helvetica, serif\"><font size=\"2\" style=\"font-size: 10pt\"><b>Log\r\nData</b></font></font></font><font color=\"#333332\"><font face=\"Helvetica, serif\"><font size=\"2\" style=\"font-size: 10pt\">&quot;)\r\ncreated by your use of the Services. Log Data may include information\r\nsuch as your IP address, browser type, operating system, the\r\nreferring web page, pages visited, location, your mobile carrier,\r\ndevice and application IDs, search terms, and cookie information. We\r\nreceive Log Data when you interact with our Services, for example,\r\nwhen you visit our websites, sign into our Services,view videos\r\nhosted by Sportemage, or interact with our email notifications.\r\nSportemage uses Log Data to provide our Services and to measure,\r\ncustomize, and improve them. If not already done earlier, we will\r\neither delete Log Data or remove any common account identifiers, such\r\nas your username, full IP address, or email address, after 18 months.</font></font></font></p>\r\n<p style=\"margin-top: 0.49cm; margin-bottom: 0cm; line-height: 0.64cm\">\r\n<font color=\"#333332\"><font face=\"Helvetica, serif\"><font size=\"2\" style=\"font-size: 10pt\"><b>Third-Party\r\nServices:</b></font></font></font><font color=\"#333332\"><font face=\"Helvetica, serif\"><font size=\"2\" style=\"font-size: 10pt\">&nbsp;Sportemage\r\nuses a variety of third-party services to help provide our Services,\r\nincluding to host our various blogs and wikis and to help us\r\nunderstand the use of our Services. These third-party service\r\nproviders may use cookies and other technologies to collect\r\ninformation about your use of our Services and other websites and\r\nservices, including your IP address, device ID, pages viewed, and\r\nlinks clicked. </font></font></font>\r\n</p>\r\n<p style=\"margin-top: 0.53cm; margin-bottom: 0cm; line-height: 0.42cm\">\r\n<font color=\"#333332\"><font face=\"Helvetica, serif\"><font size=\"3\" style=\"font-size: 13pt\">Information\r\nSharing and Disclosure</font></font></font></p>\r\n<p style=\"margin-top: 0.49cm; margin-bottom: 0cm; line-height: 0.64cm\">\r\n<font color=\"#333332\"><font face=\"Helvetica, serif\"><font size=\"2\" style=\"font-size: 10pt\"><b>Your\r\nConsent:</b></font></font></font><font color=\"#333332\"><font face=\"Helvetica, serif\"><font size=\"2\" style=\"font-size: 10pt\">&nbsp;We\r\nmay share or disclose your information at your direction, such as\r\nwhen you choose to publicly post a video or update your profile\r\ninformation.</font></font></font></p>\r\n<p style=\"margin-top: 0.49cm; margin-bottom: 0cm; line-height: 0.64cm\">\r\n<font color=\"#333332\"><font face=\"Helvetica, serif\"><font size=\"2\" style=\"font-size: 10pt\"><b>Service\r\nProviders:</b></font></font></font><font color=\"#333332\"><font face=\"Helvetica, serif\"><font size=\"2\" style=\"font-size: 10pt\">&nbsp;We\r\nengage service providers to perform functions and provide services to\r\nus in the United States and abroad. We may share your private\r\npersonal information with such service providers subject to\r\nconfidentiality obligations consistent with this Privacy Policy, and\r\non the condition that the third parties use your private personal\r\ndata only on our behalf and pursuant to our instructions.</font></font></font></p>\r\n<p style=\"margin-top: 0.49cm; margin-bottom: 0cm; line-height: 0.64cm\">\r\n<font color=\"#333332\"><font face=\"Helvetica, serif\"><font size=\"2\" style=\"font-size: 10pt\"><b>Law\r\nand Harm:</b></font></font></font><font color=\"#333332\"><font face=\"Helvetica, serif\"><font size=\"2\" style=\"font-size: 10pt\">&nbsp;Notwithstanding\r\nanything to the contrary in this Policy, we may preserve or disclose\r\nyour information if we believe that it is reasonably necessary to\r\ncomply with a law, regulation or legal request; to protect the safety\r\nof any person; to address fraud, security or technical issues; or to\r\nprotect Sportemage’s rights or property. However, nothing in this\r\nPrivacy Policy is intended to limit any legal defenses or objections\r\nthat you may have to a third party's, including a government's,\r\nrequest to disclose your information.</font></font></font></p>\r\n<p style=\"margin-top: 0.49cm; margin-bottom: 0cm; line-height: 0.64cm\">\r\n<font color=\"#333332\"><font face=\"Helvetica, serif\"><font size=\"2\" style=\"font-size: 10pt\"><b>Business\r\nTransfers:</b></font></font></font><font color=\"#333332\"><font face=\"Helvetica, serif\"><font size=\"2\" style=\"font-size: 10pt\">&nbsp;In\r\nthe event that Sportemage is involved in a bankruptcy, merger,\r\nacquisition, reorganization or sale of assets, your information may\r\nbe sold or transferred as part of that transaction. The promises in\r\nthis Privacy Policy will apply to your information as transferred to\r\nthe new entity.</font></font></font></p>\r\n<p style=\"margin-top: 0.49cm; margin-bottom: 0cm; line-height: 0.64cm\">\r\n<font color=\"#333332\"><font face=\"Helvetica, serif\"><font size=\"2\" style=\"font-size: 10pt\"><b>Non-Private\r\nor Non-Personal Information:</b></font></font></font><font color=\"#333332\"><font face=\"Helvetica, serif\"><font size=\"2\" style=\"font-size: 10pt\">&nbsp;We\r\nmay share or disclose your non-private, aggregated or otherwise\r\nnon-personal information, such as your public user profile\r\ninformation, public posts, the people you follow or that follow you,\r\nor the number of users who clicked on a particular link (even if only\r\none did).</font></font></font></p>\r\n<p style=\"margin-top: 0.53cm; margin-bottom: 0cm; line-height: 0.42cm\">\r\n<font color=\"#333332\"><font face=\"Helvetica, serif\"><font size=\"3\" style=\"font-size: 13pt\">Modifying\r\nYour Personal Information</font></font></font></p>\r\n<p style=\"margin-top: 0.53cm; margin-bottom: 0cm; line-height: 0.64cm\">\r\n<font color=\"#333332\"><font face=\"Helvetica, serif\"><font size=\"2\" style=\"font-size: 10pt\">If\r\nyou are a registered user of our Services, we provide you with tools\r\nand account settings to access or modify the profile information you\r\nprovided to us and associated with your account.</font></font></font></p>\r\n<p style=\"margin-bottom: 0.28cm; line-height: 107%\">You can also\r\npermanently delete your Sportemage account .You can mail at\r\nerasme@Sportemage.com</p>\r\n<p style=\"margin-top: 0.53cm; margin-bottom: 0cm; line-height: 0.42cm\">\r\n<font color=\"#333332\"><font face=\"Helvetica, serif\"><font size=\"3\" style=\"font-size: 13pt\">Our\r\nPolicy Towards Children</font></font></font></p>\r\n<p style=\"margin-top: 0.49cm; margin-bottom: 0cm; line-height: 0.64cm\">\r\n<font color=\"#333332\"><font face=\"Helvetica, serif\"><font size=\"2\" style=\"font-size: 10pt\">Our\r\nServices are not directed to persons under 13. If you become aware\r\nthat your child has provided us with personal information without\r\nyour consent, please&nbsp;</font></font></font><font color=\"#0083b4\"><font face=\"Helvetica, serif\"><font size=\"2\" style=\"font-size: 10pt\"><b>contact\r\nus</b></font></font></font><font color=\"#333332\"><font face=\"Helvetica, serif\"><font size=\"2\" style=\"font-size: 10pt\">\r\nWe do not knowingly collect personal information from children under\r\n13. If we become aware that a child under 13 has provided us with\r\npersonal information, we take steps to remove such information and\r\nterminate the child's account.</font></font></font></p>\r\n<p style=\"margin-top: 0.53cm; margin-bottom: 0cm; line-height: 0.42cm\"><a name=\"_GoBack\"></a>\r\n<font color=\"#333332\"><font face=\"Helvetica, serif\"><font size=\"3\" style=\"font-size: 13pt\">Changes\r\nto this Policy</font></font></font></p>\r\n<p style=\"margin-top: 0.49cm; margin-bottom: 0cm; line-height: 0.64cm\">\r\n<font color=\"#333332\"><font face=\"Helvetica, serif\"><font size=\"2\" style=\"font-size: 10pt\">We\r\nmay revise this Privacy Policy from time to time. The most current\r\nversion of the policy will govern our use of your information and\r\nwill always be at&nbsp;</font></font></font><a href=\"https://Sportemage.com/privacy\"><font face=\"Helvetica, serif\"><font size=\"2\" style=\"font-size: 10pt\"><b>https://Sportemage.com/privacy</b></font></font></a><font color=\"#333332\"><font face=\"Helvetica, serif\"><font size=\"2\" style=\"font-size: 10pt\">.\r\nIf we make a change to this policy that, in our sole discretion, is\r\nmaterial, we will notify you via an email to the email address\r\nassociated with your account or through the Services. By continuing\r\nto access or use the Services after those changes become effective,\r\nyou agree to be bound by the revised Privacy Policy.</font></font></font></p>\r\n<p style=\"margin-top: 0.49cm; margin-bottom: 0.28cm; line-height: 100%\">\r\n<font face=\"Times New Roman, serif\"><font size=\"3\" style=\"font-size: 12pt\"><br>&nbsp;</font></font></p>\r\n<p style=\"margin-bottom: 0.28cm; line-height: 107%\"><font face=\"Times New Roman, serif\"><font size=\"3\" style=\"font-size: 12pt\"><br></font></font><br><br>\r\n</p>\r\n</body>\r\n</html>\r\n";

/***/ },

/***/ 518:
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	//our root app component
	var core_1 = __webpack_require__(5);
	var angular2_infinite_scroll_1 = __webpack_require__(466);
	var PageComponent = (function () {
	    function PageComponent() {
	        this.array = [];
	        this.sum = 30;
	        for (var i = 0; i < this.sum; ++i) {
	            this.array.push(i);
	        }
	    }
	    PageComponent.prototype.onScrollDown = function () {
	        console.log('scrolled!!');
	        // add another 10 items
	        var start = this.sum;
	        this.sum += 10;
	        for (var i = start; i < this.sum; ++i) {
	            this.array.push(i);
	        }
	    };
	    PageComponent = __decorate([
	        core_1.Component({
	            selector: 'my-app',
	            directives: [angular2_infinite_scroll_1.InfiniteScroll],
	            styles: ["\n    .search-results {\n      height: 100%;\n      // overflow: scroll;\n    }\n    .title {\n      position: fixed;\n      top: 0;\n      left: 0;\n      background-color: rgba(0,0,0,.5);\n      color: white;\n      width: 100%;\n    }\n  "],
	            template: "\n    <h1 class=\"title\">Hello InfiniteScroll!<aside>items: {{sum}}</aside></h1>\n    <div class=\"search-results\"\n         infinite-scroll\n         [infiniteScrollDistance]=\"0\"\n         (scrolled)=\"onScrollDown()\">\n      <p *ngFor=\"let i of array\">\n        {{i}}\n      </p>\n    </div>\n  "
	        }), 
	        __metadata('design:paramtypes', [])
	    ], PageComponent);
	    return PageComponent;
	}());
	exports.PageComponent = PageComponent;


/***/ }

});


/** WEBPACK FOOTER **
 ** app.e74fd08fef940019f90c.js
 **/